import { $ as e, $n as t, $t as n, A as r, An as i, Ar as a, At as o, B as s, Bn as c, C as l, Cn as u, Cr as d, Ct as f, D as p, Dn as m, Dr as h, Dt as g, E as _, En as v, Er as y, Et as b, F as x, Fn as S, Ft as C, G as w, Gn as T, Gt as E, H as D, Hn as O, Ht as k, I as A, In as j, It as M, J as ee, Jn as te, Jt as ne, K as re, Kn as ie, Kt as ae, L as oe, Ln as se, M as ce, Mn as le, Mt as ue, N as de, Nn as fe, Nt as pe, O as me, On as N, Or as he, Ot as ge, P as _e, Pn as P, Q as ve, Qn as ye, Qt as be, R as xe, Rn as Se, S as Ce, Sn as we, Sr as Te, St as Ee, T as De, Tn as Oe, Tr as ke, Tt as Ae, U as je, Un as Me, Ut as Ne, V as Pe, Vn as Fe, Vt as Ie, W as Le, Wn as Re, Wt as ze, X as Be, Xn as Ve, Xt as He, Y as Ue, Yn as We, Yt as Ge, Z as Ke, Zn as qe, Zt as Je, _ as Ye, _n as Xe, _r as Ze, _t as Qe, a as $e, an as et, ar as tt, b as nt, bn as rt, br as it, bt as at, c as ot, cn as st, cr as ct, ct as lt, d as ut, dr as dt, dt as ft, en as pt, er as mt, et as ht, f as gt, fr as _t, ft as vt, g as yt, gn as bt, gt as xt, h as St, hn as Ct, hr as wt, ht as Tt, i as Et, in as Dt, ir as Ot, j as kt, jn as F, jr as I, jt as At, k as jt, kn as L, kr as Mt, kt as Nt, l as Pt, lr as R, lt as Ft, m as It, mn as Lt, mr as Rt, mt as zt, n as Bt, nn as Vt, nr as Ht, nt as Ut, o as Wt, on as Gt, or as Kt, p as qt, pn as Jt, pt as Yt, q as Xt, qn as Zt, qt as Qt, r as $t, rn as en, rr as tn, s as nn, sn as rn, t as an, tn as on, tr as sn, tt as cn, u as ln, ur as un, ut as dn, v as fn, vn as pn, vr as z, vt as mn, w as hn, wn as gn, wr as _n, wt as vn, x as yn, xn as bn, xr as xn, xt as Sn, y as Cn, yn as wn, yr as Tn, yt as En, z as Dn, zn as On } from "./runChatSteps-Bg-AIgrf.js";
import { mediaQueries as kn } from "./tokens.mjs";
import * as B from "react";
import An, { Children as jn, cloneElement as Mn, forwardRef as V, isValidElement as Nn, memo as Pn, useCallback as H, useEffect as U, useId as Fn, useImperativeHandle as In, useMemo as Ln, useReducer as Rn, useRef as W, useState as G } from "react";
import { Fragment as K, jsx as q, jsxs as J } from "react/jsx-runtime";
import * as zn from "react-dom";
//#region src/styles/index.ts
var Bn = "./globals.css";
//#endregion
//#region src/utils/a11y.ts
function Vn(e, t = "polite") {
	let n = document.createElement("div");
	n.setAttribute("aria-live", t), n.setAttribute("aria-atomic", "true"), n.setAttribute("class", "sr-only"), n.textContent = e, document.body.appendChild(n), setTimeout(() => {
		document.body.removeChild(n);
	}, 1e3);
}
function Hn(e) {
	let t = [
		"a[href]",
		"button:not([disabled])",
		"input:not([disabled])",
		"select:not([disabled])",
		"textarea:not([disabled])",
		"[tabindex]:not([tabindex=\"-1\"])"
	].join(", ");
	return Array.from(e.querySelectorAll(t));
}
var Un = {
	position: "absolute",
	width: "1px",
	height: "1px",
	padding: "0",
	margin: "-1px",
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	borderWidth: "0"
}, Wn = /[̀-ͯ]/g, Gn = /[\s\-_./:,;|]+/, Kn = /[\s\-_./:,;|]+/g, qn = /[^\p{L}\p{N}]+/u, Jn = .7;
function Yn(e) {
	return e.normalize("NFKD").replace(Wn, "").toLowerCase();
}
function Xn(e) {
	return Yn(e).split(Gn).filter((e) => e.length > 0);
}
function Zn(e) {
	return e.replace(Kn, "");
}
function Qn(e) {
	return e >= 8 ? 2 : +(e >= 4);
}
function $n(e, t, n) {
	let r = e.length, i = t.length;
	if (Math.abs(r - i) > n) return n + 1;
	if (r === 0) return i;
	if (i === 0) return r;
	let a = new Int32Array(i + 1), o = new Int32Array(i + 1);
	for (let e = 0; e <= i; e++) a[e] = e;
	for (let s = 1; s <= r; s++) {
		o[0] = s;
		let r = s, c = e.charCodeAt(s - 1);
		for (let e = 1; e <= i; e++) {
			let n = c === t.charCodeAt(e - 1) ? 0 : 1, i = (a[e] ?? 0) + 1, s = (o[e - 1] ?? 0) + 1, l = (a[e - 1] ?? 0) + n, u = Math.min(i, s, l);
			o[e] = u, u < r && (r = u);
		}
		if (r > n) return n + 1;
		let l = a;
		a = o, o = l;
	}
	return a[i] ?? 0;
}
function er(e, t, n, r, i) {
	let a = t.indexOf(e);
	if (a >= 0) return {
		quality: 1,
		index: a
	};
	let o = Zn(e);
	if (o.length > 0) {
		let e = n.indexOf(o);
		if (e >= 0) return {
			quality: 1,
			index: e
		};
	}
	if (!i) return {
		quality: 0,
		index: -1
	};
	let s = Qn(e.length);
	if (s === 0) return {
		quality: 0,
		index: -1
	};
	let c = 0;
	for (let t of r) {
		if (t.length < 4 || Math.abs(t.length - e.length) > s) continue;
		let n = $n(e, t, s);
		if (n <= s) {
			let r = Jn * (1 - n / Math.max(e.length, t.length));
			if (r > c && (c = r), n === 1) break;
		}
	}
	return {
		quality: c,
		index: -1
	};
}
function tr(e) {
	try {
		return JSON.stringify(e);
	} catch {
		return String(e);
	}
}
function nr(e, t, n = {}) {
	let r = n.haystack ?? tr, i = Xn(t);
	if (i.length === 0) return {
		hits: e.map((e) => ({
			row: e,
			score: 1
		})),
		mode: "client_substring",
		hasQuery: !1
	};
	let a = n.tokens === "or" ? "or" : "and", o = n.fuzzy !== !1, s = [];
	for (let t of e) {
		let e = Yn(r(t)), n = Zn(e), c = null, l = () => (c === null && (c = Array.from(new Set(e.split(qn))).filter((e) => e.length > 0)), c), u = 0, d = 0, f = 0;
		for (let t of i) {
			let { quality: r, index: i } = er(t, e, n, o ? l() : [], o);
			r > 0 && (u += 1, d += r, i >= 0 && (f += 1 / (1 + i / 50)));
		}
		if (a === "and" && u < i.length || a === "or" && u === 0) continue;
		let p = d / i.length, m = Math.min(1, p + f * .05);
		s.push({
			row: t,
			score: m
		});
	}
	return s.sort((e, t) => t.score - e.score), {
		hits: s,
		mode: "client_substring",
		hasQuery: !0
	};
}
function rr(e, t, n = {}) {
	return nr(e, t, n).hits.map((e) => e.row);
}
function ir(e, t, n = {}) {
	return rr(e, t, {
		haystack: (e) => [
			e.label,
			e.value,
			e.description
		].filter(Boolean).join(" "),
		fuzzy: n.fuzzy
	});
}
//#endregion
//#region src/hooks/useTheme.ts
function ar(e = "system") {
	let [t, n] = G(() => typeof window > "u" ? e : localStorage.getItem("theme") || e), [r, i] = G("light");
	return U(() => {
		let e = window.document.documentElement, n = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", r = (t) => {
			let r = t === "system" ? n() : t;
			i(r), e.classList.remove("light", "dark"), e.classList.add(r);
		};
		r(t);
		let a = window.matchMedia("(prefers-color-scheme: dark)"), o = () => {
			t === "system" && r("system");
		};
		return a.addEventListener("change", o), () => a.removeEventListener("change", o);
	}, [t]), {
		theme: t,
		setTheme: H((e) => {
			n(e), localStorage.setItem("theme", e);
		}, []),
		resolvedTheme: r
	};
}
//#endregion
//#region src/hooks/useMediaQuery.ts
function or(e) {
	let t = e in kn ? kn[e] : e, [n, r] = G(() => typeof window > "u" ? !1 : window.matchMedia(t).matches);
	return U(() => {
		let e = window.matchMedia(t), n = (e) => r(e.matches);
		return r(e.matches), e.addEventListener("change", n), () => e.removeEventListener("change", n);
	}, [t]), n;
}
function sr() {
	return !or("md");
}
function cr() {
	let e = or("md"), t = or("lg");
	return e && !t;
}
function lr() {
	return or("lg");
}
function ur() {
	return or("touch");
}
//#endregion
//#region src/hooks/useFocusTrap.ts
function dr(e = !0) {
	let t = W(null), n = W(null);
	U(() => {
		if (!e) return;
		n.current = document.activeElement;
		let r = t.current;
		if (!r) return;
		let i = Hn(r);
		return i.length > 0 && i[0].focus(), () => {
			n.current instanceof HTMLElement && n.current.focus();
		};
	}, [e]);
	let r = H((n) => {
		if (!e || n.key !== "Tab") return;
		let r = t.current;
		if (!r) return;
		let i = Hn(r);
		if (i.length === 0) return;
		let a = i[0], o = i[i.length - 1];
		n.shiftKey && document.activeElement === a ? (n.preventDefault(), o?.focus()) : !n.shiftKey && document.activeElement === o && (n.preventDefault(), a?.focus());
	}, [e]);
	return U(() => {
		if (e) return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
	}, [e, r]), t;
}
//#endregion
//#region src/hooks/useReducedMotion.ts
function fr() {
	let [e, t] = G(() => typeof window > "u" ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches);
	return U(() => {
		let e = window.matchMedia("(prefers-reduced-motion: reduce)"), n = (e) => t(e.matches);
		return e.addEventListener("change", n), () => e.removeEventListener("change", n);
	}, []), e;
}
//#endregion
//#region src/hooks/useGACRelay.ts
function pr() {
	try {
		return {
			BASE_URL: "/",
			DEV: !1,
			MODE: "production",
			PROD: !0,
			SSR: !1,
			VITE_ADMIN_DASHBOARD_URL: "https://admin.agion.dev",
			VITE_API_BASE_URL: "https://api.agion.dev",
			VITE_API_URL: "https://api.agion.dev",
			VITE_APP_NAME: "Agion",
			VITE_APP_VERSION: "2.4.0",
			VITE_AUTH_AUTHORITY: "https://auth.agion.dev",
			VITE_AUTH_DOMAIN: "auth.agion.dev",
			VITE_AUTH_SERVICE_URL: "https://auth.agion.dev",
			VITE_DEBUG_MODE: "false",
			VITE_ENVIRONMENT: "production",
			VITE_LOGIN_DOMAIN: "login.agion.dev",
			VITE_OIDC_ISSUER: "https://auth.agion.dev",
			VITE_REDIRECT_URI: "https://login.agion.dev/callback",
			VITE_UNIFIED_GATEWAY_URL: "https://api.agion.dev",
			VITE_WEBSOCKET_URL: "wss://api.agion.dev/ws"
		}.VITE_AGION_RELAY_URL ?? "http://10.135.207.164:8080/mcp";
	} catch {
		return "http://10.135.207.164:8080/mcp";
	}
}
var mr = pr();
function hr(e = {}) {
	let { relayUrl: t = mr, autoConnect: n = !0 } = e, [r, i] = G(!1), [a, o] = G(null), [s, c] = G(null), l = W(0), u = W(null), d = W(null);
	U(() => {
		d.current = a;
	}, [a]);
	let f = H(async (e) => {
		l.current = 0;
		let n = ++l.current;
		try {
			let r = await fetch(t, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					jsonrpc: "2.0",
					id: n,
					method: "initialize",
					params: {
						protocolVersion: "2024-11-05",
						capabilities: {},
						clientInfo: {
							name: "agion-dashboard",
							version: "1.0.0"
						}
					}
				}),
				signal: e
			}), a = r.headers.get("mcp-session-id"), s = await r.json();
			if (s.error) throw Error(s.error.message || "MCP initialization failed");
			return o(a), d.current = a, i(!0), c(null), a;
		} catch (e) {
			if (e.name === "AbortError") return null;
			let t = e instanceof Error ? e : Error(String(e));
			return c(t), i(!1), o(null), d.current = null, null;
		}
	}, [t]), p = H(async (e, n) => {
		let r = d.current;
		if (!r) throw Error("No active MCP session");
		let a = ++l.current, s = await fetch(t, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Mcp-Session-Id": r
			},
			body: JSON.stringify({
				jsonrpc: "2.0",
				id: a,
				method: "tools/call",
				params: {
					name: e,
					arguments: n
				}
			})
		});
		if (s.status === 404) throw i(!1), o(null), d.current = null, await f(), Error("Session expired, re-initialized");
		let c = await s.json();
		if (c.error) throw Error(c.error.message || `Tool call failed: ${e}`);
		return c;
	}, [t, f]), m = H(async () => {
		i(!1), o(null), c(null), d.current = null, await f();
	}, [f]);
	return U(() => {
		if (!n) return;
		let e = new AbortController();
		return u.current = e, f(e.signal), () => {
			e.abort(), u.current = null;
		};
	}, [n, f]), {
		isConnected: r,
		sessionId: a,
		error: s,
		callTool: p,
		reconnect: m
	};
}
//#endregion
//#region src/components/organisms/WorkflowDAG/planParser.ts
function gr(e) {
	if (!e || e.trim().length === 0) return [];
	let t = [], n = e.split("\n"), r = [];
	for (let e = 0; e < n.length; e++) {
		let i = n[e].trim();
		if (i.startsWith("@") && !i.startsWith("@affects") && !i.startsWith("@creates")) r.push(i);
		else if (i.startsWith("Scenario:") && r.some((e) => e.includes("@wp"))) {
			let e = r.join(" "), n = e.match(/@(WP-\d+[TI])/);
			if (!n) {
				r = [];
				continue;
			}
			let a = n[1], o = i.match(/Scenario:\s*(?:WP-\d+[TI]\s*-\s*)?(.+)/)?.[1]?.trim() ?? i.replace("Scenario:", "").trim(), s = "impl";
			e.includes("@type-test") ? s = "test" : e.includes("@type-impl") ? s = "impl" : a.endsWith("T") && (s = "test");
			let c = e.match(/@phase-(\d+)/), l = c ? parseInt(c[1], 10) : 1, u = e.match(/@depends-on-([\w,-]+)/), d = [];
			if (u) {
				let e = u[1].split(",").map((e) => e.trim());
				for (let t of e) {
					let e = t.startsWith("WP-") ? t : `WP-${t}`;
					d.push(e);
				}
			}
			t.push({
				id: a,
				title: o,
				type: s,
				status: "pending",
				phase: l,
				wave: 0,
				dependsOn: d
			}), r = [];
		} else i.startsWith("@") || (r = []);
	}
	return _r(t), t;
}
function _r(e) {
	let t = new Map(e.map((e) => [e.id, e])), n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
	function a(e) {
		if (n.has(e)) return n.get(e);
		if (i.has(e)) return 0;
		i.add(e);
		let o = t.get(e);
		if (!o) return 0;
		let s = -1;
		for (let e of o.dependsOn) if (t.has(e)) {
			let t = a(e);
			s = Math.max(s, t);
		}
		let c = s + 1;
		return n.set(e, c), i.delete(e), r.add(e), c;
	}
	for (let t of e) a(t.id);
	for (let t of e) t.wave = n.get(t.id) ?? 0;
}
function vr(e, t) {
	let n = new Map(t.work_packages.map((e) => [e.id, e]));
	return e.map((e) => {
		let t = n.get(e.id);
		return t ? {
			...e,
			status: yr(t.status),
			wave: t.wave ?? e.wave,
			startedAt: t.started_at,
			completedAt: t.completed_at,
			error: t.error
		} : e;
	});
}
function yr(e) {
	let t = e.toLowerCase().replace(/[-\s]/g, "_");
	return [
		"pending",
		"in_progress",
		"completed",
		"blocked",
		"failed"
	].includes(t) ? t : "pending";
}
function br(e) {
	if (e.length === 0) return {
		totalWaves: 0,
		parallelismFactor: 0,
		criticalPath: []
	};
	let t = e.map((e) => ({ ...e }));
	_r(t);
	let n = Math.max(...t.map((e) => e.wave)) + 1, r = /* @__PURE__ */ new Map();
	for (let e of t) r.set(e.wave, (r.get(e.wave) ?? 0) + 1);
	return {
		totalWaves: n,
		parallelismFactor: Math.max(...Array.from(r.values())),
		criticalPath: xr(t)
	};
}
function xr(e) {
	let t = new Map(e.map((e) => [e.id, e])), n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set();
	function i(e) {
		if (n.has(e)) return n.get(e);
		if (r.has(e)) return [e];
		r.add(e);
		let a = t.get(e);
		if (!a) return [];
		let o = [];
		for (let e of a.dependsOn) if (t.has(e)) {
			let t = i(e);
			t.length > o.length && (o = t);
		}
		let s = [...o, e];
		return n.set(e, s), r.delete(e), s;
	}
	let a = [];
	for (let t of e) {
		let e = i(t.id);
		e.length > a.length && (a = e);
	}
	return a;
}
function Sr(e, t) {
	let n = gr(e), r;
	if (t) {
		n = vr(n, t);
		let e = br(n);
		r = {
			planId: t.plan_id,
			currentPhase: t.current_phase,
			phases: [],
			dag: e
		};
	}
	return {
		workPackages: n,
		pipelineState: r
	};
}
//#endregion
//#region src/hooks/useGACPipelineState.ts
var Cr = 2e3;
function wr(e, t) {
	switch (t.type) {
		case "SET_NODES": return {
			...e,
			nodes: t.nodes,
			error: null
		};
		case "SET_LIVE_STATE": return {
			...e,
			nodes: t.nodes,
			pipelineState: t.pipelineState,
			error: null
		};
		case "SET_ERROR": return {
			...e,
			error: t.error
		};
		case "CLEAR_ERROR": return {
			...e,
			error: null
		};
		default: return e;
	}
}
function Tr(e = {}) {
	let { planPath: t, planContent: n, pollInterval: r = 3e3, autoStart: i = !0, relayUrl: a } = e, o = Math.max(r, Cr), { isConnected: s, callTool: c } = hr({
		relayUrl: a,
		autoConnect: !0
	}), [l, u] = Rn(wr, {
		nodes: [],
		pipelineState: void 0,
		error: null
	}), [d, f] = G(i), p = W(!1), m = W(null), h = W(!document.hidden), g = W([]);
	U(() => {
		if (n) {
			let e = gr(n);
			g.current = e, u({
				type: "SET_NODES",
				nodes: e
			});
		}
	}, [n]);
	let _ = W("");
	U(() => {
		if (t) {
			let e = t.match(/P-(\d+)/);
			_.current = e ? `P-${e[1]}` : t;
		} else if (n) {
			let e = n.match(/@(P-\d+)/);
			_.current = e?.[1] ?? "";
		}
	}, [t, n]);
	let v = W([]);
	U(() => {
		v.current = l.nodes;
	}, [l.nodes]);
	let y = W(c);
	U(() => {
		y.current = c;
	}, [c]);
	let b = H(async () => {
		if (!p.current && s) {
			p.current = !0;
			try {
				let e = await y.current("gac/agent/loop/status", { plan_id: _.current });
				if (e.result) {
					let t = vr(g.current.length > 0 ? g.current : v.current, e.result), n = {
						planId: e.result.plan_id,
						currentPhase: e.result.current_phase,
						phases: []
					};
					u({
						type: "SET_LIVE_STATE",
						nodes: t,
						pipelineState: n
					});
				}
				u({ type: "CLEAR_ERROR" });
			} catch (e) {
				let t = e instanceof Error ? e : Error(String(e));
				u({
					type: "SET_ERROR",
					error: t
				});
			} finally {
				p.current = !1;
			}
		}
	}, [s]), x = H(async () => {
		p.current = !1, await b();
	}, [b]), S = H(() => f(!0), []), C = H(() => f(!1), []);
	return U(() => {
		let e = () => {
			h.current = !document.hidden;
		};
		return document.addEventListener("visibilitychange", e), () => document.removeEventListener("visibilitychange", e);
	}, []), U(() => {
		if (!d || !s) m.current &&= (clearInterval(m.current), null);
		else return b(), m.current = setInterval(() => {
			h.current && b();
		}, o), () => {
			m.current &&= (clearInterval(m.current), null);
		};
	}, [
		d,
		s,
		o,
		b
	]), {
		nodes: l.nodes,
		pipelineState: l.pipelineState,
		isConnected: s,
		isPolling: d,
		error: l.error,
		refresh: x,
		startPolling: S,
		stopPolling: C
	};
}
//#endregion
//#region ../node_modules/.pnpm/lucide-react@1.55.0_@types+react@19.3.0_react@19.3.0/node_modules/lucide-react/dist/esm/icons/arrow-left-right.mjs
var Er = {
	name: "arrow-left-right",
	size: 24,
	node: [
		["path", {
			d: "M8 3 4 7l4 4",
			key: "9rb6wj"
		}],
		["path", {
			d: "M4 7h16",
			key: "6tx8e3"
		}],
		["path", {
			d: "m16 21 4-4-4-4",
			key: "siv7j2"
		}],
		["path", {
			d: "M20 17H4",
			key: "h6l3hr"
		}]
	]
};
Er.node;
var Dr = z(Er), Or = {
	name: "at-sign",
	size: 24,
	node: [["circle", {
		cx: "12",
		cy: "12",
		r: "4",
		key: "4exip2"
	}], ["path", {
		d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8",
		key: "7n84p3"
	}]]
};
Or.node;
var kr = z(Or), Ar = {
	name: "bot",
	size: 24,
	node: [
		["path", {
			d: "M12 8V4H8",
			key: "hb8ula"
		}],
		["rect", {
			width: "16",
			height: "12",
			x: "4",
			y: "8",
			rx: "2",
			key: "enze0r"
		}],
		["path", {
			d: "M2 14h2",
			key: "vft8re"
		}],
		["path", {
			d: "M20 14h2",
			key: "4cs60a"
		}],
		["path", {
			d: "M15 13v2",
			key: "1xurst"
		}],
		["path", {
			d: "M9 13v2",
			key: "rq6x2g"
		}]
	]
};
Ar.node;
var jr = z(Ar), Mr = {
	name: "brain",
	size: 24,
	node: [
		["path", {
			d: "M12 18V5",
			key: "adv99a"
		}],
		["path", {
			d: "M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4",
			key: "1e3is1"
		}],
		["path", {
			d: "M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5",
			key: "1gqd8o"
		}],
		["path", {
			d: "M17.997 5.125a4 4 0 0 1 2.526 5.77",
			key: "iwvgf7"
		}],
		["path", {
			d: "M18 18a4 4 0 0 0 2-7.464",
			key: "efp6ie"
		}],
		["path", {
			d: "M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517",
			key: "1gq6am"
		}],
		["path", {
			d: "M6 18a4 4 0 0 1-2-7.464",
			key: "k1g0md"
		}],
		["path", {
			d: "M6.003 5.125a4 4 0 0 0-2.526 5.77",
			key: "q97ue3"
		}]
	]
};
Mr.node;
var Nr = z(Mr), Pr = {
	name: "building-complex",
	size: 24,
	node: [
		["path", {
			d: "M10 12h4",
			key: "a56b0p"
		}],
		["path", {
			d: "M10 8h4",
			key: "1sr2af"
		}],
		["path", {
			d: "M14 21v-3a2 2 0 0 0-4 0v3",
			key: "1rgiei"
		}],
		["path", {
			d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
			key: "secmi2"
		}],
		["path", {
			d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16",
			key: "16ra0t"
		}]
	],
	aliases: ["building-2"]
};
Pr.node;
var Fr = z(Pr), Ir = {
	name: "captions",
	size: 24,
	node: [["rect", {
		width: "18",
		height: "14",
		x: "3",
		y: "5",
		rx: "2",
		ry: "2",
		key: "12ruh7"
	}], ["path", {
		d: "M7 15h4M15 15h2M7 11h2M13 11h4",
		key: "1ueiar"
	}]],
	aliases: ["subtitles"]
};
Ir.node;
var Lr = z(Ir), Rr = {
	name: "chevrons-up-down",
	size: 24,
	node: [["path", {
		d: "m7 15 5 5 5-5",
		key: "1hf1tw"
	}], ["path", {
		d: "m7 9 5-5 5 5",
		key: "sgt6xg"
	}]]
};
Rr.node;
var zr = z(Rr), Br = {
	name: "circle-stop",
	size: 24,
	node: [["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}], ["rect", {
		x: "9",
		y: "9",
		width: "6",
		height: "6",
		rx: "1",
		key: "1ssd4o"
	}]],
	aliases: ["stop-circle"]
};
Br.node;
var Vr = z(Br), Hr = {
	name: "circle-x",
	size: 24,
	node: [
		["circle", {
			cx: "12",
			cy: "12",
			r: "10",
			key: "1mglay"
		}],
		["path", {
			d: "m15 9-6 6",
			key: "1uzhvr"
		}],
		["path", {
			d: "m9 9 6 6",
			key: "z0biqf"
		}]
	],
	aliases: ["x-circle"]
};
Hr.node;
var Ur = z(Hr), Wr = {
	name: "clock",
	size: 24,
	node: [["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}], ["path", {
		d: "M12 6v6l4 2",
		key: "mmk7yg"
	}]]
};
Wr.node;
var Gr = z(Wr), Kr = {
	name: "code-xml",
	size: 24,
	node: [
		["path", {
			d: "m18 16 4-4-4-4",
			key: "1inbqp"
		}],
		["path", {
			d: "m6 8-4 4 4 4",
			key: "15zrgr"
		}],
		["path", {
			d: "m14.5 4-5 16",
			key: "e7oirm"
		}]
	],
	aliases: ["code-2"]
};
Kr.node;
var qr = z(Kr), Jr = {
	name: "cog",
	size: 24,
	node: [
		["path", {
			d: "M11 10.27 7 3.34",
			key: "16pf9h"
		}],
		["path", {
			d: "m11 13.73-4 6.93",
			key: "794ttg"
		}],
		["path", {
			d: "M12 22v-2",
			key: "1osdcq"
		}],
		["path", {
			d: "M12 2v2",
			key: "tus03m"
		}],
		["path", {
			d: "M14 12h8",
			key: "4f43i9"
		}],
		["path", {
			d: "m17 20.66-1-1.73",
			key: "eq3orb"
		}],
		["path", {
			d: "m17 3.34-1 1.73",
			key: "2wel8s"
		}],
		["path", {
			d: "M2 12h2",
			key: "1t8f8n"
		}],
		["path", {
			d: "m20.66 17-1.73-1",
			key: "sg0v6f"
		}],
		["path", {
			d: "m20.66 7-1.73 1",
			key: "1ow05n"
		}],
		["path", {
			d: "m3.34 17 1.73-1",
			key: "nuk764"
		}],
		["path", {
			d: "m3.34 7 1.73 1",
			key: "1ulond"
		}],
		["circle", {
			cx: "12",
			cy: "12",
			r: "2",
			key: "1c9p78"
		}],
		["circle", {
			cx: "12",
			cy: "12",
			r: "8",
			key: "46899m"
		}]
	]
};
Jr.node;
var Yr = z(Jr), Xr = {
	name: "cpu",
	size: 24,
	node: [
		["path", {
			d: "M12 20v2",
			key: "1lh1kg"
		}],
		["path", {
			d: "M12 2v2",
			key: "tus03m"
		}],
		["path", {
			d: "M17 20v2",
			key: "1rnc9c"
		}],
		["path", {
			d: "M17 2v2",
			key: "11trls"
		}],
		["path", {
			d: "M2 12h2",
			key: "1t8f8n"
		}],
		["path", {
			d: "M2 17h2",
			key: "7oei6x"
		}],
		["path", {
			d: "M2 7h2",
			key: "asdhe0"
		}],
		["path", {
			d: "M20 12h2",
			key: "1q8mjw"
		}],
		["path", {
			d: "M20 17h2",
			key: "1fpfkl"
		}],
		["path", {
			d: "M20 7h2",
			key: "1o8tra"
		}],
		["path", {
			d: "M7 20v2",
			key: "4gnj0m"
		}],
		["path", {
			d: "M7 2v2",
			key: "1i4yhu"
		}],
		["rect", {
			x: "4",
			y: "4",
			width: "16",
			height: "16",
			rx: "2",
			key: "1vbyd7"
		}],
		["rect", {
			x: "8",
			y: "8",
			width: "8",
			height: "8",
			rx: "1",
			key: "z9xiuo"
		}]
	]
};
Xr.node;
var Zr = z(Xr), Qr = {
	name: "crown",
	size: 24,
	node: [["path", {
		d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
		key: "1vdc57"
	}], ["path", {
		d: "M5 21h14",
		key: "11awu3"
	}]]
};
Qr.node;
var $r = z(Qr), ei = {
	name: "download",
	size: 24,
	node: [
		["path", {
			d: "M12 15V3",
			key: "m9g1x1"
		}],
		["path", {
			d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
			key: "ih7n3h"
		}],
		["path", {
			d: "m7 10 5 5 5-5",
			key: "brsn70"
		}]
	]
};
ei.node;
var ti = z(ei), ni = {
	name: "external-link",
	size: 24,
	node: [
		["path", {
			d: "M15 3h6v6",
			key: "1q9fwt"
		}],
		["path", {
			d: "M10 14 21 3",
			key: "gplh6r"
		}],
		["path", {
			d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
			key: "a6xqqp"
		}]
	]
};
ni.node;
var ri = z(ni), ii = {
	name: "eye-off",
	size: 24,
	node: [
		["path", {
			d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
			key: "ct8e1f"
		}],
		["path", {
			d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
			key: "151rxh"
		}],
		["path", {
			d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
			key: "13bj9a"
		}],
		["path", {
			d: "m2 2 20 20",
			key: "1ooewy"
		}]
	]
};
ii.node;
var ai = z(ii), oi = {
	name: "file-code",
	size: 24,
	node: [
		["path", {
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
			key: "1oefj6"
		}],
		["path", {
			d: "M14 2v5a1 1 0 0 0 1 1h5",
			key: "wfsgrz"
		}],
		["path", {
			d: "M10 12.5 8 15l2 2.5",
			key: "1tg20x"
		}],
		["path", {
			d: "m14 12.5 2 2.5-2 2.5",
			key: "yinavb"
		}]
	]
};
oi.node;
var si = z(oi), ci = {
	name: "file-image",
	size: 24,
	node: [
		["path", {
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
			key: "1oefj6"
		}],
		["path", {
			d: "M14 2v5a1 1 0 0 0 1 1h5",
			key: "wfsgrz"
		}],
		["circle", {
			cx: "10",
			cy: "12",
			r: "2",
			key: "737tya"
		}],
		["path", {
			d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22",
			key: "wt3hpn"
		}]
	]
};
ci.node;
var li = z(ci), ui = {
	name: "file-pen",
	size: 24,
	node: [
		["path", {
			d: "M12.659 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v9.34",
			key: "o6klzx"
		}],
		["path", {
			d: "M14 2v5a1 1 0 0 0 1 1h5",
			key: "wfsgrz"
		}],
		["path", {
			d: "M10.378 12.622a1 1 0 0 1 3 3.003L8.36 20.637a2 2 0 0 1-.854.506l-2.867.837a.5.5 0 0 1-.62-.62l.836-2.869a2 2 0 0 1 .506-.853z",
			key: "zhnas1"
		}]
	],
	aliases: ["file-edit"]
};
ui.node;
var di = z(ui), fi = {
	name: "file-spreadsheet",
	size: 24,
	node: [
		["path", {
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
			key: "1oefj6"
		}],
		["path", {
			d: "M14 2v5a1 1 0 0 0 1 1h5",
			key: "wfsgrz"
		}],
		["path", {
			d: "M8 13h2",
			key: "yr2amv"
		}],
		["path", {
			d: "M14 13h2",
			key: "un5t4a"
		}],
		["path", {
			d: "M8 17h2",
			key: "2yhykz"
		}],
		["path", {
			d: "M14 17h2",
			key: "10kma7"
		}]
	]
};
fi.node;
var pi = z(fi), mi = {
	name: "file-text",
	size: 24,
	node: [
		["path", {
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
			key: "1oefj6"
		}],
		["path", {
			d: "M14 2v5a1 1 0 0 0 1 1h5",
			key: "wfsgrz"
		}],
		["path", {
			d: "M10 9H8",
			key: "b1mrlr"
		}],
		["path", {
			d: "M16 13H8",
			key: "t4e002"
		}],
		["path", {
			d: "M16 17H8",
			key: "z1uh3a"
		}]
	]
};
mi.node;
var hi = z(mi), gi = {
	name: "file",
	size: 24,
	node: [["path", {
		d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		key: "1oefj6"
	}], ["path", {
		d: "M14 2v5a1 1 0 0 0 1 1h5",
		key: "wfsgrz"
	}]]
};
gi.node;
var _i = z(gi), vi = {
	name: "flask-conical",
	size: 24,
	node: [
		["path", {
			d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
			key: "18mbvz"
		}],
		["path", {
			d: "M6.453 15h11.094",
			key: "3shlmq"
		}],
		["path", {
			d: "M8.5 2h7",
			key: "csnxdl"
		}]
	]
};
vi.node;
var yi = z(vi), bi = {
	name: "git-branch",
	size: 24,
	node: [
		["path", {
			d: "M15 6a9 9 0 0 0-9 9V3",
			key: "1cii5b"
		}],
		["circle", {
			cx: "18",
			cy: "6",
			r: "3",
			key: "1h7g24"
		}],
		["circle", {
			cx: "6",
			cy: "18",
			r: "3",
			key: "fqmcym"
		}]
	]
};
bi.node;
var xi = z(bi), Si = {
	name: "hash",
	size: 24,
	node: [
		["line", {
			x1: "4",
			x2: "20",
			y1: "9",
			y2: "9",
			key: "4lhtct"
		}],
		["line", {
			x1: "4",
			x2: "20",
			y1: "15",
			y2: "15",
			key: "vyu0kd"
		}],
		["line", {
			x1: "10",
			x2: "8",
			y1: "3",
			y2: "21",
			key: "1ggp8o"
		}],
		["line", {
			x1: "16",
			x2: "14",
			y1: "3",
			y2: "21",
			key: "weycgp"
		}]
	]
};
Si.node;
var Ci = z(Si), wi = {
	name: "message-circle",
	size: 24,
	node: [["path", {
		d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		key: "1sd12s"
	}]]
};
wi.node;
var Ti = z(wi), Ei = {
	name: "mic-off",
	size: 24,
	node: [
		["path", {
			d: "M12 19v3",
			key: "npa21l"
		}],
		["path", {
			d: "M15 9.34V5a3 3 0 0 0-5.68-1.33",
			key: "1gzdoj"
		}],
		["path", {
			d: "M16.95 16.95A7 7 0 0 1 5 12v-2",
			key: "cqa7eg"
		}],
		["path", {
			d: "M18.89 13.23A7 7 0 0 0 19 12v-2",
			key: "16hl24"
		}],
		["path", {
			d: "m2 2 20 20",
			key: "1ooewy"
		}],
		["path", {
			d: "M9 9v3a3 3 0 0 0 5.12 2.12",
			key: "r2i35w"
		}]
	]
};
Ei.node;
var Di = z(Ei), Oi = {
	name: "mic",
	size: 24,
	node: [
		["path", {
			d: "M12 19v3",
			key: "npa21l"
		}],
		["path", {
			d: "M19 10v2a7 7 0 0 1-14 0v-2",
			key: "1vc78b"
		}],
		["rect", {
			x: "9",
			y: "2",
			width: "6",
			height: "13",
			rx: "3",
			key: "s6n7sd"
		}]
	]
};
Oi.node;
var ki = z(Oi), Ai = {
	name: "minus",
	size: 24,
	node: [["path", {
		d: "M5 12h14",
		key: "1ays0h"
	}]]
};
Ai.node;
var ji = z(Ai), Mi = {
	name: "paperclip",
	size: 24,
	node: [["path", {
		d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
		key: "1miecu"
	}]]
};
Mi.node;
var Ni = z(Mi), Pi = {
	name: "pause",
	size: 24,
	node: [["rect", {
		x: "14",
		y: "3",
		width: "5",
		height: "18",
		rx: "1",
		key: "kaeet6"
	}], ["rect", {
		x: "5",
		y: "3",
		width: "5",
		height: "18",
		rx: "1",
		key: "1wsw3u"
	}]]
};
Pi.node;
var Fi = z(Pi), Ii = {
	name: "phone-off",
	size: 24,
	node: [
		["path", {
			d: "M10.1 13.9a14 14 0 0 0 3.732 2.668 1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2 18 18 0 0 1-12.728-5.272",
			key: "1wngk7"
		}],
		["path", {
			d: "M22 2 2 22",
			key: "y4kqgn"
		}],
		["path", {
			d: "M4.76 13.582A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 .244.473",
			key: "10hv5p"
		}]
	]
};
Ii.node;
var Li = z(Ii), Ri = {
	name: "phone",
	size: 24,
	node: [["path", {
		d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
		key: "9njp5v"
	}]]
};
Ri.node;
var zi = z(Ri), Bi = {
	name: "play",
	size: 24,
	node: [["path", {
		d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
		key: "10ikf1"
	}]]
};
Bi.node;
var Vi = z(Bi), Hi = {
	name: "plus",
	size: 24,
	node: [["path", {
		d: "M5 12h14",
		key: "1ays0h"
	}], ["path", {
		d: "M12 5v14",
		key: "s699le"
	}]]
};
Hi.node;
var Ui = z(Hi), Wi = {
	name: "refresh-cw",
	size: 24,
	node: [
		["path", {
			d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
			key: "v9h5vc"
		}],
		["path", {
			d: "M21 3v5h-5",
			key: "1q7to0"
		}],
		["path", {
			d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
			key: "3uifl3"
		}],
		["path", {
			d: "M8 16H3v5",
			key: "1cv678"
		}]
	]
};
Wi.node;
var Gi = z(Wi), Ki = {
	name: "rotate-ccw",
	size: 24,
	node: [["path", {
		d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
		key: "1357e3"
	}], ["path", {
		d: "M3 3v5h5",
		key: "1xhq8a"
	}]]
};
Ki.node;
var qi = z(Ki), Ji = {
	name: "scale",
	size: 24,
	node: [
		["path", {
			d: "M12 3v18",
			key: "108xh3"
		}],
		["path", {
			d: "m19 8 3 8a5 5 0 0 1-6 0zV7",
			key: "zcdpyk"
		}],
		["path", {
			d: "M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1",
			key: "1yorad"
		}],
		["path", {
			d: "m5 8 3 8a5 5 0 0 1-6 0zV7",
			key: "eua70x"
		}],
		["path", {
			d: "M7 21h10",
			key: "1b0cd5"
		}]
	]
};
Ji.node;
var Yi = z(Ji), Xi = {
	name: "send",
	size: 24,
	node: [["path", {
		d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
		key: "1ffxy3"
	}], ["path", {
		d: "m21.854 2.147-10.94 10.939",
		key: "12cjpa"
	}]]
};
Xi.node;
var Zi = z(Xi), Qi = {
	name: "shield",
	size: 24,
	node: [["path", {
		d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		key: "oel41y"
	}]]
};
Qi.node;
var $i = z(Qi), ea = {
	name: "square",
	size: 24,
	node: [["rect", {
		width: "18",
		height: "18",
		x: "3",
		y: "3",
		rx: "2",
		key: "afitv7"
	}]]
};
ea.node;
var ta = z(ea), na = {
	name: "target",
	size: 24,
	node: [
		["circle", {
			cx: "12",
			cy: "12",
			r: "10",
			key: "1mglay"
		}],
		["circle", {
			cx: "12",
			cy: "12",
			r: "6",
			key: "1vlfrh"
		}],
		["circle", {
			cx: "12",
			cy: "12",
			r: "2",
			key: "1c9p78"
		}]
	]
};
na.node;
var ra = z(na), ia = {
	name: "thumbs-up",
	size: 24,
	node: [["path", {
		d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
		key: "emmmcr"
	}], ["path", {
		d: "M7 10v12",
		key: "1qc93n"
	}]]
};
ia.node;
var aa = z(ia), oa = {
	name: "thumbs-down",
	size: 24,
	node: [["path", {
		d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
		key: "m61m77"
	}], ["path", {
		d: "M17 14V2",
		key: "8ymqnk"
	}]]
};
oa.node;
var sa = z(oa), ca = {
	name: "trending-down",
	size: 24,
	node: [["path", {
		d: "M16 17h6v-6",
		key: "t6n2it"
	}], ["path", {
		d: "m22 17-8.5-8.5-5 5L2 7",
		key: "x473p"
	}]]
};
ca.node;
var la = z(ca), ua = {
	name: "trending-up",
	size: 24,
	node: [["path", {
		d: "M16 7h6v6",
		key: "box55l"
	}], ["path", {
		d: "m22 7-8.5 8.5-5-5L2 17",
		key: "1t1m79"
	}]]
};
ua.node;
var da = z(ua), fa = {
	name: "user",
	size: 24,
	node: [["path", {
		d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
		key: "975kel"
	}], ["circle", {
		cx: "12",
		cy: "7",
		r: "4",
		key: "17ys0d"
	}]]
};
fa.node;
var pa = z(fa), ma = {
	name: "volume-2",
	size: 24,
	node: [
		["path", {
			d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
			key: "uqj9uw"
		}],
		["path", {
			d: "M16 9a5 5 0 0 1 0 6",
			key: "1q6k2b"
		}],
		["path", {
			d: "M19.364 18.364a9 9 0 0 0 0-12.728",
			key: "ijwkga"
		}]
	]
};
ma.node;
var ha = z(ma), ga = {
	name: "wifi-off",
	size: 24,
	node: [
		["path", {
			d: "M12 20h.01",
			key: "zekei9"
		}],
		["path", {
			d: "M8.5 16.429a5 5 0 0 1 7 0",
			key: "1bycff"
		}],
		["path", {
			d: "M5 12.859a10 10 0 0 1 5.17-2.69",
			key: "1dl1wf"
		}],
		["path", {
			d: "M19 12.859a10 10 0 0 0-2.007-1.523",
			key: "4k23kn"
		}],
		["path", {
			d: "M2 8.82a15 15 0 0 1 4.177-2.643",
			key: "1grhjp"
		}],
		["path", {
			d: "M22 8.82a15 15 0 0 0-11.288-3.764",
			key: "z3jwby"
		}],
		["path", {
			d: "m2 2 20 20",
			key: "1ooewy"
		}]
	]
};
ga.node;
var _a = z(ga), va = {
	name: "wifi",
	size: 24,
	node: [
		["path", {
			d: "M12 20h.01",
			key: "zekei9"
		}],
		["path", {
			d: "M2 8.82a15 15 0 0 1 20 0",
			key: "dnpr2z"
		}],
		["path", {
			d: "M5 12.859a10 10 0 0 1 14 0",
			key: "1x1e6c"
		}],
		["path", {
			d: "M8.5 16.429a5 5 0 0 1 7 0",
			key: "1bycff"
		}]
	]
};
va.node;
var ya = z(va), ba = {
	name: "wrench",
	size: 24,
	node: [["path", {
		d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
		key: "1ngwbx"
	}]]
};
ba.node;
var xa = z(ba), Sa = {
	name: "zap",
	size: 24,
	node: [["path", {
		d: "M15.914 4a1.5 1.5 0 00-2.474-1.561l-9 9A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l9-9A1.5 1.5 0 0018.5 10h-3.997a.5.5 0 01-.472-.667z",
		key: "1v7up4"
	}]]
};
Sa.node;
var Ca = z(Sa), wa = Object.defineProperty, Ta = (e, t) => wa(e, "name", {
	value: t,
	configurable: !0
}), Ea = "Avatar", [Da, Oa] = se(Ea), ka = {
	Idle: "idle",
	Loading: "loading",
	Loaded: "loaded",
	Error: "error"
}, Aa = [0, () => void 0], [ja, Ma] = Da(Ea), Na = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Ta(function(e, t) {
	let { __scopeAvatar: n, ...r } = e, [i, a] = B.useState(ka.Idle), [o, s] = Ba();
	return /* @__PURE__ */ q(ja, {
		scope: n,
		imageLoadingStatus: i,
		setImageLoadingStatus: a,
		imageCount: o,
		setImageCount: s,
		children: /* @__PURE__ */ q(F.span, {
			...r,
			ref: t
		})
	});
}, "Avatar")), Pa = "AvatarImage", Fa = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Ta(function(e, t) {
	let { __scopeAvatar: n, src: r, onLoadingStatusChange: i, ...a } = e, o = Ma(Pa, n);
	o.setImageCount;
	let s = Ra(r, {
		referrerPolicy: a.referrerPolicy,
		crossOrigin: a.crossOrigin,
		loadingStatus: o.imageLoadingStatus,
		setLoadingStatus: o.setImageLoadingStatus
	}), c = j((e) => {
		i?.(e);
	}), l = B.useRef(s);
	return S(() => {
		let e = l.current;
		l.current = s, s !== e && c(s);
	}, [s, c]), s === ka.Loaded ? /* @__PURE__ */ q(F.img, {
		...a,
		ref: t,
		src: r
	}) : null;
}, "AvatarImage")), Ia = "AvatarFallback", La = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Ta(function(e, t) {
	let { __scopeAvatar: n, delayMs: r, ...i } = e, a = Ma(Ia, n), [o, s] = B.useState(r === void 0);
	return B.useEffect(() => {
		if (r !== void 0) {
			let e = window.setTimeout(() => s(!0), r);
			return () => window.clearTimeout(e);
		}
	}, [r]), o && a.imageLoadingStatus !== ka.Loaded ? /* @__PURE__ */ q(F.span, {
		...i,
		ref: t
	}) : null;
}, "AvatarFallback"));
function Ra(e, { loadingStatus: t, setLoadingStatus: n, referrerPolicy: r, crossOrigin: i }) {
	return S(() => {
		if (!e) {
			n(ka.Error);
			return;
		}
		let t = new window.Image(), a = /* @__PURE__ */ Ta((e) => {
			let t = e.currentTarget;
			n(za(t));
		}, "handleLoad"), o = /* @__PURE__ */ Ta(() => n(ka.Error), "handleError");
		return t.addEventListener("load", a), t.addEventListener("error", o), r && (t.referrerPolicy = r), t.crossOrigin = i ?? null, t.src = e, n(za(t)), () => {
			t.removeEventListener("load", a), t.removeEventListener("error", o), n(ka.Idle);
		};
	}, [
		e,
		i,
		r,
		n
	]), t;
}
Ta(Ra, "useImageLoadingStatus");
function za(e) {
	return e.complete ? e.naturalWidth > 0 ? ka.Loaded : ka.Error : ka.Loading;
}
Ta(za, "getImageLoadingStatus");
function Ba() {
	return Aa;
}
Ta(Ba, "useImageCount");
function Va(e) {}
Ta(Va, "useUpdateImageCount");
//#endregion
//#region src/components/atoms/Avatar/Avatar.tsx
var Ha = {
	sm: "h-8 w-8 text-xs",
	md: "h-10 w-10 text-sm",
	lg: "h-12 w-12 text-base",
	xl: "h-16 w-16 text-lg"
}, Ua = V(({ className: e, src: t, alt: n, fallback: r, size: i = "md" }, a) => /* @__PURE__ */ J(Na, {
	ref: a,
	className: I("relative flex shrink-0 overflow-hidden rounded-full", Ha[i], e),
	children: [/* @__PURE__ */ q(Fa, {
		src: t,
		alt: n,
		className: "aspect-square h-full w-full object-cover"
	}), /* @__PURE__ */ q(La, {
		className: I("flex h-full w-full items-center justify-center rounded-full", "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 font-medium"),
		children: r || n?.charAt(0).toUpperCase() || "?"
	})]
}));
Ua.displayName = "Avatar";
//#endregion
//#region src/components/atoms/Avatar/avatar-utils.ts
var Wa = [
	"bg-red-200 text-red-800",
	"bg-orange-200 text-orange-800",
	"bg-amber-200 text-amber-800",
	"bg-yellow-200 text-yellow-800",
	"bg-lime-200 text-lime-800",
	"bg-green-200 text-green-800",
	"bg-emerald-200 text-emerald-800",
	"bg-teal-200 text-teal-800",
	"bg-cyan-200 text-cyan-800",
	"bg-sky-200 text-sky-800",
	"bg-blue-200 text-blue-800",
	"bg-indigo-200 text-indigo-800",
	"bg-violet-200 text-violet-800",
	"bg-purple-200 text-purple-800",
	"bg-fuchsia-200 text-fuchsia-800",
	"bg-pink-200 text-pink-800",
	"bg-rose-200 text-rose-800"
];
function Ga(e) {
	let t = 0;
	for (let n = 0; n < e.length; n++) t = e.charCodeAt(n) + ((t << 5) - t);
	return Wa[Math.abs(t) % Wa.length] ?? "bg-gray-200 text-gray-800";
}
function Ka(e, t, n) {
	if (e && t) return `${e.charAt(0)}${t.charAt(0)}`.toUpperCase();
	if (n) {
		let e = n.trim().split(/\s+/);
		return e.length >= 2 ? `${e[0]?.charAt(0)}${e[e.length - 1]?.charAt(0)}`.toUpperCase() : n.charAt(0).toUpperCase();
	}
	return e ? e.charAt(0).toUpperCase() : "?";
}
//#endregion
//#region src/components/atoms/Combobox/Combobox.tsx
var qa = V(({ options: e, value: t, onValueChange: n, placeholder: r = "Select option...", searchPlaceholder: i = "Search...", emptyText: a = "No results found.", className: o, triggerClassName: s, disabled: c = !1 }, l) => {
	let [u, d] = G(!1), [f, p] = G(""), m = W(null), h = Ln(() => ir(e, f), [e, f]), g = Ln(() => {
		let e = [], t = /* @__PURE__ */ new Map();
		for (let n of h) if (!n.group) e.push(n);
		else {
			let e = t.get(n.group) ?? [];
			e.push(n), t.set(n.group, e);
		}
		return [{
			label: void 0,
			options: e
		}, ...Array.from(t, ([e, t]) => ({
			label: e,
			options: t
		}))];
	}, [h]), _ = e.find((e) => e.value === t);
	U(() => {
		u ? setTimeout(() => m.current?.focus(), 0) : p("");
	}, [u]);
	let v = (e) => /* @__PURE__ */ J("div", {
		onClick: () => {
			n(e.value), d(!1);
		},
		className: I("relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none", "hover:bg-surface-hover hover:text-text-primary", t === e.value && "bg-[var(--surface-selected)] text-text-primary"),
		children: [
			/* @__PURE__ */ q(un, { className: I("mr-2 h-4 w-4 shrink-0", t === e.value ? "opacity-100" : "opacity-0") }),
			e.icon && /* @__PURE__ */ q("span", {
				className: "mr-2 inline-flex shrink-0 items-center self-center",
				"data-combobox-icon": "",
				children: e.icon
			}),
			/* @__PURE__ */ J("div", {
				className: "flex min-w-0 flex-1 flex-col",
				children: [/* @__PURE__ */ J("div", {
					className: "flex min-w-0 items-start gap-2",
					children: [/* @__PURE__ */ q("span", {
						className: "min-w-0 flex-1 break-words leading-5",
						children: e.label
					}), e.badge && /* @__PURE__ */ q("span", {
						className: "inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-text-muted",
						children: e.badge
					})]
				}), e.description && /* @__PURE__ */ q("span", {
					className: "break-words text-xs text-muted-foreground",
					children: e.description
				})]
			})
		]
	}, e.value);
	return /* @__PURE__ */ J(en, {
		open: u,
		onOpenChange: d,
		children: [/* @__PURE__ */ q(st, {
			asChild: !0,
			children: /* @__PURE__ */ J(L, {
				ref: l,
				variant: "outline",
				role: "combobox",
				"aria-expanded": u,
				disabled: c,
				className: I("justify-between text-left font-normal", "border-border bg-[color:var(--field-bg)]", !t && "text-muted-foreground", s),
				children: [/* @__PURE__ */ q("span", {
					className: "flex min-w-0 flex-1 items-center gap-2 truncate",
					children: _ ? /* @__PURE__ */ J(K, { children: [
						_.icon && /* @__PURE__ */ q("span", {
							className: "inline-flex shrink-0 items-center",
							"data-combobox-icon": "",
							children: _.icon
						}),
						/* @__PURE__ */ q("span", {
							className: "min-w-0 flex-1 truncate",
							children: _.label
						}),
						_.badge && /* @__PURE__ */ q("span", {
							className: "inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-text-muted",
							children: _.badge
						})
					] }) : r
				}), /* @__PURE__ */ q(zr, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })]
			})
		}), /* @__PURE__ */ J(rn, {
			className: I("w-[var(--radix-popover-trigger-width)] p-0", o),
			align: "start",
			children: [/* @__PURE__ */ J("div", {
				className: "agn-menu-search-field agn-menu-search-inset flex items-center border-b border-border px-3",
				children: [/* @__PURE__ */ q(te, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }), /* @__PURE__ */ q("input", {
					ref: m,
					placeholder: i,
					value: f,
					onChange: (e) => p(e.target.value),
					className: I("agn-field-bare", "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none", "placeholder:text-muted-foreground", "disabled:cursor-not-allowed disabled:opacity-50")
				})]
			}), /* @__PURE__ */ q("div", {
				className: "max-h-[300px] overflow-y-auto p-1",
				children: h.length === 0 ? /* @__PURE__ */ q("div", {
					className: "py-6 text-center text-sm text-muted-foreground",
					children: a
				}) : g.map(({ label: e, options: t }) => e ? /* @__PURE__ */ J("div", {
					role: "group",
					"aria-label": e,
					className: "mt-1 border-t border-border",
					children: [/* @__PURE__ */ q("div", {
						className: "px-2 py-1.5 text-xs font-medium text-muted-foreground",
						children: e
					}), t.map(v)]
				}, `group:${e}`) : /* @__PURE__ */ q(An.Fragment, { children: t.map(v) }, "ungrouped"))
			})]
		})]
	});
});
qa.displayName = "Combobox";
//#endregion
//#region src/components/atoms/Combobox/ComboboxMulti.tsx
var Ja = V(({ options: e, value: t, onValueChange: n, placeholder: r = "Select...", searchPlaceholder: a = "Search...", emptyText: o = "No results found.", className: s, disabled: c = !1, allowCustomValues: l = !1, customInputType: u, customInputMin: d, customInputMax: f, customInputStep: p, "aria-label": m, "aria-labelledby": h }, g) => {
	let [_, v] = G(!1), [y, b] = G(""), x = W(null), S = Fn(), C = Ln(() => new Set(t), [t]), w = Ln(() => ir(e, y), [e, y]), T = H((t) => {
		let n = e.find((e) => e.value === t);
		return n ? n.label : t.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
	}, [e]), E = H((e) => {
		C.has(e) ? n(t.filter((t) => t !== e)) : n([...t, e]);
	}, [
		t,
		C,
		n
	]), D = H((e, r) => {
		r?.stopPropagation(), n(t.filter((t) => t !== e));
	}, [t, n]);
	return U(() => {
		_ ? setTimeout(() => x.current?.focus(), 0) : b("");
	}, [_]), /* @__PURE__ */ J(en, {
		open: _,
		onOpenChange: v,
		children: [/* @__PURE__ */ q(st, {
			asChild: !0,
			disabled: c,
			children: /* @__PURE__ */ J("div", {
				ref: g,
				role: "combobox",
				"aria-expanded": _,
				"aria-controls": S,
				"aria-label": m ?? (h ? void 0 : r),
				"aria-labelledby": h,
				tabIndex: c ? -1 : 0,
				onClick: () => !c && v(!0),
				onKeyDown: (e) => {
					!c && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), v(!0));
				},
				className: I("flex min-h-[36px] w-full cursor-pointer items-center gap-1 rounded-md border px-2 py-1 text-sm", "border-border bg-[color:var(--field-bg)]", "hover:border-border-hover", c && "cursor-not-allowed opacity-50", s),
				children: [/* @__PURE__ */ J("div", {
					className: "flex flex-1 flex-wrap items-center gap-1",
					children: [t.length === 0 && /* @__PURE__ */ q("span", {
						className: "text-muted-foreground",
						children: r
					}), t.map((e) => /* @__PURE__ */ J(i, {
						variant: "secondary",
						className: "gap-0.5 py-0 pl-2 pr-0.5 text-xs leading-5",
						children: [T(e), /* @__PURE__ */ q("button", {
							type: "button",
							onClick: (t) => D(e, t),
							className: I("ml-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full", "hover:bg-surface-active"),
							tabIndex: -1,
							children: /* @__PURE__ */ q(O, { className: "h-3 w-3" })
						})]
					}, e))]
				}), /* @__PURE__ */ q(zr, { className: "h-4 w-4 shrink-0 opacity-50" })]
			})
		}), /* @__PURE__ */ J(rn, {
			id: S,
			className: I("min-w-[240px] w-[var(--radix-popover-trigger-width)] p-0"),
			align: "start",
			onOpenAutoFocus: (e) => e.preventDefault(),
			children: [
				/* @__PURE__ */ J("div", {
					className: "agn-menu-search-field agn-menu-search-inset flex items-center border-b border-border px-3",
					children: [/* @__PURE__ */ q(te, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }), /* @__PURE__ */ q("input", {
						ref: x,
						type: l && u ? u : "text",
						placeholder: l && e.length === 0 ? "Type and press Enter..." : a,
						value: y,
						onChange: (e) => b(e.target.value),
						onKeyDown: (r) => {
							if (r.key === "Backspace" && !y && t.length > 0 && (n(t.slice(0, -1)), r.preventDefault()), r.key === "Enter" && y.trim()) {
								r.preventDefault();
								let i = y.trim(), a = e.find((e) => e.label.toLowerCase() === i.toLowerCase() || e.value === i);
								if (a) {
									E(a.value), b("");
									return;
								}
								l && !C.has(i) && (n([...t, i]), b(""));
							}
						},
						min: d,
						max: f,
						step: p,
						className: I("agn-field-bare", "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none", "placeholder:text-muted-foreground")
					})]
				}),
				e.length > 0 && /* @__PURE__ */ q("div", {
					className: "max-h-[300px] overflow-y-auto p-1",
					children: w.length === 0 ? /* @__PURE__ */ q("div", {
						className: "py-6 text-center text-sm text-muted-foreground",
						children: l && y.trim() ? "Press Enter to add custom value" : o
					}) : w.map((e) => {
						let t = C.has(e.value);
						return /* @__PURE__ */ J("div", {
							onClick: () => {
								E(e.value), b("");
							},
							className: I("relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none", "hover:bg-surface-hover hover:text-text-primary", t && "bg-surface-2"),
							children: [/* @__PURE__ */ q(un, { className: I("mr-2 h-4 w-4 shrink-0", t ? "opacity-100" : "opacity-0") }), /* @__PURE__ */ J("div", {
								className: "flex flex-1 flex-col",
								children: [/* @__PURE__ */ J("div", {
									className: "flex items-center gap-2",
									children: [/* @__PURE__ */ q("span", { children: e.label }), e.badge && /* @__PURE__ */ q("span", {
										className: "inline-flex items-center rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-text-muted",
										children: e.badge
									})]
								}), e.description && /* @__PURE__ */ q("span", {
									className: "text-xs text-muted-foreground",
									children: e.description
								})]
							})]
						}, e.value);
					})
				}),
				l && e.length === 0 && /* @__PURE__ */ q("div", {
					className: "px-3 py-3 text-xs text-muted-foreground",
					children: "Type a value and press Enter to add it"
				})
			]
		})]
	});
});
Ja.displayName = "ComboboxMulti";
//#endregion
//#region src/components/atoms/Combobox/EditableCombobox.tsx
var Ya = V(({ options: e, value: t, onValueChange: n, placeholder: r = "Select or type a value", emptyText: i = "No matching options. Press Enter to keep your custom value.", className: a, id: o, disabled: s = !1 }, c) => {
	let [l, u] = G(!1), [d, f] = G(!1), p = W(null), m = Fn(), [h, g] = G(-1), _ = (e) => {
		e && f(!1), g(-1), u(e);
	}, v = Ln(() => d ? ir(e, t) : e, [
		e,
		t,
		d
	]), y = (e) => {
		f(!1), n(e.value), u(!1), g(-1), p.current?.focus();
	}, b = (e) => {
		if (e.key === "ArrowDown" || e.key === "ArrowUp") {
			if (e.preventDefault(), !l) {
				_(!0);
				return;
			}
			let t = v.length;
			if (t === 0) return;
			let n = e.key === "ArrowDown" ? 1 : -1;
			g((e) => e < 0 ? n === 1 ? 0 : t - 1 : (e + n + t) % t);
		} else if (e.key === "Enter" && l) {
			let t = v[h];
			t && (e.preventDefault(), y(t));
		}
	}, x = (e) => `${m}-option-${e}`, S = l && h >= 0 && h < v.length ? x(h) : void 0;
	return /* @__PURE__ */ q("div", {
		className: I("relative", a),
		children: /* @__PURE__ */ J(en, {
			open: l,
			onOpenChange: _,
			children: [/* @__PURE__ */ q(st, {
				asChild: !0,
				children: /* @__PURE__ */ J("div", {
					className: "relative w-full",
					children: [/* @__PURE__ */ q("input", {
						ref: (e) => {
							p.current = e, typeof c == "function" ? c(e) : c && (c.current = e);
						},
						id: o,
						type: "text",
						role: "combobox",
						"aria-expanded": l,
						"aria-controls": m,
						"aria-activedescendant": S,
						"aria-autocomplete": "list",
						disabled: s,
						value: t,
						onChange: (e) => {
							f(!0), g(-1), n(e.target.value), l || u(!0);
						},
						onKeyDown: b,
						onFocus: () => _(!0),
						placeholder: r,
						className: I("flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 pr-10 text-sm", "placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-400", "disabled:cursor-not-allowed disabled:opacity-50", "dark:border-slate-800 dark:bg-slate-950 dark:placeholder:text-slate-400")
					}), /* @__PURE__ */ q("button", {
						type: "button",
						tabIndex: -1,
						disabled: s,
						onClick: (e) => {
							e.preventDefault(), _(!l), p.current?.focus();
						},
						"aria-label": "Toggle options",
						className: I("absolute right-2 top-1/2 -translate-y-1/2 flex h-6 w-6 items-center justify-center", "rounded text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"),
						children: /* @__PURE__ */ q(zr, { className: "h-4 w-4" })
					})]
				})
			}), /* @__PURE__ */ q(rn, {
				className: "w-[var(--radix-popover-trigger-width)] p-0",
				align: "start",
				onOpenAutoFocus: (e) => e.preventDefault(),
				children: v.length === 0 ? /* @__PURE__ */ q("div", {
					className: "max-h-[300px] overflow-y-auto p-1",
					children: /* @__PURE__ */ q("div", {
						className: "py-6 px-3 text-center text-sm text-slate-500 dark:text-slate-400",
						children: i
					})
				}) : /* @__PURE__ */ q("div", {
					id: m,
					role: "listbox",
					"aria-label": r,
					className: "max-h-[300px] overflow-y-auto p-1",
					children: v.map((e, n) => /* @__PURE__ */ J("div", {
						id: x(n),
						role: "option",
						tabIndex: -1,
						"aria-selected": t === e.value,
						"data-active": n === h ? "true" : void 0,
						onClick: () => y(e),
						className: I("relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none", "hover:bg-slate-100 hover:text-slate-900", "dark:hover:bg-slate-800 dark:hover:text-slate-50", (t === e.value || n === h) && "bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-slate-50"),
						children: [/* @__PURE__ */ q(un, { className: I("mr-2 h-4 w-4", t === e.value ? "opacity-100" : "opacity-0") }), /* @__PURE__ */ J("div", {
							className: "flex flex-col flex-1",
							children: [/* @__PURE__ */ J("div", {
								className: "flex items-center gap-2",
								children: [/* @__PURE__ */ q("span", { children: e.label }), e.badge && /* @__PURE__ */ q("span", {
									className: "inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600 dark:bg-slate-800 dark:text-slate-300",
									children: e.badge
								})]
							}), e.description && /* @__PURE__ */ q("span", {
								className: "text-xs text-slate-500 dark:text-slate-400",
								children: e.description
							})]
						})]
					}, e.value))
				})
			})]
		})
	});
});
Ya.displayName = "EditableCombobox";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-collapsible@1.1.21_@types+react-dom@19.3.0_@types+react@19.3.0__@types+_08f57846484fd2301092c4aac1e1f11f/node_modules/@radix-ui/react-collapsible/dist/index.mjs
var Xa = Object.defineProperty, Za = (e, t) => Xa(e, "name", {
	value: t,
	configurable: !0
}), Qa = "Collapsible", [$a, eo] = se(Qa), [to, no] = $a(Qa), ro = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Za(function(e, t) {
	let { __scopeCollapsible: n, open: r, defaultOpen: i, disabled: a, onOpenChange: o, ...s } = e, [c, l] = Ct({
		prop: r,
		defaultProp: i ?? !1,
		onChange: o,
		caller: Qa
	});
	return /* @__PURE__ */ q(to, {
		scope: n,
		disabled: a,
		contentId: u(),
		open: c,
		onOpenToggle: B.useCallback(() => l((e) => !e), [l]),
		children: /* @__PURE__ */ q(F.div, {
			"data-state": lo(c),
			"data-disabled": a ? "" : void 0,
			...s,
			ref: t
		})
	});
}, "Collapsible")), io = "CollapsibleTrigger", ao = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Za(function(e, t) {
	let { __scopeCollapsible: n, ...r } = e, i = no(io, n);
	return /* @__PURE__ */ q(F.button, {
		type: "button",
		"aria-controls": i.open ? i.contentId : void 0,
		"aria-expanded": i.open || !1,
		"data-state": lo(i.open),
		"data-disabled": i.disabled ? "" : void 0,
		disabled: i.disabled,
		...r,
		ref: t,
		onClick: N(e.onClick, i.onOpenToggle)
	});
}, "CollapsibleTrigger")), oo = "CollapsibleContent", so = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Za(function(e, t) {
	let { forceMount: n, ...r } = e, i = no(oo, e.__scopeCollapsible);
	return /* @__PURE__ */ q(bt, {
		present: n || i.open,
		children: ({ present: e }) => /* @__PURE__ */ q(co, {
			...r,
			ref: t,
			present: e
		})
	});
}, "CollapsibleContent")), co = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Za(function(e, t) {
	let { __scopeCollapsible: n, present: r, children: i, ...a } = e, o = no(oo, n), [s, c] = B.useState(r), l = B.useRef(null), u = P(t, l), d = B.useRef(0), f = d.current, p = B.useRef(0), m = p.current, h = o.open || s, g = B.useRef(h), _ = B.useRef(void 0);
	return B.useEffect(() => {
		let e = requestAnimationFrame(() => g.current = !1);
		return () => cancelAnimationFrame(e);
	}, []), S(() => {
		let e = l.current;
		if (e) {
			_.current = _.current || {
				transitionDuration: e.style.transitionDuration,
				animationName: e.style.animationName
			}, e.style.transitionDuration = "0s", e.style.animationName = "none";
			let t = e.getBoundingClientRect();
			d.current = t.height, p.current = t.width, g.current || (e.style.transitionDuration = _.current.transitionDuration, e.style.animationName = _.current.animationName), c(r);
		}
	}, [o.open, r]), /* @__PURE__ */ q(F.div, {
		"data-state": lo(o.open),
		"data-disabled": o.disabled ? "" : void 0,
		id: o.contentId,
		hidden: !h,
		...a,
		ref: u,
		style: {
			"--radix-collapsible-content-height": f ? `${f}px` : void 0,
			"--radix-collapsible-content-width": m ? `${m}px` : void 0,
			...e.style
		},
		children: h && i
	});
}, "CollapsibleContentImpl"));
function lo(e) {
	return e ? "open" : "closed";
}
Za(lo, "getState");
//#endregion
//#region src/components/atoms/Collapsible/Collapsible.tsx
var uo = ro, fo = ao, po = so, mo = {
	idle: "border-2 border-dashed border-slate-300 dark:border-slate-600",
	"drag-over": "border-2 border-dashed border-blue-500 bg-blue-50 dark:bg-blue-950/20",
	error: "border-2 border-dashed border-rose-500 bg-rose-50 dark:bg-rose-950/20"
};
function ho(e, t) {
	return t.length === 0 || t.some((t) => {
		if (t.endsWith("/*")) {
			let n = t.slice(0, -2);
			return e.type.startsWith(`${n}/`);
		}
		return e.type === t;
	});
}
var go = V(({ className: e, onDrop: t, accept: n = [], maxSize: r, disabled: i = !1, children: a, onClick: o, ...s }, c) => {
	let [l, u] = G("idle"), d = W(null), f = W(null), p = H(() => {
		u("error"), f.current && clearTimeout(f.current), f.current = setTimeout(() => u("idle"), 2e3);
	}, []), m = H((e) => {
		if (!e || e.length === 0) return;
		let i = [], a = !1;
		Array.from(e).forEach((e) => {
			let t = ho(e, n), o = r === void 0 || e.size <= r;
			t && o ? i.push(e) : a = !0;
		}), a || i.length === 0 ? p() : (u("idle"), t(i));
	}, [
		n,
		r,
		t,
		p
	]), h = H((e) => {
		i || (e.preventDefault(), e.stopPropagation(), u("drag-over"));
	}, [i]), g = H((e) => {
		i || (e.preventDefault(), e.stopPropagation(), u("drag-over"));
	}, [i]), _ = H((e) => {
		i || (e.preventDefault(), e.stopPropagation(), e.currentTarget.contains(e.relatedTarget) || u("idle"));
	}, [i]), v = H((e) => {
		i || (e.preventDefault(), e.stopPropagation(), u("idle"), m(e.dataTransfer.files));
	}, [i, m]), y = H((e) => {
		i || (o?.(e), d.current?.click());
	}, [i, o]), b = H((e) => {
		i || (e.key === "Enter" || e.key === " ") && (e.preventDefault(), d.current?.click());
	}, [i]), x = H((e) => {
		m(e.target.files), e.target.value = "";
	}, [m]);
	return /* @__PURE__ */ J("div", {
		ref: c,
		role: "button",
		tabIndex: i ? -1 : 0,
		"aria-label": "Drop files here",
		"aria-disabled": i,
		className: I("relative flex flex-col items-center justify-center rounded-lg p-6 text-center transition-colors", mo[l], i ? "cursor-not-allowed opacity-50" : "cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2", e),
		onDragEnter: h,
		onDragOver: g,
		onDragLeave: _,
		onDrop: v,
		onClick: y,
		onKeyDown: b,
		...s,
		children: [/* @__PURE__ */ q("input", {
			ref: d,
			type: "file",
			hidden: !0,
			accept: n.join(","),
			multiple: !0,
			disabled: i,
			onChange: x
		}), a ?? /* @__PURE__ */ J("div", {
			className: "flex flex-col items-center gap-2",
			children: [
				/* @__PURE__ */ q("svg", {
					className: "h-10 w-10 text-slate-400 dark:text-slate-500",
					fill: "none",
					stroke: "currentColor",
					viewBox: "0 0 24 24",
					"aria-hidden": "true",
					children: /* @__PURE__ */ q("path", {
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1.5,
						d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
					})
				}),
				/* @__PURE__ */ J("p", {
					className: "text-sm text-slate-600 dark:text-slate-400",
					children: [/* @__PURE__ */ q("span", {
						className: "font-medium",
						children: "Click to upload"
					}), " or drag and drop"]
				}),
				n.length > 0 && /* @__PURE__ */ q("p", {
					className: "text-xs text-slate-400 dark:text-slate-500",
					children: n.join(", ")
				}),
				r !== void 0 && /* @__PURE__ */ J("p", {
					className: "text-xs text-slate-400 dark:text-slate-500",
					children: [
						"Max size: ",
						(r / 1024 / 1024).toFixed(1),
						" MB"
					]
				})
			]
		})]
	});
});
go.displayName = "DropZone";
//#endregion
//#region src/components/atoms/EditableText/EditableText.tsx
var _o = V(({ value: e, onSave: t, placeholder: n, multiline: r = !1, disabled: i = !1, size: a = "md", error: o, label: s, className: c }, l) => {
	let [u, d] = G(!1), [f, p] = G(e), m = W(null), h = W(!1), g = s?.toLowerCase().replace(/\s+/g, "-");
	U(() => {
		u || p(e);
	}, [e, u]), U(() => {
		u && m.current && (m.current.focus(), m.current.select());
	}, [u]), U(() => {
		if (!u) return;
		let e = () => {
			h.current = !0;
		}, t = () => {
			h.current = !1, m.current?.focus();
		};
		return window.addEventListener("blur", e), window.addEventListener("focus", t), () => {
			window.removeEventListener("blur", e), window.removeEventListener("focus", t);
		};
	}, [u]);
	let _ = H(() => {
		d(!1), f !== e && t(f);
	}, [
		f,
		e,
		t
	]), v = H(() => {
		h.current || _();
	}, [_]), y = H(() => {
		p(e), d(!1);
	}, [e]), b = H((e) => {
		e.key === "Escape" ? y() : e.key === "Enter" && !r && (e.preventDefault(), _());
	}, [
		y,
		_,
		r
	]), x = H(() => {
		i || d(!0);
	}, [i]), S = {
		xs: "text-xs",
		sm: "text-sm",
		md: "text-sm",
		lg: "text-base"
	}[a], C = r ? "textarea" : "input";
	return /* @__PURE__ */ J("div", {
		ref: l,
		className: I("w-full", c),
		children: [
			s && /* @__PURE__ */ q("label", {
				htmlFor: g,
				className: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5",
				children: s
			}),
			u ? /* @__PURE__ */ q(C, {
				ref: m,
				id: g,
				value: f,
				onChange: (e) => p(e.target.value),
				onBlur: v,
				onKeyDown: b,
				className: I(_n({
					size: a === "xs" ? "sm" : a,
					hasError: !!o
				}), r && "min-h-[80px] py-2"),
				"aria-invalid": !!o,
				"aria-describedby": o ? `${g}-error` : void 0,
				...r ? { rows: 3 } : {}
			}) : /* @__PURE__ */ J("div", {
				role: "button",
				tabIndex: i ? -1 : 0,
				"aria-disabled": i || void 0,
				onClick: x,
				onKeyDown: (e) => {
					!i && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), x());
				},
				className: I("group relative flex items-start", "border-b border-dashed border-transparent", "rounded-sm transition-colors", S, i ? "opacity-60 cursor-default" : "cursor-text hover:border-slate-300 dark:hover:border-slate-600"),
				children: [/* @__PURE__ */ q("span", {
					className: I(e ? "text-slate-900 dark:text-white" : "text-slate-400 dark:text-slate-500 italic"),
					children: e || n || "\xA0"
				}), !i && /* @__PURE__ */ q(We, {
					className: "ml-2 h-3.5 w-3.5 shrink-0 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity",
					"aria-hidden": "true"
				})]
			}),
			o && /* @__PURE__ */ q("p", {
				id: `${g}-error`,
				className: "mt-1.5 text-sm text-rose-600 dark:text-rose-400",
				children: o
			})
		]
	});
});
_o.displayName = "EditableText";
//#endregion
//#region src/components/atoms/IdChip/IdChip.tsx
var vo = a([
	"inline-flex items-center whitespace-nowrap box-border gap-1.5",
	"border rounded-md",
	"transition-colors",
	"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-surface"
], {
	variants: {
		variant: {
			default: ["bg-muted text-text-secondary border-border", "hover:bg-[var(--border-hover)]"],
			subtle: ["bg-surface-2 text-text-muted border-border", "hover:bg-surface-active"],
			mono: ["bg-muted text-text-primary border-border", "hover:bg-[var(--border-hover)]"]
		},
		size: {
			sm: "h-[var(--inline-h,24px)] px-1.5 text-xs leading-none",
			md: "h-[var(--inline-h-lg,28px)] px-2 text-sm leading-none"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "sm"
	}
}), yo = 1500, bo = V(({ className: e, value: t, label: n, truncate: r = 8, href: i, variant: a, size: o, copyable: s = !0, onCopy: c, "aria-label": l, ...u }, d) => {
	let [f, p] = G(!1), m = r === !1 || t.length <= r ? t : t.slice(0, r), h = l || (n ? `Copy ${n} ID ${t} to clipboard` : `Copy ID ${t} to clipboard`), g = H(async (e) => {
		if (e.preventDefault(), e.stopPropagation(), s) try {
			await navigator.clipboard.writeText(t), p(!0), c?.(t), setTimeout(() => {
				p(!1);
			}, yo);
		} catch (e) {
			console.error("Failed to copy to clipboard:", e);
		}
	}, [
		t,
		s,
		c
	]);
	if (!t) return null;
	let _ = /* @__PURE__ */ J(K, { children: [
		n && /* @__PURE__ */ q("span", {
			className: "text-muted-foreground font-medium",
			children: n
		}),
		/* @__PURE__ */ q("span", {
			className: "font-mono",
			children: m
		}),
		f ? /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q(un, {
			className: "h-3 w-3 text-success-600",
			"aria-hidden": "true"
		}), /* @__PURE__ */ q("span", {
			className: "text-success-600 font-medium",
			children: "Copied"
		})] }) : s && /* @__PURE__ */ q(sn, {
			className: "h-3 w-3 opacity-0 group-hover:opacity-60 transition-opacity",
			"aria-hidden": "true"
		}),
		i && !f && /* @__PURE__ */ q(ri, {
			className: "h-3 w-3 opacity-40 group-hover:opacity-60",
			"aria-hidden": "true"
		})
	] }), v = I(vo({
		variant: a,
		size: o
	}), "group cursor-pointer", e);
	return i ? /* @__PURE__ */ J("span", {
		className: "inline-flex items-center gap-0.5",
		children: [/* @__PURE__ */ q("button", {
			ref: d,
			type: "button",
			className: v,
			onClick: g,
			"aria-label": h,
			...u,
			children: _
		}), /* @__PURE__ */ q("a", {
			href: i,
			className: I("inline-flex items-center px-1 py-0.5 rounded", "text-muted-foreground hover:text-text-secondary", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"),
			"aria-label": `Navigate to ${n || "ID"}`,
			children: /* @__PURE__ */ q(ri, {
				className: "h-3 w-3",
				"aria-hidden": "true"
			})
		})]
	}) : s ? /* @__PURE__ */ q("button", {
		ref: d,
		type: "button",
		className: v,
		onClick: g,
		"aria-label": h,
		...u,
		children: _
	}) : /* @__PURE__ */ q("span", {
		ref: d,
		className: I(vo({
			variant: a,
			size: o
		}), e),
		...u,
		children: _
	});
});
bo.displayName = "IdChip";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-label@2.1.16_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@_a0d6e2f71ba73dadad94263bc45ff639/node_modules/@radix-ui/react-label/dist/index.mjs
var xo = Object.defineProperty, So = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ ((e, t) => xo(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	return /* @__PURE__ */ q(F.label, {
		...e,
		ref: t,
		onMouseDown: (t) => {
			t.target.closest("button, input, select, textarea") || (e.onMouseDown?.(t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
		}
	});
}, "Label")), Co = {
	md: "text-sm font-medium text-text-secondary",
	sm: "text-xs font-medium text-text-muted"
}, wo = V(({ className: e, required: t, size: n = "md", children: r, ...i }, a) => /* @__PURE__ */ J(So, {
	ref: a,
	className: I(Co[n] ?? Co.md, "peer-disabled:cursor-not-allowed peer-disabled:opacity-70", e),
	...i,
	children: [r, t && /* @__PURE__ */ q("span", {
		className: "text-error-500 ml-1",
		children: "*"
	})]
}));
wo.displayName = "Label";
//#endregion
//#region src/components/atoms/List/List.tsx
var To = a("flex flex-col", {
	variants: {
		variant: {
			default: "gap-2",
			compact: "gap-0.5"
		},
		divided: {
			true: "",
			false: ""
		}
	},
	defaultVariants: {
		variant: "default",
		divided: !1
	}
}), Eo = V(({ className: e, variant: t, divided: n, interactive: r, children: i, ...a }, o) => /* @__PURE__ */ q("ul", {
	ref: o,
	role: "list",
	className: I(To({
		variant: t,
		divided: n
	}), e),
	"data-interactive": r || void 0,
	...a,
	children: i
}));
Eo.displayName = "List";
var Do = a(["flex items-center gap-3 rounded-md px-3 py-2", "text-sm text-slate-700 dark:text-slate-300"], {
	variants: { interactive: {
		true: [
			"cursor-pointer transition-colors",
			"hover:bg-slate-50 dark:hover:bg-slate-800",
			"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400"
		],
		false: ""
	} },
	defaultVariants: { interactive: !1 }
}), Oo = V(({ className: e, interactive: t, leading: n, trailing: r, children: i, onClick: a, ...o }, s) => {
	let c = t ?? !!a, l = /* @__PURE__ */ J(K, { children: [
		n && /* @__PURE__ */ q("span", {
			className: "flex-shrink-0",
			children: n
		}),
		/* @__PURE__ */ q("span", {
			className: "flex-1 min-w-0 truncate",
			children: i
		}),
		r && /* @__PURE__ */ q("span", {
			className: "flex-shrink-0",
			children: r
		})
	] });
	return c ? /* @__PURE__ */ q("li", {
		ref: s,
		...o,
		children: /* @__PURE__ */ q("button", {
			type: "button",
			className: I(Do({ interactive: !0 }), "w-full text-left", e),
			onClick: a ? (e) => a(e) : void 0,
			children: l
		})
	}) : /* @__PURE__ */ q("li", {
		ref: s,
		className: I(Do({ interactive: !1 }), e),
		...o,
		children: l
	});
});
Oo.displayName = "ListItem";
var ko = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("li", {
	ref: n,
	role: "separator",
	className: I("h-px bg-slate-200 dark:bg-slate-700 my-1", e),
	...t
}));
ko.displayName = "ListDivider";
//#endregion
//#region src/components/atoms/PasswordInput/PasswordInput.tsx
var Ao = V(({ className: e, size: t, hasError: n, hasIcon: r, error: i, label: a, id: o, showToggle: s = !0, showPasswordLabel: c = "Show password", hidePasswordLabel: l = "Hide password", disabled: u, ...d }, f) => {
	let [p, m] = G(!1), h = o || a?.toLowerCase().replace(/\s+/g, "-");
	return /* @__PURE__ */ J("div", {
		className: "w-full",
		children: [
			a && /* @__PURE__ */ q("label", {
				htmlFor: h,
				className: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5",
				children: a
			}),
			/* @__PURE__ */ J("div", {
				className: I("relative", s && "agn-password-field"),
				children: [/* @__PURE__ */ q("input", {
					ref: f,
					id: h,
					type: p ? "text" : "password",
					className: I(_n({
						size: t,
						hasError: n || !!i,
						hasIcon: s ? "right" : r
					}), s && "pr-10", e),
					"aria-invalid": n || !!i,
					"aria-describedby": i ? `${h}-error` : void 0,
					disabled: u,
					...d
				}), s && /* @__PURE__ */ q("button", {
					type: "button",
					onClick: () => m(!p),
					disabled: u,
					className: I("agn-password-toggle absolute right-0 top-0 h-full px-3", "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300", "transition-colors duration-150", "focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-0 dark:focus-visible:ring-white", "rounded-r-lg", u && "opacity-50 cursor-not-allowed hover:text-slate-500"),
					"aria-label": p ? l : c,
					tabIndex: -1,
					children: q(p ? ai : mt, {
						className: "h-4 w-4",
						"aria-hidden": "true"
					})
				})]
			}),
			i && /* @__PURE__ */ q("p", {
				id: `${h}-error`,
				className: "mt-1.5 text-sm text-rose-600 dark:text-rose-400",
				children: i
			})
		]
	});
});
Ao.displayName = "PasswordInput";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-progress@1.1.17_@types+react-dom@19.3.0_@types+react@19.3.0__@types+rea_8b02c81ec43be9627385838e23c60397/node_modules/@radix-ui/react-progress/dist/index.mjs
var jo = Object.defineProperty, Mo = (e, t) => jo(e, "name", {
	value: t,
	configurable: !0
}), No = "Progress", Po = 100, [Fo, Io] = se(No), [Lo, Ro] = Fo(No), zo = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Mo(function(e, t) {
	let { __scopeProgress: n, value: r = null, max: i, getValueLabel: a = Ho, ...o } = e;
	(i || i === 0) && !Go(i) && console.error(qo(`${i}`, "Progress"));
	let s = Go(i) ? i : Po;
	r !== null && !Ko(r, s) && console.error(Jo(`${r}`, "Progress"));
	let c = Ko(r, s) ? r : null, l = Wo(c) ? a(c, s) : void 0;
	return /* @__PURE__ */ q(Lo, {
		scope: n,
		value: c,
		max: s,
		children: /* @__PURE__ */ q(F.div, {
			"aria-valuemax": s,
			"aria-valuemin": 0,
			"aria-valuenow": Wo(c) ? c : void 0,
			"aria-valuetext": l,
			role: "progressbar",
			"data-state": Uo(c, s),
			"data-value": c ?? void 0,
			"data-max": s,
			...o,
			ref: t
		})
	});
}, "Progress")), Bo = "ProgressIndicator", Vo = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Mo(function(e, t) {
	let { __scopeProgress: n, ...r } = e, i = Ro(Bo, n);
	return /* @__PURE__ */ q(F.div, {
		"data-state": Uo(i.value, i.max),
		"data-value": i.value ?? void 0,
		"data-max": i.max,
		...r,
		ref: t
	});
}, "ProgressIndicator"));
function Ho(e, t) {
	return `${Math.round(e / t * 100)}%`;
}
Mo(Ho, "defaultGetValueLabel");
function Uo(e, t) {
	return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
Mo(Uo, "getProgressState");
function Wo(e) {
	return typeof e == "number";
}
Mo(Wo, "isNumber");
function Go(e) {
	return Wo(e) && !isNaN(e) && e > 0;
}
Mo(Go, "isValidMaxNumber");
function Ko(e, t) {
	return Wo(e) && !isNaN(e) && e <= t && e >= 0;
}
Mo(Ko, "isValidValueNumber");
function qo(e, t) {
	return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Po}\`.`;
}
Mo(qo, "getInvalidMaxError");
function Jo(e, t) {
	return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Po} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
Mo(Jo, "getInvalidValueError");
//#endregion
//#region src/components/atoms/Progress/Progress.tsx
function Yo(e, t) {
	return typeof e != "number" || !Number.isFinite(e) ? null : Math.min(Math.max(e, 0), typeof t == "number" && t > 0 ? t : 100);
}
var Xo = V(({ className: e, value: t, max: n, size: r, variant: i, ...a }, o) => /* @__PURE__ */ q(zo, {
	ref: o,
	className: I(y({ size: r }), e),
	value: Yo(t, n),
	max: n,
	...a,
	children: /* @__PURE__ */ q(Vo, {
		className: I(ke({ variant: i })),
		style: { transform: `translateX(-${100 - (t || 0)}%)` }
	})
}));
Xo.displayName = zo.displayName;
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-radio-group@1.4.8_@types+react-dom@19.3.0_@types+react@19.3.0__@types+r_348ffb426946b68081d9d648af06eca5/node_modules/@radix-ui/react-radio-group/dist/index.mjs
var Zo = Object.defineProperty, Qo = (e, t) => Zo(e, "name", {
	value: t,
	configurable: !0
}), $o = "Radio", [es, ts] = se($o), [ns, rs] = es($o);
function is(e) {
	let { __scopeRadio: t, checked: n = !1, children: r, disabled: i, form: a, name: o, onCheck: s, required: c, value: l = "on", internal_do_not_use_render: u } = e, [d, f] = B.useState(null), [p, m] = B.useState(null), h = B.useRef(!1), [g, _] = B.useReducer((e) => e + 1, 0), v = {
		checked: n,
		disabled: i,
		required: c,
		name: o,
		form: a,
		value: l,
		control: d,
		setControl: f,
		hasConsumerStoppedPropagationRef: h,
		userInteractionCount: g,
		onUserInteraction: _,
		isFormControl: !d || !!a || !!d.closest("form"),
		bubbleInput: p,
		setBubbleInput: m,
		onCheck: /* @__PURE__ */ Qo(() => s?.(), "onCheck")
	};
	return /* @__PURE__ */ q(ns, {
		scope: t,
		...v,
		children: ds(u) ? u(v) : r
	});
}
Qo(is, "RadioProvider");
var as = "RadioTrigger", os = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Qo(function({ __scopeRadio: e, onClick: t, ...n }, r) {
	let { checked: i, disabled: a, value: o, setControl: s, onCheck: c, hasConsumerStoppedPropagationRef: l, onUserInteraction: u, isFormControl: d, bubbleInput: f } = rs(as, e), p = P(r, s);
	return /* @__PURE__ */ q(F.button, {
		type: "button",
		role: "radio",
		"aria-checked": i,
		"data-state": fs(i),
		"data-disabled": a ? "" : void 0,
		disabled: a,
		value: o,
		...n,
		ref: p,
		onClick: N(t, (e) => {
			i || (u(), c()), f && d && (l.current = e.isPropagationStopped(), l.current || e.stopPropagation());
		})
	});
}, "RadioTrigger")), ss = "RadioIndicator", cs = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Qo(function(e, t) {
	let { __scopeRadio: n, forceMount: r, ...i } = e, a = rs(ss, n);
	return /* @__PURE__ */ q(bt, {
		present: r || a.checked,
		children: /* @__PURE__ */ q(F.span, {
			"data-state": fs(a.checked),
			"data-disabled": a.disabled ? "" : void 0,
			...i,
			ref: t
		})
	});
}, "RadioIndicator")), ls = "RadioBubbleInput", us = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Qo(function({ __scopeRadio: e, onClick: t, ...n }, r) {
	let { control: i, checked: a, required: o, disabled: s, name: c, value: l, form: u, bubbleInput: d, setBubbleInput: f, hasConsumerStoppedPropagationRef: p, userInteractionCount: m } = rs(ls, e), h = P(r, f), g = we(i), _ = B.useRef(!1), v = B.useRef(a), y = B.useRef(m);
	B.useEffect(() => {
		let e = d;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "checked").set, r = m !== y.current;
		y.current = m;
		let i = v.current !== a;
		v.current = a;
		let o = !(r && p.current);
		if (i && n) {
			_.current = !r;
			let t = new Event("click", { bubbles: o });
			n.call(e, a), e.dispatchEvent(t), _.current = !1;
		}
	}, [
		d,
		a,
		p,
		m
	]);
	let b = B.useRef(a);
	return /* @__PURE__ */ q(F.input, {
		type: "radio",
		"aria-hidden": !0,
		defaultChecked: b.current,
		required: o,
		disabled: s,
		name: c,
		value: l,
		form: u,
		...n,
		tabIndex: -1,
		ref: h,
		onClick: N(t, (e) => {
			_.current && e.stopPropagation();
		}),
		style: {
			...n.style,
			...g,
			position: "absolute",
			pointerEvents: "none",
			opacity: 0,
			margin: 0,
			transform: "translateX(-100%)"
		}
	});
}, "RadioBubbleInput"));
function ds(e) {
	return typeof e == "function";
}
Qo(ds, "isFunction");
function fs(e) {
	return e ? "checked" : "unchecked";
}
Qo(fs, "getState");
var ps = [
	"ArrowUp",
	"ArrowDown",
	"ArrowLeft",
	"ArrowRight"
], ms = "RadioGroup", [hs, gs] = se(ms, [be, ts]), _s = be(), vs = ts(), [ys, bs] = hs(ms), xs = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Qo(function(e, t) {
	let { __scopeRadioGroup: r, name: i, form: a, defaultValue: o, value: s, required: c = !1, disabled: l = !1, orientation: u, dir: d, loop: f = !0, onValueChange: p, ...m } = e, h = _s(r), g = n(d), [_, v] = Ct({
		prop: s,
		defaultProp: o ?? null,
		onChange: p,
		caller: ms
	}), [y, b] = B.useState(null), x = P(t, b), S = B.useRef(_);
	return B.useEffect(() => {
		let e = a ? y?.ownerDocument.getElementById(a) : y?.closest("form");
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ Qo(() => v(S.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		y,
		a,
		v
	]), /* @__PURE__ */ q(ys, {
		scope: r,
		name: i,
		form: a,
		required: c,
		disabled: l,
		value: _,
		onValueChange: v,
		children: /* @__PURE__ */ q(He, {
			asChild: !0,
			...h,
			orientation: u,
			dir: g,
			loop: f,
			children: /* @__PURE__ */ q(F.div, {
				role: "radiogroup",
				"aria-required": c,
				"aria-orientation": u,
				"data-disabled": l ? "" : void 0,
				dir: g,
				...m,
				ref: x
			})
		})
	});
}, "RadioGroup")), Ss = "RadioGroupItemProvider", Cs = "RadioGroupItemTrigger";
function ws(e) {
	let { __scopeRadioGroup: t, value: n, disabled: r, children: i, internal_do_not_use_render: a } = e, o = bs(Ss, t), s = vs(t), c = o.disabled || r;
	return /* @__PURE__ */ q(is, {
		...s,
		checked: o.value === n,
		disabled: c,
		required: o.required,
		name: o.name,
		form: o.form,
		value: n,
		onCheck: () => o.onValueChange(n),
		internal_do_not_use_render: a,
		children: i
	});
}
Qo(ws, "RadioGroupItemProvider");
var Ts = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Qo(function(e, t) {
	let { __scopeRadioGroup: n, ...r } = e, i = _s(n), a = vs(n), { checked: o, disabled: s } = rs(Cs, a.__scopeRadio), c = B.useRef(null), l = P(t, c), u = B.useRef(!1);
	return B.useEffect(() => {
		let e = /* @__PURE__ */ Qo((e) => {
			ps.includes(e.key) && (u.current = !0);
		}, "handleKeyDown"), t = /* @__PURE__ */ Qo(() => u.current = !1, "handleKeyUp");
		return document.addEventListener("keydown", e), document.addEventListener("keyup", t), () => {
			document.removeEventListener("keydown", e), document.removeEventListener("keyup", t);
		};
	}, []), /* @__PURE__ */ q(Je, {
		asChild: !0,
		...i,
		focusable: !s,
		active: o,
		children: /* @__PURE__ */ q(os, {
			...a,
			...r,
			ref: l,
			onKeyDown: N(r.onKeyDown, (e) => {
				e.key === "Enter" && e.preventDefault();
			}),
			onFocus: N(r.onFocus, () => {
				u.current && c.current?.click();
			})
		})
	});
}, "RadioGroupItemTrigger")), Es = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Qo(function(e, t) {
	let { __scopeRadioGroup: n, value: r, disabled: i, ...a } = e;
	return /* @__PURE__ */ q(ws, {
		__scopeRadioGroup: n,
		value: r,
		disabled: i,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q(Ts, {
			...a,
			ref: t,
			__scopeRadioGroup: n
		}), e && /* @__PURE__ */ q(Ds, { __scopeRadioGroup: n })] })
	});
}, "RadioGroupItem")), Ds = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Qo(function(e, t) {
	let { __scopeRadioGroup: n, ...r } = e, i = vs(n);
	return /* @__PURE__ */ q(us, {
		...i,
		...r,
		ref: t
	});
}, "RadioGroupItemBubbleInput")), Os = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Qo(function(e, t) {
	let { __scopeRadioGroup: n, ...r } = e, i = vs(n);
	return /* @__PURE__ */ q(cs, {
		...i,
		...r,
		ref: t
	});
}, "RadioGroupIndicator")), ks = V(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ q(xs, {
	ref: r,
	className: I("grid gap-2", t === "horizontal" && "grid-flow-col auto-cols-max", e),
	...n
}));
ks.displayName = "RadioGroup";
var As = V(({ className: e, label: t, id: n, ...r }, i) => {
	let a = n || t?.toLowerCase().replace(/\s+/g, "-");
	return /* @__PURE__ */ J("div", {
		className: "flex items-center gap-2",
		children: [/* @__PURE__ */ q(Es, {
			ref: i,
			id: a,
			className: I("h-5 w-5 shrink-0 rounded-full border border-border-hover", "bg-[var(--field-bg)]", "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[color:var(--ring-color)] focus-visible:ring-offset-1 focus-visible:ring-offset-surface", "disabled:cursor-not-allowed disabled:opacity-50", "data-[state=checked]:border-[var(--action-primary)]", "transition-colors", e),
			...r,
			children: /* @__PURE__ */ q(Os, {
				className: "flex items-center justify-center",
				children: /* @__PURE__ */ q(Ht, { className: "h-2.5 w-2.5 fill-[var(--action-primary)] text-[var(--action-primary)]" })
			})
		}), t && /* @__PURE__ */ q("label", {
			htmlFor: a,
			className: "text-sm text-text-secondary cursor-pointer",
			children: t
		})]
	});
});
As.displayName = "RadioGroupItem";
//#endregion
//#region src/components/atoms/ReadOnlyField/ReadOnlyField.tsx
var js = V(({ label: e, value: t, hint: n, mono: r, className: i, ...a }, o) => /* @__PURE__ */ J("div", {
	ref: o,
	className: I("space-y-0.5", i),
	...a,
	children: [
		/* @__PURE__ */ q("p", {
			className: "text-xs font-medium text-slate-500 dark:text-slate-400",
			children: e
		}),
		/* @__PURE__ */ q("p", {
			className: I("text-sm text-slate-900 dark:text-slate-100", r && "font-mono text-xs break-all"),
			children: t || "—"
		}),
		n && /* @__PURE__ */ q("p", {
			className: "text-xs text-slate-500 dark:text-slate-400 mt-1",
			children: n
		})
	]
}));
js.displayName = "ReadOnlyField";
//#endregion
//#region src/components/atoms/RoleBadge/RoleBadge.tsx
function Ms({ className: e, role: t, emphasis: n, size: r, showIcon: i = !1, label: a, icon: o, ...s }) {
	let c = a || t.charAt(0).toUpperCase() + t.slice(1), l = () => o ? /* @__PURE__ */ q(K, { children: o }) : i && t === "owner" ? /* @__PURE__ */ q($r, {
		className: I("flex-shrink-0", r === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"),
		"aria-hidden": "true"
	}) : null;
	return /* @__PURE__ */ J("span", {
		className: I(h({
			role: t,
			emphasis: n,
			size: r
		}), e),
		...s,
		children: [/* @__PURE__ */ q(l, {}), c]
	});
}
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+number@1.1.3/node_modules/@radix-ui/number/dist/index.mjs
var Ns = Object.defineProperty, Ps = (e, t) => Ns(e, "name", {
	value: t,
	configurable: !0
});
function Fs(e, [t, n]) {
	return Math.min(n, Math.max(t, e));
}
Ps(Fs, "clamp");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-use-previous@1.1.4_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-use-previous/dist/index.mjs
var Is = Object.defineProperty, Ls = (e, t) => Is(e, "name", {
	value: t,
	configurable: !0
});
function Rs(e) {
	let t = B.useRef({
		value: e,
		previous: e
	});
	return B.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
Ls(Rs, "usePrevious");
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-select@2.3.8_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@_34ec1de1099e5f0bf822b110d5b01f4b/node_modules/@radix-ui/react-select/dist/index.mjs
var zs = Object.defineProperty, Y = (e, t) => zs(e, "name", {
	value: t,
	configurable: !0
}), Bs = {
	ItemAligned: "item-aligned",
	Popper: "popper"
}, Vs = {
	LTR: "ltr",
	RTL: "rtl"
}, Hs = [
	" ",
	"Enter",
	"ArrowUp",
	"ArrowDown"
], Us = [" ", "Enter"], Ws = "Select", [Gs, Ks, qs] = pt(Ws), [Js, Ys] = se(Ws, [qs, bn]), Xs = bn(), [Zs, Qs] = Js(Ws), [$s, ec] = Js(Ws);
function tc(e) {
	let { __scopeSelect: t, children: r, open: i, defaultOpen: a, onOpenChange: o, value: s, defaultValue: c, onValueChange: l, dir: d, name: f, autoComplete: p, disabled: m, required: h, form: g, internal_do_not_use_render: _ } = e, v = Xs(t), [y, b] = B.useState(null), [x, S] = B.useState(null), [C, w] = B.useState(!1), T = n(d), [E, D] = Ct({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: Ws
	}), [O, k] = Ct({
		prop: s,
		defaultProp: c,
		onChange: l,
		caller: Ws
	}), A = B.useRef(null), j = B.useRef(O);
	B.useEffect(() => {
		let e = g ? y?.ownerDocument.getElementById(g) : y?.form;
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ Y(() => k(j.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		g,
		y,
		k
	]);
	let M = !y || !!g || !!y.closest("form"), [ee, te] = B.useState(/* @__PURE__ */ new Set()), ne = u(), re = Array.from(ee).map((e) => e.props.value).join(";"), ie = B.useCallback((e) => {
		te((t) => new Set(t).add(e));
	}, []), ae = B.useCallback((e) => {
		te((t) => {
			let n = new Set(t);
			return n.delete(e), n;
		});
	}, []), oe = {
		required: h,
		trigger: y,
		onTriggerChange: b,
		valueNode: x,
		onValueNodeChange: S,
		valueNodeHasChildren: C,
		onValueNodeHasChildrenChange: w,
		contentId: ne,
		value: O,
		onValueChange: k,
		open: E,
		onOpenChange: D,
		dir: T,
		triggerPointerDownPosRef: A,
		disabled: m,
		name: f,
		autoComplete: p,
		form: g,
		nativeOptions: ee,
		nativeSelectKey: re,
		isFormControl: M
	};
	return /* @__PURE__ */ q(pn, {
		...v,
		children: /* @__PURE__ */ q(Zs, {
			scope: t,
			...oe,
			children: /* @__PURE__ */ q(Gs.Provider, {
				scope: t,
				children: /* @__PURE__ */ q($s, {
					scope: t,
					onNativeOptionAdd: ie,
					onNativeOptionRemove: ae,
					children: Kc(_) ? _(oe) : r
				})
			})
		})
	});
}
Y(tc, "SelectProvider");
var nc = /* @__PURE__ */ Y((e) => {
	let { __scopeSelect: t, children: n, ...r } = e;
	return /* @__PURE__ */ q(tc, {
		__scopeSelect: t,
		...r,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ J(K, { children: [n, e ? /* @__PURE__ */ q(Gc, { __scopeSelect: t }) : null] })
	});
}, "Select"), rc = "SelectTrigger", ic = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, disabled: r = !1, ...i } = e, a = Xs(n), o = Qs(rc, n), s = o.disabled || r, c = P(t, o.onTriggerChange), l = Ks(n), u = B.useRef("touch"), [d, f, p] = Jc((e) => {
		let t = l().filter((e) => !e.disabled), n = Yc(t, e, t.find((e) => e.value === o.value));
		n !== void 0 && o.onValueChange(n.value);
	}), m = /* @__PURE__ */ Y((e) => {
		s || (o.onOpenChange(!0), p()), e && (o.triggerPointerDownPosRef.current = {
			x: Math.round(e.pageX),
			y: Math.round(e.pageY)
		});
	}, "handleOpen");
	return /* @__PURE__ */ q(wn, {
		asChild: !0,
		...a,
		children: /* @__PURE__ */ q(F.button, {
			type: "button",
			role: "combobox",
			"aria-controls": o.open ? o.contentId : void 0,
			"aria-expanded": o.open,
			"aria-required": o.required,
			"aria-autocomplete": "none",
			dir: o.dir,
			"data-state": o.open ? "open" : "closed",
			disabled: s,
			"data-disabled": s ? "" : void 0,
			"data-placeholder": qc(o.value) ? "" : void 0,
			...i,
			ref: c,
			onClick: N(i.onClick, (e) => {
				e.currentTarget.focus(), u.current !== "mouse" && m(e);
			}),
			onPointerDown: N(i.onPointerDown, (e) => {
				u.current = e.pointerType;
				let t = e.target;
				t.hasPointerCapture(e.pointerId) && t.releasePointerCapture(e.pointerId), e.button === 0 && e.ctrlKey === !1 && e.pointerType === "mouse" && (m(e), e.preventDefault());
			}),
			onKeyDown: N(i.onKeyDown, (e) => {
				let t = d.current !== "";
				!(e.ctrlKey || e.altKey || e.metaKey) && e.key.length === 1 && f(e.key), !(t && e.key === " ") && Hs.includes(e.key) && (m(), e.preventDefault());
			})
		})
	});
}, "SelectTrigger")), ac = "SelectValue", oc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, className: r, style: i, children: a, placeholder: o = "", ...s } = e, c = Qs(ac, n), { onValueNodeHasChildrenChange: l } = c, u = a !== void 0, d = P(t, c.onValueNodeChange);
	S(() => {
		l(u);
	}, [l, u]);
	let f = qc(c.value);
	return /* @__PURE__ */ q(F.span, {
		...s,
		asChild: !f && s.asChild,
		ref: d,
		style: { pointerEvents: "none" },
		children: /* @__PURE__ */ q(B.Fragment, { children: f ? o : a }, f ? "placeholder" : "value")
	});
}, "SelectValue")), sc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, children: r, ...i } = e;
	return /* @__PURE__ */ q(F.span, {
		"aria-hidden": !0,
		...i,
		ref: t,
		children: r || "▼"
	});
}, "SelectIcon")), [cc, lc] = Js("SelectPortal", { forceMount: void 0 }), uc = /* @__PURE__ */ Y((e) => {
	let { __scopeSelect: t, forceMount: n, ...r } = e;
	return /* @__PURE__ */ q(cc, {
		scope: e.__scopeSelect,
		forceMount: n,
		children: /* @__PURE__ */ q(Xe, {
			asChild: !0,
			...r
		})
	});
}, "SelectPortal"), dc = "SelectContent", fc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let n = lc(dc, e.__scopeSelect), { forceMount: r = n.forceMount, ...i } = e, a = Qs(dc, e.__scopeSelect), [o, s] = B.useState();
	return S(() => {
		s(new DocumentFragment());
	}, []), /* @__PURE__ */ q(bt, {
		present: r || a.open,
		children: ({ present: e }) => e ? /* @__PURE__ */ q(vc, {
			...i,
			ref: t
		}) : /* @__PURE__ */ q(pc, {
			...i,
			fragment: o
		})
	});
}, "SelectContent")), pc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, children: r, fragment: i } = e;
	return i ? zn.createPortal(/* @__PURE__ */ q(hc, {
		scope: n,
		children: /* @__PURE__ */ q(Gs.Slot, {
			scope: n,
			children: /* @__PURE__ */ q("div", {
				ref: t,
				children: r
			})
		})
	}), i) : null;
}, "SelectContentFragment")), mc = 10, [hc, gc] = Js(dc), _c = fe("SelectContent.RemoveScroll"), vc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n } = e, { position: r = Bs.ItemAligned, onCloseAutoFocus: i, onEscapeKeyDown: a, onPointerDownOutside: o, side: s, sideOffset: c, align: l, alignOffset: u, arrowPadding: d, collisionBoundary: f, collisionPadding: p, sticky: m, hideWhenDetached: h, avoidCollisions: g, ..._ } = e, y = Qs(dc, n), [b, x] = B.useState(null), [S, C] = B.useState(null), w = P(t, x), [T, E] = B.useState(null), [D, O] = B.useState(null), k = Ks(n), [A, j] = B.useState(!1), M = B.useRef(!1);
	B.useEffect(() => {
		if (b) return Lt(b);
	}, [b]), Oe();
	let ee = B.useCallback((e) => {
		let [t, ...n] = k().map((e) => e.ref.current), [r] = n.slice(-1), i = document.activeElement;
		for (let n of e) if (n === i || (n?.scrollIntoView({ block: "nearest" }), n === t && S && (S.scrollTop = 0), n === r && S && (S.scrollTop = S.scrollHeight), n?.focus(), document.activeElement !== i)) return;
	}, [k, S]), te = B.useCallback(() => ee([T, b]), [
		ee,
		T,
		b
	]);
	B.useEffect(() => {
		A && te();
	}, [A, te]);
	let { onOpenChange: ne, triggerPointerDownPosRef: re } = y;
	B.useEffect(() => {
		if (b) {
			let e = {
				x: 0,
				y: 0
			}, t = /* @__PURE__ */ Y((t) => {
				e = {
					x: Math.abs(Math.round(t.pageX) - (re.current?.x ?? 0)),
					y: Math.abs(Math.round(t.pageY) - (re.current?.y ?? 0))
				};
			}, "handlePointerMove"), n = /* @__PURE__ */ Y((n) => {
				e.x <= 10 && e.y <= 10 ? n.preventDefault() : n.composedPath().includes(b) || ne(!1), document.removeEventListener("pointermove", t), re.current = null;
			}, "handlePointerUp");
			return re.current !== null && (document.addEventListener("pointermove", t), document.addEventListener("pointerup", n, {
				capture: !0,
				once: !0
			})), () => {
				document.removeEventListener("pointermove", t), document.removeEventListener("pointerup", n, { capture: !0 });
			};
		}
	}, [
		b,
		ne,
		re
	]), B.useEffect(() => {
		let e = /* @__PURE__ */ Y(() => ne(!1), "close");
		return window.addEventListener("blur", e), window.addEventListener("resize", e), () => {
			window.removeEventListener("blur", e), window.removeEventListener("resize", e);
		};
	}, [ne]);
	let [ie, ae] = Jc((e) => {
		let t = k().filter((e) => !e.disabled), n = Yc(t, e, t.find((e) => e.ref.current === document.activeElement));
		n && setTimeout(() => n.ref.current?.focus());
	}), oe = B.useCallback((e, t, n) => {
		let r = !M.current && !n;
		(y.value !== void 0 && y.value === t || r) && (E(e), r && (M.current = !0));
	}, [y.value]), se = B.useCallback(() => b?.focus(), [b]), ce = B.useCallback((e, t, n) => {
		let r = !M.current && !n;
		(y.value !== void 0 && y.value === t || r) && O(e);
	}, [y.value]), le = r === Bs.Popper ? bc : yc, ue = le === bc ? {
		side: s,
		sideOffset: c,
		align: l,
		alignOffset: u,
		arrowPadding: d,
		collisionBoundary: f,
		collisionPadding: p,
		sticky: m,
		hideWhenDetached: h,
		avoidCollisions: g
	} : {};
	return /* @__PURE__ */ q(hc, {
		scope: n,
		content: b,
		viewport: S,
		onViewportChange: C,
		itemRefCallback: oe,
		selectedItem: T,
		onItemLeave: se,
		itemTextRefCallback: ce,
		focusSelectedItem: te,
		selectedItemText: D,
		position: r,
		isPositioned: A,
		searchRef: ie,
		children: /* @__PURE__ */ q(Jt, {
			as: _c,
			allowPinchZoom: !0,
			children: /* @__PURE__ */ q(gn, {
				asChild: !0,
				trapped: y.open,
				onMountAutoFocus: (e) => {
					e.preventDefault();
				},
				onUnmountAutoFocus: N(i, (e) => {
					y.trigger?.focus({ preventScroll: !0 }), e.preventDefault();
				}),
				children: /* @__PURE__ */ q(v, {
					asChild: !0,
					disableOutsidePointerEvents: !0,
					onEscapeKeyDown: a,
					onPointerDownOutside: o,
					onFocusOutside: (e) => e.preventDefault(),
					onDismiss: () => y.onOpenChange(!1),
					children: /* @__PURE__ */ q(le, {
						role: "listbox",
						id: y.contentId,
						"data-state": y.open ? "open" : "closed",
						dir: y.dir,
						onContextMenu: (e) => e.preventDefault(),
						..._,
						...ue,
						onPlaced: () => j(!0),
						ref: w,
						style: {
							display: "flex",
							flexDirection: "column",
							outline: "none",
							..._.style
						},
						onKeyDown: N(_.onKeyDown, (e) => {
							let t = e.ctrlKey || e.altKey || e.metaKey;
							if (e.key === "Tab" && e.preventDefault(), !t && e.key.length === 1 && ae(e.key), [
								"ArrowUp",
								"ArrowDown",
								"Home",
								"End"
							].includes(e.key)) {
								let t = k().filter((e) => !e.disabled).map((e) => e.ref.current);
								if (["ArrowUp", "End"].includes(e.key) && (t = t.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(e.key)) {
									let n = e.target, r = t.indexOf(n);
									t = t.slice(r + 1);
								}
								setTimeout(() => ee(t)), e.preventDefault();
							}
						})
					})
				})
			})
		})
	});
}, "SelectContentImpl")), yc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, onPlaced: r, ...i } = e, a = Qs(dc, n), o = gc(dc, n), [s, c] = B.useState(null), [l, u] = B.useState(null), d = P(t, u), f = Ks(n), p = B.useRef(!1), m = B.useRef(!0), { viewport: h, selectedItem: g, selectedItemText: _, focusSelectedItem: v } = o, y = B.useCallback(() => {
		if (a.trigger && a.valueNode && s && l && h && g && _) {
			let e = a.trigger.getBoundingClientRect(), t = l.getBoundingClientRect(), n = a.valueNode.getBoundingClientRect(), i = _.getBoundingClientRect();
			if (a.dir !== Vs.RTL) {
				let r = i.left - t.left, a = n.left - r, o = e.left - a, c = e.width + o, l = Math.max(c, t.width), u = window.innerWidth - mc, d = Fs(a, [mc, Math.max(mc, u - l)]);
				s.style.minWidth = c + "px", s.style.left = d + "px";
			} else {
				let r = t.right - i.right, a = window.innerWidth - n.right - r, o = window.innerWidth - e.right - a, c = e.width + o, l = Math.max(c, t.width), u = window.innerWidth - mc, d = Fs(a, [mc, Math.max(mc, u - l)]);
				s.style.minWidth = c + "px", s.style.right = d + "px";
			}
			let o = f(), c = window.innerHeight - mc * 2, u = h.scrollHeight, d = window.getComputedStyle(l), m = parseInt(d.borderTopWidth, 10), v = parseInt(d.paddingTop, 10), y = parseInt(d.borderBottomWidth, 10), b = parseInt(d.paddingBottom, 10), x = m + v + u + b + y, S = Math.min(g.offsetHeight * 5, x), C = window.getComputedStyle(h), w = parseInt(C.paddingTop, 10), T = parseInt(C.paddingBottom, 10), E = e.top + e.height / 2 - mc, D = c - E, O = g.offsetHeight / 2, k = g.offsetTop + O, A = m + v + k, j = x - A;
			if (A <= E) {
				let e = o.length > 0 && g === o[o.length - 1].ref.current;
				s.style.bottom = "0px";
				let t = l.clientHeight - h.offsetTop - h.offsetHeight, n = A + Math.max(D, O + (e ? T : 0) + t + y);
				s.style.height = n + "px";
			} else {
				let e = o.length > 0 && g === o[0].ref.current;
				s.style.top = "0px";
				let t = Math.max(E, m + h.offsetTop + (e ? w : 0) + O) + j;
				s.style.height = t + "px", h.scrollTop = A - E + h.offsetTop;
			}
			s.style.margin = `${mc}px 0`, s.style.minHeight = S + "px", s.style.maxHeight = c + "px", r?.(), requestAnimationFrame(() => p.current = !0);
		}
	}, [
		f,
		a.trigger,
		a.valueNode,
		s,
		l,
		h,
		g,
		_,
		a.dir,
		r
	]);
	S(() => y(), [y]);
	let [b, x] = B.useState();
	S(() => {
		l && x(window.getComputedStyle(l).zIndex);
	}, [l]);
	let C = B.useCallback((e) => {
		e && m.current === !0 && (y(), v?.(), m.current = !1);
	}, [y, v]);
	return /* @__PURE__ */ q(xc, {
		scope: n,
		contentWrapper: s,
		shouldExpandOnScrollRef: p,
		onScrollButtonChange: C,
		children: /* @__PURE__ */ q("div", {
			ref: c,
			style: {
				display: "flex",
				flexDirection: "column",
				position: "fixed",
				zIndex: b
			},
			children: /* @__PURE__ */ q(F.div, {
				...i,
				ref: d,
				style: {
					boxSizing: "border-box",
					maxHeight: "100%",
					...i.style
				}
			})
		})
	});
}, "SelectItemAlignedPosition")), bc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, align: r = "start", collisionPadding: i = mc, ...a } = e, o = Xs(n);
	return /* @__PURE__ */ q(rt, {
		...o,
		...a,
		ref: t,
		align: r,
		collisionPadding: i,
		style: {
			boxSizing: "border-box",
			...a.style,
			"--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-select-content-available-width": "var(--radix-popper-available-width)",
			"--radix-select-content-available-height": "var(--radix-popper-available-height)",
			"--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "SelectPopperPosition")), [xc, Sc] = Js(dc, {}), Cc = "SelectViewport", wc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, nonce: r, ...i } = e, a = gc(Cc, n), o = Sc(Cc, n), s = P(t, a.onViewportChange), c = B.useRef(0);
	return /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q("style", {
		dangerouslySetInnerHTML: { __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}" },
		nonce: r
	}), /* @__PURE__ */ q(Gs.Slot, {
		scope: n,
		children: /* @__PURE__ */ q(F.div, {
			"data-radix-select-viewport": "",
			role: "presentation",
			...i,
			ref: s,
			style: {
				position: "relative",
				flex: 1,
				overflow: "hidden auto",
				...i.style
			},
			onScroll: N(i.onScroll, (e) => {
				let t = e.currentTarget, { contentWrapper: n, shouldExpandOnScrollRef: r } = o;
				if (r?.current && n) {
					let e = Math.abs(c.current - t.scrollTop);
					if (e > 0) {
						let r = window.innerHeight - mc * 2, i = parseFloat(n.style.minHeight), a = parseFloat(n.style.height), o = Math.max(i, a);
						if (o < r) {
							let i = o + e, a = Math.min(r, i), s = i - a;
							n.style.height = a + "px", n.style.bottom === "0px" && (t.scrollTop = s > 0 ? s : 0, n.style.justifyContent = "flex-end");
						}
					}
				}
				c.current = t.scrollTop;
			})
		})
	})] });
}, "SelectViewport")), [Tc, Ec] = Js("SelectGroup"), Dc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, ...r } = e, i = u();
	return /* @__PURE__ */ q(Tc, {
		scope: n,
		id: i,
		children: /* @__PURE__ */ q(F.div, {
			role: "group",
			"aria-labelledby": i,
			...r,
			ref: t
		})
	});
}, "SelectGroup")), Oc = "SelectLabel", kc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, ...r } = e, i = Ec(Oc, n);
	return /* @__PURE__ */ q(F.div, {
		id: i.id,
		...r,
		ref: t
	});
}, "SelectLabel")), Ac = "SelectItem", [jc, Mc] = Js(Ac), Nc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, value: r, disabled: i = !1, textValue: a, ...o } = e, s = Qs(Ac, n), c = gc(Ac, n), l = s.value === r, [d, f] = B.useState(a ?? ""), [p, m] = B.useState(!1), h = j((e) => c.itemRefCallback?.(e, r, i)), g = P(t, h), _ = u(), v = B.useRef("touch"), y = /* @__PURE__ */ Y(() => {
		s.onValueChange(r), s.onOpenChange(!1);
	}, "handleSelect");
	return /* @__PURE__ */ q(jc, {
		scope: n,
		value: r,
		disabled: i,
		textId: _,
		isSelected: l,
		onItemTextChange: B.useCallback((e) => {
			f((t) => t || (e?.textContent ?? "").trim());
		}, []),
		children: /* @__PURE__ */ q(Gs.ItemSlot, {
			scope: n,
			value: r,
			disabled: i,
			textValue: d,
			children: /* @__PURE__ */ q(F.div, {
				role: "option",
				"aria-labelledby": _,
				"data-highlighted": p ? "" : void 0,
				"aria-selected": l && p,
				"data-state": l ? "checked" : "unchecked",
				"aria-disabled": i || void 0,
				"data-disabled": i ? "" : void 0,
				tabIndex: i ? void 0 : -1,
				...o,
				ref: g,
				onFocus: N(o.onFocus, () => m(!0)),
				onBlur: N(o.onBlur, () => m(!1)),
				onClick: N(o.onClick, () => {
					i || v.current !== "mouse" && y();
				}),
				onPointerUp: N(o.onPointerUp, () => {
					i || v.current === "mouse" && y();
				}),
				onPointerDown: N(o.onPointerDown, (e) => {
					v.current = e.pointerType;
				}),
				onPointerMove: N(o.onPointerMove, (e) => {
					v.current = e.pointerType, i ? c.onItemLeave?.() : v.current === "mouse" && e.currentTarget.focus({ preventScroll: !0 });
				}),
				onPointerLeave: N(o.onPointerLeave, (e) => {
					e.currentTarget === document.activeElement && c.onItemLeave?.();
				}),
				onKeyDown: N(o.onKeyDown, (e) => {
					i || e.target !== e.currentTarget || (c.searchRef?.current === "" || e.key !== " ") && (Us.includes(e.key) && y(), e.key === " " && e.preventDefault());
				})
			})
		})
	});
}, "SelectItem")), Pc = "SelectItemText", Fc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, className: r, style: i, ...a } = e, o = Qs(Pc, n), s = gc(Pc, n), c = Mc(Pc, n), l = ec(Pc, n), [u, d] = B.useState(null), f = j((e) => s.itemTextRefCallback?.(e, c.value, c.disabled)), p = P(t, d, c.onItemTextChange, f), m = u?.textContent, h = B.useMemo(() => /* @__PURE__ */ q("option", {
		value: c.value,
		disabled: c.disabled,
		children: m
	}, c.value), [
		c.disabled,
		c.value,
		m
	]), { onNativeOptionAdd: g, onNativeOptionRemove: _ } = l;
	return S(() => (g(h), () => _(h)), [
		g,
		_,
		h
	]), /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q(F.span, {
		id: c.textId,
		...a,
		ref: p
	}), c.isSelected && o.valueNode && !o.valueNodeHasChildren && !qc(o.value) ? zn.createPortal(a.children, o.valueNode) : null] });
}, "SelectItemText")), Ic = "SelectItemIndicator", Lc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, ...r } = e;
	return Mc(Ic, n).isSelected ? /* @__PURE__ */ q(F.span, {
		"aria-hidden": !0,
		...r,
		ref: t
	}) : null;
}, "SelectItemIndicator")), Rc = "SelectScrollUpButton", zc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let n = gc(Rc, e.__scopeSelect), r = Sc(Rc, e.__scopeSelect), [i, a] = B.useState(!1), o = P(t, r.onScrollButtonChange);
	return S(() => {
		if (n.viewport && n.isPositioned) {
			let e = function() {
				let e = t.scrollTop > 0;
				a(e);
			};
			Y(e, "handleScroll");
			let t = n.viewport;
			return e(), t.addEventListener("scroll", e), () => t.removeEventListener("scroll", e);
		}
	}, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ q(Hc, {
		...e,
		ref: o,
		onAutoScroll: () => {
			let { viewport: e, selectedItem: t } = n;
			e && t && (e.scrollTop -= t.offsetHeight);
		}
	}) : null;
}, "SelectScrollUpButton")), Bc = "SelectScrollDownButton", Vc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let n = gc(Bc, e.__scopeSelect), r = Sc(Bc, e.__scopeSelect), [i, a] = B.useState(!1), o = P(t, r.onScrollButtonChange);
	return S(() => {
		if (n.viewport && n.isPositioned) {
			let e = function() {
				let e = t.scrollHeight - t.clientHeight, n = Math.ceil(t.scrollTop) < e;
				a(n);
			};
			Y(e, "handleScroll");
			let t = n.viewport;
			return e(), t.addEventListener("scroll", e), () => t.removeEventListener("scroll", e);
		}
	}, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ q(Hc, {
		...e,
		ref: o,
		onAutoScroll: () => {
			let { viewport: e, selectedItem: t } = n;
			e && t && (e.scrollTop += t.offsetHeight);
		}
	}) : null;
}, "SelectScrollDownButton")), Hc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, onAutoScroll: r, ...i } = e, a = gc("SelectScrollButton", n), o = B.useRef(null), s = Ks(n), c = B.useCallback(() => {
		o.current !== null && (window.clearInterval(o.current), o.current = null);
	}, []);
	return B.useEffect(() => () => c(), [c]), S(() => {
		s().find((e) => e.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
	}, [s]), /* @__PURE__ */ q(F.div, {
		"aria-hidden": !0,
		...i,
		ref: t,
		style: {
			flexShrink: 0,
			...i.style
		},
		onPointerDown: N(i.onPointerDown, () => {
			o.current === null && (o.current = window.setInterval(r, 50));
		}),
		onPointerMove: N(i.onPointerMove, () => {
			a.onItemLeave?.(), o.current === null && (o.current = window.setInterval(r, 50));
		}),
		onPointerLeave: N(i.onPointerLeave, () => {
			c();
		})
	});
}, "SelectScrollButtonImpl")), Uc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function(e, t) {
	let { __scopeSelect: n, ...r } = e;
	return /* @__PURE__ */ q(F.div, {
		"aria-hidden": !0,
		...r,
		ref: t
	});
}, "SelectSeparator")), Wc = "SelectBubbleInput", Gc = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ Y(function({ __scopeSelect: e, ...t }, n) {
	let r = Qs(Wc, e), { value: i, onValueChange: a, required: o, disabled: s, name: c, autoComplete: l, form: u } = r, { nativeOptions: d, nativeSelectKey: f } = r, p = B.useRef(null), m = P(n, p), h = i ?? "", g = Rs(h), _ = Array.from(d).some((e) => (e.props.value ?? "") === "");
	return B.useEffect(() => {
		let e = p.current;
		if (!e) return;
		let t = window.HTMLSelectElement.prototype, n = Object.getOwnPropertyDescriptor(t, "value").set;
		if (g !== h && n) {
			let t = new Event("change", { bubbles: !0 });
			n.call(e, h), e.dispatchEvent(t);
		}
	}, [g, h]), /* @__PURE__ */ J(F.select, {
		"aria-hidden": !0,
		required: o,
		tabIndex: -1,
		name: c,
		autoComplete: l,
		disabled: s,
		form: u,
		onChange: (e) => a(e.target.value),
		...t,
		style: {
			...ne,
			...t.style
		},
		ref: m,
		defaultValue: h,
		children: [qc(i) && !_ ? /* @__PURE__ */ q("option", { value: "" }) : null, Array.from(d)]
	}, f);
}, "SelectBubbleInput"));
function Kc(e) {
	return typeof e == "function";
}
Y(Kc, "isFunction");
function qc(e) {
	return e === "" || e === void 0;
}
Y(qc, "shouldShowPlaceholder");
function Jc(e) {
	let t = j(e), n = B.useRef(""), r = B.useRef(0), i = B.useCallback((e) => {
		let i = n.current + e;
		t(i), (/* @__PURE__ */ Y((function e(t) {
			n.current = t, window.clearTimeout(r.current), t !== "" && (r.current = window.setTimeout(() => e(""), 1e3));
		}), "updateSearch"))(i);
	}, [t]), a = B.useCallback(() => {
		n.current = "", window.clearTimeout(r.current);
	}, []);
	return B.useEffect(() => () => window.clearTimeout(r.current), []), [
		n,
		i,
		a
	];
}
Y(Jc, "useTypeaheadSearch");
function Yc(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = Xc(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.textValue.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
Y(Yc, "findNextItem");
function Xc(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
Y(Xc, "wrapArray");
//#endregion
//#region src/components/atoms/Select/Select.tsx
var Zc = nc, Qc = Dc, $c = oc, el = V(({ className: e, children: t, error: n, asChild: r, ...i }, a) => {
	let o = I("flex h-10 w-full items-center justify-between rounded-md border px-3 py-2 text-sm text-left", "bg-[var(--field-bg)]", "placeholder:text-muted-foreground", "focus:outline-none focus:ring-1", "disabled:cursor-not-allowed disabled:opacity-50", "transition-colors", n ? "border-error-500/50 focus:border-error-500 focus:ring-error-500" : "border-border focus:border-[color:var(--ring-color)] focus:ring-[color:var(--ring-color)]", "[&>span]:line-clamp-1 [&>span]:text-left", e);
	return r ? /* @__PURE__ */ q(ic, {
		ref: a,
		className: o,
		asChild: !0,
		...i,
		children: t
	}) : /* @__PURE__ */ J(ic, {
		ref: a,
		className: o,
		...i,
		children: [t, /* @__PURE__ */ q(sc, {
			asChild: !0,
			children: /* @__PURE__ */ q(R, { className: "h-4 w-4 text-text-placeholder" })
		})]
	});
});
el.displayName = "SelectTrigger";
var tl = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(zc, {
	ref: n,
	className: I("flex cursor-default items-center justify-center py-1", e),
	...t,
	children: /* @__PURE__ */ q(Kt, { className: "h-4 w-4" })
}));
tl.displayName = "SelectScrollUpButton";
var nl = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(Vc, {
	ref: n,
	className: I("flex cursor-default items-center justify-center py-1", e),
	...t,
	children: /* @__PURE__ */ q(R, { className: "h-4 w-4" })
}));
nl.displayName = "SelectScrollDownButton";
var rl = V(({ className: e, children: t, position: n = "popper", ...r }, i) => /* @__PURE__ */ q(uc, { children: /* @__PURE__ */ J(fc, {
	ref: i,
	className: I("relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border", "bg-surface text-text-primary shadow-md border-border", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", "data-[side=bottom]:slide-in-from-top-2", "data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2", "data-[side=top]:slide-in-from-bottom-2", n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", e),
	position: n,
	...r,
	children: [
		/* @__PURE__ */ q(tl, {}),
		/* @__PURE__ */ q(wc, {
			className: I("p-1.5", n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"),
			children: t
		}),
		/* @__PURE__ */ q(nl, {})
	]
}) }));
rl.displayName = "SelectContent";
var il = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(kc, {
	ref: n,
	className: I("py-2 pl-8 pr-2 text-sm font-semibold text-text-primary", e),
	...t
}));
il.displayName = "SelectLabel";
var al = V(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ J(Nc, {
	ref: r,
	className: I("relative flex w-full cursor-default select-none items-center rounded-md py-2 pl-8 pr-2 text-sm", "outline-none", "focus:bg-surface-hover focus:text-text-primary", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", e),
	...n,
	children: [/* @__PURE__ */ q("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ q(Lc, { children: /* @__PURE__ */ q(un, { className: "h-4 w-4 text-text-muted" }) })
	}), /* @__PURE__ */ q(Fc, { children: t })]
}));
al.displayName = "SelectItem";
var ol = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(Uc, {
	ref: n,
	className: I("-mx-1 my-1 h-px bg-border", e),
	...t
}));
ol.displayName = "SelectSeparator";
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-slider@1.5.0_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@_764b979897bd8e11b24e0a133366e2c3/node_modules/@radix-ui/react-slider/dist/index.mjs
var sl = Object.defineProperty, X = (e, t) => sl(e, "name", {
	value: t,
	configurable: !0
}), cl = {
	Vertical: "vertical",
	Horizontal: "horizontal"
}, ll = {
	LTR: "ltr",
	RTL: "rtl"
}, ul = ["PageUp", "PageDown"], dl = [
	"ArrowUp",
	"ArrowDown",
	"ArrowLeft",
	"ArrowRight"
], fl = {
	"from-left": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowLeft"
	],
	"from-right": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowRight"
	],
	"from-bottom": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowLeft"
	],
	"from-top": [
		"Home",
		"PageDown",
		"ArrowUp",
		"ArrowLeft"
	]
}, pl = "Slider", [ml, hl, gl] = pt(pl), [_l, vl] = se(pl, [gl]), [yl, bl] = _l(pl), xl = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { name: n, min: r = 0, max: i = 100, step: a = 1, orientation: o = cl.Horizontal, disabled: s = !1, minStepsBetweenThumbs: c = 0, preserveThumbOrder: l = !1, defaultValue: u = [r], value: d, onValueChange: f = /* @__PURE__ */ X(() => {}, "onValueChange"), onValueCommit: p = /* @__PURE__ */ X(() => {}, "onValueCommit"), inverted: m = !1, form: h, ...g } = e, _ = B.useRef(/* @__PURE__ */ new Set()), v = B.useRef(0), y = B.useRef(!1), b = o === cl.Horizontal ? wl : Tl, [x, S] = B.useState(null), C = P(t, S), [w = [], T] = Ct({
		prop: d,
		defaultProp: u,
		onChange: /* @__PURE__ */ X((e) => {
			[..._.current][v.current]?.focus({
				preventScroll: !0,
				focusVisible: y.current
			}), y.current = !1, f(e);
		}, "onChange")
	}), E = B.useRef(w), D = B.useRef(w);
	B.useEffect(() => {
		let e = h ? x?.ownerDocument.getElementById(h) : x?.closest("form");
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ X(() => T(D.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		x,
		h,
		T
	]);
	function O(e) {
		j(e, Ul(w, e));
	}
	X(O, "handleSlideStart");
	function k(e) {
		j(e, v.current);
	}
	X(k, "handleSlideMove");
	function A() {
		String(w) !== String(E.current) && p(w);
	}
	X(A, "handleSlideEnd");
	function j(e, t, { commit: n } = { commit: !1 }) {
		let o = Jl(a), s = Fs(Yl(Math.round((e - r) / a) * a + r, o), [r, i]);
		T((e = []) => {
			let o = c * a, u = l ? Fs(s, [e[t - 1] === void 0 ? r : e[t - 1] + o, e[t + 1] === void 0 ? i : e[t + 1] - o]) : s, d = Bl(e, u, t);
			if (Kl(d, o)) {
				v.current = l ? t : d.indexOf(u);
				let r = String(d) !== String(e);
				return r && n && p(d), r ? d : e;
			}
			return e;
		});
	}
	return X(j, "updateValues"), /* @__PURE__ */ q(yl, {
		scope: e.__scopeSlider,
		name: n,
		disabled: s,
		min: r,
		max: i,
		valueIndexToChangeRef: v,
		thumbs: _.current,
		values: w,
		orientation: o,
		form: h,
		children: /* @__PURE__ */ q(ml.Provider, {
			scope: e.__scopeSlider,
			children: /* @__PURE__ */ q(ml.Slot, {
				scope: e.__scopeSlider,
				children: /* @__PURE__ */ q(b, {
					"aria-disabled": s,
					"data-disabled": s ? "" : void 0,
					...g,
					ref: C,
					onPointerDown: N(g.onPointerDown, () => {
						s || (E.current = w, y.current = !1);
					}),
					min: r,
					max: i,
					inverted: m,
					onSlideStart: s ? void 0 : O,
					onSlideMove: s ? void 0 : k,
					onSlideEnd: s ? void 0 : A,
					onHomeKeyDown: () => {
						s || (y.current = !0, j(r, 0, { commit: !0 }));
					},
					onEndKeyDown: () => {
						s || (y.current = !0, j(i, w.length - 1, { commit: !0 }));
					},
					onStepKeyDown: ({ event: e, direction: t }) => {
						if (!s) {
							y.current = !0;
							let n = ul.includes(e.key) || e.shiftKey && dl.includes(e.key) ? 10 : 1, i = v.current, o = w[i];
							j(Xl(o, {
								min: r,
								step: a,
								direction: t,
								multiplier: n
							}), i, { commit: !0 });
						}
					}
				})
			})
		})
	});
}, "Slider")), [Sl, Cl] = _l(pl, {
	startEdge: "left",
	endEdge: "right",
	size: "width",
	direction: 1
}), wl = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { min: r, max: i, dir: a, inverted: o, onSlideStart: s, onSlideMove: c, onSlideEnd: l, onStepKeyDown: u, ...d } = e, [f, p] = B.useState(null), m = P(t, p), h = B.useRef(void 0), g = n(a), _ = g === ll.LTR, v = _ && !o || !_ && o;
	function y(e) {
		let t = h.current || f.getBoundingClientRect(), n = ql([0, t.width], v ? [r, i] : [i, r]);
		return h.current = t, n(e - t.left);
	}
	return X(y, "getValueFromPointer"), /* @__PURE__ */ q(Sl, {
		scope: e.__scopeSlider,
		startEdge: v ? "left" : "right",
		endEdge: v ? "right" : "left",
		direction: v ? 1 : -1,
		size: "width",
		children: /* @__PURE__ */ q(El, {
			dir: g,
			"data-orientation": "horizontal",
			...d,
			ref: m,
			style: {
				...d.style,
				"--radix-slider-thumb-transform": "translateX(-50%)"
			},
			onSlideStart: (e) => {
				let t = y(e.clientX);
				s?.(t);
			},
			onSlideMove: (e) => {
				let t = y(e.clientX);
				c?.(t);
			},
			onSlideEnd: () => {
				h.current = void 0, l?.();
			},
			onStepKeyDown: (e) => {
				let t = fl[v ? "from-left" : "from-right"].includes(e.key);
				u?.({
					event: e,
					direction: t ? -1 : 1
				});
			}
		})
	});
}, "SliderHorizontal")), Tl = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { min: n, max: r, inverted: i, onSlideStart: a, onSlideMove: o, onSlideEnd: s, onStepKeyDown: c, ...l } = e, u = B.useRef(null), d = P(t, u), f = B.useRef(void 0), p = !i;
	function m(e) {
		let t = f.current || u.current.getBoundingClientRect(), i = ql([0, t.height], p ? [r, n] : [n, r]);
		return f.current = t, i(e - t.top);
	}
	return X(m, "getValueFromPointer"), /* @__PURE__ */ q(Sl, {
		scope: e.__scopeSlider,
		startEdge: p ? "bottom" : "top",
		endEdge: p ? "top" : "bottom",
		size: "height",
		direction: p ? 1 : -1,
		children: /* @__PURE__ */ q(El, {
			"data-orientation": "vertical",
			...l,
			ref: d,
			style: {
				...l.style,
				"--radix-slider-thumb-transform": "translateY(50%)"
			},
			onSlideStart: (e) => {
				let t = m(e.clientY);
				a?.(t);
			},
			onSlideMove: (e) => {
				let t = m(e.clientY);
				o?.(t);
			},
			onSlideEnd: () => {
				f.current = void 0, s?.();
			},
			onStepKeyDown: (e) => {
				let t = fl[p ? "from-bottom" : "from-top"].includes(e.key);
				c?.({
					event: e,
					direction: t ? -1 : 1
				});
			}
		})
	});
}, "SliderVertical")), El = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { __scopeSlider: n, onSlideStart: r, onSlideMove: i, onSlideEnd: a, onHomeKeyDown: o, onEndKeyDown: s, onStepKeyDown: c, ...l } = e, u = bl(pl, n);
	return /* @__PURE__ */ q(F.span, {
		...l,
		ref: t,
		onKeyDown: N(e.onKeyDown, (e) => {
			e.key === "Home" ? (o(e), e.preventDefault()) : e.key === "End" ? (s(e), e.preventDefault()) : ul.concat(dl).includes(e.key) && (c(e), e.preventDefault());
		}),
		onPointerDown: N(e.onPointerDown, (e) => {
			let t = e.target;
			t.setPointerCapture(e.pointerId), e.preventDefault(), u.thumbs.has(t) ? t.focus({
				preventScroll: !0,
				focusVisible: !1
			}) : r(e);
		}),
		onPointerMove: N(e.onPointerMove, (e) => {
			e.target.hasPointerCapture(e.pointerId) && i(e);
		}),
		onPointerUp: N(e.onPointerUp, (e) => {
			let t = e.target;
			t.hasPointerCapture(e.pointerId) && (t.releasePointerCapture(e.pointerId), a(e));
		})
	});
}, "SliderImpl")), Dl = "SliderTrack", Ol = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { __scopeSlider: n, ...r } = e, i = bl(Dl, n);
	return /* @__PURE__ */ q(F.span, {
		"data-disabled": i.disabled ? "" : void 0,
		"data-orientation": i.orientation,
		...r,
		ref: t
	});
}, "SliderTrack")), kl = "SliderRange", Al = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { __scopeSlider: n, ...r } = e, i = bl(kl, n), a = Cl(kl, n), o = B.useRef(null), s = P(t, o), c = i.values.length, l = i.values.map((e) => Vl(e, i.min, i.max)), u = c > 1 ? Math.min(...l) : 0, d = 100 - Math.max(...l);
	return /* @__PURE__ */ q(F.span, {
		"data-orientation": i.orientation,
		"data-disabled": i.disabled ? "" : void 0,
		...r,
		ref: s,
		style: {
			...e.style,
			[a.startEdge]: u + "%",
			[a.endEdge]: d + "%"
		}
	});
}, "SliderRange")), [jl, Ml] = _l("SliderThumb"), Nl = "SliderThumbProvider";
function Pl(e) {
	let { __scopeSlider: t, name: n, children: r, internal_do_not_use_render: i } = e, a = bl(Nl, t), o = hl(t), [s, c] = B.useState(null), l = B.useMemo(() => s ? o().findIndex((e) => e.ref.current === s) : -1, [o, s]), u = we(s), d = !s || !!a.form || !!s.closest("form"), f = a.values[l], p = n ?? (a.name ? a.name + (a.values.length > 1 ? "[]" : "") : void 0), m = f === void 0 ? 0 : Vl(f, a.min, a.max);
	B.useEffect(() => {
		if (s) return a.thumbs.add(s), () => {
			a.thumbs.delete(s);
		};
	}, [s, a.thumbs]);
	let h = {
		value: f,
		name: p,
		form: a.form,
		isFormControl: d,
		index: l,
		thumb: s,
		onThumbChange: c,
		percent: m,
		size: u
	};
	return /* @__PURE__ */ q(jl, {
		scope: t,
		...h,
		children: Zl(i) ? i(h) : r
	});
}
X(Pl, "SliderThumbProvider");
var Fl = "SliderThumbTrigger", Il = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { __scopeSlider: n, ...r } = e, i = bl(Fl, n), a = Cl(Fl, n), { index: o, value: s, percent: c, size: l, onThumbChange: u } = Ml(Fl, n), d = P(t, u), f = Hl(o, i.values.length), p = l?.[a.size], m = p ? Wl(p, c, a.direction) : 0;
	return /* @__PURE__ */ q("span", {
		style: {
			transform: "var(--radix-slider-thumb-transform)",
			position: "absolute",
			[a.startEdge]: `calc(${c}% + ${m}px)`
		},
		children: /* @__PURE__ */ q(ml.ItemSlot, {
			scope: n,
			children: /* @__PURE__ */ q(F.span, {
				role: "slider",
				"aria-label": e["aria-label"] || f,
				"aria-valuemin": i.min,
				"aria-valuenow": s,
				"aria-valuemax": i.max,
				"aria-orientation": i.orientation,
				"data-orientation": i.orientation,
				"data-disabled": i.disabled ? "" : void 0,
				tabIndex: i.disabled ? void 0 : 0,
				...r,
				ref: d,
				style: s === void 0 ? { display: "none" } : e.style,
				onFocus: N(e.onFocus, () => {
					i.valueIndexToChangeRef.current = o;
				})
			})
		})
	});
}, "SliderThumbTrigger")), Ll = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { __scopeSlider: n, name: r, ...i } = e;
	return /* @__PURE__ */ q(Pl, {
		__scopeSlider: n,
		name: r,
		internal_do_not_use_render: ({ index: e, isFormControl: r }) => /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q(Il, {
			...i,
			ref: t,
			__scopeSlider: n
		}), r ? /* @__PURE__ */ q(zl, { __scopeSlider: n }, e) : null] })
	});
}, "SliderThumb")), Rl = "SliderBubbleInput", zl = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ X(function({ __scopeSlider: e, ...t }, n) {
	let { value: r, name: i, form: a } = Ml(Rl, e), o = B.useRef(null), s = P(o, n), c = Rs(r);
	return B.useEffect(() => {
		let e = o.current;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "value").set;
		if (c !== r && n) {
			let t = new Event("input", { bubbles: !0 });
			n.call(e, r), e.dispatchEvent(t);
		}
	}, [c, r]), /* @__PURE__ */ q(F.input, {
		style: { display: "none" },
		name: i,
		form: a,
		...t,
		ref: s,
		defaultValue: r
	});
}, "SliderBubbleInput"));
function Bl(e = [], t, n) {
	let r = [...e];
	return r[n] = t, r.sort((e, t) => e - t);
}
X(Bl, "getNextSortedValues");
function Vl(e, t, n) {
	return Fs(100 / (n - t) * (e - t), [0, 100]);
}
X(Vl, "convertValueToPercentage");
function Hl(e, t) {
	if (t > 2) return `Value ${e + 1} of ${t}`;
	if (t === 2) return ["Minimum", "Maximum"][e];
}
X(Hl, "getLabel");
function Ul(e, t) {
	if (e.length === 1) return 0;
	let n = e.map((e) => Math.abs(e - t)), r = Math.min(...n);
	return n.indexOf(r);
}
X(Ul, "getClosestValueIndex");
function Wl(e, t, n) {
	let r = e / 2;
	return (r - ql([0, 50], [0, r])(t) * n) * n;
}
X(Wl, "getThumbInBoundsOffset");
function Gl(e) {
	return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
X(Gl, "getStepsBetweenValues");
function Kl(e, t) {
	if (t > 0) {
		let n = Gl(e);
		return Math.min(...n) >= t;
	}
	return !0;
}
X(Kl, "hasMinStepsBetweenValues");
function ql(e, t) {
	return (n) => {
		if (e[0] === e[1] || t[0] === t[1]) return t[0];
		let r = (t[1] - t[0]) / (e[1] - e[0]);
		return t[0] + r * (n - e[0]);
	};
}
X(ql, "linearScale");
function Jl(e) {
	if (!Number.isFinite(e)) return 0;
	let t = e.toString();
	if (t.includes("e")) {
		let [e, n] = t.split("e"), r = e.split(".")[1] || "", i = Number(n);
		return Math.max(0, r.length - i);
	}
	let n = t.split(".")[1];
	return n ? n.length : 0;
}
X(Jl, "getDecimalCount");
function Yl(e, t) {
	let n = 10 ** t;
	return Math.round(e * n) / n;
}
X(Yl, "roundValue");
function Xl(e, { min: t, step: n, direction: r, multiplier: i }) {
	let a = Jl(n), o = (e - t) / n, s = Math.round(o), c = Yl(s * n + t, a) === Yl(e, a), l;
	return l = c ? s + i * r : r > 0 ? Math.ceil(o) : Math.floor(o), Yl(l * n + t, a);
}
X(Xl, "getNextStepValue");
function Zl(e) {
	return typeof e == "function";
}
X(Zl, "isFunction");
//#endregion
//#region src/components/atoms/Slider/Slider.tsx
var Ql = {
	default: {
		range: "bg-gradient-to-r from-slate-500 to-slate-600 dark:from-slate-400 dark:to-slate-500",
		thumb: "border-slate-500 dark:border-slate-400",
		focus: "focus-visible:ring-slate-500 dark:focus-visible:ring-slate-400"
	},
	brand: {
		range: "bg-gradient-to-r from-amber-400 to-amber-500 dark:from-amber-300 dark:to-amber-400",
		thumb: "border-amber-500 dark:border-amber-400",
		focus: "focus-visible:ring-amber-500 dark:focus-visible:ring-amber-400"
	},
	success: {
		range: "bg-gradient-to-r from-emerald-500 to-emerald-600 dark:from-emerald-400 dark:to-emerald-500",
		thumb: "border-emerald-500 dark:border-emerald-400",
		focus: "focus-visible:ring-emerald-500 dark:focus-visible:ring-emerald-400"
	},
	warning: {
		range: "bg-gradient-to-r from-amber-400 to-yellow-500 dark:from-amber-300 dark:to-yellow-400",
		thumb: "border-amber-500 dark:border-amber-400",
		focus: "focus-visible:ring-amber-500 dark:focus-visible:ring-amber-400"
	},
	error: {
		range: "bg-gradient-to-r from-rose-500 to-rose-600 dark:from-rose-400 dark:to-rose-500",
		thumb: "border-rose-500 dark:border-rose-400",
		focus: "focus-visible:ring-rose-500 dark:focus-visible:ring-rose-400"
	}
}, $l = {
	sm: {
		root: "py-2",
		track: "h-1.5",
		thumb: "h-4 w-4"
	},
	md: {
		root: "py-3",
		track: "h-2",
		thumb: "h-5 w-5"
	},
	lg: {
		root: "py-4",
		track: "h-2.5",
		thumb: "h-6 w-6"
	}
}, eu = V(({ className: e, variant: t = "default", size: n = "md", ...r }, i) => {
	let a = Ql[t], o = $l[n];
	return /* @__PURE__ */ J(xl, {
		ref: i,
		className: I("relative flex w-full touch-none select-none items-center", o.root, e),
		...r,
		children: [/* @__PURE__ */ q(Ol, {
			className: I("relative w-full grow overflow-hidden rounded-full", "bg-slate-200 dark:bg-slate-700", o.track),
			children: /* @__PURE__ */ q(Al, { className: I("absolute h-full", a.range) })
		}), /* @__PURE__ */ q(Ll, { className: I("block rounded-full border-2 shadow-lg", "bg-white dark:bg-slate-900", "transition-all duration-200", "hover:shadow-xl hover:scale-110", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2", "dark:focus-visible:ring-offset-slate-900", "disabled:pointer-events-none disabled:opacity-50", a.thumb, a.focus, o.thumb) })]
	});
});
eu.displayName = "Slider";
//#endregion
//#region src/components/atoms/Spinner/Spinner.tsx
var tu = {
	sm: "h-4 w-4 border-2",
	md: "h-6 w-6 border-2",
	lg: "h-8 w-8 border-3"
}, nu = V(({ size: e = "md", className: t, ...n }, r) => /* @__PURE__ */ q("div", {
	ref: r,
	role: "status",
	"aria-label": "Loading",
	className: I("agn-spinner animate-spin rounded-full border-border-hover border-t-[var(--action-primary)]", tu[e], t),
	...n
}));
nu.displayName = "Spinner";
//#endregion
//#region src/components/atoms/Status/Status.tsx
var ru = {
	online: "bg-emerald-500",
	offline: "bg-slate-400",
	warning: "bg-amber-500",
	error: "bg-rose-500",
	maintenance: "bg-sky-500",
	pending: "bg-amber-500",
	inactive: "bg-slate-300"
}, iu = V(({ className: e, status: t = "offline", size: n, showDot: r = !0, animate: i = !1, children: a, ...o }, s) => /* @__PURE__ */ J("div", {
	ref: s,
	className: I(he({
		status: t,
		size: n
	}), e),
	...o,
	children: [r && /* @__PURE__ */ q("span", { className: I("h-1.5 w-1.5 rounded-full flex-shrink-0", ru[t] || ru.offline, i && "animate-blink") }), a]
}));
iu.displayName = "Status";
//#endregion
//#region src/components/atoms/Table/Table.tsx
var au = V(({ className: e, variant: t = "default", ...n }, r) => /* @__PURE__ */ q("div", {
	className: I("relative w-full overflow-auto", t === "modern" && "bg-surface border border-border rounded-xl overflow-hidden"),
	children: /* @__PURE__ */ q("table", {
		ref: r,
		className: I("w-full caption-bottom text-sm", e),
		...n
	})
}));
au.displayName = "Table";
var ou = V(({ className: e, variant: t = "default", ...n }, r) => /* @__PURE__ */ q("thead", {
	ref: r,
	className: I(t === "modern" ? "bg-[var(--table-band)] border-b border-border" : "[&_tr]:border-b", e),
	...n
}));
ou.displayName = "TableHeader";
var su = V(({ className: e, variant: t = "default", ...n }, r) => /* @__PURE__ */ q("tbody", {
	ref: r,
	className: I(t === "modern" ? "divide-y divide-border" : "[&_tr:last-child]:border-0", e),
	...n
}));
su.displayName = "TableBody";
var cu = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("tfoot", {
	ref: n,
	className: I("border-t bg-[var(--table-band)] font-medium [&>tr]:last:border-b-0", e),
	...t
}));
cu.displayName = "TableFooter";
var lu = V(({ className: e, variant: t = "default", ...n }, r) => /* @__PURE__ */ q("tr", {
	ref: r,
	className: I("transition-colors data-[state=selected]:bg-[var(--surface-selected)]", t === "modern" ? "hover:bg-surface-hover" : "border-b hover:bg-surface-hover", e),
	...n
}));
lu.displayName = "TableRow";
var uu = V(({ className: e, variant: t = "default", ...n }, r) => /* @__PURE__ */ q("th", {
	ref: r,
	className: I("h-12 px-4 text-left align-middle font-medium [&:has([role=checkbox])]:pr-0", t === "modern" ? "text-xs text-muted-foreground uppercase tracking-wider" : "text-text-muted", e),
	...n
}));
uu.displayName = "TableHead";
var du = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("td", {
	ref: n,
	className: I("p-4 align-middle text-text-primary [&:has([role=checkbox])]:pr-0", e),
	...t
}));
du.displayName = "TableCell";
var fu = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("caption", {
	ref: n,
	className: I("mt-4 text-sm text-text-muted", e),
	...t
}));
fu.displayName = "TableCaption";
//#endregion
//#region src/components/atoms/Textarea/Textarea.tsx
var pu = V(({ className: e, error: t, label: n, id: r, ...i }, a) => {
	let o = r || n?.toLowerCase().replace(/\s+/g, "-");
	return /* @__PURE__ */ J("div", {
		className: "w-full",
		children: [
			n && /* @__PURE__ */ q("label", {
				htmlFor: o,
				className: "block text-sm font-medium text-text-secondary mb-1.5",
				children: n
			}),
			/* @__PURE__ */ q("textarea", {
				ref: a,
				id: o,
				className: I("w-full min-h-[80px] px-3 py-2 bg-[var(--field-bg)]", "border border-border rounded-md", "text-text-primary placeholder-text-placeholder", "focus:outline-none focus:border-[color:var(--ring-color)] focus:ring-1 focus:ring-border", "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-surface-2", "transition-colors resize-y", t && "border-error-500 focus:ring-error-500", e),
				"aria-invalid": !!t,
				"aria-describedby": t ? `${o}-error` : void 0,
				...i
			}),
			t && /* @__PURE__ */ q("p", {
				id: `${o}-error`,
				className: "mt-1.5 text-sm text-error-600",
				children: t
			})
		]
	});
});
pu.displayName = "Textarea";
//#endregion
//#region src/components/atoms/TrustBadge/TrustBadge.tsx
function mu(e) {
	switch (e) {
		case 0: return "error";
		case 1: return "warning";
		case 2:
		case 3: return "success";
		default: return "success";
	}
}
//#endregion
//#region src/components/atoms/UserChip/UserChip.tsx
var hu = a([
	"inline-flex items-center gap-2",
	"transition-colors",
	"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
	"dark:focus-visible:ring-offset-slate-900"
], {
	variants: {
		variant: {
			user: [],
			system: ["bg-slate-100 text-slate-600 border border-slate-200 rounded-md px-2 py-1", "dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700"]
		},
		size: {
			sm: "text-xs gap-1.5",
			md: "text-sm gap-2",
			lg: "text-base gap-2.5"
		},
		interactive: {
			true: "cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/50 rounded-md",
			false: ""
		}
	},
	compoundVariants: [{
		variant: "system",
		interactive: !0,
		className: "hover:bg-slate-200 dark:hover:bg-slate-700"
	}],
	defaultVariants: {
		variant: "user",
		size: "md",
		interactive: !1
	}
}), gu = {
	sm: "sm",
	md: "sm",
	lg: "md"
}, _u = {
	sm: "sm",
	md: "sm",
	lg: "md"
}, vu = {
	sm: "h-4 w-4",
	md: "h-5 w-5",
	lg: "h-6 w-6"
};
function yu(e) {
	if (!e?.trim()) return "?";
	let t = e.trim().split(/\s+/), n = t[0] ?? "";
	if (t.length === 1) return n.charAt(0).toUpperCase();
	let r = t[t.length - 1] ?? "";
	return n.charAt(0).toUpperCase() + r.charAt(0).toUpperCase();
}
var bu = V(({ className: e, displayName: t, email: n, avatarUrl: r, initials: i, variant: a = "user", subsystem: o, role: s, href: c, size: l = "md", showEmail: u = !1, onClick: d, ...f }, p) => {
	let m = !!(c || d), h = a === "system", g = l ?? "md", _ = h ? o ? `System · ${o}` : "System" : t || "Unknown user", v = i || yu(t), y = h ? `System actor: ${o || "system"}` : _, b = I(hu({
		variant: a,
		size: l,
		interactive: m
	}), e), x = /* @__PURE__ */ J(K, { children: [
		h ? /* @__PURE__ */ q(jr, {
			className: I(vu[g], "text-slate-500 dark:text-slate-400"),
			"aria-hidden": "true"
		}) : /* @__PURE__ */ q(Ua, {
			src: r,
			alt: _,
			fallback: v,
			size: gu[g]
		}),
		/* @__PURE__ */ J("div", {
			className: "flex flex-col min-w-0",
			children: [/* @__PURE__ */ q("span", {
				className: I("truncate", h && "font-mono text-slate-600 dark:text-slate-300"),
				children: _
			}), u && n && !h && /* @__PURE__ */ q("span", {
				className: "text-xs text-slate-500 dark:text-slate-400 truncate",
				children: n
			})]
		}),
		s && !h && /* @__PURE__ */ q(Ms, {
			role: s,
			size: _u[g]
		})
	] });
	return c ? /* @__PURE__ */ q("a", {
		ref: p,
		href: c,
		className: b,
		onClick: d,
		"aria-label": y,
		...f,
		children: x
	}) : d ? /* @__PURE__ */ q("button", {
		ref: p,
		type: "button",
		className: b,
		onClick: d,
		"aria-label": y,
		...f,
		children: x
	}) : /* @__PURE__ */ q("span", {
		ref: p,
		className: b,
		...f,
		children: x
	});
});
bu.displayName = "UserChip";
//#endregion
//#region src/components/molecules/Card/Card.tsx
var xu = V(({ className: e, variant: t, interactive: n, padding: r, ...i }, a) => /* @__PURE__ */ q("div", {
	ref: a,
	className: I(Te({
		variant: t,
		interactive: n,
		padding: r
	}), e),
	...i
}));
xu.displayName = "Card";
var Su = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	className: I("flex flex-col space-y-1 p-4 pb-0", e),
	...t
}));
Su.displayName = "CardHeader";
var Cu = V(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ q("h3", {
	ref: r,
	className: I("text-lg font-semibold text-slate-900 dark:text-slate-100", e),
	...n,
	children: t
}));
Cu.displayName = "CardTitle";
var wu = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("p", {
	ref: n,
	className: I("text-sm text-slate-500 dark:text-slate-400", e),
	...t
}));
wu.displayName = "CardDescription";
var Tu = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	className: I("p-4", e),
	...t
}));
Tu.displayName = "CardContent";
var Eu = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	className: I("flex items-center px-4 pb-4 pt-0", e),
	...t
}));
Eu.displayName = "CardFooter";
//#endregion
//#region src/components/molecules/Alert/Alert.tsx
var Du = {
	default: null,
	success: Ot,
	warning: Me,
	error: tt,
	info: ye,
	purple: Nr
}, Ou = V(({ className: e, variant: t = "default", children: n, onDismiss: r, ...i }, a) => {
	let o = Du[t || "default"];
	return /* @__PURE__ */ J("div", {
		ref: a,
		role: "alert",
		className: I(Tn({ variant: t }), e),
		...i,
		children: [
			o && /* @__PURE__ */ q(o, { className: "h-5 w-5" }),
			/* @__PURE__ */ q("div", {
				className: "flex-1 min-w-0",
				children: n
			}),
			r && /* @__PURE__ */ q("button", {
				onClick: r,
				className: "shrink-0 p-1 hover:bg-black/5 dark:hover:bg-white/5 rounded transition-colors",
				"aria-label": "Dismiss alert",
				children: /* @__PURE__ */ q(O, { className: "h-4 w-4" })
			})
		]
	});
});
Ou.displayName = "Alert";
var ku = V(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ q("h5", {
	ref: r,
	className: I("font-medium leading-none tracking-tight", e),
	...n,
	children: t
}));
ku.displayName = "AlertTitle";
var Au = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("p", {
	ref: n,
	className: I("text-sm [&_p]:leading-relaxed", e),
	...t
}));
Au.displayName = "AlertDescription";
//#endregion
//#region src/components/molecules/ColoredSection/ColoredSection.tsx
var ju = a("rounded-md border", {
	variants: {
		color: {
			purple: ["bg-violet-50 border-violet-200", "dark:bg-violet-500/10 dark:border-violet-500/20"],
			blue: ["bg-blue-50 border-blue-200", "dark:bg-blue-500/10 dark:border-blue-500/20"],
			emerald: ["bg-emerald-50 border-emerald-200", "dark:bg-emerald-500/10 dark:border-emerald-500/20"],
			amber: ["bg-amber-50 border-amber-200", "dark:bg-amber-500/10 dark:border-amber-500/20"],
			slate: ["bg-slate-50 border-slate-200", "dark:bg-slate-800 dark:border-slate-700"],
			rose: ["bg-rose-50 border-rose-200", "dark:bg-rose-500/10 dark:border-rose-500/20"]
		},
		padding: {
			sm: "p-2",
			md: "p-2.5",
			lg: "p-3"
		}
	},
	defaultVariants: {
		color: "slate",
		padding: "md"
	}
}), Mu = V(({ className: e, color: t, padding: n, children: r, ...i }, a) => /* @__PURE__ */ q("div", {
	ref: a,
	className: I(ju({
		color: t,
		padding: n
	}), e),
	...i,
	children: r
}));
Mu.displayName = "ColoredSection";
//#endregion
//#region src/components/molecules/FormField/FormField.tsx
function Nu({ label: e, error: t, hint: n, required: r, children: i, className: a, id: o }) {
	let s = o || e?.toLowerCase().replace(/\s+/g, "-");
	return /* @__PURE__ */ J("div", {
		className: I("space-y-1.5", a),
		children: [
			e && /* @__PURE__ */ J("label", {
				htmlFor: s,
				className: "block text-sm font-medium text-slate-700 dark:text-slate-300",
				children: [e, r && /* @__PURE__ */ q("span", {
					className: "text-rose-500 ml-1",
					children: "*"
				})]
			}),
			i,
			n && !t && /* @__PURE__ */ q("p", {
				className: "text-sm text-slate-500 dark:text-slate-400",
				children: n
			}),
			t && /* @__PURE__ */ q("p", {
				id: `${s}-error`,
				className: "text-sm text-rose-600 dark:text-rose-400",
				children: t
			})
		]
	});
}
//#endregion
//#region src/components/molecules/IconButton/IconButton.tsx
var Pu = {
	sm: "h-8 w-8",
	md: "h-10 w-10",
	lg: "h-12 w-12"
}, Fu = {
	default: "bg-slate-100 hover:bg-slate-200 text-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-300",
	ghost: "hover:bg-slate-100 text-slate-700 dark:hover:bg-slate-800 dark:text-slate-300",
	primary: "bg-slate-900 hover:bg-slate-800 text-white dark:bg-white dark:hover:bg-slate-100 dark:text-slate-900"
}, Iu = V(({ className: e, icon: t, size: n = "md", variant: r = "default", ...i }, a) => /* @__PURE__ */ q("button", {
	ref: a,
	className: I("inline-flex items-center justify-center rounded-md transition-colors", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2", "dark:focus-visible:ring-slate-600 dark:ring-offset-slate-950", "disabled:pointer-events-none disabled:opacity-50", "[&_svg]:shrink-0", Pu[n], Fu[r], e),
	...i,
	children: t
}));
Iu.displayName = "IconButton";
//#endregion
//#region src/components/molecules/Dialog/Dialog.tsx
var Lu = lt, Ru = Tt, zu = Yt, Bu = Ft, Vu = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(vt, {
	ref: n,
	className: I("agn-dialog-overlay fixed inset-0 z-50 bg-slate-950/55 backdrop-blur-sm", "motion-safe:data-[state=open]:animate-in motion-safe:data-[state=closed]:animate-out", "motion-safe:data-[state=closed]:fade-out-0 motion-safe:data-[state=open]:fade-in-0", "motion-safe:duration-150", e),
	...t
}));
Vu.displayName = vt.displayName;
var Hu = a(I("agn-dialog-content fixed z-50", "w-full", "flex flex-col", "bg-white dark:bg-slate-900", "border border-slate-200 dark:border-slate-800", "rounded-xl shadow-xl shadow-slate-950/10 dark:shadow-slate-950/40", "focus:outline-none", "motion-safe:data-[state=open]:animate-in motion-safe:data-[state=closed]:animate-out", "motion-safe:data-[state=closed]:fade-out-0 motion-safe:data-[state=open]:fade-in-0", "motion-safe:data-[state=closed]:zoom-out-[0.98] motion-safe:data-[state=open]:zoom-in-[0.98]", "motion-safe:duration-150", "motion-safe:ease-[cubic-bezier(0.16,1,0.3,1)]"), {
	variants: {
		placement: {
			center: "left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]",
			docked: ""
		},
		size: {
			sm: "max-w-sm",
			md: "max-w-lg",
			lg: "max-w-2xl",
			xl: "max-w-4xl",
			full: "max-w-[min(96vw,72rem)] h-[min(92vh,56rem)]",
			screen: "max-w-[min(98vw,120rem)] h-[min(96vh,68rem)]"
		},
		padding: {
			default: "p-6 gap-4",
			none: "p-0 gap-0"
		}
	},
	defaultVariants: {
		placement: "center",
		size: "md",
		padding: "default"
	}
}), Uu = V(({ className: e, children: t, placement: n, size: r, padding: i, hideCloseButton: a = !1, maxHeight: o = "auto", ...s }, c) => /* @__PURE__ */ J(zu, { children: [/* @__PURE__ */ q(Vu, {}), /* @__PURE__ */ J(dn, {
	ref: c,
	className: I(Hu({
		placement: n,
		size: r,
		padding: i
	}), o === "90vh" && "max-h-[90vh] overflow-hidden", e),
	...s,
	children: [t, !a && /* @__PURE__ */ J(Ft, {
		className: I("agn-dialog-close absolute right-3 top-3 z-10", "inline-flex h-8 w-8 items-center justify-center rounded-md", "text-slate-500 dark:text-slate-400", "transition-colors", "hover:text-slate-900 hover:bg-slate-100", "dark:hover:text-slate-100 dark:hover:bg-slate-800", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400", "dark:focus-visible:ring-slate-600", "disabled:pointer-events-none disabled:opacity-40"),
		"aria-label": "Close dialog",
		children: [/* @__PURE__ */ q(O, { className: "h-4 w-4" }), /* @__PURE__ */ q("span", {
			className: "sr-only",
			children: "Close"
		})]
	})]
})] }));
Uu.displayName = dn.displayName;
var Wu = a(I("inline-flex shrink-0 items-center justify-center", "h-9 w-9 rounded-lg", "[&>svg]:h-[18px] [&>svg]:w-[18px]"), {
	variants: { tone: {
		neutral: "bg-slate-100 text-slate-600 dark:bg-slate-500/10 dark:text-slate-300",
		info: "bg-sky-500/10 text-sky-600 dark:bg-sky-500/10 dark:text-sky-300",
		success: "bg-emerald-500/10 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-300",
		warning: "bg-amber-500/10 text-amber-600 dark:bg-amber-500/10 dark:text-amber-300",
		destructive: "bg-rose-500/10 text-rose-600 dark:bg-rose-500/10 dark:text-rose-300",
		brand: "bg-amber-500/10 text-amber-600 dark:bg-amber-500/10 dark:text-amber-300"
	} },
	defaultVariants: { tone: "neutral" }
}), Gu = V(({ className: e, tone: t, children: n, ...r }, i) => /* @__PURE__ */ q("span", {
	ref: i,
	"aria-hidden": !0,
	className: I("agn-dialog-icon", Wu({ tone: t }), e),
	...r,
	children: n
}));
Gu.displayName = "DialogIcon";
var Ku = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("span", {
	ref: n,
	className: I("inline-block text-[11px] font-medium uppercase tracking-[0.08em]", "text-slate-500 dark:text-slate-400", e),
	...t
}));
Ku.displayName = "DialogEyebrow";
var qu = V(({ className: e, icon: t, children: n, ...r }, i) => t ? /* @__PURE__ */ J("div", {
	ref: i,
	className: I("agn-dialog-header flex items-start gap-3 text-left", e),
	...r,
	children: [t, /* @__PURE__ */ q("div", {
		className: "flex flex-1 flex-col space-y-1.5 min-w-0",
		children: n
	})]
}) : /* @__PURE__ */ q("div", {
	ref: i,
	className: I("agn-dialog-header flex flex-col space-y-1.5 text-left", e),
	...r,
	children: n
}));
qu.displayName = "DialogHeader";
var Ju = a(I("min-h-0 flex-1", "[mask-image:linear-gradient(to_bottom,transparent_0,black_12px,black_calc(100%-12px),transparent_100%)]"), {
	variants: {
		scroll: {
			auto: "overflow-y-auto",
			none: "overflow-visible"
		},
		padding: {
			default: "",
			comfortable: "space-y-4",
			compact: "space-y-2",
			none: ""
		},
		bleed: {
			true: "px-6 py-5",
			false: ""
		}
	},
	defaultVariants: {
		scroll: "auto",
		padding: "comfortable",
		bleed: !1
	}
}), Yu = V(({ className: e, scroll: t, padding: n, bleed: r, ...i }, a) => /* @__PURE__ */ q("div", {
	ref: a,
	className: I("agn-dialog-body", Ju({
		scroll: t,
		padding: n,
		bleed: r
	}), e),
	...i
}));
Yu.displayName = "DialogBody";
var Xu = a(I("flex flex-col-reverse gap-2", "sm:flex-row sm:justify-end sm:gap-2"), {
	variants: { tone: {
		plain: "",
		framed: I("border-t border-slate-200 dark:border-slate-800/60", "bg-slate-50/60 dark:bg-slate-900/40", "px-6 py-4")
	} },
	defaultVariants: { tone: "plain" }
}), Zu = V(({ className: e, tone: t, ...n }, r) => /* @__PURE__ */ q("div", {
	ref: r,
	className: I("agn-dialog-footer", Xu({ tone: t }), e),
	...n
}));
Zu.displayName = "DialogFooter";
var Qu = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(zt, {
	ref: n,
	className: I("agn-dialog-title text-base font-semibold leading-snug tracking-tight", "text-slate-900 dark:text-slate-100", e),
	...t
}));
Qu.displayName = zt.displayName;
var $u = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(ft, {
	ref: n,
	className: I("text-sm leading-relaxed text-slate-500 dark:text-slate-400", e),
	...t
}));
$u.displayName = ft.displayName;
function ed(e) {
	let [t, n] = G(!1), r = W(null);
	return U(() => {
		let t = e.current;
		if (!t) return;
		let i = () => {
			r.current = null, n(t.scrollTop > 1);
		}, a = () => {
			r.current === null && (r.current = requestAnimationFrame(i));
		};
		return i(), t.addEventListener("scroll", a, { passive: !0 }), () => {
			t.removeEventListener("scroll", a), r.current !== null && cancelAnimationFrame(r.current);
		};
	}, [e]), t;
}
//#endregion
//#region src/components/molecules/ConfirmDialog/ConfirmDialog.tsx
var td = {
	info: "info",
	warning: "warning",
	destructive: "destructive"
}, nd = {
	info: "primary",
	warning: "primary",
	destructive: "destructive"
}, rd = {
	info: /* @__PURE__ */ q(ye, {}),
	warning: /* @__PURE__ */ q(Me, {}),
	destructive: /* @__PURE__ */ q(Zt, {})
}, id = V(function({ open: e, onOpenChange: t, title: n, description: r, tone: i = "info", icon: a, children: o, confirmLabel: s, cancelLabel: c = "Cancel", confirmByTyping: l, confirmByTypingPlaceholder: u, confirmByTypingLabel: d, loading: f = !1, blocked: p = !1, onConfirm: m, onCancel: h }, g) {
	let _ = Fn(), [v, y] = G("");
	U(() => {
		e || y("");
	}, [e]);
	let b = !l || v === l, x = f || p || !b;
	return /* @__PURE__ */ q(Lu, {
		open: e,
		onOpenChange: (e) => {
			f || (e || h?.(), t(e));
		},
		children: /* @__PURE__ */ J(Uu, {
			ref: g,
			size: "md",
			children: [
				/* @__PURE__ */ J(qu, {
					icon: /* @__PURE__ */ q(Gu, {
						tone: td[i],
						children: a ?? rd[i]
					}),
					children: [/* @__PURE__ */ q(Qu, { children: n }), r ? /* @__PURE__ */ q($u, { children: r }) : null]
				}),
				(o || l) && /* @__PURE__ */ J(Yu, {
					scroll: "none",
					padding: "comfortable",
					children: [o, l && /* @__PURE__ */ J("div", {
						className: "space-y-2",
						children: [/* @__PURE__ */ q("label", {
							htmlFor: _,
							className: "block text-xs text-slate-500 dark:text-slate-400",
							children: d ?? /* @__PURE__ */ J(K, { children: [
								"Type",
								" ",
								/* @__PURE__ */ q("span", {
									className: "font-mono font-medium text-slate-700 dark:text-slate-200",
									children: l
								}),
								" ",
								"to confirm."
							] })
						}), /* @__PURE__ */ q(on, {
							id: _,
							type: "text",
							autoComplete: "off",
							spellCheck: !1,
							placeholder: u,
							value: v,
							onChange: (e) => y(e.target.value),
							disabled: f,
							"aria-invalid": !b && v.length > 0
						})]
					})]
				}),
				/* @__PURE__ */ J(Zu, { children: [/* @__PURE__ */ q(L, {
					variant: "outline",
					onClick: () => {
						f || (h?.(), t(!1));
					},
					disabled: f,
					"data-testid": "confirm-dialog-cancel",
					children: c
				}), /* @__PURE__ */ J(L, {
					variant: nd[i],
					onClick: m,
					disabled: x,
					"data-testid": "confirm-dialog-confirm",
					children: [f && /* @__PURE__ */ q(qe, { className: "h-4 w-4 animate-spin" }), s ?? (i === "destructive" ? "Delete" : "Confirm")]
				})] })
			]
		})
	});
});
id.displayName = "ConfirmDialog";
//#endregion
//#region src/components/molecules/SearchDropdown/SearchDropdown.tsx
function ad({ placeholder: e = "Search...", onSearch: t, onSelect: n, renderItem: r, getItemId: i, excludeIds: a = [], icon: o, addLabel: s = "Add", noResultsText: c = "No results found", typeToSearchText: l = "Type to search...", debounceMs: u = 300, className: d, align: f = "end" }) {
	let [p, m] = G(!1), [h, g] = G(""), [_, v] = G([]), [y, b] = G(!1), x = W(null), S = W(null);
	return U(() => {
		if (!p) return;
		let e = setTimeout(async () => {
			b(!0);
			try {
				let e = await t(h);
				v(e.filter((e) => !a.includes(i(e))));
			} catch {
				v([]);
			} finally {
				b(!1);
			}
		}, u);
		return () => clearTimeout(e);
	}, [
		h,
		p,
		t,
		a,
		i,
		u
	]), U(() => {
		let e = (e) => {
			S.current && !S.current.contains(e.target) && m(!1);
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, []), p ? /* @__PURE__ */ J("div", {
		ref: S,
		className: I("relative", d),
		children: [/* @__PURE__ */ J("div", {
			className: "agn-menu-search-field flex items-center gap-1 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 rounded-md px-2 py-1 shadow-sm",
			children: [
				o || /* @__PURE__ */ q(te, { className: "h-3 w-3 text-slate-400" }),
				/* @__PURE__ */ q(on, {
					ref: x,
					type: "text",
					variant: "inline",
					value: h,
					onChange: (e) => g(e.target.value),
					placeholder: e,
					className: "agn-field-bare w-36 text-xs text-primary dark:text-white placeholder-slate-400"
				}),
				y && /* @__PURE__ */ q(qe, { className: "h-3 w-3 animate-spin text-slate-400" }),
				/* @__PURE__ */ q(L, {
					variant: "ghost",
					size: "icon",
					onClick: () => m(!1),
					className: "h-5 w-5 p-0 text-slate-400 hover:text-secondary",
					children: /* @__PURE__ */ q(O, { className: "h-3 w-3" })
				})
			]
		}), /* @__PURE__ */ J("div", {
			className: I("absolute top-full mt-1 w-64 max-h-48 overflow-y-auto", "bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700", "rounded-md shadow-lg z-50", f === "start" ? "left-0" : "right-0"),
			children: [_.length === 0 && !y && /* @__PURE__ */ q("div", {
				className: "p-3 text-xs text-slate-400 dark:text-slate-500 text-center",
				children: h ? c : l
			}), _.map((e) => /* @__PURE__ */ q("button", {
				type: "button",
				onClick: () => {
					n(e), m(!1), g("");
				},
				className: I("w-full p-2 flex items-center gap-2 text-left text-sm", "hover:bg-slate-50 dark:hover:bg-slate-700/50", "transition-colors cursor-pointer", "border-none bg-transparent"),
				children: r(e)
			}, i(e)))]
		})]
	}) : /* @__PURE__ */ J(L, {
		size: "sm",
		variant: "ghost",
		onClick: () => {
			m(!0), g(""), setTimeout(() => x.current?.focus(), 0);
		},
		className: "h-7 px-2 text-xs",
		children: [/* @__PURE__ */ q(Ui, { className: "h-3 w-3 mr-1" }), s]
	});
}
ad.displayName = "SearchDropdown";
//#endregion
//#region src/components/molecules/SearchInput/SearchInput.tsx
var od = V(({ className: e, size: t = "md", onClear: n, onChange: r, value: i, label: a, id: o, placeholder: s = "Search...", ...c }, l) => {
	let [u, d] = G(""), f = i === void 0 ? u : i, p = o || a?.toLowerCase().replace(/\s+/g, "-"), m = (e) => {
		i === void 0 && d(e.target.value), r?.(e);
	}, h = () => {
		i === void 0 && d(""), n?.();
		let e = l && "current" in l ? l.current : null;
		if (e) {
			(Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set)?.call(e, "");
			let t = new Event("input", { bubbles: !0 });
			e.dispatchEvent(t);
		}
	}, g = {
		sm: "h-8 pl-9 pr-9 text-sm",
		md: "h-10 pl-11 pr-10 text-sm",
		lg: "h-12 pl-12 pr-11 text-base"
	}, _ = {
		sm: "h-4 w-4",
		md: "h-5 w-5",
		lg: "h-5 w-5"
	}, v = {
		sm: "left-2.5",
		md: "left-3",
		lg: "left-3.5"
	}, y = {
		sm: "right-2.5",
		md: "right-3",
		lg: "right-3.5"
	};
	return /* @__PURE__ */ J("div", {
		className: "w-full",
		children: [a && /* @__PURE__ */ q("label", {
			htmlFor: p,
			className: "block text-sm font-medium text-text-secondary mb-1.5",
			children: a
		}), /* @__PURE__ */ J("div", {
			className: "relative",
			children: [
				/* @__PURE__ */ q(te, {
					className: I("absolute top-1/2 -translate-y-1/2 text-text-placeholder z-10 pointer-events-none", _[t], v[t]),
					"aria-hidden": "true"
				}),
				/* @__PURE__ */ q("input", {
					ref: l,
					id: p,
					type: "text",
					value: f,
					onChange: m,
					placeholder: s,
					className: I("w-full bg-[var(--field-bg)] text-text-primary placeholder-text-placeholder", "border border-border rounded-lg", "transition-all duration-150", "focus:outline-none focus:border-info-500 focus:ring-2 focus:ring-info-500/20", "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-surface-2", g[t], e),
					role: "searchbox",
					"aria-label": a || "Search",
					...c
				}),
				f && /* @__PURE__ */ q("button", {
					type: "button",
					onClick: h,
					className: I("absolute top-1/2 -translate-y-1/2", "p-1 rounded-sm", "text-text-placeholder hover:text-text-muted", "focus:outline-none focus:ring-1 focus:ring-border-hover", "transition-colors", y[t]),
					"aria-label": "Clear search",
					children: /* @__PURE__ */ q(O, { className: _[t] })
				})
			]
		})]
	});
});
od.displayName = "SearchInput";
//#endregion
//#region src/components/molecules/Skeleton/Skeleton.tsx
var sd = V(({ className: e, variant: t = "default", animation: n = "pulse", ...r }, i) => /* @__PURE__ */ q("div", {
	ref: i,
	className: I("bg-slate-200 dark:bg-slate-800", {
		"animate-pulse": n === "pulse",
		"bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200 dark:from-slate-800 dark:via-slate-700 dark:to-slate-800 bg-[length:200%_100%] animate-shimmer": n === "wave"
	}, {
		"rounded-md": t === "default" || t === "rectangular",
		"rounded-full": t === "circular",
		"rounded h-4": t === "text"
	}, e),
	"aria-live": "polite",
	"aria-busy": "true",
	...r
}));
sd.displayName = "Skeleton";
var cd = V(({ className: e, lines: t = 3, lastLineWidth: n = "75%", ...r }, i) => /* @__PURE__ */ q("div", {
	ref: i,
	className: I("space-y-2", e),
	...r,
	children: Array.from({ length: t }).map((e, r) => /* @__PURE__ */ q(sd, {
		variant: "text",
		style: { width: r === t - 1 ? n : "100%" }
	}, r))
}));
cd.displayName = "SkeletonText";
var ld = V(({ className: e, size: t = "md", ...n }, r) => /* @__PURE__ */ q(sd, {
	ref: r,
	variant: "circular",
	className: I({
		sm: "h-8 w-8",
		md: "h-10 w-10",
		lg: "h-12 w-12",
		xl: "h-16 w-16"
	}[t], e),
	...n
}));
ld.displayName = "SkeletonAvatar";
var ud = V(({ className: e, hasImage: t = !0, imageHeight: n = "12rem", ...r }, i) => /* @__PURE__ */ J("div", {
	ref: i,
	className: I("rounded-lg border border-slate-200 dark:border-slate-800 p-4 space-y-4", e),
	...r,
	children: [t && /* @__PURE__ */ q(sd, {
		variant: "rectangular",
		style: { height: n }
	}), /* @__PURE__ */ J("div", {
		className: "space-y-2",
		children: [/* @__PURE__ */ q(sd, { className: "h-6 w-3/4" }), /* @__PURE__ */ q(cd, { lines: 2 })]
	})]
}));
ud.displayName = "SkeletonCard";
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ascending.js
function dd(e, t) {
	return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/descending.js
function fd(e, t) {
	return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisector.js
function pd(e) {
	let t, n, r;
	e.length === 2 ? (t = e === dd || e === fd ? e : md, n = e, r = e) : (t = dd, n = (t, n) => dd(e(t), n), r = (t, n) => e(t) - n);
	function i(e, r, i = 0, a = e.length) {
		if (i < a) {
			if (t(r, r) !== 0) return a;
			do {
				let t = i + a >>> 1;
				n(e[t], r) < 0 ? i = t + 1 : a = t;
			} while (i < a);
		}
		return i;
	}
	function a(e, r, i = 0, a = e.length) {
		if (i < a) {
			if (t(r, r) !== 0) return a;
			do {
				let t = i + a >>> 1;
				n(e[t], r) <= 0 ? i = t + 1 : a = t;
			} while (i < a);
		}
		return i;
	}
	function o(e, t, n = 0, a = e.length) {
		let o = i(e, t, n, a - 1);
		return o > n && r(e[o - 1], t) > -r(e[o], t) ? o - 1 : o;
	}
	return {
		left: i,
		center: o,
		right: a
	};
}
function md() {
	return 0;
}
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/number.js
function hd(e) {
	return e === null ? NaN : +e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisect.js
var gd = pd(dd), _d = gd.right;
gd.left, pd(hd).center;
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/extent.js
function vd(e, t) {
	let n, r;
	if (t === void 0) for (let t of e) t != null && (n === void 0 ? t >= t && (n = r = t) : (n > t && (n = t), r < t && (r = t)));
	else {
		let i = -1;
		for (let a of e) (a = t(a, ++i, e)) != null && (n === void 0 ? a >= a && (n = r = a) : (n > a && (n = a), r < a && (r = a)));
	}
	return [n, r];
}
//#endregion
//#region ../node_modules/.pnpm/internmap@2.0.3/node_modules/internmap/src/index.js
var yd = class extends Map {
	constructor(e, t = Cd) {
		if (super(), Object.defineProperties(this, {
			_intern: { value: /* @__PURE__ */ new Map() },
			_key: { value: t }
		}), e != null) for (let [t, n] of e) this.set(t, n);
	}
	get(e) {
		return super.get(bd(this, e));
	}
	has(e) {
		return super.has(bd(this, e));
	}
	set(e, t) {
		return super.set(xd(this, e), t);
	}
	delete(e) {
		return super.delete(Sd(this, e));
	}
};
function bd({ _intern: e, _key: t }, n) {
	let r = t(n);
	return e.has(r) ? e.get(r) : n;
}
function xd({ _intern: e, _key: t }, n) {
	let r = t(n);
	return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function Sd({ _intern: e, _key: t }, n) {
	let r = t(n);
	return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function Cd(e) {
	return typeof e == "object" && e ? e.valueOf() : e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ticks.js
var wd = Math.sqrt(50), Td = Math.sqrt(10), Ed = Math.sqrt(2);
function Dd(e, t, n) {
	let r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), a = r / 10 ** i, o = a >= wd ? 10 : a >= Td ? 5 : a >= Ed ? 2 : 1, s, c, l;
	return i < 0 ? (l = 10 ** -i / o, s = Math.round(e * l), c = Math.round(t * l), s / l < e && ++s, c / l > t && --c, l = -l) : (l = 10 ** i * o, s = Math.round(e / l), c = Math.round(t / l), s * l < e && ++s, c * l > t && --c), c < s && .5 <= n && n < 2 ? Dd(e, t, n * 2) : [
		s,
		c,
		l
	];
}
function Od(e, t, n) {
	if (t = +t, e = +e, n = +n, !(n > 0)) return [];
	if (e === t) return [e];
	let r = t < e, [i, a, o] = r ? Dd(t, e, n) : Dd(e, t, n);
	if (!(a >= i)) return [];
	let s = a - i + 1, c = Array(s);
	if (r) {
		if (o < 0) for (let e = 0; e < s; ++e) c[e] = (a - e) / -o;
		else for (let e = 0; e < s; ++e) c[e] = (a - e) * o;
	} else if (o < 0) for (let e = 0; e < s; ++e) c[e] = (i + e) / -o;
	else for (let e = 0; e < s; ++e) c[e] = (i + e) * o;
	return c;
}
function kd(e, t, n) {
	return t = +t, e = +e, n = +n, Dd(e, t, n)[2];
}
function Ad(e, t, n) {
	t = +t, e = +e, n = +n;
	let r = t < e, i = r ? kd(t, e, n) : kd(e, t, n);
	return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/max.js
function jd(e, t) {
	let n;
	if (t === void 0) for (let t of e) t != null && (n < t || n === void 0 && t >= t) && (n = t);
	else {
		let r = -1;
		for (let i of e) (i = t(i, ++r, e)) != null && (n < i || n === void 0 && i >= i) && (n = i);
	}
	return n;
}
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/min.js
function Md(e, t) {
	let n;
	if (t === void 0) for (let t of e) t != null && (n > t || n === void 0 && t >= t) && (n = t);
	else {
		let r = -1;
		for (let i of e) (i = t(i, ++r, e)) != null && (n > i || n === void 0 && i >= i) && (n = i);
	}
	return n;
}
//#endregion
//#region ../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/range.js
function Nd(e, t, n) {
	e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
	for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, a = Array(i); ++r < i;) a[r] = e + r * n;
	return a;
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/init.js
function Pd(e, t) {
	switch (arguments.length) {
		case 0: break;
		case 1:
			this.range(e);
			break;
		default: this.range(t).domain(e);
	}
	return this;
}
function Fd(e, t) {
	switch (arguments.length) {
		case 0: break;
		case 1:
			typeof e == "function" ? this.interpolator(e) : this.range(e);
			break;
		default: this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
	}
	return this;
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/ordinal.js
var Id = Symbol("implicit");
function Ld() {
	var e = new yd(), t = [], n = [], r = Id;
	function i(i) {
		let a = e.get(i);
		if (a === void 0) {
			if (r !== Id) return r;
			e.set(i, a = t.push(i) - 1);
		}
		return n[a % n.length];
	}
	return i.domain = function(n) {
		if (!arguments.length) return t.slice();
		t = [], e = new yd();
		for (let r of n) e.has(r) || e.set(r, t.push(r) - 1);
		return i;
	}, i.range = function(e) {
		return arguments.length ? (n = Array.from(e), i) : n.slice();
	}, i.unknown = function(e) {
		return arguments.length ? (r = e, i) : r;
	}, i.copy = function() {
		return Ld(t, n).unknown(r);
	}, Pd.apply(i, arguments), i;
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/band.js
function Rd() {
	var e = Ld().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, a, o, s = !1, c = 0, l = 0, u = .5;
	delete e.unknown;
	function d() {
		var e = t().length, d = i < r, f = d ? i : r, p = d ? r : i;
		a = (p - f) / Math.max(1, e - c + l * 2), s && (a = Math.floor(a)), f += (p - f - a * (e - c)) * u, o = a * (1 - c), s && (f = Math.round(f), o = Math.round(o));
		var m = Nd(e).map(function(e) {
			return f + a * e;
		});
		return n(d ? m.reverse() : m);
	}
	return e.domain = function(e) {
		return arguments.length ? (t(e), d()) : t();
	}, e.range = function(e) {
		return arguments.length ? ([r, i] = e, r = +r, i = +i, d()) : [r, i];
	}, e.rangeRound = function(e) {
		return [r, i] = e, r = +r, i = +i, s = !0, d();
	}, e.bandwidth = function() {
		return o;
	}, e.step = function() {
		return a;
	}, e.round = function(e) {
		return arguments.length ? (s = !!e, d()) : s;
	}, e.padding = function(e) {
		return arguments.length ? (c = Math.min(1, l = +e), d()) : c;
	}, e.paddingInner = function(e) {
		return arguments.length ? (c = Math.min(1, e), d()) : c;
	}, e.paddingOuter = function(e) {
		return arguments.length ? (l = +e, d()) : l;
	}, e.align = function(e) {
		return arguments.length ? (u = Math.max(0, Math.min(1, e)), d()) : u;
	}, e.copy = function() {
		return Rd(t(), [r, i]).round(s).paddingInner(c).paddingOuter(l).align(u);
	}, Pd.apply(d(), arguments);
}
//#endregion
//#region ../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/define.js
function zd(e, t, n) {
	e.prototype = t.prototype = n, n.constructor = e;
}
function Bd(e, t) {
	var n = Object.create(e.prototype);
	for (var r in t) n[r] = t[r];
	return n;
}
//#endregion
//#region ../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/color.js
function Vd() {}
var Hd = .7, Ud = 1 / Hd, Wd = "\\s*([+-]?\\d+)\\s*", Gd = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Kd = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", qd = /^#([0-9a-f]{3,8})$/, Jd = RegExp(`^rgb\\(${Wd},${Wd},${Wd}\\)$`), Yd = RegExp(`^rgb\\(${Kd},${Kd},${Kd}\\)$`), Xd = RegExp(`^rgba\\(${Wd},${Wd},${Wd},${Gd}\\)$`), Zd = RegExp(`^rgba\\(${Kd},${Kd},${Kd},${Gd}\\)$`), Qd = RegExp(`^hsl\\(${Gd},${Kd},${Kd}\\)$`), $d = RegExp(`^hsla\\(${Gd},${Kd},${Kd},${Gd}\\)$`), ef = {
	aliceblue: 15792383,
	antiquewhite: 16444375,
	aqua: 65535,
	aquamarine: 8388564,
	azure: 15794175,
	beige: 16119260,
	bisque: 16770244,
	black: 0,
	blanchedalmond: 16772045,
	blue: 255,
	blueviolet: 9055202,
	brown: 10824234,
	burlywood: 14596231,
	cadetblue: 6266528,
	chartreuse: 8388352,
	chocolate: 13789470,
	coral: 16744272,
	cornflowerblue: 6591981,
	cornsilk: 16775388,
	crimson: 14423100,
	cyan: 65535,
	darkblue: 139,
	darkcyan: 35723,
	darkgoldenrod: 12092939,
	darkgray: 11119017,
	darkgreen: 25600,
	darkgrey: 11119017,
	darkkhaki: 12433259,
	darkmagenta: 9109643,
	darkolivegreen: 5597999,
	darkorange: 16747520,
	darkorchid: 10040012,
	darkred: 9109504,
	darksalmon: 15308410,
	darkseagreen: 9419919,
	darkslateblue: 4734347,
	darkslategray: 3100495,
	darkslategrey: 3100495,
	darkturquoise: 52945,
	darkviolet: 9699539,
	deeppink: 16716947,
	deepskyblue: 49151,
	dimgray: 6908265,
	dimgrey: 6908265,
	dodgerblue: 2003199,
	firebrick: 11674146,
	floralwhite: 16775920,
	forestgreen: 2263842,
	fuchsia: 16711935,
	gainsboro: 14474460,
	ghostwhite: 16316671,
	gold: 16766720,
	goldenrod: 14329120,
	gray: 8421504,
	green: 32768,
	greenyellow: 11403055,
	grey: 8421504,
	honeydew: 15794160,
	hotpink: 16738740,
	indianred: 13458524,
	indigo: 4915330,
	ivory: 16777200,
	khaki: 15787660,
	lavender: 15132410,
	lavenderblush: 16773365,
	lawngreen: 8190976,
	lemonchiffon: 16775885,
	lightblue: 11393254,
	lightcoral: 15761536,
	lightcyan: 14745599,
	lightgoldenrodyellow: 16448210,
	lightgray: 13882323,
	lightgreen: 9498256,
	lightgrey: 13882323,
	lightpink: 16758465,
	lightsalmon: 16752762,
	lightseagreen: 2142890,
	lightskyblue: 8900346,
	lightslategray: 7833753,
	lightslategrey: 7833753,
	lightsteelblue: 11584734,
	lightyellow: 16777184,
	lime: 65280,
	limegreen: 3329330,
	linen: 16445670,
	magenta: 16711935,
	maroon: 8388608,
	mediumaquamarine: 6737322,
	mediumblue: 205,
	mediumorchid: 12211667,
	mediumpurple: 9662683,
	mediumseagreen: 3978097,
	mediumslateblue: 8087790,
	mediumspringgreen: 64154,
	mediumturquoise: 4772300,
	mediumvioletred: 13047173,
	midnightblue: 1644912,
	mintcream: 16121850,
	mistyrose: 16770273,
	moccasin: 16770229,
	navajowhite: 16768685,
	navy: 128,
	oldlace: 16643558,
	olive: 8421376,
	olivedrab: 7048739,
	orange: 16753920,
	orangered: 16729344,
	orchid: 14315734,
	palegoldenrod: 15657130,
	palegreen: 10025880,
	paleturquoise: 11529966,
	palevioletred: 14381203,
	papayawhip: 16773077,
	peachpuff: 16767673,
	peru: 13468991,
	pink: 16761035,
	plum: 14524637,
	powderblue: 11591910,
	purple: 8388736,
	rebeccapurple: 6697881,
	red: 16711680,
	rosybrown: 12357519,
	royalblue: 4286945,
	saddlebrown: 9127187,
	salmon: 16416882,
	sandybrown: 16032864,
	seagreen: 3050327,
	seashell: 16774638,
	sienna: 10506797,
	silver: 12632256,
	skyblue: 8900331,
	slateblue: 6970061,
	slategray: 7372944,
	slategrey: 7372944,
	snow: 16775930,
	springgreen: 65407,
	steelblue: 4620980,
	tan: 13808780,
	teal: 32896,
	thistle: 14204888,
	tomato: 16737095,
	turquoise: 4251856,
	violet: 15631086,
	wheat: 16113331,
	white: 16777215,
	whitesmoke: 16119285,
	yellow: 16776960,
	yellowgreen: 10145074
};
zd(Vd, of, {
	copy(e) {
		return Object.assign(new this.constructor(), this, e);
	},
	displayable() {
		return this.rgb().displayable();
	},
	hex: tf,
	formatHex: tf,
	formatHex8: nf,
	formatHsl: rf,
	formatRgb: af,
	toString: af
});
function tf() {
	return this.rgb().formatHex();
}
function nf() {
	return this.rgb().formatHex8();
}
function rf() {
	return yf(this).formatHsl();
}
function af() {
	return this.rgb().formatRgb();
}
function of(e) {
	var t, n;
	return e = (e + "").trim().toLowerCase(), (t = qd.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? sf(t) : n === 3 ? new df(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? cf(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? cf(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Jd.exec(e)) ? new df(t[1], t[2], t[3], 1) : (t = Yd.exec(e)) ? new df(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Xd.exec(e)) ? cf(t[1], t[2], t[3], t[4]) : (t = Zd.exec(e)) ? cf(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Qd.exec(e)) ? vf(t[1], t[2] / 100, t[3] / 100, 1) : (t = $d.exec(e)) ? vf(t[1], t[2] / 100, t[3] / 100, t[4]) : ef.hasOwnProperty(e) ? sf(ef[e]) : e === "transparent" ? new df(NaN, NaN, NaN, 0) : null;
}
function sf(e) {
	return new df(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function cf(e, t, n, r) {
	return r <= 0 && (e = t = n = NaN), new df(e, t, n, r);
}
function lf(e) {
	return e instanceof Vd || (e = of(e)), e ? (e = e.rgb(), new df(e.r, e.g, e.b, e.opacity)) : new df();
}
function uf(e, t, n, r) {
	return arguments.length === 1 ? lf(e) : new df(e, t, n, r ?? 1);
}
function df(e, t, n, r) {
	this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
zd(df, uf, Bd(Vd, {
	brighter(e) {
		return e = e == null ? Ud : Ud ** +e, new df(this.r * e, this.g * e, this.b * e, this.opacity);
	},
	darker(e) {
		return e = e == null ? Hd : Hd ** +e, new df(this.r * e, this.g * e, this.b * e, this.opacity);
	},
	rgb() {
		return this;
	},
	clamp() {
		return new df(gf(this.r), gf(this.g), gf(this.b), hf(this.opacity));
	},
	displayable() {
		return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
	},
	hex: ff,
	formatHex: ff,
	formatHex8: pf,
	formatRgb: mf,
	toString: mf
}));
function ff() {
	return `#${_f(this.r)}${_f(this.g)}${_f(this.b)}`;
}
function pf() {
	return `#${_f(this.r)}${_f(this.g)}${_f(this.b)}${_f((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function mf() {
	let e = hf(this.opacity);
	return `${e === 1 ? "rgb(" : "rgba("}${gf(this.r)}, ${gf(this.g)}, ${gf(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function hf(e) {
	return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function gf(e) {
	return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function _f(e) {
	return e = gf(e), (e < 16 ? "0" : "") + e.toString(16);
}
function vf(e, t, n, r) {
	return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new xf(e, t, n, r);
}
function yf(e) {
	if (e instanceof xf) return new xf(e.h, e.s, e.l, e.opacity);
	if (e instanceof Vd || (e = of(e)), !e) return new xf();
	if (e instanceof xf) return e;
	e = e.rgb();
	var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), a = Math.max(t, n, r), o = NaN, s = a - i, c = (a + i) / 2;
	return s ? (o = t === a ? (n - r) / s + (n < r) * 6 : n === a ? (r - t) / s + 2 : (t - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new xf(o, s, c, e.opacity);
}
function bf(e, t, n, r) {
	return arguments.length === 1 ? yf(e) : new xf(e, t, n, r ?? 1);
}
function xf(e, t, n, r) {
	this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
zd(xf, bf, Bd(Vd, {
	brighter(e) {
		return e = e == null ? Ud : Ud ** +e, new xf(this.h, this.s, this.l * e, this.opacity);
	},
	darker(e) {
		return e = e == null ? Hd : Hd ** +e, new xf(this.h, this.s, this.l * e, this.opacity);
	},
	rgb() {
		var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < .5 ? n : 1 - n) * t, i = 2 * n - r;
		return new df(wf(e >= 240 ? e - 240 : e + 120, i, r), wf(e, i, r), wf(e < 120 ? e + 240 : e - 120, i, r), this.opacity);
	},
	clamp() {
		return new xf(Sf(this.h), Cf(this.s), Cf(this.l), hf(this.opacity));
	},
	displayable() {
		return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
	},
	formatHsl() {
		let e = hf(this.opacity);
		return `${e === 1 ? "hsl(" : "hsla("}${Sf(this.h)}, ${Cf(this.s) * 100}%, ${Cf(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
	}
}));
function Sf(e) {
	return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Cf(e) {
	return Math.max(0, Math.min(1, e || 0));
}
function wf(e, t, n) {
	return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/constant.js
var Tf = (e) => () => e;
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/color.js
function Ef(e, t) {
	return function(n) {
		return e + n * t;
	};
}
function Df(e, t, n) {
	return e **= +n, t = t ** +n - e, n = 1 / n, function(r) {
		return (e + r * t) ** +n;
	};
}
function Of(e) {
	return (e = +e) == 1 ? kf : function(t, n) {
		return n - t ? Df(t, n, e) : Tf(isNaN(t) ? n : t);
	};
}
function kf(e, t) {
	var n = t - e;
	return n ? Ef(e, n) : Tf(isNaN(e) ? t : e);
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/rgb.js
var Af = (function e(t) {
	var n = Of(t);
	function r(e, t) {
		var r = n((e = uf(e)).r, (t = uf(t)).r), i = n(e.g, t.g), a = n(e.b, t.b), o = kf(e.opacity, t.opacity);
		return function(t) {
			return e.r = r(t), e.g = i(t), e.b = a(t), e.opacity = o(t), e + "";
		};
	}
	return r.gamma = e, r;
})(1);
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/numberArray.js
function jf(e, t) {
	t ||= [];
	var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
	return function(a) {
		for (i = 0; i < n; ++i) r[i] = e[i] * (1 - a) + t[i] * a;
		return r;
	};
}
function Mf(e) {
	return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/array.js
function Nf(e, t) {
	for (var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = Array(r), a = Array(n), o = 0; o < r; ++o) i[o] = Hf(e[o], t[o]);
	for (; o < n; ++o) a[o] = t[o];
	return function(e) {
		for (o = 0; o < r; ++o) a[o] = i[o](e);
		return a;
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/date.js
function Pf(e, t) {
	var n = /* @__PURE__ */ new Date();
	return e = +e, t = +t, function(r) {
		return n.setTime(e * (1 - r) + t * r), n;
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/number.js
function Ff(e, t) {
	return e = +e, t = +t, function(n) {
		return e * (1 - n) + t * n;
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/object.js
function If(e, t) {
	var n = {}, r = {}, i;
	for (i in (typeof e != "object" || !e) && (e = {}), (typeof t != "object" || !t) && (t = {}), t) i in e ? n[i] = Hf(e[i], t[i]) : r[i] = t[i];
	return function(e) {
		for (i in n) r[i] = n[i](e);
		return r;
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/string.js
var Lf = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Rf = new RegExp(Lf.source, "g");
function zf(e) {
	return function() {
		return e;
	};
}
function Bf(e) {
	return function(t) {
		return e(t) + "";
	};
}
function Vf(e, t) {
	var n = Lf.lastIndex = Rf.lastIndex = 0, r, i, a, o = -1, s = [], c = [];
	for (e += "", t += ""; (r = Lf.exec(e)) && (i = Rf.exec(t));) (a = i.index) > n && (a = t.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, c.push({
		i: o,
		x: Ff(r, i)
	})), n = Rf.lastIndex;
	return n < t.length && (a = t.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? c[0] ? Bf(c[0].x) : zf(t) : (t = c.length, function(e) {
		for (var n = 0, r; n < t; ++n) s[(r = c[n]).i] = r.x(e);
		return s.join("");
	});
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/value.js
function Hf(e, t) {
	var n = typeof t, r;
	return t == null || n === "boolean" ? Tf(t) : (n === "number" ? Ff : n === "string" ? (r = of(t)) ? (t = r, Af) : Vf : t instanceof of ? Af : t instanceof Date ? Pf : Mf(t) ? jf : Array.isArray(t) ? Nf : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? If : Ff)(e, t);
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/round.js
function Uf(e, t) {
	return e = +e, t = +t, function(n) {
		return Math.round(e * (1 - n) + t * n);
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/decompose.js
var Wf = 180 / Math.PI, Gf = {
	translateX: 0,
	translateY: 0,
	rotate: 0,
	skewX: 0,
	scaleX: 1,
	scaleY: 1
};
function Kf(e, t, n, r, i, a) {
	var o, s, c;
	return (o = Math.sqrt(e * e + t * t)) && (e /= o, t /= o), (c = e * n + t * r) && (n -= e * c, r -= t * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), e * r < t * n && (e = -e, t = -t, c = -c, o = -o), {
		translateX: i,
		translateY: a,
		rotate: Math.atan2(t, e) * Wf,
		skewX: Math.atan(c) * Wf,
		scaleX: o,
		scaleY: s
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/parse.js
var qf;
function Jf(e) {
	let t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
	return t.isIdentity ? Gf : Kf(t.a, t.b, t.c, t.d, t.e, t.f);
}
function Yf(e) {
	return e == null || (qf ||= document.createElementNS("http://www.w3.org/2000/svg", "g"), qf.setAttribute("transform", e), !(e = qf.transform.baseVal.consolidate())) ? Gf : (e = e.matrix, Kf(e.a, e.b, e.c, e.d, e.e, e.f));
}
//#endregion
//#region ../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/index.js
function Xf(e, t, n, r) {
	function i(e) {
		return e.length ? e.pop() + " " : "";
	}
	function a(e, r, i, a, o, s) {
		if (e !== i || r !== a) {
			var c = o.push("translate(", null, t, null, n);
			s.push({
				i: c - 4,
				x: Ff(e, i)
			}, {
				i: c - 2,
				x: Ff(r, a)
			});
		} else (i || a) && o.push("translate(" + i + t + a + n);
	}
	function o(e, t, n, a) {
		e === t ? t && n.push(i(n) + "rotate(" + t + r) : (e - t > 180 ? t += 360 : t - e > 180 && (e += 360), a.push({
			i: n.push(i(n) + "rotate(", null, r) - 2,
			x: Ff(e, t)
		}));
	}
	function s(e, t, n, a) {
		e === t ? t && n.push(i(n) + "skewX(" + t + r) : a.push({
			i: n.push(i(n) + "skewX(", null, r) - 2,
			x: Ff(e, t)
		});
	}
	function c(e, t, n, r, a, o) {
		if (e !== n || t !== r) {
			var s = a.push(i(a) + "scale(", null, ",", null, ")");
			o.push({
				i: s - 4,
				x: Ff(e, n)
			}, {
				i: s - 2,
				x: Ff(t, r)
			});
		} else (n !== 1 || r !== 1) && a.push(i(a) + "scale(" + n + "," + r + ")");
	}
	return function(t, n) {
		var r = [], i = [];
		return t = e(t), n = e(n), a(t.translateX, t.translateY, n.translateX, n.translateY, r, i), o(t.rotate, n.rotate, r, i), s(t.skewX, n.skewX, r, i), c(t.scaleX, t.scaleY, n.scaleX, n.scaleY, r, i), t = n = null, function(e) {
			for (var t = -1, n = i.length, a; ++t < n;) r[(a = i[t]).i] = a.x(e);
			return r.join("");
		};
	};
}
var Zf = Xf(Jf, "px, ", "px)", "deg)"), Qf = Xf(Yf, ", ", ")", ")"), $f = 1e-12;
function ep(e) {
	return ((e = Math.exp(e)) + 1 / e) / 2;
}
function tp(e) {
	return ((e = Math.exp(e)) - 1 / e) / 2;
}
function np(e) {
	return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
var rp = (function e(t, n, r) {
	function i(e, i) {
		var a = e[0], o = e[1], s = e[2], c = i[0], l = i[1], u = i[2], d = c - a, f = l - o, p = d * d + f * f, m, h;
		if (p < $f) h = Math.log(u / s) / t, m = function(e) {
			return [
				a + e * d,
				o + e * f,
				s * Math.exp(t * e * h)
			];
		};
		else {
			var g = Math.sqrt(p), _ = (u * u - s * s + r * p) / (2 * s * n * g), v = (u * u - s * s - r * p) / (2 * u * n * g), y = Math.log(Math.sqrt(_ * _ + 1) - _);
			h = (Math.log(Math.sqrt(v * v + 1) - v) - y) / t, m = function(e) {
				var r = e * h, i = ep(y), c = s / (n * g) * (i * np(t * r + y) - tp(y));
				return [
					a + c * d,
					o + c * f,
					s * i / ep(t * r + y)
				];
			};
		}
		return m.duration = h * 1e3 * t / Math.SQRT2, m;
	}
	return i.rho = function(t) {
		var n = Math.max(.001, +t), r = n * n;
		return e(n, r, r * r);
	}, i;
})(Math.SQRT2, 2, 4);
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/constant.js
function ip(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/number.js
function ap(e) {
	return +e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/continuous.js
var op = [0, 1];
function sp(e) {
	return e;
}
function cp(e, t) {
	return (t -= e = +e) ? function(n) {
		return (n - e) / t;
	} : ip(isNaN(t) ? NaN : .5);
}
function lp(e, t) {
	var n;
	return e > t && (n = e, e = t, t = n), function(n) {
		return Math.max(e, Math.min(t, n));
	};
}
function up(e, t, n) {
	var r = e[0], i = e[1], a = t[0], o = t[1];
	return i < r ? (r = cp(i, r), a = n(o, a)) : (r = cp(r, i), a = n(a, o)), function(e) {
		return a(r(e));
	};
}
function dp(e, t, n) {
	var r = Math.min(e.length, t.length) - 1, i = Array(r), a = Array(r), o = -1;
	for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < r;) i[o] = cp(e[o], e[o + 1]), a[o] = n(t[o], t[o + 1]);
	return function(t) {
		var n = _d(e, t, 1, r) - 1;
		return a[n](i[n](t));
	};
}
function fp(e, t) {
	return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function pp() {
	var e = op, t = op, n = Hf, r, i, a, o = sp, s, c, l;
	function u() {
		var n = Math.min(e.length, t.length);
		return o !== sp && (o = lp(e[0], e[n - 1])), s = n > 2 ? dp : up, c = l = null, d;
	}
	function d(i) {
		return i == null || isNaN(i = +i) ? a : (c ||= s(e.map(r), t, n))(r(o(i)));
	}
	return d.invert = function(n) {
		return o(i((l ||= s(t, e.map(r), Ff))(n)));
	}, d.domain = function(t) {
		return arguments.length ? (e = Array.from(t, ap), u()) : e.slice();
	}, d.range = function(e) {
		return arguments.length ? (t = Array.from(e), u()) : t.slice();
	}, d.rangeRound = function(e) {
		return t = Array.from(e), n = Uf, u();
	}, d.clamp = function(e) {
		return arguments.length ? (o = e ? !0 : sp, u()) : o !== sp;
	}, d.interpolate = function(e) {
		return arguments.length ? (n = e, u()) : n;
	}, d.unknown = function(e) {
		return arguments.length ? (a = e, d) : a;
	}, function(e, t) {
		return r = e, i = t, u();
	};
}
function mp() {
	return pp()(sp, sp);
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatDecimal.js
function hp(e) {
	return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function gp(e, t) {
	if (!isFinite(e) || e === 0) return null;
	var n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e"), r = e.slice(0, n);
	return [r.length > 1 ? r[0] + r.slice(2) : r, +e.slice(n + 1)];
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/exponent.js
function _p(e) {
	return e = gp(Math.abs(e)), e ? e[1] : NaN;
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatGroup.js
function vp(e, t) {
	return function(n, r) {
		for (var i = n.length, a = [], o = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(n.substring(i -= s, i + s)), !((c += s + 1) > r));) s = e[o = (o + 1) % e.length];
		return a.reverse().join(t);
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatNumerals.js
function yp(e) {
	return function(t) {
		return t.replace(/[0-9]/g, function(t) {
			return e[+t];
		});
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatSpecifier.js
var bp = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function xp(e) {
	if (!(t = bp.exec(e))) throw Error("invalid format: " + e);
	var t;
	return new Sp({
		fill: t[1],
		align: t[2],
		sign: t[3],
		symbol: t[4],
		zero: t[5],
		width: t[6],
		comma: t[7],
		precision: t[8] && t[8].slice(1),
		trim: t[9],
		type: t[10]
	});
}
xp.prototype = Sp.prototype;
function Sp(e) {
	this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
Sp.prototype.toString = function() {
	return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatTrim.js
function Cp(e) {
	out: for (var t = e.length, n = 1, r = -1, i; n < t; ++n) switch (e[n]) {
		case ".":
			r = i = n;
			break;
		case "0":
			r === 0 && (r = n), i = n;
			break;
		default:
			if (!+e[n]) break out;
			r > 0 && (r = 0);
	}
	return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatPrefixAuto.js
var wp;
function Tp(e, t) {
	var n = gp(e, t);
	if (!n) return wp = void 0, e.toPrecision(t);
	var r = n[0], i = n[1], a = i - (wp = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
	return a === o ? r : a > o ? r + Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + Array(1 - a).join("0") + gp(e, Math.max(0, t + a - 1))[0];
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatRounded.js
function Ep(e, t) {
	var n = gp(e, t);
	if (!n) return e + "";
	var r = n[0], i = n[1];
	return i < 0 ? "0." + Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + Array(i - r.length + 2).join("0");
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatTypes.js
var Dp = {
	"%": (e, t) => (e * 100).toFixed(t),
	b: (e) => Math.round(e).toString(2),
	c: (e) => e + "",
	d: hp,
	e: (e, t) => e.toExponential(t),
	f: (e, t) => e.toFixed(t),
	g: (e, t) => e.toPrecision(t),
	o: (e) => Math.round(e).toString(8),
	p: (e, t) => Ep(e * 100, t),
	r: Ep,
	s: Tp,
	X: (e) => Math.round(e).toString(16).toUpperCase(),
	x: (e) => Math.round(e).toString(16)
};
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/identity.js
function Op(e) {
	return e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/locale.js
var kp = Array.prototype.map, Ap = [
	"y",
	"z",
	"a",
	"f",
	"p",
	"n",
	"µ",
	"m",
	"",
	"k",
	"M",
	"G",
	"T",
	"P",
	"E",
	"Z",
	"Y"
];
function jp(e) {
	var t = e.grouping === void 0 || e.thousands === void 0 ? Op : vp(kp.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? Op : yp(kp.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
	function l(e, l) {
		e = xp(e);
		var u = e.fill, d = e.align, f = e.sign, p = e.symbol, m = e.zero, h = e.width, g = e.comma, _ = e.precision, v = e.trim, y = e.type;
		y === "n" ? (g = !0, y = "g") : Dp[y] || (_ === void 0 && (_ = 12), v = !0, y = "g"), (m || u === "0" && d === "=") && (m = !0, u = "0", d = "=");
		var b = (l && l.prefix !== void 0 ? l.prefix : "") + (p === "$" ? n : p === "#" && /[boxX]/.test(y) ? "0" + y.toLowerCase() : ""), x = (p === "$" ? r : /[%p]/.test(y) ? o : "") + (l && l.suffix !== void 0 ? l.suffix : ""), S = Dp[y], C = /[defgprs%]/.test(y);
		_ = _ === void 0 ? 6 : /[gprs]/.test(y) ? Math.max(1, Math.min(21, _)) : Math.max(0, Math.min(20, _));
		function w(e) {
			var n = b, r = x, o, l, p;
			if (y === "c") r = S(e) + r, e = "";
			else {
				e = +e;
				var w = e < 0 || 1 / e < 0;
				if (e = isNaN(e) ? c : S(Math.abs(e), _), v && (e = Cp(e)), w && +e == 0 && f !== "+" && (w = !1), n = (w ? f === "(" ? f : s : f === "-" || f === "(" ? "" : f) + n, r = (y === "s" && !isNaN(e) && wp !== void 0 ? Ap[8 + wp / 3] : "") + r + (w && f === "(" ? ")" : ""), C) {
					for (o = -1, l = e.length; ++o < l;) if (p = e.charCodeAt(o), 48 > p || p > 57) {
						r = (p === 46 ? i + e.slice(o + 1) : e.slice(o)) + r, e = e.slice(0, o);
						break;
					}
				}
			}
			g && !m && (e = t(e, Infinity));
			var T = n.length + e.length + r.length, E = T < h ? Array(h - T + 1).join(u) : "";
			switch (g && m && (e = t(E + e, E.length ? h - r.length : Infinity), E = ""), d) {
				case "<":
					e = n + e + r + E;
					break;
				case "=":
					e = n + E + e + r;
					break;
				case "^":
					e = E.slice(0, T = E.length >> 1) + n + e + r + E.slice(T);
					break;
				default: e = E + n + e + r;
			}
			return a(e);
		}
		return w.toString = function() {
			return e + "";
		}, w;
	}
	function u(e, t) {
		var n = Math.max(-8, Math.min(8, Math.floor(_p(t) / 3))) * 3, r = 10 ** -n, i = l((e = xp(e), e.type = "f", e), { suffix: Ap[8 + n / 3] });
		return function(e) {
			return i(r * e);
		};
	}
	return {
		format: l,
		formatPrefix: u
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/defaultLocale.js
var Mp, Np, Pp;
Fp({
	thousands: ",",
	grouping: [3],
	currency: ["$", ""]
});
function Fp(e) {
	return Mp = jp(e), Np = Mp.format, Pp = Mp.formatPrefix, Mp;
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionFixed.js
function Ip(e) {
	return Math.max(0, -_p(Math.abs(e)));
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionPrefix.js
function Lp(e, t) {
	return Math.max(0, Math.max(-8, Math.min(8, Math.floor(_p(t) / 3))) * 3 - _p(Math.abs(e)));
}
//#endregion
//#region ../node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionRound.js
function Rp(e, t) {
	return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, _p(t) - _p(e)) + 1;
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/tickFormat.js
function zp(e, t, n, r) {
	var i = Ad(e, t, n), a;
	switch (r = xp(r ?? ",f"), r.type) {
		case "s":
			var o = Math.max(Math.abs(e), Math.abs(t));
			return r.precision == null && !isNaN(a = Lp(i, o)) && (r.precision = a), Pp(r, o);
		case "":
		case "e":
		case "g":
		case "p":
		case "r":
			r.precision == null && !isNaN(a = Rp(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = a - (r.type === "e"));
			break;
		case "f":
		case "%": r.precision == null && !isNaN(a = Ip(i)) && (r.precision = a - (r.type === "%") * 2);
	}
	return Np(r);
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/linear.js
function Bp(e) {
	var t = e.domain;
	return e.ticks = function(e) {
		var n = t();
		return Od(n[0], n[n.length - 1], e ?? 10);
	}, e.tickFormat = function(e, n) {
		var r = t();
		return zp(r[0], r[r.length - 1], e ?? 10, n);
	}, e.nice = function(n) {
		n ??= 10;
		var r = t(), i = 0, a = r.length - 1, o = r[i], s = r[a], c, l, u = 10;
		for (s < o && (l = o, o = s, s = l, l = i, i = a, a = l); u-- > 0;) {
			if (l = kd(o, s, n), l === c) return r[i] = o, r[a] = s, t(r);
			if (l > 0) o = Math.floor(o / l) * l, s = Math.ceil(s / l) * l;
			else if (l < 0) o = Math.ceil(o * l) / l, s = Math.floor(s * l) / l;
			else break;
			c = l;
		}
		return e;
	}, e;
}
function Vp() {
	var e = mp();
	return e.copy = function() {
		return fp(e, Vp());
	}, Pd.apply(e, arguments), Bp(e);
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/nice.js
function Hp(e, t) {
	e = e.slice();
	var n = 0, r = e.length - 1, i = e[n], a = e[r], o;
	return a < i && (o = n, n = r, r = o, o = i, i = a, a = o), e[n] = t.floor(i), e[r] = t.ceil(a), e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/interval.js
var Up = /* @__PURE__ */ new Date(), Wp = /* @__PURE__ */ new Date();
function Gp(e, t, n, r) {
	function i(t) {
		return e(t = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+t)), t;
	}
	return i.floor = (t) => (e(t = /* @__PURE__ */ new Date(+t)), t), i.ceil = (n) => (e(n = /* @__PURE__ */ new Date(n - 1)), t(n, 1), e(n), n), i.round = (e) => {
		let t = i(e), n = i.ceil(e);
		return e - t < n - e ? t : n;
	}, i.offset = (e, n) => (t(e = /* @__PURE__ */ new Date(+e), n == null ? 1 : Math.floor(n)), e), i.range = (n, r, a) => {
		let o = [];
		if (n = i.ceil(n), a = a == null ? 1 : Math.floor(a), !(n < r) || !(a > 0)) return o;
		let s;
		do
			o.push(s = /* @__PURE__ */ new Date(+n)), t(n, a), e(n);
		while (s < n && n < r);
		return o;
	}, i.filter = (n) => Gp((t) => {
		if (t >= t) for (; e(t), !n(t);) t.setTime(t - 1);
	}, (e, r) => {
		if (e >= e) {
			if (r < 0) for (; ++r <= 0;) for (; t(e, -1), !n(e););
			else for (; --r >= 0;) for (; t(e, 1), !n(e););
		}
	}), n && (i.count = (t, r) => (Up.setTime(+t), Wp.setTime(+r), e(Up), e(Wp), Math.floor(n(Up, Wp))), i.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? i.filter(r ? (t) => r(t) % e === 0 : (t) => i.count(0, t) % e === 0) : i)), i;
}
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/millisecond.js
var Kp = Gp(() => {}, (e, t) => {
	e.setTime(+e + t);
}, (e, t) => t - e);
Kp.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Gp((t) => {
	t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
	t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : Kp), Kp.range;
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/duration.js
var qp = 1e3, Jp = qp * 60, Yp = Jp * 60, Xp = Yp * 24, Zp = Xp * 7, Qp = Xp * 30, $p = Xp * 365, em = Gp((e) => {
	e.setTime(e - e.getMilliseconds());
}, (e, t) => {
	e.setTime(+e + t * qp);
}, (e, t) => (t - e) / qp, (e) => e.getUTCSeconds());
em.range;
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/minute.js
var tm = Gp((e) => {
	e.setTime(e - e.getMilliseconds() - e.getSeconds() * qp);
}, (e, t) => {
	e.setTime(+e + t * Jp);
}, (e, t) => (t - e) / Jp, (e) => e.getMinutes());
tm.range;
var nm = Gp((e) => {
	e.setUTCSeconds(0, 0);
}, (e, t) => {
	e.setTime(+e + t * Jp);
}, (e, t) => (t - e) / Jp, (e) => e.getUTCMinutes());
nm.range;
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/hour.js
var rm = Gp((e) => {
	e.setTime(e - e.getMilliseconds() - e.getSeconds() * qp - e.getMinutes() * Jp);
}, (e, t) => {
	e.setTime(+e + t * Yp);
}, (e, t) => (t - e) / Yp, (e) => e.getHours());
rm.range;
var im = Gp((e) => {
	e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
	e.setTime(+e + t * Yp);
}, (e, t) => (t - e) / Yp, (e) => e.getUTCHours());
im.range;
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/day.js
var am = Gp((e) => e.setHours(0, 0, 0, 0), (e, t) => e.setDate(e.getDate() + t), (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Jp) / Xp, (e) => e.getDate() - 1);
am.range;
var om = Gp((e) => {
	e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
	e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Xp, (e) => e.getUTCDate() - 1);
om.range;
var sm = Gp((e) => {
	e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
	e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Xp, (e) => Math.floor(e / Xp));
sm.range;
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/week.js
function cm(e) {
	return Gp((t) => {
		t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
	}, (e, t) => {
		e.setDate(e.getDate() + t * 7);
	}, (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Jp) / Zp);
}
var lm = cm(0), um = cm(1), dm = cm(2), fm = cm(3), pm = cm(4), mm = cm(5), hm = cm(6);
lm.range, um.range, dm.range, fm.range, pm.range, mm.range, hm.range;
function gm(e) {
	return Gp((t) => {
		t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
	}, (e, t) => {
		e.setUTCDate(e.getUTCDate() + t * 7);
	}, (e, t) => (t - e) / Zp);
}
var _m = gm(0), vm = gm(1), ym = gm(2), bm = gm(3), xm = gm(4), Sm = gm(5), Cm = gm(6);
_m.range, vm.range, ym.range, bm.range, xm.range, Sm.range, Cm.range;
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/month.js
var wm = Gp((e) => {
	e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
	e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
wm.range;
var Tm = Gp((e) => {
	e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
	e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Tm.range;
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/year.js
var Em = Gp((e) => {
	e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
	e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Em.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Gp((t) => {
	t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
	t.setFullYear(t.getFullYear() + n * e);
}), Em.range;
var Dm = Gp((e) => {
	e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
	e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Dm.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Gp((t) => {
	t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
	t.setUTCFullYear(t.getUTCFullYear() + n * e);
}), Dm.range;
//#endregion
//#region ../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/ticks.js
function Om(e, t, n, r, i, a) {
	let o = [
		[
			em,
			1,
			qp
		],
		[
			em,
			5,
			5 * qp
		],
		[
			em,
			15,
			15 * qp
		],
		[
			em,
			30,
			30 * qp
		],
		[
			a,
			1,
			Jp
		],
		[
			a,
			5,
			5 * Jp
		],
		[
			a,
			15,
			15 * Jp
		],
		[
			a,
			30,
			30 * Jp
		],
		[
			i,
			1,
			Yp
		],
		[
			i,
			3,
			3 * Yp
		],
		[
			i,
			6,
			6 * Yp
		],
		[
			i,
			12,
			12 * Yp
		],
		[
			r,
			1,
			Xp
		],
		[
			r,
			2,
			2 * Xp
		],
		[
			n,
			1,
			Zp
		],
		[
			t,
			1,
			Qp
		],
		[
			t,
			3,
			3 * Qp
		],
		[
			e,
			1,
			$p
		]
	];
	function s(e, t, n) {
		let r = t < e;
		r && ([e, t] = [t, e]);
		let i = n && typeof n.range == "function" ? n : c(e, t, n), a = i ? i.range(e, +t + 1) : [];
		return r ? a.reverse() : a;
	}
	function c(t, n, r) {
		let i = Math.abs(n - t) / r, a = pd(([, , e]) => e).right(o, i);
		if (a === o.length) return e.every(Ad(t / $p, n / $p, r));
		if (a === 0) return Kp.every(Math.max(Ad(t, n, r), 1));
		let [s, c] = o[i / o[a - 1][2] < o[a][2] / i ? a - 1 : a];
		return s.every(c);
	}
	return [s, c];
}
var [km, Am] = Om(Dm, Tm, _m, sm, im, nm), [jm, Mm] = Om(Em, wm, lm, am, rm, tm);
//#endregion
//#region ../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/locale.js
function Nm(e) {
	if (0 <= e.y && e.y < 100) {
		var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
		return t.setFullYear(e.y), t;
	}
	return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Pm(e) {
	if (0 <= e.y && e.y < 100) {
		var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
		return t.setUTCFullYear(e.y), t;
	}
	return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Fm(e, t, n) {
	return {
		y: e,
		m: t,
		d: n,
		H: 0,
		M: 0,
		S: 0,
		L: 0
	};
}
function Im(e) {
	var t = e.dateTime, n = e.date, r = e.time, i = e.periods, a = e.days, o = e.shortDays, s = e.months, c = e.shortMonths, l = Hm(i), u = Um(i), d = Hm(a), f = Um(a), p = Hm(o), m = Um(o), h = Hm(s), g = Um(s), _ = Hm(c), v = Um(c), y = {
		a: ee,
		A: te,
		b: ne,
		B: re,
		c: null,
		d: uh,
		e: uh,
		f: hh,
		g: Eh,
		G: Oh,
		H: dh,
		I: fh,
		j: ph,
		L: mh,
		m: gh,
		M: _h,
		p: ie,
		q: ae,
		Q: Zh,
		s: Qh,
		S: vh,
		u: yh,
		U: bh,
		V: Sh,
		w: Ch,
		W: wh,
		x: null,
		X: null,
		y: Th,
		Y: Dh,
		Z: kh,
		"%": Xh
	}, b = {
		a: oe,
		A: se,
		b: ce,
		B: le,
		c: null,
		d: Ah,
		e: Ah,
		f: Fh,
		g: Kh,
		G: Jh,
		H: jh,
		I: Mh,
		j: Nh,
		L: Ph,
		m: Ih,
		M: Lh,
		p: ue,
		q: de,
		Q: Zh,
		s: Qh,
		S: Rh,
		u: zh,
		U: Bh,
		V: Hh,
		w: Uh,
		W: Wh,
		x: null,
		X: null,
		y: Gh,
		Y: qh,
		Z: Yh,
		"%": Xh
	}, x = {
		a: E,
		A: D,
		b: O,
		B: k,
		c: A,
		d: eh,
		e: eh,
		f: oh,
		g: Xm,
		G: Ym,
		H: nh,
		I: nh,
		j: th,
		L: ah,
		m: $m,
		M: rh,
		p: T,
		q: Qm,
		Q: ch,
		s: lh,
		S: ih,
		u: Gm,
		U: Km,
		V: qm,
		w: Wm,
		W: Jm,
		x: j,
		X: M,
		y: Xm,
		Y: Ym,
		Z: Zm,
		"%": sh
	};
	y.x = S(n, y), y.X = S(r, y), y.c = S(t, y), b.x = S(n, b), b.X = S(r, b), b.c = S(t, b);
	function S(e, t) {
		return function(n) {
			var r = [], i = -1, a = 0, o = e.length, s, c, l;
			for (n instanceof Date || (n = /* @__PURE__ */ new Date(+n)); ++i < o;) e.charCodeAt(i) === 37 && (r.push(e.slice(a, i)), (c = Lm[s = e.charAt(++i)]) == null ? c = s === "e" ? " " : "0" : s = e.charAt(++i), (l = t[s]) && (s = l(n, c)), r.push(s), a = i + 1);
			return r.push(e.slice(a, i)), r.join("");
		};
	}
	function C(e, t) {
		return function(n) {
			var r = Fm(1900, void 0, 1), i = w(r, e, n += "", 0), a, o;
			if (i != n.length) return null;
			if ("Q" in r) return new Date(r.Q);
			if ("s" in r) return new Date(r.s * 1e3 + ("L" in r ? r.L : 0));
			if (t && !("Z" in r) && (r.Z = 0), "p" in r && (r.H = r.H % 12 + r.p * 12), r.m === void 0 && (r.m = "q" in r ? r.q : 0), "V" in r) {
				if (r.V < 1 || r.V > 53) return null;
				"w" in r || (r.w = 1), "Z" in r ? (a = Pm(Fm(r.y, 0, 1)), o = a.getUTCDay(), a = o > 4 || o === 0 ? vm.ceil(a) : vm(a), a = om.offset(a, (r.V - 1) * 7), r.y = a.getUTCFullYear(), r.m = a.getUTCMonth(), r.d = a.getUTCDate() + (r.w + 6) % 7) : (a = Nm(Fm(r.y, 0, 1)), o = a.getDay(), a = o > 4 || o === 0 ? um.ceil(a) : um(a), a = am.offset(a, (r.V - 1) * 7), r.y = a.getFullYear(), r.m = a.getMonth(), r.d = a.getDate() + (r.w + 6) % 7);
			} else ("W" in r || "U" in r) && ("w" in r || (r.w = "u" in r ? r.u % 7 : +("W" in r)), o = "Z" in r ? Pm(Fm(r.y, 0, 1)).getUTCDay() : Nm(Fm(r.y, 0, 1)).getDay(), r.m = 0, r.d = "W" in r ? (r.w + 6) % 7 + r.W * 7 - (o + 5) % 7 : r.w + r.U * 7 - (o + 6) % 7);
			return "Z" in r ? (r.H += r.Z / 100 | 0, r.M += r.Z % 100, Pm(r)) : Nm(r);
		};
	}
	function w(e, t, n, r) {
		for (var i = 0, a = t.length, o = n.length, s, c; i < a;) {
			if (r >= o) return -1;
			if (s = t.charCodeAt(i++), s === 37) {
				if (s = t.charAt(i++), c = x[s in Lm ? t.charAt(i++) : s], !c || (r = c(e, n, r)) < 0) return -1;
			} else if (s != n.charCodeAt(r++)) return -1;
		}
		return r;
	}
	function T(e, t, n) {
		var r = l.exec(t.slice(n));
		return r ? (e.p = u.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function E(e, t, n) {
		var r = p.exec(t.slice(n));
		return r ? (e.w = m.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function D(e, t, n) {
		var r = d.exec(t.slice(n));
		return r ? (e.w = f.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function O(e, t, n) {
		var r = _.exec(t.slice(n));
		return r ? (e.m = v.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function k(e, t, n) {
		var r = h.exec(t.slice(n));
		return r ? (e.m = g.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function A(e, n, r) {
		return w(e, t, n, r);
	}
	function j(e, t, r) {
		return w(e, n, t, r);
	}
	function M(e, t, n) {
		return w(e, r, t, n);
	}
	function ee(e) {
		return o[e.getDay()];
	}
	function te(e) {
		return a[e.getDay()];
	}
	function ne(e) {
		return c[e.getMonth()];
	}
	function re(e) {
		return s[e.getMonth()];
	}
	function ie(e) {
		return i[+(e.getHours() >= 12)];
	}
	function ae(e) {
		return 1 + ~~(e.getMonth() / 3);
	}
	function oe(e) {
		return o[e.getUTCDay()];
	}
	function se(e) {
		return a[e.getUTCDay()];
	}
	function ce(e) {
		return c[e.getUTCMonth()];
	}
	function le(e) {
		return s[e.getUTCMonth()];
	}
	function ue(e) {
		return i[+(e.getUTCHours() >= 12)];
	}
	function de(e) {
		return 1 + ~~(e.getUTCMonth() / 3);
	}
	return {
		format: function(e) {
			var t = S(e += "", y);
			return t.toString = function() {
				return e;
			}, t;
		},
		parse: function(e) {
			var t = C(e += "", !1);
			return t.toString = function() {
				return e;
			}, t;
		},
		utcFormat: function(e) {
			var t = S(e += "", b);
			return t.toString = function() {
				return e;
			}, t;
		},
		utcParse: function(e) {
			var t = C(e += "", !0);
			return t.toString = function() {
				return e;
			}, t;
		}
	};
}
var Lm = {
	"-": "",
	_: " ",
	0: "0"
}, Rm = /^\s*\d+/, zm = /^%/, Bm = /[\\^$*+?|[\]().{}]/g;
function Z(e, t, n) {
	var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", a = i.length;
	return r + (a < n ? Array(n - a + 1).join(t) + i : i);
}
function Vm(e) {
	return e.replace(Bm, "\\$&");
}
function Hm(e) {
	return RegExp("^(?:" + e.map(Vm).join("|") + ")", "i");
}
function Um(e) {
	return new Map(e.map((e, t) => [e.toLowerCase(), t]));
}
function Wm(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 1));
	return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function Gm(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 1));
	return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function Km(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 2));
	return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function qm(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 2));
	return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function Jm(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 2));
	return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function Ym(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 4));
	return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function Xm(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 2));
	return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function Zm(e, t, n) {
	var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
	return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function Qm(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 1));
	return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function $m(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 2));
	return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function eh(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 2));
	return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function th(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 3));
	return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function nh(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 2));
	return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function rh(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 2));
	return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function ih(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 2));
	return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function ah(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 3));
	return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function oh(e, t, n) {
	var r = Rm.exec(t.slice(n, n + 6));
	return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function sh(e, t, n) {
	var r = zm.exec(t.slice(n, n + 1));
	return r ? n + r[0].length : -1;
}
function ch(e, t, n) {
	var r = Rm.exec(t.slice(n));
	return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function lh(e, t, n) {
	var r = Rm.exec(t.slice(n));
	return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function uh(e, t) {
	return Z(e.getDate(), t, 2);
}
function dh(e, t) {
	return Z(e.getHours(), t, 2);
}
function fh(e, t) {
	return Z(e.getHours() % 12 || 12, t, 2);
}
function ph(e, t) {
	return Z(1 + am.count(Em(e), e), t, 3);
}
function mh(e, t) {
	return Z(e.getMilliseconds(), t, 3);
}
function hh(e, t) {
	return mh(e, t) + "000";
}
function gh(e, t) {
	return Z(e.getMonth() + 1, t, 2);
}
function _h(e, t) {
	return Z(e.getMinutes(), t, 2);
}
function vh(e, t) {
	return Z(e.getSeconds(), t, 2);
}
function yh(e) {
	var t = e.getDay();
	return t === 0 ? 7 : t;
}
function bh(e, t) {
	return Z(lm.count(Em(e) - 1, e), t, 2);
}
function xh(e) {
	var t = e.getDay();
	return t >= 4 || t === 0 ? pm(e) : pm.ceil(e);
}
function Sh(e, t) {
	return e = xh(e), Z(pm.count(Em(e), e) + (Em(e).getDay() === 4), t, 2);
}
function Ch(e) {
	return e.getDay();
}
function wh(e, t) {
	return Z(um.count(Em(e) - 1, e), t, 2);
}
function Th(e, t) {
	return Z(e.getFullYear() % 100, t, 2);
}
function Eh(e, t) {
	return e = xh(e), Z(e.getFullYear() % 100, t, 2);
}
function Dh(e, t) {
	return Z(e.getFullYear() % 1e4, t, 4);
}
function Oh(e, t) {
	var n = e.getDay();
	return e = n >= 4 || n === 0 ? pm(e) : pm.ceil(e), Z(e.getFullYear() % 1e4, t, 4);
}
function kh(e) {
	var t = e.getTimezoneOffset();
	return (t > 0 ? "-" : (t *= -1, "+")) + Z(t / 60 | 0, "0", 2) + Z(t % 60, "0", 2);
}
function Ah(e, t) {
	return Z(e.getUTCDate(), t, 2);
}
function jh(e, t) {
	return Z(e.getUTCHours(), t, 2);
}
function Mh(e, t) {
	return Z(e.getUTCHours() % 12 || 12, t, 2);
}
function Nh(e, t) {
	return Z(1 + om.count(Dm(e), e), t, 3);
}
function Ph(e, t) {
	return Z(e.getUTCMilliseconds(), t, 3);
}
function Fh(e, t) {
	return Ph(e, t) + "000";
}
function Ih(e, t) {
	return Z(e.getUTCMonth() + 1, t, 2);
}
function Lh(e, t) {
	return Z(e.getUTCMinutes(), t, 2);
}
function Rh(e, t) {
	return Z(e.getUTCSeconds(), t, 2);
}
function zh(e) {
	var t = e.getUTCDay();
	return t === 0 ? 7 : t;
}
function Bh(e, t) {
	return Z(_m.count(Dm(e) - 1, e), t, 2);
}
function Vh(e) {
	var t = e.getUTCDay();
	return t >= 4 || t === 0 ? xm(e) : xm.ceil(e);
}
function Hh(e, t) {
	return e = Vh(e), Z(xm.count(Dm(e), e) + (Dm(e).getUTCDay() === 4), t, 2);
}
function Uh(e) {
	return e.getUTCDay();
}
function Wh(e, t) {
	return Z(vm.count(Dm(e) - 1, e), t, 2);
}
function Gh(e, t) {
	return Z(e.getUTCFullYear() % 100, t, 2);
}
function Kh(e, t) {
	return e = Vh(e), Z(e.getUTCFullYear() % 100, t, 2);
}
function qh(e, t) {
	return Z(e.getUTCFullYear() % 1e4, t, 4);
}
function Jh(e, t) {
	var n = e.getUTCDay();
	return e = n >= 4 || n === 0 ? xm(e) : xm.ceil(e), Z(e.getUTCFullYear() % 1e4, t, 4);
}
function Yh() {
	return "+0000";
}
function Xh() {
	return "%";
}
function Zh(e) {
	return +e;
}
function Qh(e) {
	return Math.floor(e / 1e3);
}
//#endregion
//#region ../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/defaultLocale.js
var $h, eg;
tg({
	dateTime: "%x, %X",
	date: "%-m/%-d/%Y",
	time: "%-I:%M:%S %p",
	periods: ["AM", "PM"],
	days: [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	],
	shortDays: [
		"Sun",
		"Mon",
		"Tue",
		"Wed",
		"Thu",
		"Fri",
		"Sat"
	],
	months: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	],
	shortMonths: [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	]
});
function tg(e) {
	return $h = Im(e), eg = $h.format, $h.parse, $h.utcFormat, $h.utcParse, $h;
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/time.js
function ng(e) {
	return new Date(e);
}
function rg(e) {
	return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function ig(e, t, n, r, i, a, o, s, c, l) {
	var u = mp(), d = u.invert, f = u.domain, p = l(".%L"), m = l(":%S"), h = l("%I:%M"), g = l("%I %p"), _ = l("%a %d"), v = l("%b %d"), y = l("%B"), b = l("%Y");
	function x(e) {
		return (c(e) < e ? p : s(e) < e ? m : o(e) < e ? h : a(e) < e ? g : r(e) < e ? i(e) < e ? _ : v : n(e) < e ? y : b)(e);
	}
	return u.invert = function(e) {
		return new Date(d(e));
	}, u.domain = function(e) {
		return arguments.length ? f(Array.from(e, rg)) : f().map(ng);
	}, u.ticks = function(t) {
		var n = f();
		return e(n[0], n[n.length - 1], t ?? 10);
	}, u.tickFormat = function(e, t) {
		return t == null ? x : l(t);
	}, u.nice = function(e) {
		var n = f();
		return (!e || typeof e.range != "function") && (e = t(n[0], n[n.length - 1], e ?? 10)), e ? f(Hp(n, e)) : u;
	}, u.copy = function() {
		return fp(u, ig(e, t, n, r, i, a, o, s, c, l));
	}, u;
}
function ag() {
	return Pd.apply(ig(jm, Mm, Em, wm, lm, am, rm, tm, em, eg).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
//#endregion
//#region ../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/sequential.js
function og() {
	var e = 0, t = 1, n, r, i, a, o = sp, s = !1, c;
	function l(e) {
		return e == null || isNaN(e = +e) ? c : o(i === 0 ? .5 : (e = (a(e) - n) * i, s ? Math.max(0, Math.min(1, e)) : e));
	}
	l.domain = function(o) {
		return arguments.length ? ([e, t] = o, n = a(e = +e), r = a(t = +t), i = n === r ? 0 : 1 / (r - n), l) : [e, t];
	}, l.clamp = function(e) {
		return arguments.length ? (s = !!e, l) : s;
	}, l.interpolator = function(e) {
		return arguments.length ? (o = e, l) : o;
	};
	function u(e) {
		return function(t) {
			var n, r;
			return arguments.length ? ([n, r] = t, o = e(n, r), l) : [o(0), o(1)];
		};
	}
	return l.range = u(Hf), l.rangeRound = u(Uf), l.unknown = function(e) {
		return arguments.length ? (c = e, l) : c;
	}, function(o) {
		return a = o, n = o(e), r = o(t), i = n === r ? 0 : 1 / (r - n), l;
	};
}
function sg(e, t) {
	return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function cg() {
	var e = Bp(og()(sp));
	return e.copy = function() {
		return sg(e, cg());
	}, Fd.apply(e, arguments);
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/constant.js
function Q(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/math.js
var lg = Math.abs, ug = Math.atan2, dg = Math.cos, fg = Math.max, pg = Math.min, mg = Math.sin, hg = Math.sqrt, gg = Math.PI, _g = gg / 2, vg = 2 * gg;
function yg(e) {
	return e > 1 ? 0 : e < -1 ? gg : Math.acos(e);
}
function bg(e) {
	return e >= 1 ? _g : e <= -1 ? -_g : Math.asin(e);
}
//#endregion
//#region ../node_modules/.pnpm/d3-path@3.1.0/node_modules/d3-path/src/path.js
var xg = Math.PI, Sg = 2 * xg, Cg = 1e-6, wg = Sg - Cg;
function Tg(e) {
	this._ += e[0];
	for (let t = 1, n = e.length; t < n; ++t) this._ += arguments[t] + e[t];
}
function Eg(e) {
	let t = Math.floor(e);
	if (!(t >= 0)) throw Error(`invalid digits: ${e}`);
	if (t > 15) return Tg;
	let n = 10 ** t;
	return function(e) {
		this._ += e[0];
		for (let t = 1, r = e.length; t < r; ++t) this._ += Math.round(arguments[t] * n) / n + e[t];
	};
}
var Dg = class {
	constructor(e) {
		this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "", this._append = e == null ? Tg : Eg(e);
	}
	moveTo(e, t) {
		this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}`;
	}
	closePath() {
		this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
	}
	lineTo(e, t) {
		this._append`L${this._x1 = +e},${this._y1 = +t}`;
	}
	quadraticCurveTo(e, t, n, r) {
		this._append`Q${+e},${+t},${this._x1 = +n},${this._y1 = +r}`;
	}
	bezierCurveTo(e, t, n, r, i, a) {
		this._append`C${+e},${+t},${+n},${+r},${this._x1 = +i},${this._y1 = +a}`;
	}
	arcTo(e, t, n, r, i) {
		if (e = +e, t = +t, n = +n, r = +r, i = +i, i < 0) throw Error(`negative radius: ${i}`);
		let a = this._x1, o = this._y1, s = n - e, c = r - t, l = a - e, u = o - t, d = l * l + u * u;
		if (this._x1 === null) this._append`M${this._x1 = e},${this._y1 = t}`;
		else if (d > Cg) {
			if (!(Math.abs(u * s - c * l) > Cg) || !i) this._append`L${this._x1 = e},${this._y1 = t}`;
			else {
				let f = n - a, p = r - o, m = s * s + c * c, h = f * f + p * p, g = Math.sqrt(m), _ = Math.sqrt(d), v = i * Math.tan((xg - Math.acos((m + d - h) / (2 * g * _))) / 2), y = v / _, b = v / g;
				Math.abs(y - 1) > Cg && this._append`L${e + y * l},${t + y * u}`, this._append`A${i},${i},0,0,${+(u * f > l * p)},${this._x1 = e + b * s},${this._y1 = t + b * c}`;
			}
		}
	}
	arc(e, t, n, r, i, a) {
		if (e = +e, t = +t, n = +n, a = !!a, n < 0) throw Error(`negative radius: ${n}`);
		let o = n * Math.cos(r), s = n * Math.sin(r), c = e + o, l = t + s, u = 1 ^ a, d = a ? r - i : i - r;
		this._x1 === null ? this._append`M${c},${l}` : (Math.abs(this._x1 - c) > Cg || Math.abs(this._y1 - l) > Cg) && this._append`L${c},${l}`, n && (d < 0 && (d = d % Sg + Sg), d > wg ? this._append`A${n},${n},0,1,${u},${e - o},${t - s}A${n},${n},0,1,${u},${this._x1 = c},${this._y1 = l}` : d > Cg && this._append`A${n},${n},0,${+(d >= xg)},${u},${this._x1 = e + n * Math.cos(i)},${this._y1 = t + n * Math.sin(i)}`);
	}
	rect(e, t, n, r) {
		this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}h${n = +n}v${+r}h${-n}Z`;
	}
	toString() {
		return this._;
	}
};
Dg.prototype;
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/path.js
function Og(e) {
	let t = 3;
	return e.digits = function(n) {
		if (!arguments.length) return t;
		if (n == null) t = null;
		else {
			let e = Math.floor(n);
			if (!(e >= 0)) throw RangeError(`invalid digits: ${n}`);
			t = e;
		}
		return e;
	}, () => new Dg(t);
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/arc.js
function kg(e) {
	return e.innerRadius;
}
function Ag(e) {
	return e.outerRadius;
}
function jg(e) {
	return e.startAngle;
}
function Mg(e) {
	return e.endAngle;
}
function Ng(e) {
	return e && e.padAngle;
}
function Pg(e, t, n, r, i, a, o, s) {
	var c = n - e, l = r - t, u = o - i, d = s - a, f = d * c - u * l;
	if (!(f * f < 1e-12)) return f = (u * (t - a) - d * (e - i)) / f, [e + f * c, t + f * l];
}
function Fg(e, t, n, r, i, a, o) {
	var s = e - n, c = t - r, l = (o ? a : -a) / hg(s * s + c * c), u = l * c, d = -l * s, f = e + u, p = t + d, m = n + u, h = r + d, g = (f + m) / 2, _ = (p + h) / 2, v = m - f, y = h - p, b = v * v + y * y, x = i - a, S = f * h - m * p, C = (y < 0 ? -1 : 1) * hg(fg(0, x * x * b - S * S)), w = (S * y - v * C) / b, T = (-S * v - y * C) / b, E = (S * y + v * C) / b, D = (-S * v + y * C) / b, O = w - g, k = T - _, A = E - g, j = D - _;
	return O * O + k * k > A * A + j * j && (w = E, T = D), {
		cx: w,
		cy: T,
		x01: -u,
		y01: -d,
		x11: w * (i / x - 1),
		y11: T * (i / x - 1)
	};
}
function Ig() {
	var e = kg, t = Ag, n = Q(0), r = null, i = jg, a = Mg, o = Ng, s = null, c = Og(l);
	function l() {
		var l, u, d = +e.apply(this, arguments), f = +t.apply(this, arguments), p = i.apply(this, arguments) - _g, m = a.apply(this, arguments) - _g, h = lg(m - p), g = m > p;
		if (s ||= l = c(), f < d && (u = f, f = d, d = u), !(f > 1e-12)) s.moveTo(0, 0);
		else if (h > vg - 1e-12) s.moveTo(f * dg(p), f * mg(p)), s.arc(0, 0, f, p, m, !g), d > 1e-12 && (s.moveTo(d * dg(m), d * mg(m)), s.arc(0, 0, d, m, p, g));
		else {
			var _ = p, v = m, y = p, b = m, x = h, S = h, C = o.apply(this, arguments) / 2, w = C > 1e-12 && (r ? +r.apply(this, arguments) : hg(d * d + f * f)), T = pg(lg(f - d) / 2, +n.apply(this, arguments)), E = T, D = T, O, k;
			if (w > 1e-12) {
				var A = bg(w / d * mg(C)), j = bg(w / f * mg(C));
				(x -= A * 2) > 1e-12 ? (A *= g ? 1 : -1, y += A, b -= A) : (x = 0, y = b = (p + m) / 2), (S -= j * 2) > 1e-12 ? (j *= g ? 1 : -1, _ += j, v -= j) : (S = 0, _ = v = (p + m) / 2);
			}
			var M = f * dg(_), ee = f * mg(_), te = d * dg(b), ne = d * mg(b);
			if (T > 1e-12) {
				var re = f * dg(v), ie = f * mg(v), ae = d * dg(y), oe = d * mg(y), se;
				if (h < gg) {
					if (se = Pg(M, ee, ae, oe, re, ie, te, ne)) {
						var ce = M - se[0], le = ee - se[1], ue = re - se[0], de = ie - se[1], fe = 1 / mg(yg((ce * ue + le * de) / (hg(ce * ce + le * le) * hg(ue * ue + de * de))) / 2), pe = hg(se[0] * se[0] + se[1] * se[1]);
						E = pg(T, (d - pe) / (fe - 1)), D = pg(T, (f - pe) / (fe + 1));
					} else E = D = 0;
				}
			}
			S > 1e-12 ? D > 1e-12 ? (O = Fg(ae, oe, M, ee, f, D, g), k = Fg(re, ie, te, ne, f, D, g), s.moveTo(O.cx + O.x01, O.cy + O.y01), D < T ? s.arc(O.cx, O.cy, D, ug(O.y01, O.x01), ug(k.y01, k.x01), !g) : (s.arc(O.cx, O.cy, D, ug(O.y01, O.x01), ug(O.y11, O.x11), !g), s.arc(0, 0, f, ug(O.cy + O.y11, O.cx + O.x11), ug(k.cy + k.y11, k.cx + k.x11), !g), s.arc(k.cx, k.cy, D, ug(k.y11, k.x11), ug(k.y01, k.x01), !g))) : (s.moveTo(M, ee), s.arc(0, 0, f, _, v, !g)) : s.moveTo(M, ee), !(d > 1e-12) || !(x > 1e-12) ? s.lineTo(te, ne) : E > 1e-12 ? (O = Fg(te, ne, re, ie, d, -E, g), k = Fg(M, ee, ae, oe, d, -E, g), s.lineTo(O.cx + O.x01, O.cy + O.y01), E < T ? s.arc(O.cx, O.cy, E, ug(O.y01, O.x01), ug(k.y01, k.x01), !g) : (s.arc(O.cx, O.cy, E, ug(O.y01, O.x01), ug(O.y11, O.x11), !g), s.arc(0, 0, d, ug(O.cy + O.y11, O.cx + O.x11), ug(k.cy + k.y11, k.cx + k.x11), g), s.arc(k.cx, k.cy, E, ug(k.y11, k.x11), ug(k.y01, k.x01), !g))) : s.arc(0, 0, d, b, y, g);
		}
		if (s.closePath(), l) return s = null, l + "" || null;
	}
	return l.centroid = function() {
		var n = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, r = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - gg / 2;
		return [dg(r) * n, mg(r) * n];
	}, l.innerRadius = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : Q(+t), l) : e;
	}, l.outerRadius = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : Q(+e), l) : t;
	}, l.cornerRadius = function(e) {
		return arguments.length ? (n = typeof e == "function" ? e : Q(+e), l) : n;
	}, l.padRadius = function(e) {
		return arguments.length ? (r = e == null ? null : typeof e == "function" ? e : Q(+e), l) : r;
	}, l.startAngle = function(e) {
		return arguments.length ? (i = typeof e == "function" ? e : Q(+e), l) : i;
	}, l.endAngle = function(e) {
		return arguments.length ? (a = typeof e == "function" ? e : Q(+e), l) : a;
	}, l.padAngle = function(e) {
		return arguments.length ? (o = typeof e == "function" ? e : Q(+e), l) : o;
	}, l.context = function(e) {
		return arguments.length ? (s = e ?? null, l) : s;
	}, l;
}
Array.prototype.slice;
function Lg(e) {
	return typeof e == "object" && "length" in e ? e : Array.from(e);
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/linear.js
function Rg(e) {
	this._context = e;
}
Rg.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._point = 0;
	},
	lineEnd: function() {
		(this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
	},
	point: function(e, t) {
		switch (e = +e, t = +t, this._point) {
			case 0:
				this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
				break;
			case 1: this._point = 2;
			default: this._context.lineTo(e, t);
		}
	}
};
function zg(e) {
	return new Rg(e);
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/point.js
function Bg(e) {
	return e[0];
}
function Vg(e) {
	return e[1];
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/line.js
function Hg(e, t) {
	var n = Q(!0), r = null, i = zg, a = null, o = Og(s);
	e = typeof e == "function" ? e : e === void 0 ? Bg : Q(e), t = typeof t == "function" ? t : t === void 0 ? Vg : Q(t);
	function s(s) {
		var c, l = (s = Lg(s)).length, u, d = !1, f;
		for (r ?? (a = i(f = o())), c = 0; c <= l; ++c) !(c < l && n(u = s[c], c, s)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(u, c, s), +t(u, c, s));
		if (f) return a = null, f + "" || null;
	}
	return s.x = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : Q(+t), s) : e;
	}, s.y = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : Q(+e), s) : t;
	}, s.defined = function(e) {
		return arguments.length ? (n = typeof e == "function" ? e : Q(!!e), s) : n;
	}, s.curve = function(e) {
		return arguments.length ? (i = e, r != null && (a = i(r)), s) : i;
	}, s.context = function(e) {
		return arguments.length ? (e == null ? r = a = null : a = i(r = e), s) : r;
	}, s;
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/area.js
function Ug(e, t, n) {
	var r = null, i = Q(!0), a = null, o = zg, s = null, c = Og(l);
	e = typeof e == "function" ? e : e === void 0 ? Bg : Q(+e), t = typeof t == "function" ? t : Q(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? Vg : Q(+n);
	function l(l) {
		var u, d, f, p = (l = Lg(l)).length, m, h = !1, g, _ = Array(p), v = Array(p);
		for (a ?? (s = o(g = c())), u = 0; u <= p; ++u) {
			if (!(u < p && i(m = l[u], u, l)) === h) {
				if (h = !h) d = u, s.areaStart(), s.lineStart();
				else {
					for (s.lineEnd(), s.lineStart(), f = u - 1; f >= d; --f) s.point(_[f], v[f]);
					s.lineEnd(), s.areaEnd();
				}
			}
			h && (_[u] = +e(m, u, l), v[u] = +t(m, u, l), s.point(r ? +r(m, u, l) : _[u], n ? +n(m, u, l) : v[u]));
		}
		if (g) return s = null, g + "" || null;
	}
	function u() {
		return Hg().defined(i).curve(o).context(a);
	}
	return l.x = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : Q(+t), r = null, l) : e;
	}, l.x0 = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : Q(+t), l) : e;
	}, l.x1 = function(e) {
		return arguments.length ? (r = e == null ? null : typeof e == "function" ? e : Q(+e), l) : r;
	}, l.y = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : Q(+e), n = null, l) : t;
	}, l.y0 = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : Q(+e), l) : t;
	}, l.y1 = function(e) {
		return arguments.length ? (n = e == null ? null : typeof e == "function" ? e : Q(+e), l) : n;
	}, l.lineX0 = l.lineY0 = function() {
		return u().x(e).y(t);
	}, l.lineY1 = function() {
		return u().x(e).y(n);
	}, l.lineX1 = function() {
		return u().x(r).y(t);
	}, l.defined = function(e) {
		return arguments.length ? (i = typeof e == "function" ? e : Q(!!e), l) : i;
	}, l.curve = function(e) {
		return arguments.length ? (o = e, a != null && (s = o(a)), l) : o;
	}, l.context = function(e) {
		return arguments.length ? (e == null ? a = s = null : s = o(a = e), l) : a;
	}, l;
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/descending.js
function Wg(e, t) {
	return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/identity.js
function Gg(e) {
	return e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/pie.js
function Kg() {
	var e = Gg, t = Wg, n = null, r = Q(0), i = Q(vg), a = Q(0);
	function o(o) {
		var s, c = (o = Lg(o)).length, l, u, d = 0, f = Array(c), p = Array(c), m = +r.apply(this, arguments), h = Math.min(vg, Math.max(-vg, i.apply(this, arguments) - m)), g, _ = Math.min(Math.abs(h) / c, a.apply(this, arguments)), v = _ * (h < 0 ? -1 : 1), y;
		for (s = 0; s < c; ++s) (y = p[f[s] = s] = +e(o[s], s, o)) > 0 && (d += y);
		for (t == null ? n != null && f.sort(function(e, t) {
			return n(o[e], o[t]);
		}) : f.sort(function(e, n) {
			return t(p[e], p[n]);
		}), s = 0, u = d ? (h - c * v) / d : 0; s < c; ++s, m = g) l = f[s], y = p[l], g = m + (y > 0 ? y * u : 0) + v, p[l] = {
			data: o[l],
			index: s,
			value: y,
			startAngle: m,
			endAngle: g,
			padAngle: _
		};
		return p;
	}
	return o.value = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : Q(+t), o) : e;
	}, o.sortValues = function(e) {
		return arguments.length ? (t = e, n = null, o) : t;
	}, o.sort = function(e) {
		return arguments.length ? (n = e, t = null, o) : n;
	}, o.startAngle = function(e) {
		return arguments.length ? (r = typeof e == "function" ? e : Q(+e), o) : r;
	}, o.endAngle = function(e) {
		return arguments.length ? (i = typeof e == "function" ? e : Q(+e), o) : i;
	}, o.padAngle = function(e) {
		return arguments.length ? (a = typeof e == "function" ? e : Q(+e), o) : a;
	}, o;
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/basis.js
function qg(e, t, n) {
	e._context.bezierCurveTo((2 * e._x0 + e._x1) / 3, (2 * e._y0 + e._y1) / 3, (e._x0 + 2 * e._x1) / 3, (e._y0 + 2 * e._y1) / 3, (e._x0 + 4 * e._x1 + t) / 6, (e._y0 + 4 * e._y1 + n) / 6);
}
function Jg(e) {
	this._context = e;
}
Jg.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 3: qg(this, this._x1, this._y1);
			case 2: this._context.lineTo(this._x1, this._y1);
		}
		(this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
	},
	point: function(e, t) {
		switch (e = +e, t = +t, this._point) {
			case 0:
				this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
				break;
			case 1:
				this._point = 2;
				break;
			case 2: this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
			default: qg(this, e, t);
		}
		this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
	}
};
function Yg(e) {
	return new Jg(e);
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/monotone.js
function Xg(e) {
	return e < 0 ? -1 : 1;
}
function Zg(e, t, n) {
	var r = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (r || i < 0 && -0), o = (n - e._y1) / (i || r < 0 && -0), s = (a * i + o * r) / (r + i);
	return (Xg(a) + Xg(o)) * Math.min(Math.abs(a), Math.abs(o), .5 * Math.abs(s)) || 0;
}
function Qg(e, t) {
	var n = e._x1 - e._x0;
	return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function $g(e, t, n) {
	var r = e._x0, i = e._y0, a = e._x1, o = e._y1, s = (a - r) / 3;
	e._context.bezierCurveTo(r + s, i + s * t, a - s, o - s * n, a, o);
}
function e_(e) {
	this._context = e;
}
e_.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 2:
				this._context.lineTo(this._x1, this._y1);
				break;
			case 3: $g(this, this._t0, Qg(this, this._t0));
		}
		(this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
	},
	point: function(e, t) {
		var n = NaN;
		if (e = +e, t = +t, e !== this._x1 || t !== this._y1) {
			switch (this._point) {
				case 0:
					this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
					break;
				case 1:
					this._point = 2;
					break;
				case 2:
					this._point = 3, $g(this, Qg(this, n = Zg(this, e, t)), n);
					break;
				default: $g(this, this._t0, n = Zg(this, e, t));
			}
			this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
		}
	}
}, Object.create(e_.prototype).point = function(e, t) {
	e_.prototype.point.call(this, t, e);
};
function t_(e) {
	return new e_(e);
}
//#endregion
//#region ../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/step.js
function n_(e, t) {
	this._context = e, this._t = t;
}
n_.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x = this._y = NaN, this._point = 0;
	},
	lineEnd: function() {
		0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
	},
	point: function(e, t) {
		switch (e = +e, t = +t, this._point) {
			case 0:
				this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
				break;
			case 1: this._point = 2;
			default: if (this._t <= 0) this._context.lineTo(this._x, t), this._context.lineTo(e, t);
			else {
				var n = this._x * (1 - this._t) + e * this._t;
				this._context.lineTo(n, this._y), this._context.lineTo(n, t);
			}
		}
		this._x = e, this._y = t;
	}
};
function r_(e) {
	return new n_(e, .5);
}
//#endregion
//#region src/components/organisms/Charts/Sparkline.tsx
function i_({ data: e, width: t = 120, height: n = 32, color: r = "var(--chart-1)", showArea: i = !0, strokeWidth: a = 1.5, className: o = "" }) {
	let { linePath: s, areaPath: c } = Ln(() => {
		if (e.length < 2) return {
			linePath: "",
			areaPath: ""
		};
		let r = Vp().domain([0, e.length - 1]).range([1, t - 1]), [i, a] = vd(e), o = (a - i) * .1 || 1, s = Vp().domain([i - o, a + o]).range([n - 1, 1]), c = Hg().x((e, t) => r(t)).y((e) => s(e)).curve(t_), l = Ug().x((e, t) => r(t)).y0(n).y1((e) => s(e)).curve(t_);
		return {
			linePath: c(e) ?? "",
			areaPath: l(e) ?? ""
		};
	}, [
		e,
		t,
		n
	]);
	return e.length < 2 ? null : /* @__PURE__ */ J("svg", {
		width: t,
		height: n,
		className: o,
		"aria-hidden": "true",
		children: [i && /* @__PURE__ */ q("path", {
			d: c,
			fill: r,
			opacity: .1
		}), /* @__PURE__ */ q("path", {
			d: s,
			fill: "none",
			stroke: r,
			strokeWidth: a
		})]
	});
}
//#endregion
//#region src/components/molecules/StatCard/StatCard.tsx
var a_ = a([
	"relative flex flex-col",
	"bg-white border border-slate-200 rounded-lg",
	"transition-all",
	"dark:bg-slate-800 dark:border-slate-700"
], {
	variants: {
		tone: {
			default: "",
			success: "",
			warning: "",
			error: "",
			info: ""
		},
		size: {
			sm: "p-3 gap-1",
			md: "p-4 gap-2",
			lg: "p-5 gap-3"
		},
		interactive: {
			true: [
				"cursor-pointer",
				"hover:shadow-md hover:border-slate-300",
				"active:scale-[0.99]",
				"dark:hover:border-slate-600"
			],
			false: ""
		}
	},
	defaultVariants: {
		tone: "default",
		size: "md",
		interactive: !1
	}
}), o_ = {
	sm: "h-4 w-4",
	md: "h-5 w-5",
	lg: "h-6 w-6"
}, s_ = {
	default: "text-slate-600 dark:text-slate-300",
	success: "text-emerald-600 dark:text-emerald-400",
	warning: "text-amber-600 dark:text-amber-400",
	error: "text-rose-600 dark:text-rose-400",
	info: "text-sky-600 dark:text-sky-400"
}, c_ = {
	sm: "text-xl",
	md: "text-2xl",
	lg: "text-3xl"
}, l_ = {
	sm: "text-xs",
	md: "text-sm",
	lg: "text-base"
}, u_ = {
	sm: {
		width: 60,
		height: 20
	},
	md: {
		width: 80,
		height: 24
	},
	lg: {
		width: 100,
		height: 28
	}
};
function d_(e) {
	switch (e) {
		case "success": return "var(--color-emerald-500, #10b981)";
		case "warning": return "var(--color-amber-500, #f59e0b)";
		case "error": return "var(--color-rose-500, #f43f5e)";
		case "info": return "var(--color-sky-500, #0ea5e9)";
		default: return "var(--color-slate-500, #64748b)";
	}
}
function f_(e, t) {
	return e === "flat" ? "muted" : e === "up" && t === "positive" || e === "down" && t === "negative" ? "success" : "error";
}
function p_(e) {
	let t = e.direction === "up" ? "+" : e.direction === "down" ? "-" : "", n = e.format === "percent" ? "%" : "";
	return `${t}${Math.abs(e.value)}${n}`;
}
var m_ = V(({ className: e, icon: t, label: n, value: r, unit: a, sparkline: o, delta: s, tone: c = "default", size: l = "md", loading: u = !1, onClick: d, href: f, ...p }, m) => {
	let h = !!(d || f), g = l ?? "md", _ = I(a_({
		tone: c,
		size: l,
		interactive: h
	}), e), v = s_[c ?? "default"] ?? s_.default, y = /* @__PURE__ */ J(K, { children: [
		/* @__PURE__ */ J("div", {
			className: "flex items-center gap-2",
			children: [t && /* @__PURE__ */ q("div", {
				className: I("flex items-center justify-center shrink-0", v, o_[g]),
				children: t
			}), /* @__PURE__ */ q("span", {
				className: I("text-slate-500 dark:text-slate-400 font-normal", l_[g]),
				children: n
			})]
		}),
		/* @__PURE__ */ q("div", {
			className: "flex items-baseline gap-2 mt-2",
			children: u ? /* @__PURE__ */ q(sd, { className: I("w-24", g === "sm" ? "h-6" : g === "lg" ? "h-10" : "h-8") }) : /* @__PURE__ */ J(K, { children: [
				/* @__PURE__ */ q("span", {
					className: I("font-semibold text-slate-900 dark:text-slate-100 tabular-nums", "overflow-hidden text-ellipsis whitespace-nowrap max-w-full", c_[g]),
					title: String(r),
					children: r
				}),
				a && /* @__PURE__ */ q("span", {
					className: I("text-slate-500 dark:text-slate-400 font-normal shrink-0", l_[g]),
					children: a
				}),
				s && /* @__PURE__ */ J(i, {
					variant: f_(s.direction, s.polarity),
					size: "sm",
					className: "ml-auto flex items-center gap-0.5 shrink-0",
					children: [
						s.direction === "up" && /* @__PURE__ */ q(da, { className: "h-3 w-3" }),
						s.direction === "down" && /* @__PURE__ */ q(la, { className: "h-3 w-3" }),
						s.direction === "flat" && /* @__PURE__ */ q(ji, { className: "h-3 w-3" }),
						p_(s)
					]
				})
			] })
		}),
		o && o.length >= 2 && !u && /* @__PURE__ */ q("div", {
			className: "mt-2",
			children: /* @__PURE__ */ q(i_, {
				data: o,
				width: u_[g].width,
				height: u_[g].height,
				color: d_(c),
				showArea: !0
			})
		}),
		u && o && o.length >= 2 && /* @__PURE__ */ q(sd, {
			className: I("mt-2", `w-[${u_[g].width}px]`, `h-[${u_[g].height}px]`),
			style: {
				width: u_[g].width,
				height: u_[g].height
			}
		})
	] });
	return f ? /* @__PURE__ */ q("a", {
		ref: m,
		href: f,
		className: _,
		onClick: d,
		...p,
		children: y
	}) : d ? /* @__PURE__ */ q("button", {
		ref: m,
		type: "button",
		className: _,
		onClick: d,
		...p,
		children: y
	}) : /* @__PURE__ */ q("div", {
		ref: m,
		className: _,
		...p,
		children: y
	});
});
m_.displayName = "StatCard";
//#endregion
//#region src/components/molecules/Tabs/Tabs.tsx
var h_ = xe, g_ = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(s, {
	ref: n,
	className: I("inline-flex h-10 items-center justify-center rounded-md", "bg-slate-100 p-1", "dark:bg-slate-800", "text-slate-500", e),
	...t
}));
g_.displayName = s.displayName;
var __ = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(Pe, {
	ref: n,
	className: I("inline-flex items-center justify-center whitespace-nowrap rounded-sm", "px-3 py-1.5 text-sm font-medium", "ring-offset-white transition-all", "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-300 focus-visible:ring-offset-1", "disabled:pointer-events-none disabled:opacity-50", "data-[state=active]:bg-white data-[state=active]:text-slate-900 data-[state=active]:shadow-sm", "dark:ring-offset-slate-900 dark:focus-visible:ring-slate-600", "dark:data-[state=active]:bg-slate-900 dark:data-[state=active]:text-slate-100", e),
	...t
}));
__.displayName = Pe.displayName;
var v_ = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(Dn, {
	ref: n,
	className: I("mt-2 ring-offset-white", "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-300 focus-visible:ring-offset-1", "dark:ring-offset-slate-900 dark:focus-visible:ring-slate-600", e),
	...t
}));
v_.displayName = Dn.displayName;
//#endregion
//#region ../node_modules/.pnpm/@radix-ui+react-toast@1.2.24_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@_4574a1037aebd3bf5c8d57247b3c23b0/node_modules/@radix-ui/react-toast/dist/index.mjs
var y_ = Object.defineProperty, $ = (e, t) => y_(e, "name", {
	value: t,
	configurable: !0
}), b_ = "ToastProvider", [x_, S_, C_] = pt("Toast"), w_ = {
	Up: "up",
	Down: "down",
	Left: "left",
	Right: "right"
}, T_ = {
	Foreground: "foreground",
	Background: "background"
}, [E_, D_] = se("Toast", [C_]), [O_, k_] = E_(b_), A_ = /* @__PURE__ */ $((e) => {
	let { __scopeToast: t, label: n = "Notification", duration: r = 5e3, swipeDirection: i = w_.Right, swipeThreshold: a = 50, announcerContainer: o, children: s } = e, [c, l] = B.useState(null), [u, d] = B.useState(0), f = B.useRef(!1);
	return n.trim() || console.error(`Invalid prop \`label\` supplied to \`${b_}\`. Expected non-empty \`string\`.`), /* @__PURE__ */ q(x_.Provider, {
		scope: t,
		children: /* @__PURE__ */ q(O_, {
			scope: t,
			label: n,
			duration: r,
			swipeDirection: i,
			swipeThreshold: a,
			toastCount: u,
			viewport: c,
			onViewportChange: l,
			onToastAdd: B.useCallback(() => d((e) => e + 1), []),
			onToastRemove: B.useCallback(() => d((e) => e - 1), []),
			isClosePausedRef: f,
			announcerContainer: o,
			children: s
		})
	});
}, "ToastProvider"), j_ = "ToastViewport", M_ = ["F8"], N_ = "toast.viewportPause", P_ = "toast.viewportResume", F_ = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeToast: n, hotkey: r = M_, label: i = "Notifications ({hotkey})", ...a } = e, o = k_(j_, n), s = S_(n), c = B.useRef(null), l = B.useRef(null), u = B.useRef(null), d = B.useRef(null), f = P(t, d, o.onViewportChange), p = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), h = o.toastCount > 0;
	B.useEffect(() => {
		let e = /* @__PURE__ */ $((e) => {
			r.length !== 0 && r.every((t) => e[t] || e.code === t) && d.current?.focus();
		}, "handleKeyDown");
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [r]), B.useEffect(() => {
		let e = c.current, t = d.current;
		if (h && e && t) {
			let n = /* @__PURE__ */ $(() => {
				if (!o.isClosePausedRef.current) {
					let e = new CustomEvent(N_);
					t.dispatchEvent(e), o.isClosePausedRef.current = !0;
				}
			}, "handlePause"), r = /* @__PURE__ */ $(() => {
				if (o.isClosePausedRef.current) {
					let e = new CustomEvent(P_);
					t.dispatchEvent(e), o.isClosePausedRef.current = !1;
				}
			}, "handleResume"), i = /* @__PURE__ */ $((t) => {
				e.contains(t.relatedTarget) || r();
			}, "handleFocusOutResume"), a = /* @__PURE__ */ $(() => {
				e.contains(document.activeElement) || r();
			}, "handlePointerLeaveResume");
			return e.addEventListener("focusin", n), e.addEventListener("focusout", i), e.addEventListener("pointermove", n), e.addEventListener("pointerleave", a), window.addEventListener("blur", n), window.addEventListener("focus", r), () => {
				e.removeEventListener("focusin", n), e.removeEventListener("focusout", i), e.removeEventListener("pointermove", n), e.removeEventListener("pointerleave", a), window.removeEventListener("blur", n), window.removeEventListener("focus", r);
			};
		}
	}, [h, o.isClosePausedRef]);
	let g = B.useCallback(({ tabbingDirection: e }) => {
		let t = s().map((t) => {
			let n = t.ref.current, r = [n, ...ov(n)];
			return e === "forwards" ? r : r.reverse();
		});
		return (e === "forwards" ? t.reverse() : t).flat();
	}, [s]);
	return B.useEffect(() => {
		let e = d.current;
		if (e) {
			let t = /* @__PURE__ */ $((t) => {
				let n = t.altKey || t.ctrlKey || t.metaKey;
				if (t.key === "Tab" && !n) {
					let n = document.activeElement, r = t.shiftKey;
					if (t.target === e && r) {
						l.current?.focus();
						return;
					}
					let i = g({ tabbingDirection: r ? "backwards" : "forwards" }), a = i.findIndex((e) => e === n);
					sv(i.slice(a + 1)) ? t.preventDefault() : r ? l.current?.focus() : u.current?.focus();
				}
			}, "handleKeyDown");
			return e.addEventListener("keydown", t), () => e.removeEventListener("keydown", t);
		}
	}, [s, g]), /* @__PURE__ */ J(m, {
		ref: c,
		role: "region",
		"aria-label": i.replace("{hotkey}", p),
		tabIndex: -1,
		style: { pointerEvents: h ? void 0 : "none" },
		children: [
			h && /* @__PURE__ */ q(L_, {
				ref: l,
				onFocusFromOutsideViewport: () => {
					sv(g({ tabbingDirection: "forwards" }));
				}
			}),
			/* @__PURE__ */ q(x_.Slot, {
				scope: n,
				children: /* @__PURE__ */ q(F.ol, {
					tabIndex: -1,
					...a,
					ref: f
				})
			}),
			h && /* @__PURE__ */ q(L_, {
				ref: u,
				onFocusFromOutsideViewport: () => {
					sv(g({ tabbingDirection: "backwards" }));
				}
			})
		]
	});
}, "ToastViewport")), I_ = "ToastFocusProxy", L_ = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeToast: n, onFocusFromOutsideViewport: r, ...i } = e, a = k_(I_, n);
	return /* @__PURE__ */ q(Ge, {
		tabIndex: 0,
		...i,
		ref: t,
		style: { position: "fixed" },
		onFocus: (e) => {
			let t = e.relatedTarget;
			a.viewport?.contains(t) || r();
		}
	});
}, "ToastFocusProxy")), R_ = "Toast", z_ = "toast.swipeStart", B_ = "toast.swipeMove", V_ = "toast.swipeCancel", H_ = "toast.swipeEnd", U_ = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { forceMount: n, open: r, defaultOpen: i, onOpenChange: a, ...o } = e, [s, c] = Ct({
		prop: r,
		defaultProp: i ?? !0,
		onChange: a,
		caller: R_
	});
	return /* @__PURE__ */ q(bt, {
		present: n || s,
		children: /* @__PURE__ */ q(K_, {
			open: s,
			...o,
			ref: t,
			onClose: () => c(!1),
			onPause: j(e.onPause),
			onResume: j(e.onResume),
			onSwipeStart: N(e.onSwipeStart, (e) => {
				e.currentTarget.setAttribute("data-swipe", "start");
			}),
			onSwipeMove: N(e.onSwipeMove, (e) => {
				let { x: t, y: n } = e.detail.delta;
				e.currentTarget.setAttribute("data-swipe", "move"), e.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${t}px`), e.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${n}px`);
			}),
			onSwipeCancel: N(e.onSwipeCancel, (e) => {
				e.currentTarget.setAttribute("data-swipe", "cancel"), e.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), e.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), e.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), e.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
			}),
			onSwipeEnd: N(e.onSwipeEnd, (e) => {
				let { x: t, y: n } = e.detail.delta;
				e.currentTarget.setAttribute("data-swipe", "end"), e.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), e.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), e.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${t}px`), e.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${n}px`), c(!1);
			})
		})
	});
}, "Toast")), [W_, G_] = E_(R_, { onClose() {} }), K_ = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeToast: n, type: r = T_.Foreground, duration: i, open: a, onClose: o, onEscapeKeyDown: s, onPause: c, onResume: l, onSwipeStart: u, onSwipeMove: d, onSwipeCancel: f, onSwipeEnd: p, ...m } = e, h = k_(R_, n), g = S_(n), [_, y] = B.useState(null), b = P(t, y), x = B.useRef(null), S = B.useRef(null), C = i || h.duration, w = B.useRef(0), T = B.useRef(C), E = B.useRef(0), { onToastAdd: D, onToastRemove: O } = h, k = j(() => {
		_?.contains(document.activeElement) && h.viewport?.focus(), o();
	}), A = B.useCallback((e) => {
		e && e !== Infinity && (window.clearTimeout(E.current), w.current = (/* @__PURE__ */ new Date()).getTime(), E.current = window.setTimeout(k, e));
	}, [k]);
	B.useEffect(() => {
		let e = h.viewport;
		if (e) {
			let t = /* @__PURE__ */ $(() => {
				A(T.current), l?.();
			}, "handleResume"), n = /* @__PURE__ */ $(() => {
				let e = (/* @__PURE__ */ new Date()).getTime() - w.current;
				T.current -= e, window.clearTimeout(E.current), c?.();
			}, "handlePause");
			return e.addEventListener(N_, n), e.addEventListener(P_, t), () => {
				e.removeEventListener(N_, n), e.removeEventListener(P_, t);
			};
		}
	}, [
		h.viewport,
		C,
		c,
		l,
		A
	]), B.useEffect(() => {
		T.current = C, a && !h.isClosePausedRef.current && A(C);
	}, [
		a,
		C,
		h.isClosePausedRef,
		A
	]), B.useEffect(() => () => {
		window.clearTimeout(E.current);
	}, []), B.useEffect(() => (D(), () => O()), [D, O]);
	let M = B.useMemo(() => _ ? tv(_) : null, [_]);
	return h.viewport ? /* @__PURE__ */ J(K, { children: [M && /* @__PURE__ */ q(q_, {
		__scopeToast: n,
		role: "status",
		"aria-live": r === T_.Foreground ? "assertive" : "polite",
		children: M
	}), /* @__PURE__ */ q(W_, {
		scope: n,
		onClose: k,
		children: zn.createPortal(/* @__PURE__ */ q(x_.ItemSlot, {
			scope: n,
			children: /* @__PURE__ */ q(v, {
				asChild: !0,
				onEscapeKeyDown: N(s, (e) => {
					g().some((t) => t.ref.current?.contains(e.target)) || k();
				}),
				children: /* @__PURE__ */ q(F.li, {
					tabIndex: 0,
					"data-state": a ? "open" : "closed",
					"data-swipe-direction": h.swipeDirection,
					...m,
					ref: b,
					style: {
						userSelect: "none",
						touchAction: "none",
						...e.style
					},
					onKeyDown: N(e.onKeyDown, (e) => {
						e.key === "Escape" && (s?.(e.nativeEvent), e.nativeEvent.defaultPrevented || k());
					}),
					onPointerDown: N(e.onPointerDown, (e) => {
						e.button === 0 && (x.current = {
							x: e.clientX,
							y: e.clientY
						});
					}),
					onPointerMove: N(e.onPointerMove, (e) => {
						if (!x.current) return;
						let t = e.clientX - x.current.x, n = e.clientY - x.current.y, r = !!S.current, i = ["left", "right"].includes(h.swipeDirection), a = ["left", "up"].includes(h.swipeDirection) ? Math.min : Math.max, o = i ? a(0, t) : 0, s = i ? 0 : a(0, n), c = e.pointerType === "touch" ? 10 : 2, l = {
							x: o,
							y: s
						}, f = {
							originalEvent: e,
							delta: l
						};
						r ? (S.current = l, nv(B_, d, f, { discrete: !1 })) : rv(l, h.swipeDirection, c) ? (S.current = l, nv(z_, u, f, { discrete: !1 }), e.target.setPointerCapture(e.pointerId)) : (Math.abs(t) > c || Math.abs(n) > c) && (x.current = null);
					}),
					onPointerUp: N(e.onPointerUp, (e) => {
						let t = S.current, n = e.target;
						if (n.hasPointerCapture(e.pointerId) && n.releasePointerCapture(e.pointerId), S.current = null, x.current = null, t) {
							let n = e.currentTarget, r = {
								originalEvent: e,
								delta: t
							};
							rv(t, h.swipeDirection, h.swipeThreshold) ? nv(H_, p, r, { discrete: !0 }) : nv(V_, f, r, { discrete: !0 }), n.addEventListener("click", (e) => e.preventDefault(), { once: !0 });
						}
					})
				})
			})
		}), h.viewport)
	})] }) : null;
}, "ToastImpl")), q_ = /* @__PURE__ */ $((e) => {
	let { __scopeToast: t, children: n, ...r } = e, i = k_(R_, t), [a, o] = B.useState(!1), [s, c] = B.useState(!1);
	return iv(() => o(!0)), B.useEffect(() => {
		let e = window.setTimeout(() => c(!0), 1e3);
		return () => window.clearTimeout(e);
	}, []), s ? null : /* @__PURE__ */ q(Xe, {
		asChild: !0,
		container: i.announcerContainer || void 0,
		children: /* @__PURE__ */ q(Ge, {
			...r,
			children: a && /* @__PURE__ */ J(K, { children: [
				i.label,
				" ",
				n
			] })
		})
	});
}, "ToastAnnounce"), J_ = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeToast: n, ...r } = e;
	return /* @__PURE__ */ q(F.div, {
		...r,
		ref: t
	});
}, "ToastTitle")), Y_ = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeToast: n, ...r } = e;
	return /* @__PURE__ */ q(F.div, {
		...r,
		ref: t
	});
}, "ToastDescription")), X_ = "ToastAction", Z_ = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { altText: n, ...r } = e;
	return n.trim() ? /* @__PURE__ */ q(ev, {
		altText: n,
		asChild: !0,
		children: /* @__PURE__ */ q($_, {
			...r,
			ref: t
		})
	}) : (console.error(`Invalid prop \`altText\` supplied to \`${X_}\`. Expected non-empty \`string\`.`), null);
}, "ToastAction")), Q_ = "ToastClose", $_ = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeToast: n, ...r } = e, i = G_(Q_, n);
	return /* @__PURE__ */ q(ev, {
		asChild: !0,
		children: /* @__PURE__ */ q(F.button, {
			type: "button",
			...r,
			ref: t,
			onClick: N(e.onClick, i.onClose)
		})
	});
}, "ToastClose")), ev = /* @__PURE__ */ B.forwardRef(/* @__PURE__ */ $(function(e, t) {
	let { __scopeToast: n, altText: r, ...i } = e;
	return /* @__PURE__ */ q(F.div, {
		"data-radix-toast-announce-exclude": "",
		"data-radix-toast-announce-alt": r || void 0,
		...i,
		ref: t
	});
}, "ToastAnnounceExclude"));
function tv(e) {
	let t = [];
	return Array.from(e.childNodes).forEach((e) => {
		if (e.nodeType === e.TEXT_NODE && e.textContent && t.push(e.textContent), av(e)) {
			let n = e.ariaHidden || e.hidden || e.style.display === "none", r = e.dataset.radixToastAnnounceExclude === "";
			if (!n) {
				if (r) {
					let n = e.dataset.radixToastAnnounceAlt;
					n && t.push(n);
				} else t.push(...tv(e));
			}
		}
	}), t;
}
$(tv, "getAnnounceTextContent");
function nv(e, t, n, { discrete: r }) {
	let i = n.originalEvent.currentTarget, a = new CustomEvent(e, {
		bubbles: !0,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? le(i, a) : i.dispatchEvent(a);
}
$(nv, "handleAndDispatchCustomEvent");
var rv = /* @__PURE__ */ $((e, t, n = 0) => {
	let r = Math.abs(e.x), i = Math.abs(e.y), a = r > i;
	return t === w_.Left || t === w_.Right ? a && r > n : !a && i > n;
}, "isDeltaInDirection");
function iv(e = () => {}) {
	let t = j(e);
	S(() => {
		let e = 0, n = 0;
		return e = window.requestAnimationFrame(() => n = window.requestAnimationFrame(t)), () => {
			window.cancelAnimationFrame(e), window.cancelAnimationFrame(n);
		};
	}, [t]);
}
$(iv, "useNextFrame");
function av(e) {
	return e.nodeType === e.ELEMENT_NODE;
}
$(av, "isHTMLElement");
function ov(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ $((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
$(ov, "getTabbableCandidates");
function sv(e) {
	let t = document.activeElement;
	return e.some((e) => e === t || (e.focus(), document.activeElement !== t));
}
$(sv, "focusFirst");
//#endregion
//#region src/components/molecules/Toast/Toast.tsx
var cv = A_, lv = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(F_, {
	ref: n,
	className: I("pointer-events-none fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4", "sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]", e),
	...t
}));
lv.displayName = F_.displayName;
var uv = a([
	"group pointer-events-auto relative flex w-full items-center justify-between",
	"space-x-4 overflow-hidden rounded-lg border p-4 pr-8 shadow-lg dark:shadow-slate-950/50 transition-all",
	"data-[swipe=cancel]:translate-x-0",
	"data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)]",
	"data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
	"data-[swipe=move]:transition-none",
	"data-[state=open]:animate-in data-[state=closed]:animate-out",
	"data-[swipe=end]:animate-out",
	"data-[state=closed]:fade-out-80",
	"data-[state=closed]:slide-out-to-right-full",
	"data-[state=open]:slide-in-from-top-full",
	"data-[state=open]:sm:slide-in-from-bottom-full"
], {
	variants: { variant: {
		default: ["bg-slate-50 border-slate-200 text-slate-900", "dark:bg-slate-800 dark:border-slate-600 dark:text-slate-100"],
		success: [
			"bg-emerald-50 border-emerald-200 text-emerald-900",
			"dark:bg-emerald-950 dark:border-emerald-700 dark:text-emerald-100",
			"[&>svg]:text-emerald-600 dark:[&>svg]:text-emerald-400"
		],
		error: [
			"bg-rose-50 border-rose-200 text-rose-900",
			"dark:bg-rose-950 dark:border-rose-700 dark:text-rose-100",
			"[&>svg]:text-rose-600 dark:[&>svg]:text-rose-400"
		],
		warning: [
			"bg-amber-50 border-amber-200 text-amber-900",
			"dark:bg-amber-950 dark:border-amber-700 dark:text-amber-100",
			"[&>svg]:text-amber-600 dark:[&>svg]:text-amber-400"
		],
		info: [
			"bg-sky-50 border-sky-200 text-sky-900",
			"dark:bg-sky-950 dark:border-sky-700 dark:text-sky-100",
			"[&>svg]:text-sky-600 dark:[&>svg]:text-sky-400"
		]
	} },
	defaultVariants: { variant: "default" }
}), dv = V(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ q(U_, {
	ref: r,
	className: I(uv({ variant: t }), e),
	...n
}));
dv.displayName = U_.displayName;
var fv = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(Z_, {
	ref: n,
	className: I("inline-flex h-8 shrink-0 items-center justify-center rounded-md", "bg-slate-900 text-white px-3 text-sm font-medium", "transition-colors", "hover:bg-slate-800", "focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 dark:focus:ring-offset-slate-900", "disabled:pointer-events-none disabled:opacity-50", "dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100", "dark:focus:ring-slate-600", e),
	...t
}));
fv.displayName = Z_.displayName;
var pv = V(({ className: e, ...t }, n) => /* @__PURE__ */ q($_, {
	ref: n,
	className: I("absolute right-2 top-2 rounded-md p-1 opacity-70", "transition-opacity", "hover:opacity-100", "focus:outline-none focus:ring-1 focus:ring-slate-300", "dark:focus:ring-slate-600", e),
	"toast-close": "",
	"aria-label": "Close toast",
	...t,
	children: /* @__PURE__ */ q(O, { className: "h-4 w-4" })
}));
pv.displayName = $_.displayName;
var mv = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(J_, {
	ref: n,
	className: I("text-sm font-semibold", e),
	...t
}));
mv.displayName = J_.displayName;
var hv = V(({ className: e, ...t }, n) => /* @__PURE__ */ q(Y_, {
	ref: n,
	className: I("text-sm opacity-90", e),
	...t
}));
hv.displayName = Y_.displayName;
//#endregion
//#region src/components/molecules/FilterChipBar/FilterChipBar.tsx
var gv = a([
	"flex items-center gap-2",
	"overflow-x-auto",
	"scrollbar-thin scrollbar-thumb-slate-300 scrollbar-track-transparent",
	"dark:scrollbar-thumb-slate-600"
], {
	variants: { size: {
		sm: "text-xs",
		md: "text-sm"
	} },
	defaultVariants: { size: "md" }
}), _v = a([
	"inline-flex items-center gap-1.5",
	"border rounded-full",
	"whitespace-nowrap",
	"transition-colors",
	"bg-slate-100 text-slate-700 border-slate-200",
	"dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700"
], {
	variants: { size: {
		sm: "px-2 py-0.5",
		md: "px-3 py-1"
	} },
	defaultVariants: { size: "md" }
});
function vv({ chipKey: e, label: t, value: n, size: r = "md", onRemove: i }) {
	let a = r === "sm" ? "h-3 w-3" : "h-3.5 w-3.5";
	return /* @__PURE__ */ q("button", {
		type: "button",
		onClick: () => i?.(e),
		className: I("flex items-center justify-center rounded-full", "text-slate-500 hover:text-slate-700 hover:bg-slate-200", "dark:text-slate-400 dark:hover:text-slate-200 dark:hover:bg-slate-700", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400", "dark:focus-visible:ring-slate-500", "transition-colors", "p-0.5"),
		"aria-label": `Remove ${t} filter: ${n}`,
		children: /* @__PURE__ */ q(O, {
			className: a,
			"aria-hidden": "true"
		})
	});
}
var yv = V(({ className: e, filters: t, onRemove: n, onClearAll: r, showClearAll: i, size: a = "md", emptyState: o, ...s }, c) => {
	if (t.length === 0) return o ? /* @__PURE__ */ q(K, { children: o }) : null;
	let l = i === void 0 ? t.length >= 2 && !!r : i && !!r;
	return /* @__PURE__ */ J("div", {
		ref: c,
		role: "group",
		"aria-label": "Active filters",
		className: I(gv({ size: a }), e),
		...s,
		children: [t.map((e) => {
			let t = e.removable !== !1;
			return /* @__PURE__ */ J("span", {
				className: _v({ size: a }),
				children: [
					/* @__PURE__ */ J("span", {
						className: "font-medium text-slate-500 dark:text-slate-400",
						children: [e.label, ":"]
					}),
					/* @__PURE__ */ q("span", {
						className: "truncate max-w-[200px]",
						children: e.value
					}),
					t && /* @__PURE__ */ q(vv, {
						chipKey: e.key,
						label: e.label,
						value: e.value,
						size: a ?? "md",
						onRemove: n
					})
				]
			}, e.key);
		}), l && /* @__PURE__ */ q("button", {
			type: "button",
			onClick: r,
			className: I("text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300", "font-medium whitespace-nowrap", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400", "focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900", "rounded px-1", "transition-colors"),
			"aria-label": "Clear all filters",
			children: "Clear all"
		})]
	});
});
yv.displayName = "FilterChipBar";
//#endregion
//#region src/components/molecules/OrgSwitcher/OrgSwitcher.tsx
var bv = {
	selectOrg: "Select Organization",
	title: "Organizations",
	description: "Switch between your organizations",
	switchingTo: "Switching...",
	tooltip: "Switch organization",
	retry: "Retry"
}, xv = ({ organizations: e, currentOrgId: t, onSwitch: n, variant: r = "header", collapsed: i = !1, isLoading: a = !1, error: o, onRetry: s, labels: c, className: l }) => {
	let [u, d] = G(!1), [f, p] = G(!1), m = {
		...bv,
		...c
	}, h = e.find((e) => e.id === t), _ = a || u;
	if (!a && !o && e.length <= 1) return null;
	let v = async (e) => {
		if (e !== t && n) try {
			d(!0), await n(e);
		} finally {
			d(!1);
		}
	};
	return r === "sidebar" ? i ? /* @__PURE__ */ J(en, { children: [/* @__PURE__ */ q(st, {
		asChild: !0,
		children: /* @__PURE__ */ q("button", {
			type: "button",
			"data-testid": "org-switcher",
			title: m.tooltip,
			"aria-label": m.tooltip,
			disabled: _,
			className: I("w-full flex items-center justify-center rounded-md px-0 py-2 hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors cursor-pointer disabled:opacity-50", l),
			children: _ ? /* @__PURE__ */ q(qe, { className: "h-5 w-5 text-slate-600 dark:text-slate-400 flex-shrink-0 animate-spin" }) : /* @__PURE__ */ J("div", {
				className: "relative flex-shrink-0",
				children: [/* @__PURE__ */ q(Fr, { className: "h-5 w-5 text-slate-600 dark:text-slate-400" }), o && /* @__PURE__ */ q("span", { className: "absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-amber-500" })]
			})
		})
	}), /* @__PURE__ */ J(rn, {
		side: "right",
		align: "start",
		sideOffset: 8,
		className: "w-64 p-1.5",
		children: [
			/* @__PURE__ */ q("div", {
				className: "px-2 py-1 mb-1 border-b border-slate-200 dark:border-slate-700/50",
				children: /* @__PURE__ */ q(g, {
					size: "xs",
					weight: "semibold",
					className: "text-slate-500 dark:text-slate-400",
					children: m.title
				})
			}),
			o && /* @__PURE__ */ J("div", {
				className: "mx-1 my-1 flex items-center gap-2 text-xs text-amber-600 dark:text-amber-400",
				role: "alert",
				children: [
					/* @__PURE__ */ q(Me, { className: "h-3.5 w-3.5 flex-shrink-0" }),
					/* @__PURE__ */ q("span", {
						className: "flex-1 truncate",
						children: o
					}),
					s && /* @__PURE__ */ q("button", {
						onClick: (e) => {
							e.stopPropagation(), s();
						},
						className: "text-xs underline hover:no-underline flex-shrink-0",
						"aria-label": m.retry,
						children: m.retry
					})
				]
			}),
			e.map((e) => /* @__PURE__ */ J("button", {
				type: "button",
				onClick: () => v(e.id),
				disabled: _,
				className: I("w-full flex items-center gap-2.5 rounded-md px-3 py-2 text-sm transition-colors text-left disabled:opacity-50", e.id === t ? "bg-slate-100 text-slate-900 dark:bg-slate-700/50 dark:text-slate-100" : "text-slate-700 hover:bg-slate-50 dark:text-slate-300 dark:hover:bg-slate-700/30"),
				children: [/* @__PURE__ */ q("span", {
					className: "flex-1 truncate",
					children: e.name
				}), e.id === t && /* @__PURE__ */ q(un, { className: "h-4 w-4 text-green-500 flex-shrink-0" })]
			}, e.id))
		]
	})] }) : /* @__PURE__ */ J("div", {
		className: I("space-y-1", l),
		children: [
			/* @__PURE__ */ J("div", {
				className: "flex items-center gap-2.5 rounded-md px-3 py-2 hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors cursor-pointer",
				onClick: () => p(!f),
				"data-testid": "org-switcher",
				children: [
					_ ? /* @__PURE__ */ q(qe, { className: "h-5 w-5 text-slate-600 dark:text-slate-400 flex-shrink-0 animate-spin" }) : /* @__PURE__ */ J("div", {
						className: "relative flex-shrink-0",
						children: [/* @__PURE__ */ q(Fr, { className: "h-5 w-5 text-slate-600 dark:text-slate-400" }), o && /* @__PURE__ */ q("span", { className: "absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-amber-500" })]
					}),
					/* @__PURE__ */ q(g, {
						as: "span",
						className: "flex-1 text-slate-700 dark:text-slate-300 truncate",
						children: h?.name || m.selectOrg
					}),
					q(f ? Kt : R, { className: "h-4 w-4 text-slate-500" })
				]
			}),
			o && /* @__PURE__ */ q("div", {
				className: "mx-3 mt-1",
				role: "alert",
				children: /* @__PURE__ */ J("div", {
					className: "flex items-center gap-2 text-xs text-amber-600 dark:text-amber-400",
					children: [
						/* @__PURE__ */ q(Me, { className: "h-3.5 w-3.5 flex-shrink-0" }),
						/* @__PURE__ */ q("span", {
							className: "flex-1 truncate",
							children: o
						}),
						s && /* @__PURE__ */ q("button", {
							onClick: (e) => {
								e.stopPropagation(), s();
							},
							className: "text-xs underline hover:no-underline flex-shrink-0",
							"aria-label": m.retry,
							children: m.retry
						})
					]
				})
			}),
			f && /* @__PURE__ */ q("div", {
				className: "ml-7 mb-2 space-y-1",
				children: e.map((e) => /* @__PURE__ */ J(L, {
					variant: "ghost",
					size: "sm",
					onClick: () => v(e.id),
					disabled: _,
					className: I("w-full flex items-center gap-2 rounded-md px-3 py-1.5 text-sm transition-colors justify-start h-auto", e.id === t ? "bg-slate-100 text-slate-900 dark:bg-slate-700/50 dark:text-slate-100" : "text-slate-600 hover:bg-slate-50 dark:text-slate-400 dark:hover:bg-slate-700/30"),
					children: [/* @__PURE__ */ q("span", {
						className: "flex-1 text-left truncate",
						children: e.name
					}), e.id === t && /* @__PURE__ */ q(un, { className: "h-4 w-4 text-green-500 flex-shrink-0" })]
				}, e.id))
			})
		]
	}) : /* @__PURE__ */ J(D, { children: [/* @__PURE__ */ q(Ut, {
		asChild: !0,
		children: /* @__PURE__ */ J(L, {
			variant: "ghost",
			size: "sm",
			className: I("h-10 px-3 flex items-center gap-2", l),
			disabled: _,
			title: m.tooltip,
			"data-testid": "org-switcher",
			children: [
				_ ? /* @__PURE__ */ q(qe, { className: "h-4 w-4 animate-spin" }) : /* @__PURE__ */ q(Fr, { className: "h-4 w-4" }),
				/* @__PURE__ */ q(g, {
					as: "span",
					className: "max-sm:hidden max-w-[150px] truncate",
					children: h?.name || m.selectOrg
				}),
				/* @__PURE__ */ q(R, { className: "h-3 w-3 opacity-50" })
			]
		})
	}), /* @__PURE__ */ J(Le, {
		align: "end",
		className: "w-64 p-1 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700/50 rounded-lg shadow-lg",
		children: [/* @__PURE__ */ J("div", {
			className: "px-3 py-2 border-b border-slate-200 dark:border-slate-700/50",
			children: [/* @__PURE__ */ q(En, {
				level: "h6",
				as: "h3",
				children: m.title
			}), /* @__PURE__ */ q(g, {
				size: "xs",
				color: "muted",
				className: "dark:text-slate-400",
				children: m.description
			})]
		}), /* @__PURE__ */ q("div", {
			className: "py-1 max-h-[300px] overflow-y-auto",
			children: e.map((e) => /* @__PURE__ */ J(re, {
				onClick: () => v(e.id),
				disabled: _,
				className: "flex items-center gap-3 px-3 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/30 rounded-md transition-colors mx-1 cursor-pointer",
				children: [
					/* @__PURE__ */ q("div", {
						className: "w-8 h-8 rounded-md bg-slate-100 dark:bg-slate-700 flex items-center justify-center flex-shrink-0",
						children: /* @__PURE__ */ q(Fr, { className: "h-4 w-4 text-slate-500 dark:text-slate-400" })
					}),
					/* @__PURE__ */ J("div", {
						className: "flex-1 min-w-0",
						children: [/* @__PURE__ */ q(g, {
							size: "sm",
							weight: "medium",
							className: "truncate",
							children: e.name
						}), e.domain && /* @__PURE__ */ q(g, {
							size: "xs",
							color: "muted",
							className: "truncate dark:text-slate-400",
							children: e.domain
						})]
					}),
					e.id === t && /* @__PURE__ */ q(un, { className: "h-4 w-4 text-green-500 flex-shrink-0" })
				]
			}, e.id))
		})]
	})] });
};
xv.displayName = "OrgSwitcher";
//#endregion
//#region src/components/molecules/AppSwitcher/appSwitcherUtils.ts
var Sv = [
	"agion.ai",
	"agion.dev",
	"agion.cloud",
	"agion.fi"
], Cv = [
	"admin",
	"control",
	"app",
	"analytics"
], wv = {
	admin: "4001",
	app: "4002",
	control: "4003",
	analytics: "4004"
}, Tv = {
	admin: "admin",
	control: "control",
	app: "app",
	chat: "app",
	analytics: "analytics"
}, Ev = /* @__PURE__ */ new Set([
	...Object.keys(Tv),
	"api",
	"auth",
	"login"
]), Dv = {
	admin: ie,
	control: t,
	app: Ve,
	analytics: dt
};
function Ov(e = window.location) {
	let t = e.hostname.toLowerCase(), n = Tv[t.split(".")[0] ?? ""];
	if (n) return n;
	if (jv(t)) {
		for (let t of Cv) if (wv[t] === e.port) return t;
	}
	return null;
}
function kv(e, t = window.location) {
	let n = Nv(t.protocol), r = t.hostname.toLowerCase();
	if (jv(r)) return Pv(n, r, wv[e]);
	let i = r.split(".").filter(Boolean);
	if (i.length >= 2) {
		let a = i[0] ?? "";
		if (Ev.has(a)) return i[0] = e, Pv(n, i.join("."), t.port);
		if (Mv(r)) return Pv(n, `${e}.${r}`, t.port);
		if (i.length > 2) return i[0] = e, Pv(n, i.join("."), t.port);
	}
	return Pv(n, r, t.port);
}
function Av(e, t = window.location) {
	return Cv.map((n) => ({
		id: n,
		name: e[n],
		href: kv(n, t),
		icon: Dv[n]
	}));
}
function jv(e) {
	return e === "localhost" || e === "127.0.0.1" || e === "::1";
}
function Mv(e) {
	return Sv.some((t) => e === t || e.endsWith(`.${t}`));
}
function Nv(e) {
	return e.endsWith(":") ? e : `${e}:`;
}
function Pv(e, t, n) {
	return `${e}//${t.includes(":") && !t.startsWith("[") ? `[${t}]` : t}${n ? `:${n}` : ""}/`;
}
//#endregion
//#region src/components/molecules/AppSwitcher/AppSwitcher.tsx
var Fv = {
	selectApp: "Select App",
	title: "Applications",
	description: "Switch between Agion applications",
	tooltip: "Switch application"
}, Iv = ({ apps: e, currentAppId: t, variant: n = "header", collapsed: r = !1, labels: i, className: a }) => {
	let [o, s] = G(!1), c = {
		...Fv,
		...i
	}, l = e.find((e) => e.id === t), u = l?.icon ?? Ze;
	return e.length === 0 ? null : n === "sidebar" ? r ? /* @__PURE__ */ J(en, { children: [/* @__PURE__ */ q(st, {
		asChild: !0,
		children: /* @__PURE__ */ q("button", {
			type: "button",
			"data-testid": "app-switcher",
			title: c.tooltip,
			"aria-label": c.tooltip,
			className: I("w-full flex items-center justify-center rounded-md px-0 py-2 hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors cursor-pointer", a),
			children: /* @__PURE__ */ q(u, { className: "h-5 w-5 text-slate-600 dark:text-slate-400 flex-shrink-0" })
		})
	}), /* @__PURE__ */ J(rn, {
		side: "right",
		align: "start",
		sideOffset: 8,
		className: "w-56 p-1.5",
		children: [/* @__PURE__ */ q("div", {
			className: "px-2 py-1 mb-1 border-b border-slate-200 dark:border-slate-700/50",
			children: /* @__PURE__ */ q(g, {
				size: "xs",
				weight: "semibold",
				className: "text-slate-500 dark:text-slate-400",
				children: c.title
			})
		}), e.map((e) => {
			let n = e.icon ?? Ze, r = e.id === t;
			return /* @__PURE__ */ J("a", {
				href: e.href,
				"aria-current": r ? "page" : void 0,
				"data-testid": `app-switcher-${e.id}`,
				className: I("flex items-center gap-2.5 rounded-md px-3 py-2 text-sm transition-colors", r ? "bg-slate-100 text-slate-900 dark:bg-slate-700/50 dark:text-slate-100" : "text-slate-700 hover:bg-slate-50 dark:text-slate-300 dark:hover:bg-slate-700/30"),
				children: [
					/* @__PURE__ */ q(n, { className: "h-4 w-4 flex-shrink-0" }),
					/* @__PURE__ */ q("span", {
						className: "flex-1 truncate",
						children: e.name
					}),
					r && /* @__PURE__ */ q(un, { className: "h-4 w-4 text-green-500 flex-shrink-0" })
				]
			}, e.id);
		})]
	})] }) : /* @__PURE__ */ J("div", {
		className: I("space-y-1", a),
		"data-testid": "app-switcher",
		children: [/* @__PURE__ */ J("div", {
			className: "flex items-center gap-2.5 rounded-md px-3 py-2 hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors cursor-pointer",
			onClick: () => s(!o),
			"aria-label": c.tooltip,
			"aria-expanded": o,
			children: [
				/* @__PURE__ */ q(u, { className: "h-5 w-5 text-slate-600 dark:text-slate-400 flex-shrink-0" }),
				/* @__PURE__ */ q(g, {
					as: "span",
					className: "flex-1 text-slate-700 dark:text-slate-300 truncate",
					children: l?.name || c.selectApp
				}),
				q(o ? Kt : R, { className: "h-4 w-4 text-slate-500" })
			]
		}), o && /* @__PURE__ */ q("div", {
			className: "ml-7 mb-2 space-y-1",
			children: e.map((e) => {
				let n = e.icon ?? Ze, r = e.id === t;
				return /* @__PURE__ */ q(L, {
					asChild: !0,
					variant: "ghost",
					size: "sm",
					className: I("w-full flex items-center gap-2 rounded-md px-3 py-1.5 text-sm transition-colors justify-start h-auto", r ? "bg-slate-100 text-slate-900 dark:bg-slate-700/50 dark:text-slate-100" : "text-slate-600 hover:bg-slate-50 dark:text-slate-400 dark:hover:bg-slate-700/30"),
					children: /* @__PURE__ */ J("a", {
						href: e.href,
						"aria-current": r ? "page" : void 0,
						onClick: () => s(!1),
						"data-testid": `app-switcher-${e.id}`,
						children: [
							/* @__PURE__ */ q(n, { className: "h-4 w-4 flex-shrink-0" }),
							/* @__PURE__ */ q("span", {
								className: "flex-1 text-left truncate",
								children: e.name
							}),
							r && /* @__PURE__ */ q(un, { className: "h-4 w-4 text-green-500 flex-shrink-0" })
						]
					})
				}, e.id);
			})
		})]
	}) : /* @__PURE__ */ J(D, { children: [/* @__PURE__ */ q(Ut, {
		asChild: !0,
		children: /* @__PURE__ */ J(L, {
			variant: "ghost",
			size: "sm",
			className: I("h-10 px-3 flex items-center gap-2", a),
			title: c.tooltip,
			"data-testid": "app-switcher",
			children: [
				/* @__PURE__ */ q(u, { className: "h-4 w-4" }),
				/* @__PURE__ */ q(g, {
					as: "span",
					className: "hidden sm:inline max-w-[150px] truncate",
					children: l?.name || c.selectApp
				}),
				/* @__PURE__ */ q(R, { className: "h-3 w-3 opacity-50" })
			]
		})
	}), /* @__PURE__ */ J(Le, {
		align: "end",
		className: "w-64 p-1 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700/50 rounded-lg shadow-lg",
		children: [/* @__PURE__ */ J("div", {
			className: "px-3 py-2 border-b border-slate-200 dark:border-slate-700/50",
			children: [/* @__PURE__ */ q(En, {
				level: "h6",
				as: "h3",
				children: c.title
			}), /* @__PURE__ */ q(g, {
				size: "xs",
				color: "muted",
				className: "dark:text-slate-400",
				children: c.description
			})]
		}), /* @__PURE__ */ q("div", {
			className: "py-1 max-h-[300px] overflow-y-auto",
			children: e.map((e) => {
				let n = e.icon ?? Ze, r = e.id === t;
				return /* @__PURE__ */ q(re, {
					asChild: !0,
					className: "flex items-center gap-3 px-3 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/30 rounded-md transition-colors mx-1 cursor-pointer",
					children: /* @__PURE__ */ J("a", {
						href: e.href,
						"aria-current": r ? "page" : void 0,
						"data-testid": `app-switcher-${e.id}`,
						children: [
							/* @__PURE__ */ q("div", {
								className: "w-8 h-8 rounded-md bg-slate-100 dark:bg-slate-700 flex items-center justify-center flex-shrink-0",
								children: /* @__PURE__ */ q(n, { className: "h-4 w-4 text-slate-500 dark:text-slate-400" })
							}),
							/* @__PURE__ */ J("div", {
								className: "flex-1 min-w-0",
								children: [/* @__PURE__ */ q(g, {
									size: "sm",
									weight: "medium",
									className: "truncate",
									children: e.name
								}), e.description && /* @__PURE__ */ q(g, {
									size: "xs",
									color: "muted",
									className: "truncate dark:text-slate-400",
									children: e.description
								})]
							}),
							r && /* @__PURE__ */ q(un, { className: "h-4 w-4 text-green-500 flex-shrink-0" })
						]
					})
				}, e.id);
			})
		})]
	})] });
};
Iv.displayName = "AppSwitcher";
//#endregion
//#region src/components/molecules/SectionCard/SectionCard.tsx
var Lv = V(({ icon: e, title: t, badge: n, actions: r, collapsible: i = !1, defaultExpanded: a = !0, expanded: o, onExpandedChange: s, children: c, className: l, ...u }, d) => {
	let [f, p] = G(a), m = o !== void 0, h = m ? o : f, g = () => {
		let e = !h;
		m || p(e), s?.(e);
	}, _ = /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ J("div", {
		className: "flex items-center gap-2 min-w-0",
		children: [
			e && /* @__PURE__ */ q("span", {
				className: "flex-shrink-0 [&>svg]:h-5 [&>svg]:w-5",
				children: e
			}),
			/* @__PURE__ */ q("span", {
				className: "text-base font-semibold text-slate-900 dark:text-slate-100 truncate",
				children: t
			}),
			n
		]
	}), /* @__PURE__ */ J("div", {
		className: "flex items-center gap-2 flex-shrink-0",
		children: [r && /* @__PURE__ */ q("span", {
			onClick: (e) => e.stopPropagation(),
			children: r
		}), i && q(h ? R : ct, { className: "h-4 w-4 text-slate-400" })]
	})] });
	return i ? /* @__PURE__ */ J("div", {
		ref: d,
		className: I(Te({ variant: "default" }), l),
		...u,
		children: [/* @__PURE__ */ q("button", {
			type: "button",
			onClick: g,
			className: "flex items-center justify-between w-full p-4 text-left cursor-pointer",
			children: _
		}), h && /* @__PURE__ */ q("div", {
			className: "border-t border-slate-200 dark:border-slate-700",
			children: c
		})]
	}) : /* @__PURE__ */ J("div", {
		ref: d,
		className: I(Te({
			variant: "default",
			padding: "lg"
		}), l),
		...u,
		children: [/* @__PURE__ */ q("div", {
			className: "flex items-center justify-between mb-4",
			children: _
		}), c]
	});
});
Lv.displayName = "SectionCard";
//#endregion
//#region src/components/molecules/ProcessStatusStrip/ProcessStatusStrip.tsx
var Rv = V(({ className: e, title: t, detail: n, metadataLines: r = [], status: i = "maintenance", progressValue: a, progressLabel: o, progressVariant: s = "default", phases: c = [], ...l }, u) => {
	let d = typeof a == "number" ? Math.max(0, Math.min(100, a)) : void 0;
	return /* @__PURE__ */ q(xu, {
		ref: u,
		variant: "outline",
		padding: "sm",
		className: I("mb-4", e),
		role: "status",
		"aria-live": "polite",
		"aria-atomic": "true",
		...l,
		children: /* @__PURE__ */ J("div", {
			className: "flex items-center justify-between gap-4",
			children: [/* @__PURE__ */ J("div", {
				className: "min-w-0 flex-1",
				children: [
					/* @__PURE__ */ q(iu, {
						status: i,
						size: "sm",
						animate: i === "maintenance",
						children: t
					}),
					n && /* @__PURE__ */ q(g, {
						size: "xs",
						color: "muted",
						className: "mt-0.5 truncate",
						children: n
					}),
					r.map((e, t) => /* @__PURE__ */ q(g, {
						size: "xs",
						color: "muted",
						className: I(t === 0 ? "mt-1" : "mt-0.5", "truncate"),
						children: e
					}, `${t}-${e}`)),
					d !== void 0 && o && /* @__PURE__ */ q(Xo, {
						size: "sm",
						variant: s,
						value: d,
						className: "mt-2 max-w-sm",
						"aria-label": o,
						"aria-valuetext": `${d}%`
					})
				]
			}), c.length > 0 && /* @__PURE__ */ q("ol", {
				className: "flex shrink-0 items-center gap-1.5",
				"aria-label": "Process phases",
				children: c.map((e) => /* @__PURE__ */ q("li", {
					className: "flex items-center",
					children: /* @__PURE__ */ q(iu, {
						status: e.status,
						size: "sm",
						showDot: !0,
						animate: e.active,
						className: "h-4 w-4 justify-center rounded-full border-transparent bg-transparent p-0",
						"aria-label": e.label,
						title: e.label
					})
				}, e.id))
			})]
		})
	});
});
Rv.displayName = "ProcessStatusStrip";
//#endregion
//#region src/components/molecules/JsonViewer/JsonViewer.tsx
function zv(e) {
	try {
		return JSON.parse(e);
	} catch {
		return null;
	}
}
function Bv(e, t) {
	return e[t] ?? "";
}
function Vv(e) {
	let t = [], n = 0;
	for (; n < e.length;) {
		let r = Bv(e, n);
		if (!r) break;
		if (/\s/.test(r)) {
			let r = "";
			for (; n < e.length;) {
				let t = Bv(e, n);
				if (!t || !/\s/.test(t)) break;
				r += t, n++;
			}
			t.push({
				type: "punctuation",
				value: r
			});
		} else if (/[{}[\]:,]/.test(r)) t.push({
			type: "punctuation",
			value: r
		}), n++;
		else if (r === "\"") {
			let r = "\"";
			for (n++; n < e.length;) {
				let t = Bv(e, n);
				if (t === "\"") break;
				t === "\\" && n + 1 < e.length ? (r += t + Bv(e, n + 1), n += 2) : (r += t, n++);
			}
			n < e.length && (r += "\"", n++);
			let i = n;
			for (; i < e.length;) {
				let t = Bv(e, i);
				if (!/\s/.test(t)) break;
				i++;
			}
			let a = Bv(e, i) === ":";
			t.push({
				type: a ? "key" : "string",
				value: r
			});
		} else if (/[-0-9]/.test(r)) {
			let r = "";
			for (; n < e.length;) {
				let t = Bv(e, n);
				if (!t || !/[-0-9.eE+]/.test(t)) break;
				r += t, n++;
			}
			t.push({
				type: "number",
				value: r
			});
		} else e.slice(n, n + 4) === "true" ? (t.push({
			type: "boolean",
			value: "true"
		}), n += 4) : e.slice(n, n + 5) === "false" ? (t.push({
			type: "boolean",
			value: "false"
		}), n += 5) : e.slice(n, n + 4) === "null" ? (t.push({
			type: "null",
			value: "null"
		}), n += 4) : (t.push({
			type: "punctuation",
			value: r
		}), n++);
	}
	return t;
}
function Hv(e) {
	switch (e) {
		case "string": return "text-emerald-600 dark:text-emerald-400";
		case "number": return "text-blue-600 dark:text-blue-400";
		case "boolean":
		case "null": return "text-purple-600 dark:text-purple-400";
		case "key": return "text-slate-700 dark:text-slate-300";
		default: return "text-slate-600 dark:text-slate-400";
	}
}
function Uv({ content: e }) {
	let t = Vv(e);
	return /* @__PURE__ */ q(K, { children: t.map((e, t) => /* @__PURE__ */ q("span", {
		className: Hv(e.type),
		children: e.value
	}, t)) });
}
var Wv = V(({ className: e, value: t, pretty: n = !0, showToggle: r = !0, copyable: i = !0, collapseAbove: a = 12, collapsed: o, onCollapseChange: s, maxHeight: c, ariaLabel: l = "JSON content", ...u }, d) => {
	let [f, p] = G(n), [m, h] = G(!0), [g, _] = G(!1), v = n === void 0 || f, y = o !== void 0, b = y ? o : m, x = H((e) => {
		y ? s?.(e) : h(e);
	}, [y, s]), { content: S, isValidJson: C, lineCount: w } = Ln(() => {
		if (t == null) return {
			content: null,
			isValidJson: !1,
			lineCount: 0
		};
		if (typeof t == "string") {
			let e = zv(t);
			if (e !== null) {
				let t = v ? JSON.stringify(e, null, 2) : JSON.stringify(e);
				return {
					content: t,
					isValidJson: !0,
					lineCount: t.split("\n").length
				};
			}
			return {
				content: t,
				isValidJson: !1,
				lineCount: t.split("\n").length
			};
		}
		let e = v ? JSON.stringify(t, null, 2) : JSON.stringify(t);
		return {
			content: e,
			isValidJson: !0,
			lineCount: e.split("\n").length
		};
	}, [t, v]), T = w > a, E = T && b, D = H(async () => {
		if (S) try {
			await navigator.clipboard.writeText(S), _(!0), setTimeout(() => _(!1), 2e3);
		} catch (e) {
			console.error("Failed to copy:", e);
		}
	}, [S]);
	return t == null ? /* @__PURE__ */ q("div", {
		ref: d,
		className: I("font-mono text-sm text-slate-400 dark:text-slate-500", e),
		...u,
		children: "—"
	}) : /* @__PURE__ */ J("div", {
		ref: d,
		className: I("relative", e),
		...u,
		children: [
			/* @__PURE__ */ J("div", {
				className: "flex items-center gap-2 mb-1",
				children: [r && C && /* @__PURE__ */ J("div", {
					className: "inline-flex rounded-md border border-slate-200 dark:border-slate-700 overflow-hidden",
					children: [/* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => p(!0),
						className: I("px-2 py-0.5 text-xs transition-colors", f ? "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200" : "bg-white text-slate-500 hover:bg-slate-50 dark:bg-slate-900 dark:text-slate-400 dark:hover:bg-slate-800"),
						"aria-label": "Pretty format",
						"aria-pressed": f,
						children: "Pretty"
					}), /* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => p(!1),
						className: I("px-2 py-0.5 text-xs transition-colors border-l border-slate-200 dark:border-slate-700", f ? "bg-white text-slate-500 hover:bg-slate-50 dark:bg-slate-900 dark:text-slate-400 dark:hover:bg-slate-800" : "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200"),
						"aria-label": "Raw format",
						"aria-pressed": !f,
						children: "Raw"
					})]
				}), /* @__PURE__ */ q("div", {
					className: "flex items-center gap-1 ml-auto",
					children: i && S && /* @__PURE__ */ q("button", {
						type: "button",
						onClick: D,
						className: "p-1 rounded text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors",
						"aria-label": "Copy to clipboard",
						children: g ? /* @__PURE__ */ q(un, { className: "h-3.5 w-3.5 text-emerald-500" }) : /* @__PURE__ */ q(sn, { className: "h-3.5 w-3.5" })
					})
				})]
			}),
			E && /* @__PURE__ */ q("div", {
				className: "text-sm text-slate-500 dark:text-slate-400",
				children: /* @__PURE__ */ J("button", {
					type: "button",
					onClick: () => x(!1),
					className: "inline-flex items-center gap-1 text-sky-500 hover:text-sky-600 dark:hover:text-sky-400",
					children: [
						/* @__PURE__ */ q(R, { className: "h-3.5 w-3.5" }),
						"Show payload (",
						w,
						" lines)"
					]
				})
			}),
			!E && S && /* @__PURE__ */ J("div", {
				className: I("rounded-lg overflow-hidden border", "bg-slate-50 border-slate-200 dark:bg-slate-800/50 dark:border-slate-700"),
				children: [T && /* @__PURE__ */ q("div", {
					className: "px-3 py-1.5 border-b border-slate-200 dark:border-slate-700",
					children: /* @__PURE__ */ J("button", {
						type: "button",
						onClick: () => x(!0),
						className: "inline-flex items-center gap-1 text-xs text-sky-500 hover:text-sky-600 dark:hover:text-sky-400",
						children: [/* @__PURE__ */ q(Kt, { className: "h-3 w-3" }), "Hide payload"]
					})
				}), /* @__PURE__ */ q("div", {
					className: I("overflow-auto", c && "overflow-y-auto"),
					style: c ? { maxHeight: `${c}px` } : void 0,
					children: /* @__PURE__ */ q("pre", {
						className: "p-3 leading-relaxed",
						children: /* @__PURE__ */ q("code", {
							className: "font-mono text-sm whitespace-pre",
							role: "region",
							"aria-label": l,
							children: C ? /* @__PURE__ */ q(Uv, { content: S }) : /* @__PURE__ */ q("span", {
								className: "text-slate-700 dark:text-slate-300",
								children: S
							})
						})
					})
				})]
			})
		]
	});
});
Wv.displayName = "JsonViewer";
//#endregion
//#region src/components/molecules/LineageCard/LineageCard.tsx
var Gv = a([
	"relative",
	"bg-white border border-slate-200 rounded-lg",
	"transition-all",
	"dark:bg-slate-800 dark:border-slate-700"
], {
	variants: { size: {
		sm: "p-3 gap-2",
		md: "p-4 gap-3"
	} },
	defaultVariants: { size: "md" }
});
function Kv(e) {
	switch (e) {
		case "eligible": return "success";
		case "not_eligible": return "warning";
		case "pending": return "info";
		default: return "default";
	}
}
function qv(e) {
	switch (e) {
		case "eligible": return "Eligible";
		case "not_eligible": return "Not eligible";
		case "pending": return "Pending";
		default: return "Unknown";
	}
}
function Jv(e) {
	let t = e.split("_").join(" ");
	return t.charAt(0).toUpperCase() + t.slice(1);
}
function Yv({ label: e, value: t, onClick: n }) {
	return /* @__PURE__ */ J("div", {
		className: "flex items-center justify-between gap-2 py-1",
		children: [/* @__PURE__ */ q("span", {
			className: "text-sm text-slate-500 dark:text-slate-400",
			children: e
		}), n ? /* @__PURE__ */ q("button", {
			type: "button",
			onClick: () => {
				n && n(t);
			},
			className: "inline-flex focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900 rounded",
			children: /* @__PURE__ */ q(bo, {
				value: t,
				truncate: 8,
				copyable: !1
			})
		}) : /* @__PURE__ */ q(bo, {
			value: t,
			truncate: 8,
			copyable: !0
		})]
	});
}
var Xv = V(({ className: e, lineage: t, size: n = "md", onSourceEventClick: r, onContextPackClick: a, onLearningEpisodeClick: o, collapsible: s = !1, defaultCollapsed: c = !0, ...l }, u) => {
	let [d, f] = G(!c), { eligibility: p, blockerCode: m, blockerLabel: h, sourceAuditEventId: g, sourceChainIndex: _, sourceEventHash: v, contextPackId: y, contextPackHash: b, learningEpisodeId: x, learningEpisodeHash: S, sourceMissionName: C, sourceExecutionId: w } = t, T = p === "not_eligible" && (h || m), E = h || (m ? Jv(m) : ""), D = g || _ !== void 0 || v || y || b || x || S || C, O = () => /* @__PURE__ */ J("div", {
		className: "flex flex-col gap-1",
		children: [
			g && /* @__PURE__ */ q(Yv, {
				label: "Source event",
				value: g,
				onClick: r
			}),
			_ !== void 0 && /* @__PURE__ */ J("div", {
				className: "flex items-center justify-between gap-2 py-1",
				children: [/* @__PURE__ */ q("span", {
					className: "text-sm text-slate-500 dark:text-slate-400",
					children: "Chain index"
				}), /* @__PURE__ */ q("span", {
					className: "font-mono text-sm text-slate-700 dark:text-slate-300",
					children: _
				})]
			}),
			v && /* @__PURE__ */ q(Yv, {
				label: "Event hash",
				value: v
			}),
			y && /* @__PURE__ */ q(Yv, {
				label: "Context pack",
				value: y,
				onClick: a
			}),
			b && /* @__PURE__ */ q(Yv, {
				label: "Context hash",
				value: b
			}),
			x && /* @__PURE__ */ q(Yv, {
				label: "Learning episode",
				value: x,
				onClick: o
			}),
			S && /* @__PURE__ */ q(Yv, {
				label: "Episode hash",
				value: S
			}),
			C && /* @__PURE__ */ J("div", {
				className: "flex items-center gap-2 py-1.5 mt-1 border-t border-slate-100 dark:border-slate-700",
				children: [/* @__PURE__ */ q(Rt, { className: "h-3.5 w-3.5 text-slate-400" }), /* @__PURE__ */ J("span", {
					className: "text-sm text-slate-600 dark:text-slate-300",
					children: [
						"Mission",
						" ",
						/* @__PURE__ */ q("span", {
							className: "font-medium text-slate-900 dark:text-slate-100",
							children: C
						}),
						w && /* @__PURE__ */ J(K, { children: [" / Execution ", /* @__PURE__ */ q(bo, {
							value: w,
							truncate: 8,
							size: "sm"
						})] })
					]
				})]
			})
		]
	});
	return /* @__PURE__ */ J("div", {
		ref: u,
		className: I(Gv({ size: n }), e),
		...l,
		children: [
			/* @__PURE__ */ J("div", {
				className: "flex items-center gap-2 mb-2",
				children: [
					/* @__PURE__ */ q(xi, { className: "h-4 w-4 text-slate-400 dark:text-slate-500" }),
					/* @__PURE__ */ q("span", {
						className: "text-sm font-medium text-slate-700 dark:text-slate-200",
						children: "Learning Lineage"
					}),
					/* @__PURE__ */ q(i, {
						variant: Kv(p),
						size: "sm",
						className: "ml-auto",
						"aria-label": `Eligibility status: ${qv(p)}`,
						children: qv(p)
					})
				]
			}),
			T && /* @__PURE__ */ J("div", {
				"data-testid": "lineage-blocker-row",
				className: I("flex items-center gap-2 px-3 py-2 mb-2 rounded-md", "bg-rose-50 border border-rose-200", "dark:bg-rose-500/10 dark:border-rose-500/20"),
				children: [/* @__PURE__ */ q(Me, { className: "h-4 w-4 text-rose-600 dark:text-rose-400 shrink-0" }), /* @__PURE__ */ q("span", {
					className: "text-sm text-rose-700 dark:text-rose-300",
					children: E
				})]
			}),
			D && (s ? /* @__PURE__ */ J(uo, {
				open: d,
				onOpenChange: f,
				children: [/* @__PURE__ */ J(fo, {
					className: I("flex items-center gap-1.5 text-sm text-slate-600 dark:text-slate-400", "hover:text-slate-900 dark:hover:text-slate-200", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2", "dark:focus-visible:ring-offset-slate-900", "rounded px-1 -mx-1 py-0.5"),
					"aria-label": d ? "Hide details" : "Show details",
					children: [q(d ? R : ct, { className: "h-4 w-4" }), d ? "Hide details" : "Show details"]
				}), /* @__PURE__ */ q(po, {
					className: "mt-2",
					children: O()
				})]
			}) : O())
		]
	});
});
Xv.displayName = "LineageCard";
//#endregion
//#region src/components/organisms/ArtifactPanel/ArtifactPanel.tsx
var Zv = {
	card: /* @__PURE__ */ q(hi, { className: "h-3.5 w-3.5" }),
	table: /* @__PURE__ */ q(Re, { className: "h-3.5 w-3.5" }),
	code: /* @__PURE__ */ q(qr, { className: "h-3.5 w-3.5" }),
	file: /* @__PURE__ */ q(_i, { className: "h-3.5 w-3.5" })
};
function Qv() {
	return /* @__PURE__ */ J("div", {
		className: "flex flex-1 flex-col items-center justify-center gap-3 py-12 px-6",
		children: [
			/* @__PURE__ */ q(hi, { className: "h-10 w-10 text-slate-300 dark:text-slate-600" }),
			/* @__PURE__ */ q("p", {
				className: "text-sm text-slate-500 dark:text-slate-400",
				children: "No artifacts yet"
			}),
			/* @__PURE__ */ q("p", {
				className: "text-xs text-slate-400 dark:text-slate-500 text-center max-w-[180px]",
				children: "Artifacts produced during mission execution will appear here."
			})
		]
	});
}
var $v = V(({ className: e, artifacts: t, activeId: n, onClose: r, onDownload: i, versions: a, selectedVersion: o, onVersionChange: s, onRestore: c, isRestoring: l, ...u }, d) => {
	let f = n || (t.length > 0 ? t[0].id : void 0), p = a != null && a.length > 1, m = o == null ? null : a?.find((e) => e.version_number === o) ?? null, h = m != null && !m.is_current && c != null;
	function g(e) {
		try {
			return new Date(e).toLocaleDateString(void 0, {
				month: "short",
				day: "numeric",
				year: "numeric"
			});
		} catch {
			return e;
		}
	}
	return /* @__PURE__ */ J("div", {
		ref: d,
		className: I("flex flex-col h-full", "bg-white dark:bg-slate-950", "border-l border-slate-200 dark:border-slate-800", e),
		...u,
		children: [/* @__PURE__ */ J("div", {
			className: "flex items-center justify-between px-4 py-2.5 border-b border-slate-200 dark:border-slate-800 flex-shrink-0 gap-2",
			children: [
				/* @__PURE__ */ q("h3", {
					className: "text-sm font-semibold text-slate-900 dark:text-slate-100 flex-shrink-0",
					children: "Artifacts"
				}),
				p && a && /* @__PURE__ */ q("select", {
					"aria-label": "Select version",
					value: o ?? "",
					onChange: (e) => s?.(Number(e.target.value)),
					className: I("flex-1 min-w-0 max-w-[200px] text-xs rounded-md px-2 py-1", "border border-slate-200 dark:border-slate-700", "bg-white dark:bg-slate-900", "text-slate-700 dark:text-slate-200", "focus:outline-none focus:ring-1 focus:ring-blue-500"),
					children: a.map((e) => /* @__PURE__ */ J("option", {
						value: e.version_number,
						children: [
							"Version ",
							e.version_number,
							e.is_current ? " (current)" : "",
							" — ",
							g(e.created_at)
						]
					}, e.id))
				}),
				r && /* @__PURE__ */ q(L, {
					variant: "ghost",
					size: "sm",
					onClick: r,
					"aria-label": "Close artifacts panel",
					className: "h-7 w-7 p-0 flex-shrink-0",
					children: /* @__PURE__ */ q(O, { className: "h-4 w-4" })
				})
			]
		}), t.length === 0 ? /* @__PURE__ */ q(Qv, {}) : /* @__PURE__ */ J(h_, {
			defaultValue: f,
			className: "flex flex-col flex-1 min-h-0",
			children: [/* @__PURE__ */ q(g_, {
				className: "rounded-none border-b border-slate-200 dark:border-slate-800 bg-transparent h-auto p-0 justify-start flex-shrink-0 gap-0 overflow-x-auto",
				children: t.map((e) => /* @__PURE__ */ J(__, {
					value: e.id,
					className: I("flex items-center gap-1.5 rounded-none border-b-2 border-transparent px-3 py-2", "text-xs font-medium text-slate-500 dark:text-slate-400", "hover:text-slate-700 dark:hover:text-slate-200", "data-[state=active]:border-blue-500 data-[state=active]:text-slate-900 dark:data-[state=active]:text-slate-100", "data-[state=active]:bg-transparent data-[state=active]:shadow-none"),
					children: [/* @__PURE__ */ q("span", {
						className: "text-slate-400 dark:text-slate-500",
						children: Zv[e.type]
					}), /* @__PURE__ */ q("span", {
						className: "truncate max-w-[120px]",
						children: e.title
					})]
				}, e.id))
			}), t.map((e) => /* @__PURE__ */ J(v_, {
				value: e.id,
				className: "flex flex-col flex-1 min-h-0 mt-0 overflow-auto p-4 gap-3",
				children: [/* @__PURE__ */ q("div", {
					className: "flex-1 min-h-0 overflow-auto",
					children: e.content
				}), (h || i) && /* @__PURE__ */ J("div", {
					className: "flex items-center justify-between flex-shrink-0 pt-2 border-t border-slate-100 dark:border-slate-800 gap-2",
					children: [h && m && /* @__PURE__ */ J(L, {
						variant: "outline",
						size: "sm",
						onClick: () => c(m.id),
						disabled: l,
						"aria-label": "Restore this version",
						className: "gap-1.5",
						children: [/* @__PURE__ */ q(qi, { className: I("h-3.5 w-3.5", l && "animate-spin") }), l ? "Restoring…" : "Restore this version"]
					}), i && /* @__PURE__ */ J(L, {
						variant: "outline",
						size: "sm",
						onClick: () => i(e.id),
						className: "gap-1.5 ml-auto",
						children: [/* @__PURE__ */ q(ti, { className: "h-3.5 w-3.5" }), "Download"]
					})]
				})]
			}, e.id))]
		})]
	});
});
$v.displayName = "ArtifactPanel";
var ey = {
	svg: "http://www.w3.org/2000/svg",
	xhtml: "http://www.w3.org/1999/xhtml",
	xlink: "http://www.w3.org/1999/xlink",
	xml: "http://www.w3.org/XML/1998/namespace",
	xmlns: "http://www.w3.org/2000/xmlns/"
};
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/namespace.js
function ty(e) {
	var t = e += "", n = t.indexOf(":");
	return n >= 0 && (t = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), ey.hasOwnProperty(t) ? {
		space: ey[t],
		local: e
	} : e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/creator.js
function ny(e) {
	return function() {
		var t = this.ownerDocument, n = this.namespaceURI;
		return n === "http://www.w3.org/1999/xhtml" && t.documentElement.namespaceURI === "http://www.w3.org/1999/xhtml" ? t.createElement(e) : t.createElementNS(n, e);
	};
}
function ry(e) {
	return function() {
		return this.ownerDocument.createElementNS(e.space, e.local);
	};
}
function iy(e) {
	var t = ty(e);
	return (t.local ? ry : ny)(t);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selector.js
function ay() {}
function oy(e) {
	return e == null ? ay : function() {
		return this.querySelector(e);
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/select.js
function sy(e) {
	typeof e != "function" && (e = oy(e));
	for (var t = this._groups, n = t.length, r = Array(n), i = 0; i < n; ++i) for (var a = t[i], o = a.length, s = r[i] = Array(o), c, l, u = 0; u < o; ++u) (c = a[u]) && (l = e.call(c, c.__data__, u, a)) && ("__data__" in c && (l.__data__ = c.__data__), s[u] = l);
	return new Yb(r, this._parents);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/array.js
function cy(e) {
	return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selectorAll.js
function ly() {
	return [];
}
function uy(e) {
	return e == null ? ly : function() {
		return this.querySelectorAll(e);
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectAll.js
function dy(e) {
	return function() {
		return cy(e.apply(this, arguments));
	};
}
function fy(e) {
	e = typeof e == "function" ? dy(e) : uy(e);
	for (var t = this._groups, n = t.length, r = [], i = [], a = 0; a < n; ++a) for (var o = t[a], s = o.length, c, l = 0; l < s; ++l) (c = o[l]) && (r.push(e.call(c, c.__data__, l, o)), i.push(c));
	return new Yb(r, i);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/matcher.js
function py(e) {
	return function() {
		return this.matches(e);
	};
}
function my(e) {
	return function(t) {
		return t.matches(e);
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectChild.js
var hy = Array.prototype.find;
function gy(e) {
	return function() {
		return hy.call(this.children, e);
	};
}
function _y() {
	return this.firstElementChild;
}
function vy(e) {
	return this.select(e == null ? _y : gy(typeof e == "function" ? e : my(e)));
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectChildren.js
var yy = Array.prototype.filter;
function by() {
	return Array.from(this.children);
}
function xy(e) {
	return function() {
		return yy.call(this.children, e);
	};
}
function Sy(e) {
	return this.selectAll(e == null ? by : xy(typeof e == "function" ? e : my(e)));
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/filter.js
function Cy(e) {
	typeof e != "function" && (e = py(e));
	for (var t = this._groups, n = t.length, r = Array(n), i = 0; i < n; ++i) for (var a = t[i], o = a.length, s = r[i] = [], c, l = 0; l < o; ++l) (c = a[l]) && e.call(c, c.__data__, l, a) && s.push(c);
	return new Yb(r, this._parents);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/sparse.js
function wy(e) {
	return Array(e.length);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/enter.js
function Ty() {
	return new Yb(this._enter || this._groups.map(wy), this._parents);
}
function Ey(e, t) {
	this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
Ey.prototype = {
	constructor: Ey,
	appendChild: function(e) {
		return this._parent.insertBefore(e, this._next);
	},
	insertBefore: function(e, t) {
		return this._parent.insertBefore(e, t);
	},
	querySelector: function(e) {
		return this._parent.querySelector(e);
	},
	querySelectorAll: function(e) {
		return this._parent.querySelectorAll(e);
	}
};
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/constant.js
function Dy(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/data.js
function Oy(e, t, n, r, i, a) {
	for (var o = 0, s, c = t.length, l = a.length; o < l; ++o) (s = t[o]) ? (s.__data__ = a[o], r[o] = s) : n[o] = new Ey(e, a[o]);
	for (; o < c; ++o) (s = t[o]) && (i[o] = s);
}
function ky(e, t, n, r, i, a, o) {
	var s, c, l = /* @__PURE__ */ new Map(), u = t.length, d = a.length, f = Array(u), p;
	for (s = 0; s < u; ++s) (c = t[s]) && (f[s] = p = o.call(c, c.__data__, s, t) + "", l.has(p) ? i[s] = c : l.set(p, c));
	for (s = 0; s < d; ++s) p = o.call(e, a[s], s, a) + "", (c = l.get(p)) ? (r[s] = c, c.__data__ = a[s], l.delete(p)) : n[s] = new Ey(e, a[s]);
	for (s = 0; s < u; ++s) (c = t[s]) && l.get(f[s]) === c && (i[s] = c);
}
function Ay(e) {
	return e.__data__;
}
function jy(e, t) {
	if (!arguments.length) return Array.from(this, Ay);
	var n = t ? ky : Oy, r = this._parents, i = this._groups;
	typeof e != "function" && (e = Dy(e));
	for (var a = i.length, o = Array(a), s = Array(a), c = Array(a), l = 0; l < a; ++l) {
		var u = r[l], d = i[l], f = d.length, p = My(e.call(u, u && u.__data__, l, r)), m = p.length, h = s[l] = Array(m), g = o[l] = Array(m);
		n(u, d, h, g, c[l] = Array(f), p, t);
		for (var _ = 0, v = 0, y, b; _ < m; ++_) if (y = h[_]) {
			for (_ >= v && (v = _ + 1); !(b = g[v]) && ++v < m;);
			y._next = b || null;
		}
	}
	return o = new Yb(o, r), o._enter = s, o._exit = c, o;
}
function My(e) {
	return typeof e == "object" && "length" in e ? e : Array.from(e);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/exit.js
function Ny() {
	return new Yb(this._exit || this._groups.map(wy), this._parents);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/join.js
function Py(e, t, n) {
	var r = this.enter(), i = this, a = this.exit();
	return typeof e == "function" ? (r = e(r), r &&= r.selection()) : r = r.append(e + ""), t != null && (i = t(i), i &&= i.selection()), n == null ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/merge.js
function Fy(e) {
	for (var t = e.selection ? e.selection() : e, n = this._groups, r = t._groups, i = n.length, a = r.length, o = Math.min(i, a), s = Array(i), c = 0; c < o; ++c) for (var l = n[c], u = r[c], d = l.length, f = s[c] = Array(d), p, m = 0; m < d; ++m) (p = l[m] || u[m]) && (f[m] = p);
	for (; c < i; ++c) s[c] = n[c];
	return new Yb(s, this._parents);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/order.js
function Iy() {
	for (var e = this._groups, t = -1, n = e.length; ++t < n;) for (var r = e[t], i = r.length - 1, a = r[i], o; --i >= 0;) (o = r[i]) && (a && o.compareDocumentPosition(a) ^ 4 && a.parentNode.insertBefore(o, a), a = o);
	return this;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/sort.js
function Ly(e) {
	e ||= Ry;
	function t(t, n) {
		return t && n ? e(t.__data__, n.__data__) : !t - !n;
	}
	for (var n = this._groups, r = n.length, i = Array(r), a = 0; a < r; ++a) {
		for (var o = n[a], s = o.length, c = i[a] = Array(s), l, u = 0; u < s; ++u) (l = o[u]) && (c[u] = l);
		c.sort(t);
	}
	return new Yb(i, this._parents).order();
}
function Ry(e, t) {
	return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/call.js
function zy() {
	var e = arguments[0];
	return arguments[0] = this, e.apply(null, arguments), this;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/nodes.js
function By() {
	return Array.from(this);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/node.js
function Vy() {
	for (var e = this._groups, t = 0, n = e.length; t < n; ++t) for (var r = e[t], i = 0, a = r.length; i < a; ++i) {
		var o = r[i];
		if (o) return o;
	}
	return null;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/size.js
function Hy() {
	let e = 0;
	for (let t of this) ++e;
	return e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/empty.js
function Uy() {
	return !this.node();
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/each.js
function Wy(e) {
	for (var t = this._groups, n = 0, r = t.length; n < r; ++n) for (var i = t[n], a = 0, o = i.length, s; a < o; ++a) (s = i[a]) && e.call(s, s.__data__, a, i);
	return this;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/attr.js
function Gy(e) {
	return function() {
		this.removeAttribute(e);
	};
}
function Ky(e) {
	return function() {
		this.removeAttributeNS(e.space, e.local);
	};
}
function qy(e, t) {
	return function() {
		this.setAttribute(e, t);
	};
}
function Jy(e, t) {
	return function() {
		this.setAttributeNS(e.space, e.local, t);
	};
}
function Yy(e, t) {
	return function() {
		var n = t.apply(this, arguments);
		n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
	};
}
function Xy(e, t) {
	return function() {
		var n = t.apply(this, arguments);
		n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
	};
}
function Zy(e, t) {
	var n = ty(e);
	if (arguments.length < 2) {
		var r = this.node();
		return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
	}
	return this.each((t == null ? n.local ? Ky : Gy : typeof t == "function" ? n.local ? Xy : Yy : n.local ? Jy : qy)(n, t));
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/window.js
function Qy(e) {
	return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/style.js
function $y(e) {
	return function() {
		this.style.removeProperty(e);
	};
}
function eb(e, t, n) {
	return function() {
		this.style.setProperty(e, t, n);
	};
}
function tb(e, t, n) {
	return function() {
		var r = t.apply(this, arguments);
		r == null ? this.style.removeProperty(e) : this.style.setProperty(e, r, n);
	};
}
function nb(e, t, n) {
	return arguments.length > 1 ? this.each((t == null ? $y : typeof t == "function" ? tb : eb)(e, t, n ?? "")) : rb(this.node(), e);
}
function rb(e, t) {
	return e.style.getPropertyValue(t) || Qy(e).getComputedStyle(e, null).getPropertyValue(t);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/property.js
function ib(e) {
	return function() {
		delete this[e];
	};
}
function ab(e, t) {
	return function() {
		this[e] = t;
	};
}
function ob(e, t) {
	return function() {
		var n = t.apply(this, arguments);
		n == null ? delete this[e] : this[e] = n;
	};
}
function sb(e, t) {
	return arguments.length > 1 ? this.each((t == null ? ib : typeof t == "function" ? ob : ab)(e, t)) : this.node()[e];
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/classed.js
function cb(e) {
	return e.trim().split(/^|\s+/);
}
function lb(e) {
	return e.classList || new ub(e);
}
function ub(e) {
	this._node = e, this._names = cb(e.getAttribute("class") || "");
}
ub.prototype = {
	add: function(e) {
		this._names.indexOf(e) < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
	},
	remove: function(e) {
		var t = this._names.indexOf(e);
		t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
	},
	contains: function(e) {
		return this._names.indexOf(e) >= 0;
	}
};
function db(e, t) {
	for (var n = lb(e), r = -1, i = t.length; ++r < i;) n.add(t[r]);
}
function fb(e, t) {
	for (var n = lb(e), r = -1, i = t.length; ++r < i;) n.remove(t[r]);
}
function pb(e) {
	return function() {
		db(this, e);
	};
}
function mb(e) {
	return function() {
		fb(this, e);
	};
}
function hb(e, t) {
	return function() {
		(t.apply(this, arguments) ? db : fb)(this, e);
	};
}
function gb(e, t) {
	var n = cb(e + "");
	if (arguments.length < 2) {
		for (var r = lb(this.node()), i = -1, a = n.length; ++i < a;) if (!r.contains(n[i])) return !1;
		return !0;
	}
	return this.each((typeof t == "function" ? hb : t ? pb : mb)(n, t));
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/text.js
function _b() {
	this.textContent = "";
}
function vb(e) {
	return function() {
		this.textContent = e;
	};
}
function yb(e) {
	return function() {
		var t = e.apply(this, arguments);
		this.textContent = t ?? "";
	};
}
function bb(e) {
	return arguments.length ? this.each(e == null ? _b : (typeof e == "function" ? yb : vb)(e)) : this.node().textContent;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/html.js
function xb() {
	this.innerHTML = "";
}
function Sb(e) {
	return function() {
		this.innerHTML = e;
	};
}
function Cb(e) {
	return function() {
		var t = e.apply(this, arguments);
		this.innerHTML = t ?? "";
	};
}
function wb(e) {
	return arguments.length ? this.each(e == null ? xb : (typeof e == "function" ? Cb : Sb)(e)) : this.node().innerHTML;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/raise.js
function Tb() {
	this.nextSibling && this.parentNode.appendChild(this);
}
function Eb() {
	return this.each(Tb);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/lower.js
function Db() {
	this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Ob() {
	return this.each(Db);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/append.js
function kb(e) {
	var t = typeof e == "function" ? e : iy(e);
	return this.select(function() {
		return this.appendChild(t.apply(this, arguments));
	});
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/insert.js
function Ab() {
	return null;
}
function jb(e, t) {
	var n = typeof e == "function" ? e : iy(e), r = t == null ? Ab : typeof t == "function" ? t : oy(t);
	return this.select(function() {
		return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
	});
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/remove.js
function Mb() {
	var e = this.parentNode;
	e && e.removeChild(this);
}
function Nb() {
	return this.each(Mb);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/clone.js
function Pb() {
	var e = this.cloneNode(!1), t = this.parentNode;
	return t ? t.insertBefore(e, this.nextSibling) : e;
}
function Fb() {
	var e = this.cloneNode(!0), t = this.parentNode;
	return t ? t.insertBefore(e, this.nextSibling) : e;
}
function Ib(e) {
	return this.select(e ? Fb : Pb);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/datum.js
function Lb(e) {
	return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/on.js
function Rb(e) {
	return function(t) {
		e.call(this, t, this.__data__);
	};
}
function zb(e) {
	return e.trim().split(/^|\s+/).map(function(e) {
		var t = "", n = e.indexOf(".");
		return n >= 0 && (t = e.slice(n + 1), e = e.slice(0, n)), {
			type: e,
			name: t
		};
	});
}
function Bb(e) {
	return function() {
		var t = this.__on;
		if (t) {
			for (var n = 0, r = -1, i = t.length, a; n < i; ++n) a = t[n], (!e.type || a.type === e.type) && a.name === e.name ? this.removeEventListener(a.type, a.listener, a.options) : t[++r] = a;
			++r ? t.length = r : delete this.__on;
		}
	};
}
function Vb(e, t, n) {
	return function() {
		var r = this.__on, i, a = Rb(t);
		if (r) {
			for (var o = 0, s = r.length; o < s; ++o) if ((i = r[o]).type === e.type && i.name === e.name) {
				this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = a, i.options = n), i.value = t;
				return;
			}
		}
		this.addEventListener(e.type, a, n), i = {
			type: e.type,
			name: e.name,
			value: t,
			listener: a,
			options: n
		}, r ? r.push(i) : this.__on = [i];
	};
}
function Hb(e, t, n) {
	var r = zb(e + ""), i, a = r.length, o;
	if (arguments.length < 2) {
		var s = this.node().__on;
		if (s) {
			for (var c = 0, l = s.length, u; c < l; ++c) for (i = 0, u = s[c]; i < a; ++i) if ((o = r[i]).type === u.type && o.name === u.name) return u.value;
		}
	} else {
		for (s = t ? Vb : Bb, i = 0; i < a; ++i) this.each(s(r[i], t, n));
		return this;
	}
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/dispatch.js
function Ub(e, t, n) {
	var r = Qy(e), i = r.CustomEvent;
	typeof i == "function" ? i = new i(t, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(t, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(t, !1, !1)), e.dispatchEvent(i);
}
function Wb(e, t) {
	return function() {
		return Ub(this, e, t);
	};
}
function Gb(e, t) {
	return function() {
		return Ub(this, e, t.apply(this, arguments));
	};
}
function Kb(e, t) {
	return this.each((typeof t == "function" ? Gb : Wb)(e, t));
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/iterator.js
function* qb() {
	for (var e = this._groups, t = 0, n = e.length; t < n; ++t) for (var r = e[t], i = 0, a = r.length, o; i < a; ++i) (o = r[i]) && (yield o);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/index.js
var Jb = [null];
function Yb(e, t) {
	this._groups = e, this._parents = t;
}
function Xb() {
	return new Yb([[document.documentElement]], Jb);
}
function Zb() {
	return this;
}
Yb.prototype = Xb.prototype = {
	constructor: Yb,
	select: sy,
	selectAll: fy,
	selectChild: vy,
	selectChildren: Sy,
	filter: Cy,
	data: jy,
	enter: Ty,
	exit: Ny,
	join: Py,
	merge: Fy,
	selection: Zb,
	order: Iy,
	sort: Ly,
	call: zy,
	nodes: By,
	node: Vy,
	size: Hy,
	empty: Uy,
	each: Wy,
	attr: Zy,
	style: nb,
	property: sb,
	classed: gb,
	text: bb,
	html: wb,
	raise: Eb,
	lower: Ob,
	append: kb,
	insert: jb,
	remove: Nb,
	clone: Ib,
	datum: Lb,
	on: Hb,
	dispatch: Kb,
	[Symbol.iterator]: qb
};
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/select.js
function Qb(e) {
	return typeof e == "string" ? new Yb([[document.querySelector(e)]], [document.documentElement]) : new Yb([[e]], Jb);
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/sourceEvent.js
function $b(e) {
	let t;
	for (; t = e.sourceEvent;) e = t;
	return e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/pointer.js
function ex(e, t) {
	if (e = $b(e), t === void 0 && (t = e.currentTarget), t) {
		var n = t.ownerSVGElement || t;
		if (n.createSVGPoint) {
			var r = n.createSVGPoint();
			return r.x = e.clientX, r.y = e.clientY, r = r.matrixTransform(t.getScreenCTM().inverse()), [r.x, r.y];
		}
		if (t.getBoundingClientRect) {
			var i = t.getBoundingClientRect();
			return [e.clientX - i.left - t.clientLeft, e.clientY - i.top - t.clientTop];
		}
	}
	return [e.pageX, e.pageY];
}
//#endregion
//#region ../node_modules/.pnpm/d3-dispatch@3.0.1/node_modules/d3-dispatch/src/dispatch.js
var tx = { value: () => {} };
function nx() {
	for (var e = 0, t = arguments.length, n = {}, r; e < t; ++e) {
		if (!(r = arguments[e] + "") || r in n || /[\s.]/.test(r)) throw Error("illegal type: " + r);
		n[r] = [];
	}
	return new rx(n);
}
function rx(e) {
	this._ = e;
}
function ix(e, t) {
	return e.trim().split(/^|\s+/).map(function(e) {
		var n = "", r = e.indexOf(".");
		if (r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), e && !t.hasOwnProperty(e)) throw Error("unknown type: " + e);
		return {
			type: e,
			name: n
		};
	});
}
rx.prototype = nx.prototype = {
	constructor: rx,
	on: function(e, t) {
		var n = this._, r = ix(e + "", n), i, a = -1, o = r.length;
		if (arguments.length < 2) {
			for (; ++a < o;) if ((i = (e = r[a]).type) && (i = ax(n[i], e.name))) return i;
		} else {
			if (t != null && typeof t != "function") throw Error("invalid callback: " + t);
			for (; ++a < o;) if (i = (e = r[a]).type) n[i] = ox(n[i], e.name, t);
			else if (t == null) for (i in n) n[i] = ox(n[i], e.name, null);
			return this;
		}
	},
	copy: function() {
		var e = {}, t = this._;
		for (var n in t) e[n] = t[n].slice();
		return new rx(e);
	},
	call: function(e, t) {
		if ((i = arguments.length - 2) > 0) for (var n = Array(i), r = 0, i, a; r < i; ++r) n[r] = arguments[r + 2];
		if (!this._.hasOwnProperty(e)) throw Error("unknown type: " + e);
		for (a = this._[e], r = 0, i = a.length; r < i; ++r) a[r].value.apply(t, n);
	},
	apply: function(e, t, n) {
		if (!this._.hasOwnProperty(e)) throw Error("unknown type: " + e);
		for (var r = this._[e], i = 0, a = r.length; i < a; ++i) r[i].value.apply(t, n);
	}
};
function ax(e, t) {
	for (var n = 0, r = e.length, i; n < r; ++n) if ((i = e[n]).name === t) return i.value;
}
function ox(e, t, n) {
	for (var r = 0, i = e.length; r < i; ++r) if (e[r].name === t) {
		e[r] = tx, e = e.slice(0, r).concat(e.slice(r + 1));
		break;
	}
	return n != null && e.push({
		name: t,
		value: n
	}), e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/timer.js
var sx = 0, cx = 0, lx = 0, ux = 1e3, dx, fx, px = 0, mx = 0, hx = 0, gx = typeof performance == "object" && performance.now ? performance : Date, _x = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
	setTimeout(e, 17);
};
function vx() {
	return mx ||= (_x(yx), gx.now() + hx);
}
function yx() {
	mx = 0;
}
function bx() {
	this._call = this._time = this._next = null;
}
bx.prototype = xx.prototype = {
	constructor: bx,
	restart: function(e, t, n) {
		if (typeof e != "function") throw TypeError("callback is not a function");
		n = (n == null ? vx() : +n) + (t == null ? 0 : +t), !this._next && fx !== this && (fx ? fx._next = this : dx = this, fx = this), this._call = e, this._time = n, Ex();
	},
	stop: function() {
		this._call && (this._call = null, this._time = Infinity, Ex());
	}
};
function xx(e, t, n) {
	var r = new bx();
	return r.restart(e, t, n), r;
}
function Sx() {
	vx(), ++sx;
	for (var e = dx, t; e;) (t = mx - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
	--sx;
}
function Cx() {
	mx = (px = gx.now()) + hx, sx = cx = 0;
	try {
		Sx();
	} finally {
		sx = 0, Tx(), mx = 0;
	}
}
function wx() {
	var e = gx.now(), t = e - px;
	t > ux && (hx -= t, px = e);
}
function Tx() {
	for (var e, t = dx, n, r = Infinity; t;) t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : dx = n);
	fx = e, Ex(r);
}
function Ex(e) {
	sx || (cx &&= clearTimeout(cx), e - mx > 24 ? (e < Infinity && (cx = setTimeout(Cx, e - gx.now() - hx)), lx &&= clearInterval(lx)) : (lx ||= (px = gx.now(), setInterval(wx, ux)), sx = 1, _x(Cx)));
}
//#endregion
//#region ../node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/timeout.js
function Dx(e, t, n) {
	var r = new bx();
	return t = t == null ? 0 : +t, r.restart((n) => {
		r.stop(), e(n + t);
	}, t, n), r;
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/schedule.js
var Ox = nx("start", "end", "cancel", "interrupt"), kx = [];
function Ax(e, t, n, r, i, a) {
	var o = e.__transition;
	if (!o) e.__transition = {};
	else if (n in o) return;
	Px(e, n, {
		name: t,
		index: r,
		group: i,
		on: Ox,
		tween: kx,
		time: a.time,
		delay: a.delay,
		duration: a.duration,
		ease: a.ease,
		timer: null,
		state: 0
	});
}
function jx(e, t) {
	var n = Nx(e, t);
	if (n.state > 0) throw Error("too late; already scheduled");
	return n;
}
function Mx(e, t) {
	var n = Nx(e, t);
	if (n.state > 3) throw Error("too late; already running");
	return n;
}
function Nx(e, t) {
	var n = e.__transition;
	if (!n || !(n = n[t])) throw Error("transition not found");
	return n;
}
function Px(e, t, n) {
	var r = e.__transition, i;
	r[t] = n, n.timer = xx(a, 0, n.time);
	function a(e) {
		n.state = 1, n.timer.restart(o, n.delay, n.time), n.delay <= e && o(e - n.delay);
	}
	function o(a) {
		var l, u, d, f;
		if (n.state !== 1) return c();
		for (l in r) if (f = r[l], f.name === n.name) {
			if (f.state === 3) return Dx(o);
			f.state === 4 ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", e, e.__data__, f.index, f.group), delete r[l]) : +l < t && (f.state = 6, f.timer.stop(), f.on.call("cancel", e, e.__data__, f.index, f.group), delete r[l]);
		}
		if (Dx(function() {
			n.state === 3 && (n.state = 4, n.timer.restart(s, n.delay, n.time), s(a));
		}), n.state = 2, n.on.call("start", e, e.__data__, n.index, n.group), n.state === 2) {
			for (n.state = 3, i = Array(d = n.tween.length), l = 0, u = -1; l < d; ++l) (f = n.tween[l].value.call(e, e.__data__, n.index, n.group)) && (i[++u] = f);
			i.length = u + 1;
		}
	}
	function s(t) {
		for (var r = t < n.duration ? n.ease.call(null, t / n.duration) : (n.timer.restart(c), n.state = 5, 1), a = -1, o = i.length; ++a < o;) i[a].call(e, r);
		n.state === 5 && (n.on.call("end", e, e.__data__, n.index, n.group), c());
	}
	function c() {
		for (var i in n.state = 6, n.timer.stop(), delete r[t], r) return;
		delete e.__transition;
	}
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/interrupt.js
function Fx(e, t) {
	var n = e.__transition, r, i, a = !0, o;
	if (n) {
		for (o in t = t == null ? null : t + "", n) (r = n[o]).name === t ? (i = r.state > 2 && r.state < 5, r.state = 6, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", e, e.__data__, r.index, r.group), delete n[o]) : a = !1;
		a && delete e.__transition;
	}
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/interrupt.js
function Ix(e) {
	return this.each(function() {
		Fx(this, e);
	});
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/tween.js
function Lx(e, t) {
	var n, r;
	return function() {
		var i = Mx(this, e), a = i.tween;
		if (a !== n) {
			r = n = a;
			for (var o = 0, s = r.length; o < s; ++o) if (r[o].name === t) {
				r = r.slice(), r.splice(o, 1);
				break;
			}
		}
		i.tween = r;
	};
}
function Rx(e, t, n) {
	var r, i;
	if (typeof n != "function") throw Error();
	return function() {
		var a = Mx(this, e), o = a.tween;
		if (o !== r) {
			i = (r = o).slice();
			for (var s = {
				name: t,
				value: n
			}, c = 0, l = i.length; c < l; ++c) if (i[c].name === t) {
				i[c] = s;
				break;
			}
			c === l && i.push(s);
		}
		a.tween = i;
	};
}
function zx(e, t) {
	var n = this._id;
	if (e += "", arguments.length < 2) {
		for (var r = Nx(this.node(), n).tween, i = 0, a = r.length, o; i < a; ++i) if ((o = r[i]).name === e) return o.value;
		return null;
	}
	return this.each((t == null ? Lx : Rx)(n, e, t));
}
function Bx(e, t, n) {
	var r = e._id;
	return e.each(function() {
		var e = Mx(this, r);
		(e.value ||= {})[t] = n.apply(this, arguments);
	}), function(e) {
		return Nx(e, r).value[t];
	};
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/interpolate.js
function Vx(e, t) {
	var n;
	return (typeof t == "number" ? Ff : t instanceof of ? Af : (n = of(t)) ? (t = n, Af) : Vf)(e, t);
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/attr.js
function Hx(e) {
	return function() {
		this.removeAttribute(e);
	};
}
function Ux(e) {
	return function() {
		this.removeAttributeNS(e.space, e.local);
	};
}
function Wx(e, t, n) {
	var r, i = n + "", a;
	return function() {
		var o = this.getAttribute(e);
		return o === i ? null : o === r ? a : a = t(r = o, n);
	};
}
function Gx(e, t, n) {
	var r, i = n + "", a;
	return function() {
		var o = this.getAttributeNS(e.space, e.local);
		return o === i ? null : o === r ? a : a = t(r = o, n);
	};
}
function Kx(e, t, n) {
	var r, i, a;
	return function() {
		var o, s = n(this), c;
		return s == null ? void this.removeAttribute(e) : (o = this.getAttribute(e), c = s + "", o === c ? null : o === r && c === i ? a : (i = c, a = t(r = o, s)));
	};
}
function qx(e, t, n) {
	var r, i, a;
	return function() {
		var o, s = n(this), c;
		return s == null ? void this.removeAttributeNS(e.space, e.local) : (o = this.getAttributeNS(e.space, e.local), c = s + "", o === c ? null : o === r && c === i ? a : (i = c, a = t(r = o, s)));
	};
}
function Jx(e, t) {
	var n = ty(e), r = n === "transform" ? Qf : Vx;
	return this.attrTween(e, typeof t == "function" ? (n.local ? qx : Kx)(n, r, Bx(this, "attr." + e, t)) : t == null ? (n.local ? Ux : Hx)(n) : (n.local ? Gx : Wx)(n, r, t));
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/attrTween.js
function Yx(e, t) {
	return function(n) {
		this.setAttribute(e, t.call(this, n));
	};
}
function Xx(e, t) {
	return function(n) {
		this.setAttributeNS(e.space, e.local, t.call(this, n));
	};
}
function Zx(e, t) {
	var n, r;
	function i() {
		var i = t.apply(this, arguments);
		return i !== r && (n = (r = i) && Xx(e, i)), n;
	}
	return i._value = t, i;
}
function Qx(e, t) {
	var n, r;
	function i() {
		var i = t.apply(this, arguments);
		return i !== r && (n = (r = i) && Yx(e, i)), n;
	}
	return i._value = t, i;
}
function $x(e, t) {
	var n = "attr." + e;
	if (arguments.length < 2) return (n = this.tween(n)) && n._value;
	if (t == null) return this.tween(n, null);
	if (typeof t != "function") throw Error();
	var r = ty(e);
	return this.tween(n, (r.local ? Zx : Qx)(r, t));
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/delay.js
function eS(e, t) {
	return function() {
		jx(this, e).delay = +t.apply(this, arguments);
	};
}
function tS(e, t) {
	return t = +t, function() {
		jx(this, e).delay = t;
	};
}
function nS(e) {
	var t = this._id;
	return arguments.length ? this.each((typeof e == "function" ? eS : tS)(t, e)) : Nx(this.node(), t).delay;
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/duration.js
function rS(e, t) {
	return function() {
		Mx(this, e).duration = +t.apply(this, arguments);
	};
}
function iS(e, t) {
	return t = +t, function() {
		Mx(this, e).duration = t;
	};
}
function aS(e) {
	var t = this._id;
	return arguments.length ? this.each((typeof e == "function" ? rS : iS)(t, e)) : Nx(this.node(), t).duration;
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/ease.js
function oS(e, t) {
	if (typeof t != "function") throw Error();
	return function() {
		Mx(this, e).ease = t;
	};
}
function sS(e) {
	var t = this._id;
	return arguments.length ? this.each(oS(t, e)) : Nx(this.node(), t).ease;
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/easeVarying.js
function cS(e, t) {
	return function() {
		var n = t.apply(this, arguments);
		if (typeof n != "function") throw Error();
		Mx(this, e).ease = n;
	};
}
function lS(e) {
	if (typeof e != "function") throw Error();
	return this.each(cS(this._id, e));
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/filter.js
function uS(e) {
	typeof e != "function" && (e = py(e));
	for (var t = this._groups, n = t.length, r = Array(n), i = 0; i < n; ++i) for (var a = t[i], o = a.length, s = r[i] = [], c, l = 0; l < o; ++l) (c = a[l]) && e.call(c, c.__data__, l, a) && s.push(c);
	return new zS(r, this._parents, this._name, this._id);
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/merge.js
function dS(e) {
	if (e._id !== this._id) throw Error();
	for (var t = this._groups, n = e._groups, r = t.length, i = n.length, a = Math.min(r, i), o = Array(r), s = 0; s < a; ++s) for (var c = t[s], l = n[s], u = c.length, d = o[s] = Array(u), f, p = 0; p < u; ++p) (f = c[p] || l[p]) && (d[p] = f);
	for (; s < r; ++s) o[s] = t[s];
	return new zS(o, this._parents, this._name, this._id);
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/on.js
function fS(e) {
	return (e + "").trim().split(/^|\s+/).every(function(e) {
		var t = e.indexOf(".");
		return t >= 0 && (e = e.slice(0, t)), !e || e === "start";
	});
}
function pS(e, t, n) {
	var r, i, a = fS(t) ? jx : Mx;
	return function() {
		var o = a(this, e), s = o.on;
		s !== r && (i = (r = s).copy()).on(t, n), o.on = i;
	};
}
function mS(e, t) {
	var n = this._id;
	return arguments.length < 2 ? Nx(this.node(), n).on.on(e) : this.each(pS(n, e, t));
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/remove.js
function hS(e) {
	return function() {
		var t = this.parentNode;
		for (var n in this.__transition) if (+n !== e) return;
		t && t.removeChild(this);
	};
}
function gS() {
	return this.on("end.remove", hS(this._id));
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/select.js
function _S(e) {
	var t = this._name, n = this._id;
	typeof e != "function" && (e = oy(e));
	for (var r = this._groups, i = r.length, a = Array(i), o = 0; o < i; ++o) for (var s = r[o], c = s.length, l = a[o] = Array(c), u, d, f = 0; f < c; ++f) (u = s[f]) && (d = e.call(u, u.__data__, f, s)) && ("__data__" in u && (d.__data__ = u.__data__), l[f] = d, Ax(l[f], t, n, f, l, Nx(u, n)));
	return new zS(a, this._parents, t, n);
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/selectAll.js
function vS(e) {
	var t = this._name, n = this._id;
	typeof e != "function" && (e = uy(e));
	for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) for (var c = r[s], l = c.length, u, d = 0; d < l; ++d) if (u = c[d]) {
		for (var f = e.call(u, u.__data__, d, c), p, m = Nx(u, n), h = 0, g = f.length; h < g; ++h) (p = f[h]) && Ax(p, t, n, h, f, m);
		a.push(f), o.push(u);
	}
	return new zS(a, o, t, n);
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/selection.js
var yS = Xb.prototype.constructor;
function bS() {
	return new yS(this._groups, this._parents);
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/style.js
function xS(e, t) {
	var n, r, i;
	return function() {
		var a = rb(this, e), o = (this.style.removeProperty(e), rb(this, e));
		return a === o ? null : a === n && o === r ? i : i = t(n = a, r = o);
	};
}
function SS(e) {
	return function() {
		this.style.removeProperty(e);
	};
}
function CS(e, t, n) {
	var r, i = n + "", a;
	return function() {
		var o = rb(this, e);
		return o === i ? null : o === r ? a : a = t(r = o, n);
	};
}
function wS(e, t, n) {
	var r, i, a;
	return function() {
		var o = rb(this, e), s = n(this), c = s + "";
		return s ?? (c = s = (this.style.removeProperty(e), rb(this, e))), o === c ? null : o === r && c === i ? a : (i = c, a = t(r = o, s));
	};
}
function TS(e, t) {
	var n, r, i, a = "style." + t, o = "end." + a, s;
	return function() {
		var c = Mx(this, e), l = c.on, u = c.value[a] == null ? s ||= SS(t) : void 0;
		(l !== n || i !== u) && (r = (n = l).copy()).on(o, i = u), c.on = r;
	};
}
function ES(e, t, n) {
	var r = (e += "") == "transform" ? Zf : Vx;
	return t == null ? this.styleTween(e, xS(e, r)).on("end.style." + e, SS(e)) : typeof t == "function" ? this.styleTween(e, wS(e, r, Bx(this, "style." + e, t))).each(TS(this._id, e)) : this.styleTween(e, CS(e, r, t), n).on("end.style." + e, null);
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/styleTween.js
function DS(e, t, n) {
	return function(r) {
		this.style.setProperty(e, t.call(this, r), n);
	};
}
function OS(e, t, n) {
	var r, i;
	function a() {
		var a = t.apply(this, arguments);
		return a !== i && (r = (i = a) && DS(e, a, n)), r;
	}
	return a._value = t, a;
}
function kS(e, t, n) {
	var r = "style." + (e += "");
	if (arguments.length < 2) return (r = this.tween(r)) && r._value;
	if (t == null) return this.tween(r, null);
	if (typeof t != "function") throw Error();
	return this.tween(r, OS(e, t, n ?? ""));
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/text.js
function AS(e) {
	return function() {
		this.textContent = e;
	};
}
function jS(e) {
	return function() {
		var t = e(this);
		this.textContent = t ?? "";
	};
}
function MS(e) {
	return this.tween("text", typeof e == "function" ? jS(Bx(this, "text", e)) : AS(e == null ? "" : e + ""));
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/textTween.js
function NS(e) {
	return function(t) {
		this.textContent = e.call(this, t);
	};
}
function PS(e) {
	var t, n;
	function r() {
		var r = e.apply(this, arguments);
		return r !== n && (t = (n = r) && NS(r)), t;
	}
	return r._value = e, r;
}
function FS(e) {
	var t = "text";
	if (arguments.length < 1) return (t = this.tween(t)) && t._value;
	if (e == null) return this.tween(t, null);
	if (typeof e != "function") throw Error();
	return this.tween(t, PS(e));
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/transition.js
function IS() {
	for (var e = this._name, t = this._id, n = BS(), r = this._groups, i = r.length, a = 0; a < i; ++a) for (var o = r[a], s = o.length, c, l = 0; l < s; ++l) if (c = o[l]) {
		var u = Nx(c, t);
		Ax(c, e, n, l, o, {
			time: u.time + u.delay + u.duration,
			delay: 0,
			duration: u.duration,
			ease: u.ease
		});
	}
	return new zS(r, this._parents, e, n);
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/end.js
function LS() {
	var e, t, n = this, r = n._id, i = n.size();
	return new Promise(function(a, o) {
		var s = { value: o }, c = { value: function() {
			--i === 0 && a();
		} };
		n.each(function() {
			var n = Mx(this, r), i = n.on;
			i !== e && (t = (e = i).copy(), t._.cancel.push(s), t._.interrupt.push(s), t._.end.push(c)), n.on = t;
		}), i === 0 && a();
	});
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/index.js
var RS = 0;
function zS(e, t, n, r) {
	this._groups = e, this._parents = t, this._name = n, this._id = r;
}
function BS() {
	return ++RS;
}
var VS = Xb.prototype;
zS.prototype = {
	constructor: zS,
	select: _S,
	selectAll: vS,
	selectChild: VS.selectChild,
	selectChildren: VS.selectChildren,
	filter: uS,
	merge: dS,
	selection: bS,
	transition: IS,
	call: VS.call,
	nodes: VS.nodes,
	node: VS.node,
	size: VS.size,
	empty: VS.empty,
	each: VS.each,
	on: mS,
	attr: Jx,
	attrTween: $x,
	style: ES,
	styleTween: kS,
	text: MS,
	textTween: FS,
	remove: gS,
	tween: zx,
	delay: nS,
	duration: aS,
	ease: sS,
	easeVarying: lS,
	end: LS,
	[Symbol.iterator]: VS[Symbol.iterator]
};
//#endregion
//#region ../node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/cubic.js
function HS(e) {
	return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
//#endregion
//#region ../node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/transition.js
var US = {
	time: null,
	delay: 0,
	duration: 250,
	ease: HS
};
function WS(e, t) {
	for (var n; !(n = e.__transition) || !(n = n[t]);) if (!(e = e.parentNode)) throw Error(`transition ${t} not found`);
	return n;
}
function GS(e) {
	var t, n;
	e instanceof zS ? (t = e._id, e = e._name) : (t = BS(), (n = US).time = vx(), e = e == null ? null : e + "");
	for (var r = this._groups, i = r.length, a = 0; a < i; ++a) for (var o = r[a], s = o.length, c, l = 0; l < s; ++l) (c = o[l]) && Ax(c, e, t, l, o, n || WS(c, t));
	return new zS(r, this._parents, e, t);
}
Xb.prototype.interrupt = Ix, Xb.prototype.transition = GS;
//#endregion
//#region ../node_modules/.pnpm/d3-axis@3.0.0/node_modules/d3-axis/src/identity.js
function KS(e) {
	return e;
}
//#endregion
//#region ../node_modules/.pnpm/d3-axis@3.0.0/node_modules/d3-axis/src/axis.js
var qS = 1, JS = 2, YS = 3, XS = 4, ZS = 1e-6;
function QS(e) {
	return "translate(" + e + ",0)";
}
function $S(e) {
	return "translate(0," + e + ")";
}
function eC(e) {
	return (t) => +e(t);
}
function tC(e, t) {
	return t = Math.max(0, e.bandwidth() - t * 2) / 2, e.round() && (t = Math.round(t)), (n) => +e(n) + t;
}
function nC() {
	return !this.__axis;
}
function rC(e, t) {
	var n = [], r = null, i = null, a = 6, o = 6, s = 3, c = typeof window < "u" && window.devicePixelRatio > 1 ? 0 : .5, l = e === qS || e === XS ? -1 : 1, u = e === XS || e === JS ? "x" : "y", d = e === qS || e === YS ? QS : $S;
	function f(f) {
		var p = r ?? (t.ticks ? t.ticks.apply(t, n) : t.domain()), m = i ?? (t.tickFormat ? t.tickFormat.apply(t, n) : KS), h = Math.max(a, 0) + s, g = t.range(), _ = +g[0] + c, v = +g[g.length - 1] + c, y = (t.bandwidth ? tC : eC)(t.copy(), c), b = f.selection ? f.selection() : f, x = b.selectAll(".domain").data([null]), S = b.selectAll(".tick").data(p, t).order(), C = S.exit(), w = S.enter().append("g").attr("class", "tick"), T = S.select("line"), E = S.select("text");
		x = x.merge(x.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), S = S.merge(w), T = T.merge(w.append("line").attr("stroke", "currentColor").attr(u + "2", l * a)), E = E.merge(w.append("text").attr("fill", "currentColor").attr(u, l * h).attr("dy", e === qS ? "0em" : e === YS ? "0.71em" : "0.32em")), f !== b && (x = x.transition(f), S = S.transition(f), T = T.transition(f), E = E.transition(f), C = C.transition(f).attr("opacity", ZS).attr("transform", function(e) {
			return isFinite(e = y(e)) ? d(e + c) : this.getAttribute("transform");
		}), w.attr("opacity", ZS).attr("transform", function(e) {
			var t = this.parentNode.__axis;
			return d((t && isFinite(t = t(e)) ? t : y(e)) + c);
		})), C.remove(), x.attr("d", e === XS || e === JS ? o ? "M" + l * o + "," + _ + "H" + c + "V" + v + "H" + l * o : "M" + c + "," + _ + "V" + v : o ? "M" + _ + "," + l * o + "V" + c + "H" + v + "V" + l * o : "M" + _ + "," + c + "H" + v), S.attr("opacity", 1).attr("transform", function(e) {
			return d(y(e) + c);
		}), T.attr(u + "2", l * a), E.attr(u, l * h).text(m), b.filter(nC).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", e === JS ? "start" : e === XS ? "end" : "middle"), b.each(function() {
			this.__axis = y;
		});
	}
	return f.scale = function(e) {
		return arguments.length ? (t = e, f) : t;
	}, f.ticks = function() {
		return n = Array.from(arguments), f;
	}, f.tickArguments = function(e) {
		return arguments.length ? (n = e == null ? [] : Array.from(e), f) : n.slice();
	}, f.tickValues = function(e) {
		return arguments.length ? (r = e == null ? null : Array.from(e), f) : r && r.slice();
	}, f.tickFormat = function(e) {
		return arguments.length ? (i = e, f) : i;
	}, f.tickSize = function(e) {
		return arguments.length ? (a = o = +e, f) : a;
	}, f.tickSizeInner = function(e) {
		return arguments.length ? (a = +e, f) : a;
	}, f.tickSizeOuter = function(e) {
		return arguments.length ? (o = +e, f) : o;
	}, f.tickPadding = function(e) {
		return arguments.length ? (s = +e, f) : s;
	}, f.offset = function(e) {
		return arguments.length ? (c = +e, f) : c;
	}, f;
}
function iC(e) {
	return rC(YS, e);
}
function aC(e) {
	return rC(XS, e);
}
//#endregion
//#region src/components/organisms/Charts/useChartDimensions.ts
function oC(e = 600, t = 400) {
	let n = W(null), [r, i] = G({
		width: e,
		height: t
	}), a = H((e) => {
		for (let t of e) {
			let { width: e, height: n } = t.contentRect;
			e > 0 && n > 0 && i({
				width: Math.floor(e),
				height: Math.floor(n)
			});
		}
	}, []);
	return U(() => {
		let e = n.current;
		if (!e) return;
		let t = new ResizeObserver(a);
		t.observe(e);
		let r = e.getBoundingClientRect();
		return r.width > 0 && r.height > 0 && i({
			width: Math.floor(r.width),
			height: Math.floor(r.height)
		}), () => t.disconnect();
	}, [a]), [n, r];
}
//#endregion
//#region src/components/organisms/Charts/types.ts
var sC = {
	top: 20,
	right: 20,
	bottom: 40,
	left: 50
}, cC = [
	"var(--chart-1)",
	"var(--chart-2)",
	"var(--chart-3)",
	"var(--chart-4)",
	"var(--chart-5)",
	"var(--chart-6)",
	"var(--chart-7)",
	"var(--chart-8)"
];
//#endregion
//#region src/components/organisms/Charts/useChartColors.ts
function lC(e) {
	return Ln(() => {
		let t = Ld().range([...cC]);
		return e && t.domain(e), t;
	}, [e]);
}
function uC(e, t = "#6366f1") {
	if (typeof window > "u") return t;
	if (!e.startsWith("var(")) return e;
	let n = e.replace(/^var\(/, "").replace(/\)$/, "");
	return getComputedStyle(document.documentElement).getPropertyValue(n).trim() || t;
}
//#endregion
//#region src/components/organisms/Charts/ChartTooltip.tsx
function dC({ content: e, visible: t, x: n, y: r, containerRef: i }) {
	let a = W(null), [o, s] = G({
		left: n,
		top: r
	});
	return U(() => {
		if (!t || !a.current || !i.current) return;
		let e = i.current.getBoundingClientRect(), o = a.current.getBoundingClientRect(), c = n + 12, l = r - o.height / 2;
		c + o.width > e.width && (c = n - o.width - 12), l < 0 && (l = 4), l + o.height > e.height && (l = e.height - o.height - 4), s({
			left: c,
			top: l
		});
	}, [
		t,
		n,
		r,
		i
	]), t ? /* @__PURE__ */ q("div", {
		ref: a,
		className: "pointer-events-none absolute z-50 rounded-md border border-[var(--border)] bg-[var(--surface)] px-3 py-2 text-sm font-[var(--font-family-body)] text-[var(--foreground)] shadow-md",
		style: {
			left: o.left,
			top: o.top
		},
		children: e
	}) : null;
}
//#endregion
//#region src/components/organisms/Charts/ChartLegend.tsx
function fC({ items: e, direction: t = "horizontal", className: n = "" }) {
	return /* @__PURE__ */ q("div", {
		className: `flex gap-4 text-xs font-[var(--font-family-body)] text-[var(--muted-foreground)] ${t === "vertical" ? "flex-col gap-2" : "flex-row flex-wrap justify-center"} ${n}`,
		children: e.map((e) => /* @__PURE__ */ J("div", {
			className: "flex items-center gap-1.5",
			children: [/* @__PURE__ */ q("span", {
				className: "inline-block h-2.5 w-2.5 shrink-0 rounded-full",
				style: { backgroundColor: e.color }
			}), /* @__PURE__ */ q("span", { children: e.label })]
		}, e.label))
	});
}
//#endregion
//#region src/components/organisms/Charts/LineChart.tsx
var pC = {
	monotone: t_,
	linear: zg,
	step: r_,
	basis: Yg
};
function mC({ data: e, curveType: t = "monotone", showGrid: n = !0, showDots: r = !1, showLegend: i = !0, thresholds: a, xLabel: o, yLabel: s, yDomain: c, formatX: l, formatY: u, height: d, margin: f, animate: p = !0, className: m = "" }) {
	let [h, { width: g, height: _ }] = oC(600, d ?? 300), v = W(null), [y, b] = G({
		visible: !1,
		x: 0,
		y: 0,
		content: null
	}), x = d ?? _, S = f ?? {
		top: 20,
		right: 20,
		bottom: 40,
		left: 50
	}, C = g - S.left - S.right, w = x - S.top - S.bottom, T = lC(e.map((e) => e.label)), E = Ln(() => e.flatMap((e) => e.values.map((e) => new Date(e.date))), [e]), D = Ln(() => e.flatMap((e) => e.values.map((e) => e.value)), [e]);
	U(() => {
		if (!v.current || C <= 0 || w <= 0) return;
		let i = Qb(v.current);
		i.selectAll("*").remove();
		let d = i.append("g").attr("transform", `translate(${S.left},${S.top})`), f = vd(E), m = ag().domain(f).range([0, C]), h = c?.[1] ?? (jd(D) ?? 100) * 1.1, g = c?.[0] ?? 0, _ = Vp().domain([g, h]).range([w, 0]).nice();
		n && d.append("g").attr("class", "grid").selectAll("line").data(_.ticks(5)).join("line").attr("x1", 0).attr("x2", C).attr("y1", (e) => _(e)).attr("y2", (e) => _(e)).attr("stroke", "var(--border)").attr("stroke-dasharray", "2,4").attr("opacity", .5);
		let y = iC(m).ticks(6);
		if (l ? y.tickFormat((e) => l(e)) : y.tickFormat((e) => eg("%b %d")(e)), d.append("g").attr("transform", `translate(0,${w})`).call(y).selectAll("text").attr("fill", "var(--muted-foreground)").attr("font-size", "11px").attr("font-family", "var(--font-family-body)"), d.append("g").call(aC(_).ticks(5).tickFormat((e) => u ? u(e) : String(e))).selectAll("text").attr("fill", "var(--muted-foreground)").attr("font-size", "11px").attr("font-family", "var(--font-family-body)"), d.selectAll(".domain").attr("stroke", "var(--border)"), d.selectAll(".tick line").attr("stroke", "var(--border)"), o && d.append("text").attr("x", C / 2).attr("y", w + 35).attr("text-anchor", "middle").attr("fill", "var(--muted-foreground)").attr("font-size", "12px").attr("font-family", "var(--font-family-body)").text(o), s && d.append("text").attr("transform", "rotate(-90)").attr("x", -w / 2).attr("y", -40).attr("text-anchor", "middle").attr("fill", "var(--muted-foreground)").attr("font-size", "12px").attr("font-family", "var(--font-family-body)").text(s), a) for (let e of a) d.append("line").attr("x1", 0).attr("x2", C).attr("y1", _(e.value)).attr("y2", _(e.value)).attr("stroke", e.color).attr("stroke-width", 1.5).attr("stroke-dasharray", e.dashed === !1 ? "none" : "6,4"), e.label && d.append("text").attr("x", C - 4).attr("y", _(e.value) - 4).attr("text-anchor", "end").attr("fill", e.color).attr("font-size", "10px").attr("font-family", "var(--font-family-body)").text(e.label);
		let x = pC[t], O = Hg().x((e) => m(e.date)).y((e) => _(e.value)).curve(x);
		for (let t of e) {
			let e = t.color ?? T(t.label), n = t.values.map((e) => ({
				date: new Date(e.date),
				value: e.value
			})), i = d.append("path").datum(n).attr("fill", "none").attr("stroke", e).attr("stroke-width", 2).attr("d", O);
			if (p) {
				let e = i.node()?.getTotalLength?.() ?? 0;
				e > 0 && i.attr("stroke-dasharray", `${e} ${e}`).attr("stroke-dashoffset", e).transition().duration(800).attr("stroke-dashoffset", 0);
			}
			r && d.selectAll(`.dot-${t.label}`).data(n).join("circle").attr("cx", (e) => m(e.date)).attr("cy", (e) => _(e.value)).attr("r", 3).attr("fill", e).attr("stroke", "var(--surface)").attr("stroke-width", 1.5);
		}
		d.append("rect").attr("width", C).attr("height", w).attr("fill", "transparent").attr("cursor", "crosshair").on("mousemove", (t) => {
			let [n] = [t.offsetX - S.left], r = m.invert(n), i = e.map((e) => {
				let t = e.values.reduce((e, t) => Math.abs(new Date(t.date).getTime() - r.getTime()) < Math.abs(new Date(e.date).getTime() - r.getTime()) ? t : e);
				return {
					label: e.label,
					value: t.value,
					color: e.color ?? T(e.label)
				};
			});
			b({
				visible: !0,
				x: t.offsetX,
				y: t.offsetY,
				content: /* @__PURE__ */ J("div", {
					className: "space-y-1",
					children: [/* @__PURE__ */ q("div", {
						className: "font-medium text-[var(--foreground)]",
						children: eg("%b %d, %Y")(r)
					}), i.map((e) => /* @__PURE__ */ J("div", {
						className: "flex items-center gap-2",
						children: [
							/* @__PURE__ */ q("span", {
								className: "h-2 w-2 rounded-full",
								style: { backgroundColor: e.color }
							}),
							/* @__PURE__ */ J("span", {
								className: "text-[var(--muted-foreground)]",
								children: [e.label, ":"]
							}),
							/* @__PURE__ */ q("span", {
								className: "font-medium",
								children: u ? u(e.value) : e.value.toLocaleString()
							})
						]
					}, e.label))]
				})
			});
		}).on("mouseleave", () => b({
			visible: !1,
			x: 0,
			y: 0,
			content: null
		}));
	}, [
		e,
		g,
		x,
		S,
		C,
		w,
		t,
		n,
		r,
		a,
		p,
		T,
		E,
		D,
		c,
		l,
		u,
		o,
		s
	]);
	let O = e.map((e) => ({
		label: e.label,
		color: e.color ?? T(e.label)
	}));
	return /* @__PURE__ */ J("div", {
		ref: h,
		className: `relative w-full ${m}`,
		style: { minHeight: x },
		children: [
			/* @__PURE__ */ q("svg", {
				ref: v,
				width: g,
				height: x
			}),
			/* @__PURE__ */ q(dC, {
				content: y.content,
				visible: y.visible,
				x: y.x,
				y: y.y,
				containerRef: h
			}),
			i && e.length > 1 && /* @__PURE__ */ q(fC, {
				items: O,
				className: "mt-2"
			})
		]
	});
}
//#endregion
//#region src/components/organisms/Charts/AreaChart.tsx
function hC({ data: e, gradient: t = !0, stacked: n = !1, showLegend: r = !0, curveType: i = "monotone", formatX: a, formatY: o, height: s, margin: c, animate: l = !0, className: u = "" }) {
	let [d, { width: f, height: p }] = oC(600, s ?? 300), m = W(null), [h, g] = G({
		visible: !1,
		x: 0,
		y: 0,
		content: null
	}), _ = s ?? p, v = c ?? {
		top: 20,
		right: 20,
		bottom: 40,
		left: 50
	}, y = f - v.left - v.right, b = _ - v.top - v.bottom, x = i === "monotone" ? t_ : zg, S = lC(e.map((e) => e.label));
	U(() => {
		if (!m.current || y <= 0 || b <= 0) return;
		let n = Qb(m.current);
		n.selectAll("*").remove();
		let r = n.append("defs"), i = n.append("g").attr("transform", `translate(${v.left},${v.top})`), s = e.flatMap((e) => e.values.map((e) => new Date(e.date))), c = ag().domain(vd(s)).range([0, y]), u = e.flatMap((e) => e.values.map((e) => e.value)), d = Vp().domain([0, (jd(u) ?? 100) * 1.1]).range([b, 0]).nice();
		i.append("g").selectAll("line").data(d.ticks(5)).join("line").attr("x1", 0).attr("x2", y).attr("y1", (e) => d(e)).attr("y2", (e) => d(e)).attr("stroke", "var(--border)").attr("stroke-dasharray", "2,4").attr("opacity", .5);
		let f = iC(c).ticks(6);
		a ? f.tickFormat((e) => a(e)) : f.tickFormat((e) => eg("%b %d")(e)), i.append("g").attr("transform", `translate(0,${b})`).call(f).selectAll("text").attr("fill", "var(--muted-foreground)").attr("font-size", "11px"), i.append("g").call(aC(d).ticks(5).tickFormat((e) => o ? o(e) : String(e))).selectAll("text").attr("fill", "var(--muted-foreground)").attr("font-size", "11px"), i.selectAll(".domain").attr("stroke", "var(--border)"), i.selectAll(".tick line").attr("stroke", "var(--border)");
		let p = Ug().x((e) => c(e.date)).y0(b).y1((e) => d(e.value)).curve(x), h = Hg().x((e) => c(e.date)).y((e) => d(e.value)).curve(x);
		for (let n = e.length - 1; n >= 0; n--) {
			let a = e[n], o = a.color ?? S(a.label), s = a.values.map((e) => ({
				date: new Date(e.date),
				value: e.value
			})), c = `area-gradient-${n}`;
			if (t) {
				let e = r.append("linearGradient").attr("id", c).attr("x1", "0%").attr("y1", "0%").attr("x2", "0%").attr("y2", "100%");
				e.append("stop").attr("offset", "0%").attr("stop-color", o).attr("stop-opacity", .3), e.append("stop").attr("offset", "100%").attr("stop-color", o).attr("stop-opacity", .02);
			}
			let u = i.append("path").datum(s).attr("fill", t ? `url(#${c})` : o).attr("fill-opacity", t ? 1 : .15).attr("d", p);
			i.append("path").datum(s).attr("fill", "none").attr("stroke", o).attr("stroke-width", 2).attr("d", h), l && u.attr("opacity", 0).transition().duration(600).delay(n * 100).attr("opacity", 1);
		}
		i.append("rect").attr("width", y).attr("height", b).attr("fill", "transparent").attr("cursor", "crosshair").on("mousemove", (t) => {
			let n = t.offsetX - v.left, r = c.invert(n), i = e.map((e) => {
				let t = e.values.reduce((e, t) => Math.abs(new Date(t.date).getTime() - r.getTime()) < Math.abs(new Date(e.date).getTime() - r.getTime()) ? t : e);
				return {
					label: e.label,
					value: t.value,
					color: e.color ?? S(e.label)
				};
			});
			g({
				visible: !0,
				x: t.offsetX,
				y: t.offsetY,
				content: /* @__PURE__ */ J("div", {
					className: "space-y-1",
					children: [/* @__PURE__ */ q("div", {
						className: "font-medium",
						children: eg("%b %d, %Y")(r)
					}), i.map((e) => /* @__PURE__ */ J("div", {
						className: "flex items-center gap-2",
						children: [
							/* @__PURE__ */ q("span", {
								className: "h-2 w-2 rounded-full",
								style: { backgroundColor: e.color }
							}),
							/* @__PURE__ */ J("span", {
								className: "text-[var(--muted-foreground)]",
								children: [e.label, ":"]
							}),
							/* @__PURE__ */ q("span", {
								className: "font-medium",
								children: o ? o(e.value) : e.value.toLocaleString()
							})
						]
					}, e.label))]
				})
			});
		}).on("mouseleave", () => g({
			visible: !1,
			x: 0,
			y: 0,
			content: null
		}));
	}, [
		e,
		f,
		_,
		v,
		y,
		b,
		t,
		x,
		l,
		S,
		a,
		o
	]);
	let C = e.map((e) => ({
		label: e.label,
		color: e.color ?? S(e.label)
	}));
	return /* @__PURE__ */ J("div", {
		ref: d,
		className: `relative w-full ${u}`,
		style: { minHeight: _ },
		children: [
			/* @__PURE__ */ q("svg", {
				ref: m,
				width: f,
				height: _
			}),
			/* @__PURE__ */ q(dC, {
				content: h.content,
				visible: h.visible,
				x: h.x,
				y: h.y,
				containerRef: d
			}),
			r && e.length > 1 && /* @__PURE__ */ q(fC, {
				items: C,
				className: "mt-2"
			})
		]
	});
}
//#endregion
//#region src/components/organisms/Charts/BarChart.tsx
function gC({ data: e, orientation: t = "vertical", stacked: n = !1, barPadding: r = .2, showLegend: i = !0, showValues: a = !1, colors: o, formatValue: s, height: c, margin: l, animate: u = !0, className: d = "" }) {
	let [f, { width: p, height: m }] = oC(600, c ?? 300), h = W(null), [g, _] = G({
		visible: !1,
		x: 0,
		y: 0,
		content: null
	}), v = c ?? m, y = l ?? {
		top: 20,
		right: 20,
		bottom: 40,
		left: 50
	}, b = p - y.left - y.right, x = v - y.top - y.bottom, S = e.length > 0 ? Object.keys(e[0].values) : [], C = Ld().domain(S).range(o ?? [...cC]);
	U(() => {
		if (!h.current || b <= 0 || x <= 0 || e.length === 0) return;
		let i = Qb(h.current);
		i.selectAll("*").remove();
		let a = i.append("g").attr("transform", `translate(${y.left},${y.top})`), o = t === "vertical", c = e.map((e) => e.category), l = n ? jd(e, (e) => Object.values(e.values).reduce((e, t) => e + t, 0)) ?? 100 : jd(e, (e) => jd(Object.values(e.values)) ?? 0) ?? 100, d = Rd().domain(c).range(o ? [0, b] : [0, x]).padding(r), f = Vp().domain([0, l * 1.1]).range(o ? [x, 0] : [0, b]).nice(), p = Rd().domain(S).range([0, d.bandwidth()]).padding(.05), m = f.ticks(5);
		a.append("g").selectAll("line").data(m).join("line").attr("x1", o ? 0 : (e) => f(e)).attr("x2", o ? b : (e) => f(e)).attr("y1", o ? (e) => f(e) : 0).attr("y2", o ? (e) => f(e) : x).attr("stroke", "var(--border)").attr("stroke-dasharray", "2,4").attr("opacity", .5), o ? (a.append("g").attr("transform", `translate(0,${x})`).call(iC(d)).selectAll("text").attr("fill", "var(--muted-foreground)").attr("font-size", "11px"), a.append("g").call(aC(f).ticks(5).tickFormat((e) => s ? s(e) : String(e))).selectAll("text").attr("fill", "var(--muted-foreground)").attr("font-size", "11px")) : (a.append("g").call(aC(d)).selectAll("text").attr("fill", "var(--muted-foreground)").attr("font-size", "11px"), a.append("g").attr("transform", `translate(0,${x})`).call(iC(f).ticks(5)).selectAll("text").attr("fill", "var(--muted-foreground)").attr("font-size", "11px")), a.selectAll(".domain").attr("stroke", "var(--border)"), a.selectAll(".tick line").attr("stroke", "var(--border)");
		for (let t of e) {
			let e = d(t.category) ?? 0, r = 0;
			for (let i of S) {
				let c = t.values[i] ?? 0, l = C(i), m, h, g, v;
				n ? (o ? (m = e, h = f(r + c), g = d.bandwidth(), v = x - f(c)) : (m = f(r), h = e, g = f(r + c) - f(r), v = d.bandwidth()), r += c) : o ? (m = e + (p(i) ?? 0), h = f(c), g = p.bandwidth(), v = x - f(c)) : (m = 0, h = e + (p(i) ?? 0), g = f(c), v = p.bandwidth());
				let y = a.append("rect").attr("x", m).attr("y", o && u ? x : h).attr("width", o ? g : u ? 0 : g).attr("height", o ? 0 : v).attr("fill", l).attr("rx", 2).attr("cursor", "pointer").on("mousemove", (e) => {
					_({
						visible: !0,
						x: e.offsetX,
						y: e.offsetY,
						content: /* @__PURE__ */ J("div", {
							className: "space-y-1",
							children: [/* @__PURE__ */ q("div", {
								className: "font-medium",
								children: t.category
							}), /* @__PURE__ */ J("div", {
								className: "flex items-center gap-2",
								children: [
									/* @__PURE__ */ q("span", {
										className: "h-2 w-2 rounded-full",
										style: { backgroundColor: l }
									}),
									/* @__PURE__ */ J("span", {
										className: "text-[var(--muted-foreground)]",
										children: [i, ":"]
									}),
									/* @__PURE__ */ q("span", {
										className: "font-medium",
										children: s ? s(c) : c.toLocaleString()
									})
								]
							})]
						})
					});
				}).on("mouseleave", () => _({
					visible: !1,
					x: 0,
					y: 0,
					content: null
				}));
				u ? o ? y.transition().duration(600).attr("y", h).attr("height", v) : y.transition().duration(600).attr("width", g) : o && y.attr("y", h).attr("height", v);
			}
		}
	}, [
		e,
		p,
		v,
		y,
		b,
		x,
		t,
		n,
		r,
		u,
		S,
		C,
		s
	]);
	let w = S.map((e) => ({
		label: e,
		color: C(e)
	}));
	return /* @__PURE__ */ J("div", {
		ref: f,
		className: `relative w-full ${d}`,
		style: { minHeight: v },
		children: [
			/* @__PURE__ */ q("svg", {
				ref: h,
				width: p,
				height: v
			}),
			/* @__PURE__ */ q(dC, {
				content: g.content,
				visible: g.visible,
				x: g.x,
				y: g.y,
				containerRef: f
			}),
			i && S.length > 1 && /* @__PURE__ */ q(fC, {
				items: w,
				className: "mt-2"
			})
		]
	});
}
//#endregion
//#region src/components/organisms/Charts/DonutChart.tsx
function _C({ data: e, innerRadius: t = .6, showLabels: n = !1, showPercentage: r = !0, showLegend: i = !0, colors: a, formatValue: o, height: s, animate: c = !0, className: l = "" }) {
	let [u, { width: d, height: f }] = oC(300, s ?? 300), p = W(null), [m, h] = G({
		visible: !1,
		x: 0,
		y: 0,
		content: null
	}), g = s ?? f, _ = Math.min(d, g) / 2 - 10, v = Ld().domain(e.map((e) => e.label)).range(a ?? [...cC]);
	U(() => {
		if (!p.current || _ <= 0 || e.length === 0) return;
		let n = Qb(p.current);
		n.selectAll("*").remove();
		let r = n.append("g").attr("transform", `translate(${d / 2},${g / 2})`), i = e.reduce((e, t) => e + t.value, 0), a = Kg().value((e) => e.value).sort(null).padAngle(.02), s = Ig().innerRadius(_ * t).outerRadius(_).cornerRadius(3), c = a(e);
		r.selectAll("path").data(c).join("path").attr("fill", (e) => v(e.data.label)).attr("cursor", "pointer").attr("d", s).on("mousemove", (e, t) => {
			let n = (t.data.value / i * 100).toFixed(1);
			h({
				visible: !0,
				x: e.offsetX,
				y: e.offsetY,
				content: /* @__PURE__ */ J("div", {
					className: "space-y-1",
					children: [/* @__PURE__ */ J("div", {
						className: "flex items-center gap-2",
						children: [/* @__PURE__ */ q("span", {
							className: "h-2 w-2 rounded-full",
							style: { backgroundColor: v(t.data.label) }
						}), /* @__PURE__ */ q("span", {
							className: "font-medium",
							children: t.data.label
						})]
					}), /* @__PURE__ */ J("div", {
						className: "text-[var(--muted-foreground)]",
						children: [
							o ? o(t.data.value) : t.data.value.toLocaleString(),
							" (",
							n,
							"%)"
						]
					})]
				})
			});
		}).on("mouseleave", () => h({
			visible: !1,
			x: 0,
			y: 0,
			content: null
		})), t > 0 && (r.append("text").attr("text-anchor", "middle").attr("dy", "-0.2em").attr("fill", "var(--foreground)").attr("font-size", "24px").attr("font-weight", "600").attr("font-family", "var(--font-family-heading)").text(o ? o(i) : i.toLocaleString()), r.append("text").attr("text-anchor", "middle").attr("dy", "1.2em").attr("fill", "var(--muted-foreground)").attr("font-size", "12px").attr("font-family", "var(--font-family-body)").text("Total"));
	}, [
		e,
		d,
		g,
		_,
		t,
		c,
		v,
		o
	]);
	let y = e.map((e) => ({
		label: e.label,
		color: v(e.label)
	}));
	return /* @__PURE__ */ J("div", {
		ref: u,
		className: `relative w-full ${l}`,
		style: { minHeight: g },
		children: [
			/* @__PURE__ */ q("svg", {
				ref: p,
				width: d,
				height: g
			}),
			/* @__PURE__ */ q(dC, {
				content: m.content,
				visible: m.visible,
				x: m.x,
				y: m.y,
				containerRef: u
			}),
			i && /* @__PURE__ */ q(fC, {
				items: y,
				className: "mt-2"
			})
		]
	});
}
//#endregion
//#region src/components/organisms/Charts/HeatMap.tsx
function vC({ data: e, colorInterpolator: t, formatValue: n, xLabels: r, yLabels: i, cellRadius: a = 2, height: o, margin: s, className: c = "" }) {
	let [l, { width: u, height: d }] = oC(600, o ?? 300), f = W(null), [p, m] = G({
		visible: !1,
		x: 0,
		y: 0,
		content: null
	}), h = o ?? d, g = s ?? {
		top: 20,
		right: 20,
		bottom: 40,
		left: 60
	}, _ = u - g.left - g.right, v = h - g.top - g.bottom;
	return U(() => {
		if (!f.current || _ <= 0 || v <= 0 || e.length === 0) return;
		let o = Qb(f.current);
		o.selectAll("*").remove();
		let s = o.append("g").attr("transform", `translate(${g.left},${g.top})`), c = r ?? [...new Set(e.map((e) => e.x))], l = i ?? [...new Set(e.map((e) => e.y))], u = Rd().domain(c).range([0, _]).padding(.05), d = Rd().domain(l).range([0, v]).padding(.05), p = e.map((e) => e.value), h = cg().domain([Md(p) ?? 0, jd(p) ?? 1]).interpolator(t ?? Af("#fef3c7", "#dc2626"));
		s.append("g").attr("transform", `translate(0,${v})`).selectAll("text").data(c).join("text").attr("x", (e) => (u(e) ?? 0) + u.bandwidth() / 2).attr("y", 16).attr("text-anchor", "middle").attr("fill", "var(--muted-foreground)").attr("font-size", "10px").attr("font-family", "var(--font-family-body)").text((e) => e), s.append("g").selectAll("text").data(l).join("text").attr("x", -8).attr("y", (e) => (d(e) ?? 0) + d.bandwidth() / 2).attr("text-anchor", "end").attr("dominant-baseline", "central").attr("fill", "var(--muted-foreground)").attr("font-size", "10px").attr("font-family", "var(--font-family-body)").text((e) => e), s.selectAll("rect").data(e).join("rect").attr("x", (e) => u(e.x) ?? 0).attr("y", (e) => d(e.y) ?? 0).attr("width", u.bandwidth()).attr("height", d.bandwidth()).attr("rx", a).attr("fill", (e) => h(e.value)).attr("cursor", "pointer").on("mousemove", (e, t) => {
			m({
				visible: !0,
				x: e.offsetX,
				y: e.offsetY,
				content: /* @__PURE__ */ J("div", {
					className: "space-y-1",
					children: [/* @__PURE__ */ J("div", {
						className: "font-medium",
						children: [
							t.x,
							" / ",
							t.y
						]
					}), /* @__PURE__ */ q("div", {
						className: "text-[var(--muted-foreground)]",
						children: n ? n(t.value) : t.value.toLocaleString()
					})]
				})
			});
		}).on("mouseleave", () => m({
			visible: !1,
			x: 0,
			y: 0,
			content: null
		}));
	}, [
		e,
		u,
		h,
		g,
		_,
		v,
		t,
		r,
		i,
		a,
		n
	]), /* @__PURE__ */ J("div", {
		ref: l,
		className: `relative w-full ${c}`,
		style: { minHeight: h },
		children: [/* @__PURE__ */ q("svg", {
			ref: f,
			width: u,
			height: h
		}), /* @__PURE__ */ q(dC, {
			content: p.content,
			visible: p.visible,
			x: p.x,
			y: p.y,
			containerRef: l
		})]
	});
}
//#endregion
//#region src/components/organisms/Charts/Gauge.tsx
function yC({ value: e, min: t = 0, max: n = 100, label: r, unit: i = "%", thresholds: a, size: o = 160, className: s = "" }) {
	let { segments: c, needle: l, displayValue: u } = Ln(() => {
		let r = -Math.PI * .75, i = Math.PI * .75, s = o / 2 - 10, c = s * .7, l = s, u = Vp().domain([t, n]).range([r, i]).clamp(!0), d = a ? [...a].sort((e, t) => e.value - t.value) : [
			{
				value: n * .5,
				color: "var(--chart-trust-low)"
			},
			{
				value: n * .8,
				color: "var(--chart-trust-medium)"
			},
			{
				value: n,
				color: "var(--chart-trust-high)"
			}
		], f = Ig(), p = [], m = t;
		for (let e of d) {
			let t = f({
				innerRadius: c,
				outerRadius: l,
				startAngle: u(m),
				endAngle: u(Math.min(e.value, n))
			});
			t && p.push({
				path: t,
				color: e.color
			}), m = e.value;
		}
		let h = f({
			innerRadius: c,
			outerRadius: l,
			startAngle: u(m),
			endAngle: i
		});
		h && m < n && p.push({
			path: h,
			color: "var(--muted)"
		});
		let g = u(Math.max(t, Math.min(n, e))), _ = s * .85, v = Math.cos(g - Math.PI / 2) * _, y = Math.sin(g - Math.PI / 2) * _, b = Math.max(t, Math.min(n, e)), x = Number.isInteger(b) ? b : b.toFixed(1);
		return {
			segments: p,
			needle: {
				x: v,
				y
			},
			displayValue: x
		};
	}, [
		e,
		t,
		n,
		o,
		a
	]);
	return /* @__PURE__ */ J("div", {
		className: `flex flex-col items-center ${s}`,
		children: [/* @__PURE__ */ J("svg", {
			width: o,
			height: o * .65,
			viewBox: `${-o / 2} ${-o / 2} ${o} ${o * .65}`,
			children: [
				c.map((e, t) => /* @__PURE__ */ q("path", {
					d: e.path,
					fill: e.color,
					opacity: .85
				}, t)),
				/* @__PURE__ */ q("line", {
					x1: 0,
					y1: 0,
					x2: l.x,
					y2: l.y,
					stroke: "var(--foreground)",
					strokeWidth: 2,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ q("circle", {
					cx: 0,
					cy: 0,
					r: 4,
					fill: "var(--foreground)"
				})
			]
		}), /* @__PURE__ */ J("div", {
			className: "mt-1 text-center",
			children: [/* @__PURE__ */ J("div", {
				className: "text-2xl font-semibold font-[var(--font-family-heading)] text-[var(--foreground)]",
				children: [u, i]
			}), r && /* @__PURE__ */ q("div", {
				className: "text-xs text-[var(--muted-foreground)] font-[var(--font-family-body)]",
				children: r
			})]
		})]
	});
}
//#endregion
//#region src/components/organisms/Charts/TimeSeriesChart.tsx
function bC({ data: e, enableBrush: t = !1, timeRange: n, onTimeRangeChange: r, brushHeight: i = 50, height: a, ...o }) {
	let [s, c] = G(n ?? null), l = s ? e.map((e) => ({
		...e,
		values: e.values.filter((e) => {
			let t = new Date(e.date).getTime();
			return t >= s[0].getTime() && t <= s[1].getTime();
		})
	})) : e;
	return H((e) => {
		c(e), r?.(e);
	}, [r]), /* @__PURE__ */ J("div", {
		className: "flex flex-col gap-2",
		children: [/* @__PURE__ */ q(mC, {
			data: l,
			height: a ?? 300,
			...o
		}), t && /* @__PURE__ */ J("div", {
			className: "px-[50px]",
			children: [/* @__PURE__ */ q(mC, {
				data: e,
				height: i,
				showGrid: !1,
				showDots: !1,
				showLegend: !1,
				animate: !1,
				margin: {
					top: 4,
					right: 20,
					bottom: 20,
					left: 0
				},
				className: "opacity-50"
			}), /* @__PURE__ */ q("div", {
				className: "text-center text-xs text-[var(--muted-foreground)] mt-1",
				children: "Drag to select time range"
			})]
		})]
	});
}
//#endregion
//#region src/components/organisms/CommandPalette/CommandPalette.tsx
var xC = V(({ open: e, onOpenChange: t, children: n }, r) => /* @__PURE__ */ q(lt, {
	open: e,
	onOpenChange: t,
	children: /* @__PURE__ */ J(Yt, { children: [/* @__PURE__ */ q(vt, { className: "fixed inset-0 z-50 bg-slate-900/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" }), /* @__PURE__ */ q(dn, {
		ref: r,
		className: "fixed left-1/2 top-1/2 z-50 w-full max-w-2xl -translate-x-1/2 -translate-y-1/2 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
		children: /* @__PURE__ */ q("div", {
			className: "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-2xl dark:border-slate-800 dark:bg-slate-950",
			children: n
		})
	})] })
}));
xC.displayName = "CommandPalette";
var SC = V(({ className: e, value: t, onChange: n, placeholder: r = "Search...", ...i }, a) => /* @__PURE__ */ J("div", {
	className: "agn-menu-search-field agn-menu-search-inset flex items-center px-4 py-2",
	children: [/* @__PURE__ */ q("svg", {
		className: "h-5 w-5 shrink-0 text-slate-400 dark:text-slate-500",
		fill: "none",
		stroke: "currentColor",
		viewBox: "0 0 24 24",
		"aria-hidden": "true",
		children: /* @__PURE__ */ q("path", {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2,
			d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
		})
	}), /* @__PURE__ */ q("input", {
		ref: a,
		type: "text",
		value: t,
		onChange: (e) => n?.(e.target.value),
		placeholder: r,
		className: I("agn-field-bare", "flex h-12 w-full bg-transparent px-4 py-3 text-base", "outline-none border-none ring-0 shadow-none", "focus:outline-none focus:border-none focus:ring-0 focus:shadow-none", "placeholder:text-slate-400 disabled:cursor-not-allowed disabled:opacity-50", "dark:placeholder:text-slate-500 dark:text-white", e),
		...i
	})]
}));
SC.displayName = "CommandPaletteInput";
var CC = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	role: "listbox",
	className: I("max-h-96 overflow-y-auto overflow-x-hidden p-2", "border-t border-slate-100 dark:border-slate-800", e),
	...t
}));
CC.displayName = "CommandPaletteList";
var wC = V(({ className: e, heading: t, children: n, ...r }, i) => /* @__PURE__ */ J("div", {
	ref: i,
	className: I("overflow-hidden", e),
	...r,
	children: [t && /* @__PURE__ */ q("div", {
		className: "px-3 py-2 text-xs font-semibold text-slate-500 dark:text-slate-400",
		children: t
	}), /* @__PURE__ */ q("div", {
		className: "space-y-1",
		children: n
	})]
}));
wC.displayName = "CommandPaletteGroup";
var TC = V(({ className: e, icon: t, shortcut: n, isSelected: r, disabled: i, onSelect: a, children: o, ...s }, c) => /* @__PURE__ */ J("div", {
	ref: c,
	role: "option",
	tabIndex: -1,
	"aria-selected": r,
	"aria-disabled": i,
	className: I("relative flex cursor-pointer select-none items-center gap-3 rounded-md px-3 py-2 text-sm outline-none transition-colors", r && "bg-slate-100 dark:bg-slate-800", !i && "hover:bg-slate-100 dark:hover:bg-slate-800", i && "cursor-not-allowed opacity-50", e),
	onClick: i ? void 0 : a,
	...s,
	children: [
		t && /* @__PURE__ */ q("span", {
			className: "shrink-0 text-slate-500 dark:text-slate-400",
			children: t
		}),
		/* @__PURE__ */ q("div", {
			className: "flex-1 overflow-hidden",
			children: /* @__PURE__ */ q("div", {
				className: "truncate",
				children: o
			})
		}),
		n && /* @__PURE__ */ q("kbd", {
			className: "pointer-events-none ml-auto hidden h-5 select-none items-center gap-1 rounded border border-slate-200 bg-slate-50 px-1.5 font-mono text-xs font-medium text-slate-600 opacity-100 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-400 sm:flex",
			children: n
		})
	]
}));
TC.displayName = "CommandPaletteItem";
var EC = V(({ className: e, message: t = "No results found", ...n }, r) => /* @__PURE__ */ q("div", {
	ref: r,
	className: I("py-6 text-center text-sm text-slate-500 dark:text-slate-400", e),
	...n,
	children: t
}));
EC.displayName = "CommandPaletteEmpty";
var DC = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	role: "separator",
	className: I("my-2 h-px bg-slate-200 dark:bg-slate-800", e),
	...t
}));
DC.displayName = "CommandPaletteSeparator";
function OC(e) {
	let [t, n] = G(!1), [r, i] = G(""), [a, o] = G(0), s = Ln(() => r ? e.map((e) => ({
		...e,
		commands: e.commands.filter((e) => {
			let t = r.toLowerCase();
			return e.label.toLowerCase().includes(t) || e.description?.toLowerCase().includes(t) || e.keywords?.some((e) => e.toLowerCase().includes(t));
		})
	})).filter((e) => e.commands.length > 0) : e, [e, r]), c = Ln(() => s.flatMap((e) => e.commands), [s]);
	return {
		open: t,
		setOpen: n,
		search: r,
		setSearch: i,
		selectedIndex: a,
		setSelectedIndex: o,
		filteredGroups: s,
		allCommands: c,
		handleKeyDown: (e) => {
			if (e.key === "ArrowDown") e.preventDefault(), o((e) => (e + 1) % c.length);
			else if (e.key === "ArrowUp") e.preventDefault(), o((e) => (e - 1 + c.length) % c.length);
			else if (e.key === "Enter") {
				e.preventDefault();
				let t = c[a];
				t && !t.disabled && (t.onSelect?.(), n(!1));
			}
		}
	};
}
//#endregion
//#region src/components/organisms/Form/Form.tsx
var kC = V(({ className: e, isLoading: t, error: n, children: r, ...i }, a) => /* @__PURE__ */ J("form", {
	ref: a,
	className: I("space-y-6", e),
	...i,
	children: [n && /* @__PURE__ */ q("div", {
		role: "alert",
		className: "rounded-md border border-rose-200 bg-rose-50 p-4 text-sm text-rose-800 dark:border-rose-900 dark:bg-rose-950 dark:text-rose-200",
		children: n
	}), /* @__PURE__ */ q("fieldset", {
		disabled: t,
		className: "space-y-6",
		children: r
	})]
}));
kC.displayName = "Form";
var AC = V(({ className: e, title: t, description: n, children: r, ...i }, a) => /* @__PURE__ */ J("div", {
	ref: a,
	className: I("space-y-4", e),
	...i,
	children: [(t || n) && /* @__PURE__ */ J("div", {
		className: "space-y-1",
		children: [t && /* @__PURE__ */ q("h3", {
			className: "text-lg font-medium text-slate-900 dark:text-slate-100",
			children: t
		}), n && /* @__PURE__ */ q("p", {
			className: "text-sm text-slate-500 dark:text-slate-400",
			children: n
		})]
	}), /* @__PURE__ */ q("div", {
		className: "space-y-4",
		children: r
	})]
}));
AC.displayName = "FormSection";
var jC = V(({ className: e, layout: t = "vertical", columns: n = 1, children: r, ...i }, a) => /* @__PURE__ */ q("div", {
	ref: a,
	className: I(t === "grid" && "grid gap-4", t === "grid" && n === 2 && "grid-cols-1 md:grid-cols-2", t === "grid" && n === 3 && "grid-cols-1 md:grid-cols-2 lg:grid-cols-3", t === "grid" && n === 4 && "grid-cols-1 md:grid-cols-2 lg:grid-cols-4", t === "horizontal" && "flex flex-wrap gap-4", t === "vertical" && "space-y-4", e),
	...i,
	children: r
}));
jC.displayName = "FormGroup";
var MC = V(({ className: e, align: t = "right", children: n, ...r }, i) => /* @__PURE__ */ q("div", {
	ref: i,
	className: I("flex gap-3", t === "left" && "justify-start", t === "center" && "justify-center", t === "right" && "justify-end", t === "between" && "justify-between", e),
	...r,
	children: n
}));
MC.displayName = "FormActions";
var NC = V(({ className: e, variant: t = "info", icon: n, children: r, ...i }, a) => /* @__PURE__ */ J("div", {
	ref: a,
	role: "status",
	className: I("flex items-start gap-3 rounded-md border p-4 text-sm", {
		info: "border-sky-200 bg-sky-50 text-sky-800 dark:border-sky-900 dark:bg-sky-950 dark:text-sky-200",
		success: "border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-900 dark:bg-emerald-950 dark:text-emerald-200",
		warning: "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-200",
		error: "border-rose-200 bg-rose-50 text-rose-800 dark:border-rose-900 dark:bg-rose-950 dark:text-rose-200"
	}[t], e),
	...i,
	children: [n && /* @__PURE__ */ q("span", {
		className: "shrink-0",
		children: n
	}), /* @__PURE__ */ q("div", {
		className: "flex-1",
		children: r
	})]
}));
NC.displayName = "FormMessage";
var PC = V(({ className: e, label: t, ...n }, r) => /* @__PURE__ */ J("div", {
	ref: r,
	className: I("relative", e),
	...n,
	children: [/* @__PURE__ */ q("div", {
		className: "absolute inset-0 flex items-center",
		"aria-hidden": "true",
		children: /* @__PURE__ */ q("div", { className: "w-full border-t border-slate-200 dark:border-slate-800" })
	}), t && /* @__PURE__ */ q("div", {
		className: "relative flex justify-center",
		children: /* @__PURE__ */ q("span", {
			className: "bg-white px-3 text-sm text-slate-500 dark:bg-slate-950 dark:text-slate-400",
			children: t
		})
	})]
}));
PC.displayName = "FormDivider";
//#endregion
//#region src/components/organisms/Header/Header.tsx
var FC = V(({ className: e, variant: t = "default", ...n }, r) => /* @__PURE__ */ q("header", {
	ref: r,
	className: I("flex h-16 items-center border-b border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950", t === "sticky" && "sticky top-0 z-50", e),
	...n
}));
FC.displayName = "Header";
var IC = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	className: I("mx-auto flex w-full max-w-7xl items-center gap-4 px-4 sm:px-6 lg:px-8", e),
	...t
}));
IC.displayName = "HeaderContainer";
var LC = V(({ className: e, logo: t, href: n, children: r, ...i }, a) => {
	let o = /* @__PURE__ */ q("div", {
		ref: a,
		className: I("flex shrink-0 items-center font-semibold text-slate-900 dark:text-slate-100", e),
		...i,
		children: t || r
	});
	return n ? /* @__PURE__ */ q("a", {
		href: n,
		className: "flex items-center",
		children: o
	}) : o;
});
LC.displayName = "HeaderLogo";
var RC = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("nav", {
	ref: n,
	className: I("flex flex-1 items-center gap-6", e),
	"aria-label": "Main navigation",
	...t
}));
RC.displayName = "HeaderNav";
var zC = V(({ className: e, href: t, isActive: n, children: r, ...i }, a) => /* @__PURE__ */ q("a", {
	ref: a,
	href: t,
	className: I("text-sm font-medium transition-colors hover:text-slate-900 dark:hover:text-slate-100", n ? "text-slate-900 dark:text-slate-100" : "text-slate-600 dark:text-slate-400", e),
	"aria-current": n ? "page" : void 0,
	...i,
	children: r
}));
zC.displayName = "HeaderNavItem";
var BC = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	className: I("flex items-center gap-2", e),
	...t
}));
BC.displayName = "HeaderActions";
var VC = V(({ className: e, user: t, children: n, ...r }, i) => /* @__PURE__ */ q("div", {
	ref: i,
	className: I("flex items-center gap-3", e),
	...r,
	children: n
}));
VC.displayName = "HeaderUserMenu";
var HC = V(({ className: e, sticky: t = !1, children: n, ...r }, i) => /* @__PURE__ */ q("div", {
	ref: i,
	className: I("flex flex-col gap-2 border-b border-slate-200 bg-white px-6 py-4", "dark:border-slate-800 dark:bg-slate-950", t && "sticky top-0 z-40", e),
	...r,
	children: n
}));
HC.displayName = "PageHeader";
var UC = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	className: I("flex items-center justify-between gap-4", e),
	...t
}));
UC.displayName = "PageHeaderRow";
var WC = V(({ className: e, items: t, ...n }, r) => /* @__PURE__ */ q("nav", {
	ref: r,
	"aria-label": "Breadcrumb",
	className: I("flex items-center text-sm", e),
	...n,
	children: /* @__PURE__ */ q("ol", {
		className: "flex items-center gap-1",
		children: t.map((e, t) => /* @__PURE__ */ J("li", {
			className: "flex items-center gap-1",
			children: [t > 0 && /* @__PURE__ */ q(ct, {
				className: "h-4 w-4 text-slate-400 dark:text-slate-500",
				"aria-hidden": "true"
			}), e.href ? /* @__PURE__ */ q("a", {
				href: e.href,
				className: "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors",
				children: e.label
			}) : /* @__PURE__ */ q("span", {
				className: "text-slate-900 dark:text-slate-100 font-medium",
				children: e.label
			})]
		}, t))
	})
}));
WC.displayName = "PageHeaderBreadcrumbs";
var GC = V(({ className: e, description: t, children: n, ...r }, i) => /* @__PURE__ */ J("div", {
	className: "flex-1 min-w-0",
	children: [/* @__PURE__ */ q("h1", {
		ref: i,
		className: I("text-xl font-semibold text-slate-900 dark:text-slate-100 truncate", e),
		...r,
		children: n
	}), t && /* @__PURE__ */ q("p", {
		className: "mt-1 text-sm text-slate-500 dark:text-slate-400 truncate",
		children: t
	})]
}));
GC.displayName = "PageHeaderTitle";
var KC = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	className: I("flex items-center gap-2 shrink-0", e),
	...t
}));
KC.displayName = "PageHeaderActions";
var qC = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	className: I("flex h-screen bg-white dark:bg-slate-950", e),
	...t
}));
qC.displayName = "AppShell";
var JC = V(({ className: e, collapsed: t = !1, ...n }, r) => /* @__PURE__ */ q("aside", {
	ref: r,
	className: I("flex flex-col border-r border-slate-200 bg-slate-50 transition-all duration-300", "dark:border-slate-800 dark:bg-slate-900", t ? "w-16" : "w-64", e),
	"aria-label": "Main navigation",
	...n
}));
JC.displayName = "AppSidebar";
var YC = V(({ className: e, logo: t, href: n, children: r, ...i }, a) => {
	let o = /* @__PURE__ */ q("div", {
		ref: a,
		className: I("flex h-14 items-center px-4", e),
		...i,
		children: t || r
	});
	return n ? /* @__PURE__ */ q("a", {
		href: n,
		children: o
	}) : o;
});
YC.displayName = "AppSidebarHeader";
var XC = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("nav", {
	ref: n,
	className: I("flex-1 overflow-y-auto px-2 py-2 space-y-1", e),
	"aria-label": "Sidebar navigation",
	...t
}));
XC.displayName = "AppSidebarNav";
var ZC = V(({ className: e, href: t, icon: n, isActive: r, collapsed: i, badge: a, children: o, ...s }, c) => {
	let l = I("flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors", "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-300 dark:focus-visible:ring-slate-600", r ? "bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-slate-100" : "text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800", e), u = /* @__PURE__ */ J(K, { children: [
		n && /* @__PURE__ */ q("span", {
			className: "shrink-0",
			children: n
		}),
		!i && /* @__PURE__ */ q("span", {
			className: "flex-1 truncate",
			children: o
		}),
		!i && a && /* @__PURE__ */ q("span", {
			className: "shrink-0",
			children: a
		})
	] });
	return t ? /* @__PURE__ */ q("a", {
		ref: c,
		href: t,
		className: l,
		"aria-current": r ? "page" : void 0,
		title: i ? String(o) : void 0,
		...s,
		children: u
	}) : /* @__PURE__ */ q("div", {
		ref: c,
		className: l,
		role: "button",
		tabIndex: 0,
		title: i ? String(o) : void 0,
		children: u
	});
});
ZC.displayName = "AppSidebarNavItem";
var QC = V(({ className: e, icon: t, label: n, collapsed: r, defaultOpen: i = !1, children: a, ...o }, s) => {
	let [c, l] = G(i);
	return /* @__PURE__ */ J("div", {
		ref: s,
		className: I("space-y-1", e),
		...o,
		children: [/* @__PURE__ */ J("button", {
			type: "button",
			onClick: () => l(!c),
			className: I("w-full flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors", "hover:bg-slate-100 dark:hover:bg-slate-800", "text-slate-700 dark:text-slate-300", "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-300 dark:focus-visible:ring-slate-600"),
			"aria-expanded": c,
			children: [t && /* @__PURE__ */ q("span", {
				className: "shrink-0",
				children: t
			}), !r && /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q("span", {
				className: "flex-1 text-left",
				children: n
			}), q(c ? R : ct, { className: "h-4 w-4 shrink-0" })] })]
		}), !r && c && /* @__PURE__ */ q("div", {
			className: "ml-7 space-y-1",
			children: a
		})]
	});
});
QC.displayName = "AppSidebarSection";
var $C = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("div", {
	ref: n,
	className: I("border-t border-slate-200 dark:border-slate-800 p-2 space-y-1", e),
	...t
}));
$C.displayName = "AppSidebarFooter";
var ew = V(({ className: e, firstName: t, lastName: n, email: r, role: i, avatar: a, collapsed: o, children: s, ...c }, l) => {
	let u = `${t?.[0] || ""}${n?.[0] || ""}`.toUpperCase() || "?", d = [t, n].filter(Boolean).join(" ") || r;
	return /* @__PURE__ */ J("div", {
		ref: l,
		className: I("flex items-center gap-3 rounded-md px-3 py-2 transition-colors", "hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer", e),
		...c,
		children: [
			a || /* @__PURE__ */ q("div", {
				className: "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-200 dark:bg-slate-700 text-xs font-medium text-slate-600 dark:text-slate-300",
				children: u
			}),
			!o && /* @__PURE__ */ J("div", {
				className: "flex-1 min-w-0",
				children: [d && /* @__PURE__ */ q("p", {
					className: "text-sm font-medium text-slate-900 dark:text-white truncate",
					children: d
				}), i && /* @__PURE__ */ q("p", {
					className: "text-xs text-slate-500 dark:text-slate-400 truncate",
					children: i
				})]
			}),
			s
		]
	});
});
ew.displayName = "AppSidebarUserProfile";
var tw = V(({ className: e, currentLanguage: t = "en", languages: n = [], onLanguageChange: r, collapsed: i, icon: a, ...o }, s) => {
	let c = n.find((e) => e.code === t) || {
		code: t,
		name: t.toUpperCase()
	};
	return /* @__PURE__ */ J("div", {
		ref: s,
		className: I("flex items-center gap-2.5 rounded-md px-3 py-2 transition-colors cursor-pointer", "hover:bg-slate-100 dark:hover:bg-slate-800", "text-slate-600 dark:text-slate-400", e),
		...o,
		children: [a || /* @__PURE__ */ q("svg", {
			className: "h-5 w-5 shrink-0",
			fill: "none",
			stroke: "currentColor",
			viewBox: "0 0 24 24",
			children: /* @__PURE__ */ q("path", {
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
			})
		}), !i && /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q("span", {
			className: "flex-1 text-sm",
			children: c.name
		}), /* @__PURE__ */ q(R, { className: "h-4 w-4 shrink-0" })] })]
	});
});
tw.displayName = "AppSidebarLanguageSwitch";
var nw = V(({ className: e, currentLanguage: t = "en", languages: n = [], onLanguageChange: r, collapsed: i, defaultOpen: a = !1, icon: o, ...s }, c) => {
	let [l, u] = G(a), d = n.find((e) => e.code === t) || {
		code: t,
		name: t.toUpperCase()
	}, f = (e) => {
		r?.(e), u(!1);
	};
	return /* @__PURE__ */ J("div", {
		ref: c,
		className: I("space-y-1", e),
		...s,
		children: [/* @__PURE__ */ J("button", {
			type: "button",
			onClick: () => u(!l),
			className: I("w-full flex items-center gap-2.5 rounded-md px-3 py-2 text-sm transition-colors", "hover:bg-slate-100 dark:hover:bg-slate-800", "text-slate-600 dark:text-slate-400", "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-300 dark:focus-visible:ring-slate-600"),
			"aria-expanded": l,
			children: [o || /* @__PURE__ */ q("svg", {
				className: "h-5 w-5 shrink-0",
				fill: "none",
				stroke: "currentColor",
				viewBox: "0 0 24 24",
				children: /* @__PURE__ */ q("path", {
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2,
					d: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
				})
			}), !i && /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q("span", {
				className: "flex-1 text-left",
				children: d.name
			}), q(l ? R : ct, { className: "h-4 w-4 shrink-0" })] })]
		}), !i && l && /* @__PURE__ */ q("div", {
			className: "ml-7 space-y-1",
			children: n.map((e) => /* @__PURE__ */ q("button", {
				type: "button",
				onClick: () => f(e.code),
				className: I("w-full flex items-center gap-2 rounded-md px-3 py-1.5 text-sm transition-colors text-left", "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-300 dark:focus-visible:ring-slate-600", e.code === t ? "bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-slate-100" : "text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800"),
				children: e.name
			}, e.code))
		})]
	});
});
nw.displayName = "AppSidebarLanguageMenu";
var rw = V(({ className: e, firstName: t, lastName: n, email: r, role: i, avatar: a, collapsed: o, defaultOpen: s = !1, children: c, ...l }, u) => {
	let [d, f] = G(s), p = `${t?.[0] || ""}${n?.[0] || ""}`.toUpperCase() || "?", m = [t, n].filter(Boolean).join(" ") || r;
	return /* @__PURE__ */ J("div", {
		ref: u,
		className: I("space-y-1", e),
		...l,
		children: [/* @__PURE__ */ J("button", {
			type: "button",
			onClick: () => f(!d),
			className: I("w-full flex items-center gap-3 rounded-md px-3 py-2 transition-colors", "hover:bg-slate-100 dark:hover:bg-slate-800", "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-300 dark:focus-visible:ring-slate-600"),
			"aria-expanded": d,
			children: [a || /* @__PURE__ */ q("div", {
				className: "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-200 dark:bg-slate-700 text-xs font-medium text-slate-600 dark:text-slate-300",
				children: p
			}), !o && /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ J("div", {
				className: "flex-1 min-w-0 text-left",
				children: [m && /* @__PURE__ */ q("p", {
					className: "text-sm font-medium text-slate-900 dark:text-white truncate",
					children: m
				}), i && /* @__PURE__ */ q("p", {
					className: "text-xs text-slate-500 dark:text-slate-400 truncate",
					children: i
				})]
			}), q(d ? R : ct, { className: "h-4 w-4 shrink-0 text-slate-400 dark:text-slate-500" })] })]
		}), !o && d && /* @__PURE__ */ q("div", {
			className: "ml-7 space-y-1",
			children: c
		})]
	});
});
rw.displayName = "AppSidebarUserMenu";
var iw = V(({ className: e, ...t }, n) => /* @__PURE__ */ q("main", {
	ref: n,
	className: I("flex-1 overflow-auto bg-white dark:bg-slate-950", e),
	...t
}));
iw.displayName = "AppMain";
//#endregion
//#region src/components/organisms/MissionCard/MissionCard.tsx
var aw = {
	idle: {
		label: "Idle",
		badgeVariant: "default"
	},
	running: {
		label: "Running",
		customClass: "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300",
		pulse: !0
	},
	attention: {
		label: "Attention",
		customClass: "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300",
		pulse: !0
	},
	complete: {
		label: "Complete",
		badgeVariant: "success"
	},
	failed: {
		label: "Failed",
		badgeVariant: "error"
	}
};
function ow({ status: e }) {
	if (e === "idle") return null;
	let t = aw[e];
	return t.customClass ? /* @__PURE__ */ q("span", {
		className: I(t.customClass, t.pulse && "animate-pulse"),
		children: t.label
	}) : /* @__PURE__ */ q(i, {
		variant: t.badgeVariant,
		size: "sm",
		children: t.label
	});
}
var sw = V(({ className: e, name: t, status: n, progress: r, trustTier: i, onClick: a, variant: o = "default", description: s, ...c }, l) => {
	let u = a !== void 0;
	return o === "compact" ? /* @__PURE__ */ J("div", {
		ref: l,
		role: u ? "button" : void 0,
		tabIndex: u ? 0 : void 0,
		className: I("flex items-center gap-2 rounded-md border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800", "px-2 py-1.5", u && "cursor-pointer hover:shadow-sm transition-shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1", e),
		onClick: a,
		onKeyDown: u ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), a());
		} : void 0,
		...c,
		children: [/* @__PURE__ */ q("span", {
			className: "flex-1 truncate text-sm font-medium text-slate-900 dark:text-slate-100",
			children: t
		}), /* @__PURE__ */ q(ow, { status: n })]
	}) : /* @__PURE__ */ J("div", {
		ref: l,
		role: u ? "button" : void 0,
		tabIndex: u ? 0 : void 0,
		className: I("relative flex flex-col gap-3 rounded-lg border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800", "p-4", u && "cursor-pointer hover:shadow-md transition-shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2", e),
		onClick: a,
		onKeyDown: u ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), a());
		} : void 0,
		...c,
		children: [/* @__PURE__ */ J("div", {
			className: "flex items-start justify-between gap-2",
			children: [/* @__PURE__ */ J("div", {
				className: "flex-1 min-w-0",
				children: [/* @__PURE__ */ q("h4", {
					className: "text-sm font-semibold text-slate-900 dark:text-slate-100 truncate",
					children: t
				}), s && /* @__PURE__ */ q("p", {
					className: "mt-0.5 text-xs text-slate-500 dark:text-slate-400 line-clamp-2",
					children: s
				})]
			}), /* @__PURE__ */ J("div", {
				className: "flex items-center gap-1.5 shrink-0",
				children: [i !== void 0 && /* @__PURE__ */ q(C, {
					tier: i,
					size: "sm",
					showLabel: !1,
					showIcon: !0
				}), /* @__PURE__ */ q(ow, { status: n })]
			})]
		}), r !== void 0 && /* @__PURE__ */ q(Xo, {
			value: r,
			variant: n === "failed" ? "error" : n === "complete" ? "success" : n === "attention" ? "warning" : "default",
			size: "sm"
		})]
	});
});
sw.displayName = "MissionCard";
//#endregion
//#region src/components/organisms/SplitView/SplitView.tsx
function cw(e, t) {
	if (!e) return t;
	try {
		let t = localStorage.getItem(e);
		if (t !== null) {
			let e = parseFloat(t);
			if (!isNaN(e) && e > 0 && e < 100) return e;
		}
	} catch {}
	return t;
}
function lw(e, t) {
	if (e) try {
		localStorage.setItem(e, String(t));
	} catch {}
}
var uw = V(({ className: e, left: t, right: n, defaultSplit: r = 50, minLeft: i = 200, minRight: a = 200, onResize: o, storageKey: s, ...c }, l) => {
	let [u, d] = G(() => cw(s, r)), f = W(null), p = W(!1), m = H((e) => {
		f.current = e, typeof l == "function" ? l(e) : l && (l.current = e);
	}, [l]), h = H((e) => {
		e.preventDefault(), p.current = !0, e.target.setPointerCapture(e.pointerId);
	}, []), g = H((e) => {
		if (!p.current || !f.current) return;
		let t = f.current.getBoundingClientRect(), n = t.width;
		if (n === 0) return;
		let r = (e.clientX - t.left) / n * 100, s = i / n * 100, c = a / n * 100, l = Math.min(Math.max(r, s), 100 - c);
		d(l), o?.(l);
	}, [
		i,
		a,
		o
	]), _ = H((e) => {
		p.current && (p.current = !1, e.target.releasePointerCapture(e.pointerId), lw(s, u));
	}, [s, u]);
	U(() => {
		p.current || lw(s, u);
	}, [u, s]);
	let v = n !== null;
	return /* @__PURE__ */ J("div", {
		ref: m,
		className: I("relative flex h-full w-full overflow-hidden", e),
		onPointerMove: v ? g : void 0,
		onPointerUp: v ? _ : void 0,
		...c,
		children: [
			/* @__PURE__ */ q("div", {
				className: I("flex-shrink-0 overflow-auto", "transition-[width] duration-150 ease-out", v ? "" : "w-full"),
				style: v ? { width: `${u}%` } : void 0,
				children: t
			}),
			v && /* @__PURE__ */ q("div", {
				role: "separator",
				"aria-orientation": "vertical",
				"aria-label": "Resize panels",
				className: I("relative z-10 flex w-1 flex-shrink-0 cursor-col-resize select-none", "bg-slate-200 dark:bg-slate-700", "hover:bg-slate-300 dark:hover:bg-slate-600", "transition-colors duration-150", "items-center justify-center"),
				onPointerDown: h,
				children: /* @__PURE__ */ J("div", {
					className: "flex flex-col items-center gap-[3px] pointer-events-none",
					children: [
						/* @__PURE__ */ q("span", { className: "block h-[3px] w-[3px] rounded-full bg-slate-400 dark:bg-slate-500" }),
						/* @__PURE__ */ q("span", { className: "block h-[3px] w-[3px] rounded-full bg-slate-400 dark:bg-slate-500" }),
						/* @__PURE__ */ q("span", { className: "block h-[3px] w-[3px] rounded-full bg-slate-400 dark:bg-slate-500" })
					]
				})
			}),
			v && /* @__PURE__ */ q("div", {
				className: "flex-1 overflow-auto transition-[flex] duration-150 ease-out",
				children: n
			})
		]
	});
});
uw.displayName = "SplitView";
//#endregion
//#region src/hooks/useElkLayout.ts
function dw(e, t, n) {
	let [r, i] = G({
		nodes: [],
		edgeRoutes: /* @__PURE__ */ new Map(),
		isLayouting: !1,
		error: null
	}), a = W(0);
	return U(() => {
		if (e.length === 0) {
			i((e) => e.nodes.length === 0 && !e.isLayouting && !e.error ? e : {
				nodes: [],
				edgeRoutes: /* @__PURE__ */ new Map(),
				isLayouting: !1,
				error: null
			});
			return;
		}
		let r = ++a.current;
		i((e) => ({
			...e,
			isLayouting: !0,
			error: null
		})), import("./elk-layout-B70wAATx.js").then(({ elkLayoutWorkPackages: r }) => r(e, t, n)).then((e) => {
			a.current === r && i({
				nodes: e.nodes,
				edgeRoutes: e.edgeRoutes,
				isLayouting: !1,
				error: null
			});
		}).catch((e) => {
			a.current === r && i((t) => ({
				...t,
				isLayouting: !1,
				error: e instanceof Error ? e : Error(String(e))
			}));
		});
	}, [
		e,
		t,
		n?.direction,
		n?.nodeWidth,
		n?.nodeHeight,
		n?.spacing?.horizontalSpacing,
		n?.spacing?.verticalSpacing
	]), r;
}
//#endregion
//#region ../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/noevent.js
var fw = {
	capture: !0,
	passive: !1
};
function pw(e) {
	e.preventDefault(), e.stopImmediatePropagation();
}
//#endregion
//#region ../node_modules/.pnpm/d3-drag@3.0.0/node_modules/d3-drag/src/nodrag.js
function mw(e) {
	var t = e.document.documentElement, n = Qb(e).on("dragstart.drag", pw, fw);
	"onselectstart" in t ? n.on("selectstart.drag", pw, fw) : (t.__noselect = t.style.MozUserSelect, t.style.MozUserSelect = "none");
}
function hw(e, t) {
	var n = e.document.documentElement, r = Qb(e).on("dragstart.drag", null);
	t && (r.on("click.drag", pw, fw), setTimeout(function() {
		r.on("click.drag", null);
	}, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
//#endregion
//#region ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/constant.js
var gw = (e) => () => e;
//#endregion
//#region ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/event.js
function _w(e, { sourceEvent: t, target: n, transform: r, dispatch: i }) {
	Object.defineProperties(this, {
		type: {
			value: e,
			enumerable: !0,
			configurable: !0
		},
		sourceEvent: {
			value: t,
			enumerable: !0,
			configurable: !0
		},
		target: {
			value: n,
			enumerable: !0,
			configurable: !0
		},
		transform: {
			value: r,
			enumerable: !0,
			configurable: !0
		},
		_: { value: i }
	});
}
//#endregion
//#region ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/transform.js
function vw(e, t, n) {
	this.k = e, this.x = t, this.y = n;
}
vw.prototype = {
	constructor: vw,
	scale: function(e) {
		return e === 1 ? this : new vw(this.k * e, this.x, this.y);
	},
	translate: function(e, t) {
		return e === 0 & t === 0 ? this : new vw(this.k, this.x + this.k * e, this.y + this.k * t);
	},
	apply: function(e) {
		return [e[0] * this.k + this.x, e[1] * this.k + this.y];
	},
	applyX: function(e) {
		return e * this.k + this.x;
	},
	applyY: function(e) {
		return e * this.k + this.y;
	},
	invert: function(e) {
		return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
	},
	invertX: function(e) {
		return (e - this.x) / this.k;
	},
	invertY: function(e) {
		return (e - this.y) / this.k;
	},
	rescaleX: function(e) {
		return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
	},
	rescaleY: function(e) {
		return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
	},
	toString: function() {
		return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
	}
};
var yw = new vw(1, 0, 0);
bw.prototype = vw.prototype;
function bw(e) {
	for (; !e.__zoom;) if (!(e = e.parentNode)) return yw;
	return e.__zoom;
}
//#endregion
//#region ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/noevent.js
function xw(e) {
	e.stopImmediatePropagation();
}
function Sw(e) {
	e.preventDefault(), e.stopImmediatePropagation();
}
//#endregion
//#region ../node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/zoom.js
function Cw(e) {
	return (!e.ctrlKey || e.type === "wheel") && !e.button;
}
function ww() {
	var e = this;
	return e instanceof SVGElement ? (e = e.ownerSVGElement || e, e.hasAttribute("viewBox") ? (e = e.viewBox.baseVal, [[e.x, e.y], [e.x + e.width, e.y + e.height]]) : [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]]) : [[0, 0], [e.clientWidth, e.clientHeight]];
}
function Tw() {
	return this.__zoom || yw;
}
function Ew(e) {
	return -e.deltaY * (e.deltaMode === 1 ? .05 : e.deltaMode ? 1 : .002) * (e.ctrlKey ? 10 : 1);
}
function Dw() {
	return navigator.maxTouchPoints || "ontouchstart" in this;
}
function Ow(e, t, n) {
	var r = e.invertX(t[0][0]) - n[0][0], i = e.invertX(t[1][0]) - n[1][0], a = e.invertY(t[0][1]) - n[0][1], o = e.invertY(t[1][1]) - n[1][1];
	return e.translate(i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i), o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o));
}
function kw() {
	var e = Cw, t = ww, n = Ow, r = Ew, i = Dw, a = [0, Infinity], o = [[-Infinity, -Infinity], [Infinity, Infinity]], s = 250, c = rp, l = nx("start", "zoom", "end"), u, d, f, p = 500, m = 150, h = 0, g = 10;
	function _(e) {
		e.property("__zoom", Tw).on("wheel.zoom", w, { passive: !1 }).on("mousedown.zoom", T).on("dblclick.zoom", E).filter(i).on("touchstart.zoom", D).on("touchmove.zoom", O).on("touchend.zoom touchcancel.zoom", k).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	}
	_.transform = function(e, t, n, r) {
		var i = e.selection ? e.selection() : e;
		i.property("__zoom", Tw), e === i ? i.interrupt().each(function() {
			S(this, arguments).event(r).start().zoom(null, typeof t == "function" ? t.apply(this, arguments) : t).end();
		}) : x(e, t, n, r);
	}, _.scaleBy = function(e, t, n, r) {
		_.scaleTo(e, function() {
			return this.__zoom.k * (typeof t == "function" ? t.apply(this, arguments) : t);
		}, n, r);
	}, _.scaleTo = function(e, r, i, a) {
		_.transform(e, function() {
			var e = t.apply(this, arguments), a = this.__zoom, s = i == null ? b(e) : typeof i == "function" ? i.apply(this, arguments) : i, c = a.invert(s), l = typeof r == "function" ? r.apply(this, arguments) : r;
			return n(y(v(a, l), s, c), e, o);
		}, i, a);
	}, _.translateBy = function(e, r, i, a) {
		_.transform(e, function() {
			return n(this.__zoom.translate(typeof r == "function" ? r.apply(this, arguments) : r, typeof i == "function" ? i.apply(this, arguments) : i), t.apply(this, arguments), o);
		}, null, a);
	}, _.translateTo = function(e, r, i, a, s) {
		_.transform(e, function() {
			var e = t.apply(this, arguments), s = this.__zoom, c = a == null ? b(e) : typeof a == "function" ? a.apply(this, arguments) : a;
			return n(yw.translate(c[0], c[1]).scale(s.k).translate(typeof r == "function" ? -r.apply(this, arguments) : -r, typeof i == "function" ? -i.apply(this, arguments) : -i), e, o);
		}, a, s);
	};
	function v(e, t) {
		return t = Math.max(a[0], Math.min(a[1], t)), t === e.k ? e : new vw(t, e.x, e.y);
	}
	function y(e, t, n) {
		var r = t[0] - n[0] * e.k, i = t[1] - n[1] * e.k;
		return r === e.x && i === e.y ? e : new vw(e.k, r, i);
	}
	function b(e) {
		return [(+e[0][0] + +e[1][0]) / 2, (+e[0][1] + +e[1][1]) / 2];
	}
	function x(e, n, r, i) {
		e.on("start.zoom", function() {
			S(this, arguments).event(i).start();
		}).on("interrupt.zoom end.zoom", function() {
			S(this, arguments).event(i).end();
		}).tween("zoom", function() {
			var e = this, a = arguments, o = S(e, a).event(i), s = t.apply(e, a), l = r == null ? b(s) : typeof r == "function" ? r.apply(e, a) : r, u = Math.max(s[1][0] - s[0][0], s[1][1] - s[0][1]), d = e.__zoom, f = typeof n == "function" ? n.apply(e, a) : n, p = c(d.invert(l).concat(u / d.k), f.invert(l).concat(u / f.k));
			return function(e) {
				if (e === 1) e = f;
				else {
					var t = p(e), n = u / t[2];
					e = new vw(n, l[0] - t[0] * n, l[1] - t[1] * n);
				}
				o.zoom(null, e);
			};
		});
	}
	function S(e, t, n) {
		return !n && e.__zooming || new C(e, t);
	}
	function C(e, n) {
		this.that = e, this.args = n, this.active = 0, this.sourceEvent = null, this.extent = t.apply(e, n), this.taps = 0;
	}
	C.prototype = {
		event: function(e) {
			return e && (this.sourceEvent = e), this;
		},
		start: function() {
			return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
		},
		zoom: function(e, t) {
			return this.mouse && e !== "mouse" && (this.mouse[1] = t.invert(this.mouse[0])), this.touch0 && e !== "touch" && (this.touch0[1] = t.invert(this.touch0[0])), this.touch1 && e !== "touch" && (this.touch1[1] = t.invert(this.touch1[0])), this.that.__zoom = t, this.emit("zoom"), this;
		},
		end: function() {
			return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
		},
		emit: function(e) {
			var t = Qb(this.that).datum();
			l.call(e, this.that, new _w(e, {
				sourceEvent: this.sourceEvent,
				target: _,
				type: e,
				transform: this.that.__zoom,
				dispatch: l
			}), t);
		}
	};
	function w(t, ...i) {
		if (!e.apply(this, arguments)) return;
		var s = S(this, i).event(t), c = this.__zoom, l = Math.max(a[0], Math.min(a[1], c.k * 2 ** r.apply(this, arguments))), u = ex(t);
		if (s.wheel) (s.mouse[0][0] !== u[0] || s.mouse[0][1] !== u[1]) && (s.mouse[1] = c.invert(s.mouse[0] = u)), clearTimeout(s.wheel);
		else if (c.k === l) return;
		else s.mouse = [u, c.invert(u)], Fx(this), s.start();
		Sw(t), s.wheel = setTimeout(d, m), s.zoom("mouse", n(y(v(c, l), s.mouse[0], s.mouse[1]), s.extent, o));
		function d() {
			s.wheel = null, s.end();
		}
	}
	function T(t, ...r) {
		if (f || !e.apply(this, arguments)) return;
		var i = t.currentTarget, a = S(this, r, !0).event(t), s = Qb(t.view).on("mousemove.zoom", d, !0).on("mouseup.zoom", p, !0), c = ex(t, i), l = t.clientX, u = t.clientY;
		mw(t.view), xw(t), a.mouse = [c, this.__zoom.invert(c)], Fx(this), a.start();
		function d(e) {
			if (Sw(e), !a.moved) {
				var t = e.clientX - l, r = e.clientY - u;
				a.moved = t * t + r * r > h;
			}
			a.event(e).zoom("mouse", n(y(a.that.__zoom, a.mouse[0] = ex(e, i), a.mouse[1]), a.extent, o));
		}
		function p(e) {
			s.on("mousemove.zoom mouseup.zoom", null), hw(e.view, a.moved), Sw(e), a.event(e).end();
		}
	}
	function E(r, ...i) {
		if (e.apply(this, arguments)) {
			var a = this.__zoom, c = ex(r.changedTouches ? r.changedTouches[0] : r, this), l = a.invert(c), u = a.k * (r.shiftKey ? .5 : 2), d = n(y(v(a, u), c, l), t.apply(this, i), o);
			Sw(r), s > 0 ? Qb(this).transition().duration(s).call(x, d, c, r) : Qb(this).call(_.transform, d, c, r);
		}
	}
	function D(t, ...n) {
		if (e.apply(this, arguments)) {
			var r = t.touches, i = r.length, a = S(this, n, t.changedTouches.length === i).event(t), o, s, c, l;
			for (xw(t), s = 0; s < i; ++s) c = r[s], l = ex(c, this), l = [
				l,
				this.__zoom.invert(l),
				c.identifier
			], a.touch0 ? !a.touch1 && a.touch0[2] !== l[2] && (a.touch1 = l, a.taps = 0) : (a.touch0 = l, o = !0, a.taps = 1 + !!u);
			u &&= clearTimeout(u), o && (a.taps < 2 && (d = l[0], u = setTimeout(function() {
				u = null;
			}, p)), Fx(this), a.start());
		}
	}
	function O(e, ...t) {
		if (this.__zooming) {
			var r = S(this, t).event(e), i = e.changedTouches, a = i.length, s, c, l, u;
			for (Sw(e), s = 0; s < a; ++s) c = i[s], l = ex(c, this), r.touch0 && r.touch0[2] === c.identifier ? r.touch0[0] = l : r.touch1 && r.touch1[2] === c.identifier && (r.touch1[0] = l);
			if (c = r.that.__zoom, r.touch1) {
				var d = r.touch0[0], f = r.touch0[1], p = r.touch1[0], m = r.touch1[1], h = (h = p[0] - d[0]) * h + (h = p[1] - d[1]) * h, g = (g = m[0] - f[0]) * g + (g = m[1] - f[1]) * g;
				c = v(c, Math.sqrt(h / g)), l = [(d[0] + p[0]) / 2, (d[1] + p[1]) / 2], u = [(f[0] + m[0]) / 2, (f[1] + m[1]) / 2];
			} else if (r.touch0) l = r.touch0[0], u = r.touch0[1];
			else return;
			r.zoom("touch", n(y(c, l, u), r.extent, o));
		}
	}
	function k(e, ...t) {
		if (this.__zooming) {
			var n = S(this, t).event(e), r = e.changedTouches, i = r.length, a, o;
			for (xw(e), f && clearTimeout(f), f = setTimeout(function() {
				f = null;
			}, p), a = 0; a < i; ++a) o = r[a], n.touch0 && n.touch0[2] === o.identifier ? delete n.touch0 : n.touch1 && n.touch1[2] === o.identifier && delete n.touch1;
			if (n.touch1 && !n.touch0 && (n.touch0 = n.touch1, delete n.touch1), n.touch0) n.touch0[1] = this.__zoom.invert(n.touch0[0]);
			else if (n.end(), n.taps === 2 && (o = ex(o, this), Math.hypot(d[0] - o[0], d[1] - o[1]) < g)) {
				var s = Qb(this).on("dblclick.zoom");
				s && s.apply(this, arguments);
			}
		}
	}
	return _.wheelDelta = function(e) {
		return arguments.length ? (r = typeof e == "function" ? e : gw(+e), _) : r;
	}, _.filter = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : gw(!!t), _) : e;
	}, _.touchable = function(e) {
		return arguments.length ? (i = typeof e == "function" ? e : gw(!!e), _) : i;
	}, _.extent = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : gw([[+e[0][0], +e[0][1]], [+e[1][0], +e[1][1]]]), _) : t;
	}, _.scaleExtent = function(e) {
		return arguments.length ? (a[0] = +e[0], a[1] = +e[1], _) : [a[0], a[1]];
	}, _.translateExtent = function(e) {
		return arguments.length ? (o[0][0] = +e[0][0], o[1][0] = +e[1][0], o[0][1] = +e[0][1], o[1][1] = +e[1][1], _) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
	}, _.constrain = function(e) {
		return arguments.length ? (n = e, _) : n;
	}, _.duration = function(e) {
		return arguments.length ? (s = +e, _) : s;
	}, _.interpolate = function(e) {
		return arguments.length ? (c = e, _) : c;
	}, _.on = function() {
		var e = l.on.apply(l, arguments);
		return e === l ? _ : e;
	}, _.clickDistance = function(e) {
		return arguments.length ? (h = (e = +e) * e, _) : Math.sqrt(h);
	}, _.tapDistance = function(e) {
		return arguments.length ? (g = +e, _) : g;
	}, _;
}
//#endregion
//#region src/hooks/useZoomPan.ts
var Aw = {
	minZoom: .1,
	maxZoom: 4,
	zoomStep: .2
};
function jw(e) {
	let t = e?.minZoom ?? Aw.minZoom, n = e?.maxZoom ?? Aw.maxZoom, r = e?.zoomStep ?? Aw.zoomStep, i = W(null), a = W(null), [o, s] = G({
		x: 0,
		y: 0,
		k: 1
	});
	return U(() => {
		if (!i.current) return;
		let e = kw().scaleExtent([t, n]).on("zoom", (e) => {
			let { x: t, y: n, k: r } = e.transform;
			s({
				x: t,
				y: n,
				k: r
			});
		}), r = Qb(i.current);
		return r.call(e), r.on("dblclick.zoom", null), a.current = e, () => {
			r.on(".zoom", null);
		};
	}, [t, n]), {
		containerRef: i,
		transform: o,
		actions: {
			zoomIn: H(() => {
				i.current && a.current && a.current.scaleBy(Qb(i.current), 1 + r);
			}, [r]),
			zoomOut: H(() => {
				i.current && a.current && a.current.scaleBy(Qb(i.current), 1 - r);
			}, [r]),
			fitToScreen: H((e) => {
				if (!i.current || !a.current) return;
				let t = i.current.getBoundingClientRect(), n = t.width / e.width, r = t.height / e.height, o = Math.min(n, r, 1) * .9, s = (t.width - e.width * o) / 2 - e.minX * o, c = (t.height - e.height * o) / 2 - e.minY * o, l = Qb(i.current);
				a.current.transform(l, yw.translate(s, c).scale(o));
			}, []),
			resetView: H(() => {
				if (!i.current || !a.current) return;
				let e = Qb(i.current);
				a.current.transform(e, yw);
			}, []),
			scaleBy: H((e) => {
				i.current && a.current && a.current.scaleBy(Qb(i.current), e);
			}, [])
		}
	};
}
//#endregion
//#region src/components/organisms/WorkflowDAG/layout.ts
var Mw = {
	nodeWidth: 200,
	nodeHeight: 100,
	horizontalSpacing: 60,
	verticalSpacing: 80
};
function Nw(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), r = new Set(e.map((e) => e.id));
	for (let r of e) t.set(r.id, []), n.set(r.id, []);
	for (let i of e) for (let e of i.dependsOn) {
		if (!r.has(e)) continue;
		let a = t.get(e);
		a && a.push(i.id);
		let o = n.get(i.id);
		o && o.push(e);
	}
	return {
		outgoing: t,
		incoming: n
	};
}
function Pw(e, t) {
	let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
	function a(e) {
		r.add(e), i.add(e);
		let o = t.outgoing.get(e) ?? [];
		for (let s of o) if (i.has(s)) {
			n.add(`${e}->${s}`);
			let r = t.outgoing.get(e);
			if (r) {
				let e = r.indexOf(s);
				e >= 0 && r.splice(e, 1);
			}
			let i = t.incoming.get(s);
			if (i) {
				let t = i.indexOf(e);
				t >= 0 && i.splice(t, 1);
			}
		} else r.has(s) || a(s);
		return i.delete(e), !1;
	}
	for (let t of e) r.has(t.id) || a(t.id);
	return n;
}
function Fw(e, t) {
	let n = /* @__PURE__ */ new Map(), r = new Set(e.map((e) => e.id)), i = e.filter((e) => {
		let n = t.incoming.get(e.id);
		return !n || n.length === 0;
	}), a = (i.length > 0 ? i : e).map((e) => ({
		nodeId: e.id,
		layer: 0
	}));
	for (; a.length > 0;) {
		let e = a.shift();
		if (!e) continue;
		let { nodeId: i, layer: o } = e, s = n.get(i);
		if (s !== void 0 && s >= o) continue;
		n.set(i, o);
		let c = t.outgoing.get(i) ?? [];
		for (let e of c) r.has(e) && a.push({
			nodeId: e,
			layer: o + 1
		});
	}
	for (let t of e) n.has(t.id) || n.set(t.id, 0);
	return n;
}
function Iw(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let r of e) {
		let e = t.get(r.id) ?? 0, i = n.get(e) ?? [];
		i.push(r), n.set(e, i);
	}
	return n;
}
function Lw(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i = Array.from(e.keys()).sort((e, t) => e - t);
	if (i.length === 0) return r;
	let a = i[0], o = e.get(a) ?? [];
	r.set(a, o);
	let s = /* @__PURE__ */ new Map();
	o.forEach((e, t) => s.set(e.id, t));
	for (let a = 1; a < i.length; a++) {
		let o = i[a], c = (e.get(o) ?? []).map((e) => {
			let r = (t.incoming.get(e.id) ?? []).filter((e) => {
				let t = n.get(e);
				return t !== void 0 && t < o;
			});
			return r.length === 0 ? {
				node: e,
				barycenter: 0
			} : {
				node: e,
				barycenter: r.reduce((e, t) => e + (s.get(t) ?? 0), 0) / r.length
			};
		});
		c.sort((e, t) => e.barycenter - t.barycenter);
		let l = c.map((e) => e.node);
		r.set(o, l), l.forEach((e, t) => s.set(e.id, t));
	}
	return r;
}
function Rw(e, t, n, r) {
	let i = [], a = Array.from(e.keys()).sort((e, t) => e - t);
	for (let t of a) {
		let a = e.get(t) ?? [];
		a.forEach((e, o) => {
			let s, c;
			r === "TB" ? (s = -(a.length * n.nodeWidth + (a.length - 1) * n.horizontalSpacing) / 2 + o * (n.nodeWidth + n.horizontalSpacing), c = t * (n.nodeHeight + n.verticalSpacing)) : (s = t * (n.nodeWidth + n.horizontalSpacing), c = -(a.length * n.nodeHeight + (a.length - 1) * n.verticalSpacing) / 2 + o * (n.nodeHeight + n.verticalSpacing)), i.push({
				...e,
				x: s,
				y: c,
				width: n.nodeWidth,
				height: n.nodeHeight,
				layer: t
			});
		});
	}
	return i;
}
function zw(e, t) {
	let n = t?.direction ?? "TB", r = {
		...Mw,
		...t?.spacing
	};
	if (e.length === 0) return {
		nodes: [],
		layers: /* @__PURE__ */ new Map(),
		totalLayers: 0
	};
	let i = Nw(e);
	Pw(e, i);
	let a = Fw(e, i);
	return {
		nodes: Rw(Lw(Iw(e, a), i, a), a, r, n),
		layers: a,
		totalLayers: a.size > 0 ? Math.max(...Array.from(a.values())) + 1 : 0
	};
}
//#endregion
//#region src/components/organisms/WorkflowDAG/edges.ts
var Bw = 8, Vw = 6;
function Hw(e, t) {
	return t === "LR" ? {
		x: e.x + e.width,
		y: e.y + e.height / 2
	} : {
		x: e.x + e.width / 2,
		y: e.y + e.height
	};
}
function Uw(e, t) {
	return t === "LR" ? {
		x: e.x,
		y: e.y + e.height / 2
	} : {
		x: e.x + e.width / 2,
		y: e.y
	};
}
function Ww(e, t, n) {
	let r = Hw(e, n), i = Uw(t, n);
	return n === "TB" ? Gw(r, i) : Kw(r, i);
}
function Gw(e, t) {
	let n = (e.y + t.y) / 2, r = t.x - e.x;
	if (Math.abs(r) < 1) return `M ${e.x} ${e.y} L ${t.x} ${t.y}`;
	let i = Math.min(Bw, Math.abs(n - e.y), Math.abs(r) / 2), a = r > 0 ? 1 : -1;
	return [
		`M ${e.x} ${e.y}`,
		`L ${e.x} ${n - i}`,
		`Q ${e.x} ${n} ${e.x + a * i} ${n}`,
		`L ${t.x - a * i} ${n}`,
		`Q ${t.x} ${n} ${t.x} ${n + i}`,
		`L ${t.x} ${t.y}`
	].join(" ");
}
function Kw(e, t) {
	let n = (e.x + t.x) / 2, r = t.y - e.y;
	if (Math.abs(r) < 1) return `M ${e.x} ${e.y} L ${t.x} ${t.y}`;
	let i = Math.min(Bw, Math.abs(n - e.x), Math.abs(r) / 2), a = r > 0 ? 1 : -1;
	return [
		`M ${e.x} ${e.y}`,
		`L ${n - i} ${e.y}`,
		`Q ${n} ${e.y} ${n} ${e.y + a * i}`,
		`L ${n} ${t.y - a * i}`,
		`Q ${n} ${t.y} ${n + i} ${t.y}`,
		`L ${t.x} ${t.y}`
	].join(" ");
}
function qw(e) {
	let t = [], n = e.match(/[MLQC][^MLQC]*/gi) ?? [], r = 0, i = 0;
	for (let e of n) {
		let n = e[0]?.toUpperCase(), a = e.slice(1).trim().split(/[\s,]+/).map(parseFloat).filter((e) => !isNaN(e));
		switch (n) {
			case "M":
				a.length >= 2 && (r = a[0], i = a[1]);
				break;
			case "L":
				if (a.length >= 2) {
					let e = a[0], n = a[1];
					t.push({
						start: {
							x: r,
							y: i
						},
						end: {
							x: e,
							y: n
						}
					}), r = e, i = n;
				}
				break;
			case "Q":
				if (a.length >= 4) {
					let e = a[2], n = a[3];
					t.push({
						start: {
							x: r,
							y: i
						},
						end: {
							x: e,
							y: n
						}
					}), r = e, i = n;
				}
				break;
			case "C": if (a.length >= 6) {
				let e = a[4], n = a[5];
				t.push({
					start: {
						x: r,
						y: i
					},
					end: {
						x: e,
						y: n
					}
				}), r = e, i = n;
			}
		}
	}
	return t;
}
function Jw(e, t) {
	let n = e.start.x, r = e.start.y, i = e.end.x, a = e.end.y, o = t.start.x, s = t.start.y, c = t.end.x, l = t.end.y, u = (n - i) * (s - l) - (r - a) * (o - c);
	if (Math.abs(u) < 1e-4) return null;
	let d = ((n - o) * (s - l) - (r - s) * (o - c)) / u, f = -((n - i) * (r - s) - (r - a) * (n - o)) / u, p = .01;
	return d >= p && d <= .99 && f >= p && f <= .99 ? {
		x: n + d * (i - n),
		y: r + d * (a - r)
	} : null;
}
function Yw(e, t) {
	let n = qw(e), r = qw(t), i = [];
	for (let e of n) for (let t of r) {
		let n = Jw(e, t);
		n && (i.some((e) => Math.abs(e.x - n.x) < 5 && Math.abs(e.y - n.y) < 5) || i.push(n));
	}
	return i;
}
function Xw(e, t) {
	let n = Math.cos(t), r = Math.sin(t);
	return `M ${e.x - n * Vw} ${e.y - r * Vw} A ${Vw} ${Vw} 0 0 1 ${e.x + n * Vw} ${e.y + r * Vw}`;
}
function Zw(e, t, n) {
	return n === "completed" ? {
		strokeVar: "var(--dag-edge-completed)",
		type: "completed"
	} : n === "failed" ? {
		strokeVar: "var(--dag-edge-failed)",
		type: "failed"
	} : e === "test" && t === "impl" ? {
		strokeVar: "var(--dag-edge-test-dep)",
		type: "test-dep"
	} : {
		strokeVar: "var(--dag-edge-default)",
		type: "default"
	};
}
//#endregion
//#region src/components/organisms/WorkflowDAG/WPNode.tsx
var Qw = {
	completed: "Completed",
	failed: "Failed",
	in_progress: "In Progress",
	blocked: "Blocked",
	pending: "Pending"
}, $w = {
	completed: "bg-emerald-300",
	failed: "bg-rose-300",
	in_progress: "bg-white",
	blocked: "bg-amber-200",
	pending: "bg-white/50"
}, eT = {
	test: {
		icon: yi,
		label: "Test",
		headerBg: "bg-sky-500",
		borderColor: "border-sky-400"
	},
	impl: {
		icon: Yr,
		label: "Impl",
		headerBg: "bg-amber-500",
		borderColor: "border-amber-400"
	}
}, tT = V(({ node: e, isSelected: t = !1, onSelect: n, className: r }, a) => {
	let o = fr(), s = () => {
		n?.(e.id);
	}, c = (t) => {
		(t.key === "Enter" || t.key === " ") && (t.preventDefault(), n?.(e.id));
	}, l = e.status === "in_progress", u = eT[e.type], d = u.icon;
	return /* @__PURE__ */ J("div", {
		ref: a,
		className: "relative w-[200px]",
		children: [
			/* @__PURE__ */ J(xu, {
				variant: "default",
				interactive: !0,
				role: "button",
				tabIndex: 0,
				"aria-label": `Work package ${e.id}: ${e.title}, status ${Qw[e.status]}`,
				"aria-pressed": t,
				className: I("relative p-0 w-full overflow-hidden", !o && "transition-all duration-200", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2", t && "ring-2 ring-amber-400 dark:ring-amber-500 border-amber-300", e.status === "failed" && "border-rose-200 dark:border-rose-800", r),
				onClick: s,
				onKeyDown: c,
				"data-testid": `wp-node-${e.id}`,
				"data-node-id": e.id,
				"data-status": e.status,
				children: [/* @__PURE__ */ J("div", {
					className: I("flex items-center justify-between px-2 py-1 text-white", u.headerBg),
					"data-testid": "type-header",
					children: [/* @__PURE__ */ J("div", {
						className: "flex items-center gap-1",
						children: [/* @__PURE__ */ q(d, { className: "h-3 w-3" }), /* @__PURE__ */ q("span", {
							className: "text-[10px] font-bold uppercase tracking-wide",
							children: u.label
						})]
					}), /* @__PURE__ */ q("span", {
						className: I("h-2 w-2 rounded-full", $w[e.status], l && !o && "animate-blink"),
						"aria-label": Qw[e.status],
						"data-testid": "status-indicator"
					})]
				}), /* @__PURE__ */ J("div", {
					className: "px-2.5 py-2",
					children: [/* @__PURE__ */ q("h4", {
						className: "text-sm font-medium text-slate-900 dark:text-slate-100 line-clamp-2 min-h-[2.5rem]",
						title: e.title,
						children: e.title
					}), /* @__PURE__ */ q("div", {
						className: "mt-1 min-h-[1.25rem]",
						children: e.error ? /* @__PURE__ */ q("div", {
							className: "text-[10px] text-rose-600 dark:text-rose-400 truncate",
							title: e.error,
							"data-testid": "error-text",
							children: e.error
						}) : e.scenarios && e.scenarios.length > 0 ? /* @__PURE__ */ J(i, {
							variant: "muted",
							size: "sm",
							"data-testid": "scenario-count",
							children: [e.scenarios.length, " scenarios"]
						}) : null
					})]
				})]
			}),
			/* @__PURE__ */ q("div", {
				className: "absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-slate-300 dark:bg-slate-600",
				"data-port": "input",
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ q("div", {
				className: "absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-2 h-2 rounded-full bg-slate-300 dark:bg-slate-600",
				"data-port": "output",
				"aria-hidden": "true"
			})
		]
	});
});
tT.displayName = "WPNode";
//#endregion
//#region src/components/organisms/WorkflowDAG/elk-edges.ts
var nT = 8;
function rT(e, t = nT) {
	let n = [
		e.startPoint,
		...e.bendPoints,
		e.endPoint
	];
	if (n.length < 2) return "";
	if (n.length === 2) return `M ${n[0].x} ${n[0].y} L ${n[1].x} ${n[1].y}`;
	let r = `M ${n[0].x} ${n[0].y}`;
	for (let e = 1; e < n.length - 1; e++) {
		let i = n[e - 1], a = n[e], o = n[e + 1], s = Math.hypot(a.x - i.x, a.y - i.y), c = Math.hypot(o.x - a.x, o.y - a.y), l = Math.min(t, s / 2, c / 2);
		if (l < .5) {
			r += ` L ${a.x} ${a.y}`;
			continue;
		}
		let u = a.x - i.x, d = a.y - i.y, f = Math.hypot(u, d), p = o.x - a.x, m = o.y - a.y, h = Math.hypot(p, m), g = a.x - u / f * l, _ = a.y - d / f * l, v = a.x + p / h * l, y = a.y + m / h * l;
		r += ` L ${g} ${_}`, r += ` Q ${a.x} ${a.y} ${v} ${y}`;
	}
	let i = n[n.length - 1];
	return r += ` L ${i.x} ${i.y}`, r;
}
//#endregion
//#region src/components/organisms/WorkflowDAG/WPEdge.tsx
var iT = 5, aT = 13;
function oT(e, t, n) {
	let r = e.startPoint;
	if (t > 0) {
		let n = e.bendPoints.length > 0 ? e.bendPoints[0] : e.endPoint, i = n.x - r.x, a = n.y - r.y, o = Math.hypot(i, a);
		o > t && (r = {
			x: r.x + i / o * t,
			y: r.y + a / o * t
		});
	}
	let i = e.endPoint;
	if (n > 0) {
		let t = e.bendPoints.length > 0 ? e.bendPoints[e.bendPoints.length - 1] : e.startPoint, r = t.x - i.x, a = t.y - i.y, o = Math.hypot(r, a);
		o > n && (i = {
			x: i.x + r / o * n,
			y: i.y + a / o * n
		});
	}
	return {
		edgeId: e.edgeId,
		startPoint: r,
		endPoint: i,
		bendPoints: e.bendPoints
	};
}
var sT = V(({ edge: e, sourceNode: t, targetNode: n, direction: r, allEdgePaths: i, elkRoute: a, sourceStatus: o, className: s }, c) => {
	let l = fr(), u = a ? rT(oT(a, iT, aT)) : Ww(t, n, r), d = Zw(t.type, n.type, o ?? t.status), f = [];
	if (!a && i) {
		let r = Array.from(i.entries()).filter(([t]) => t !== e.id).map(([, e]) => e);
		for (let e of r) {
			let r = Yw(u, e);
			for (let e of r) {
				let r = Math.atan2(n.y - t.y, n.x - t.x);
				f.push(Xw(e, r));
			}
		}
	}
	let p = o === "in_progress" || t.status === "in_progress", m = o === "completed" || t.status === "completed", h = o === "failed" || t.status === "failed", g = `arrowhead-${e.id}`;
	return /* @__PURE__ */ J("g", {
		ref: c,
		className: I("workflow-edge", s),
		"data-testid": `wp-edge-${e.id}`,
		"data-edge-type": e.edgeType,
		children: [
			/* @__PURE__ */ q("defs", { children: /* @__PURE__ */ q("marker", {
				id: g,
				markerWidth: "8",
				markerHeight: "8",
				refX: "0",
				refY: "4",
				orient: "auto",
				markerUnits: "userSpaceOnUse",
				children: /* @__PURE__ */ q("path", {
					d: "M 0 0 L 8 4 L 0 8 Z",
					style: { fill: d.strokeVar }
				})
			}) }),
			/* @__PURE__ */ q("title", { children: `Dependency from ${e.source} to ${e.target}` }),
			/* @__PURE__ */ q("path", {
				d: u,
				fill: "none",
				stroke: "transparent",
				strokeWidth: "12",
				className: "cursor-pointer",
				"data-testid": "edge-hit-area"
			}),
			/* @__PURE__ */ q("path", {
				d: u,
				fill: "none",
				strokeWidth: "2",
				style: { stroke: d.strokeVar },
				className: I(p && !l && "animate-dash", m && "opacity-60", h && "opacity-80"),
				strokeDasharray: p && !l ? "6 4" : void 0,
				markerEnd: `url(#${g})`,
				"data-testid": "edge-path"
			}),
			f.map((e, t) => /* @__PURE__ */ q("path", {
				d: e,
				fill: "none",
				strokeWidth: "2",
				style: { stroke: d.strokeVar },
				"data-testid": "hop-bridge"
			}, t)),
			e.edgeType === "test-to-impl" && (() => {
				let e = a ? (a.startPoint.x + a.endPoint.x) / 2 : (t.x + t.width / 2 + n.x + n.width / 2) / 2, r = a ? (a.startPoint.y + a.endPoint.y) / 2 - 8 : (t.y + t.height + n.y) / 2 - 8;
				return /* @__PURE__ */ q("text", {
					x: e,
					y: r,
					className: "text-[10px] select-none",
					style: { fill: d.strokeVar },
					textAnchor: "middle",
					"data-testid": "edge-label",
					children: "test-dep"
				});
			})()
		]
	});
});
sT.displayName = "WPEdge";
//#endregion
//#region src/components/organisms/WorkflowDAG/PipelineProgress.tsx
var cT = [
	"plan",
	"plan_eval",
	"eval",
	"wp",
	"wp_eval",
	"run",
	"test",
	"post_eval",
	"record"
];
function lT(e) {
	switch (e.status) {
		case "active": return "brand";
		case "completed": return "success";
		case "failed": return "error";
		default: return "muted";
	}
}
var uT = V(({ pipelineState: e, onPhaseFilter: t, className: n }, r) => {
	let a = fr(), o = e?.phases?.length ? e.phases : cT.map((e) => ({
		name: e,
		status: "pending"
	})), s = o.filter((e) => e.status === "completed").length, c = o.length, l = c > 0 ? s / c * 100 : 0;
	return /* @__PURE__ */ J("div", {
		ref: r,
		className: I("flex flex-col gap-2", n),
		role: "region",
		"aria-label": "Pipeline progress",
		"data-testid": "pipeline-progress",
		children: [/* @__PURE__ */ q(Xo, {
			value: l,
			className: "h-2",
			"data-testid": "progress-bar"
		}), /* @__PURE__ */ q("div", {
			className: "flex flex-wrap gap-1.5",
			"data-testid": "phase-badges",
			children: o.map((e) => {
				let n = lT(e), r = e.status === "active", o = e.status === "completed";
				return /* @__PURE__ */ J(i, {
					variant: n,
					size: "sm",
					className: I("cursor-pointer select-none transition-transform", "hover:scale-105", r && !a && "animate-pulse", !r && !o && e.status !== "failed" && "opacity-60"),
					onClick: () => t?.(e.name),
					role: "button",
					tabIndex: 0,
					"aria-label": `Phase ${e.name}: ${e.status}`,
					"data-testid": `phase-badge-${e.name}`,
					"data-phase-status": e.status,
					children: [
						o && /* @__PURE__ */ q("span", {
							"aria-hidden": "true",
							className: "mr-0.5",
							children: "✓"
						}),
						e.name,
						e.score !== void 0 && /* @__PURE__ */ J("span", {
							className: "ml-1 opacity-70",
							children: [
								"(",
								e.score,
								")"
							]
						})
					]
				}, e.name);
			})
		})]
	});
});
uT.displayName = "PipelineProgress";
//#endregion
//#region src/components/organisms/WorkflowDAG/NodeDetails.tsx
var dT = {
	completed: "online",
	failed: "error",
	in_progress: "maintenance",
	blocked: "warning",
	pending: "offline"
}, fT = {
	completed: "Completed",
	failed: "Failed",
	in_progress: "In Progress",
	blocked: "Blocked",
	pending: "Pending"
}, pT = V(({ node: e, onClose: t, onDependencyClick: n, className: r }, a) => {
	let o = W(null), s = W(null);
	return U(() => {
		e && s.current?.focus();
	}, [e]), U(() => {
		if (!e) return;
		let n = (e) => {
			e.key === "Escape" && t();
		};
		return document.addEventListener("keydown", n), () => document.removeEventListener("keydown", n);
	}, [e, t]), e ? /* @__PURE__ */ J("div", {
		ref: (e) => {
			o.current = e, typeof a == "function" ? a(e) : a && (a.current = e);
		},
		className: I("fixed right-0 top-0 h-full w-80 bg-white border-l border-slate-200 shadow-lg", "dark:bg-slate-800 dark:border-slate-700", "overflow-y-auto p-4 z-50", "animate-in slide-in-from-right", r),
		role: "dialog",
		"aria-label": `Details for ${e.id}`,
		"aria-modal": "true",
		onKeyDown: (e) => {
			if (e.key === "Tab" && o.current) {
				let t = o.current.querySelectorAll("button, [tabindex]:not([tabindex=\"-1\"]), a[href]"), n = t[0], r = t[t.length - 1];
				e.shiftKey && document.activeElement === n ? (e.preventDefault(), r?.focus()) : !e.shiftKey && document.activeElement === r && (e.preventDefault(), n?.focus());
			}
		},
		"data-testid": "node-details",
		children: [
			/* @__PURE__ */ J("div", {
				className: "flex items-center justify-between mb-4",
				children: [/* @__PURE__ */ J("div", {
					className: "flex items-center gap-2",
					children: [/* @__PURE__ */ q("span", {
						className: "text-lg font-semibold text-slate-900 dark:text-slate-100",
						children: e.id
					}), /* @__PURE__ */ q(i, {
						variant: e.type === "test" ? "info" : "brand",
						size: "sm",
						children: e.type
					})]
				}), /* @__PURE__ */ q(L, {
					ref: s,
					variant: "ghost",
					size: "icon-sm",
					onClick: t,
					"aria-label": "Close details",
					"data-testid": "close-button",
					children: "✕"
				})]
			}),
			/* @__PURE__ */ J("div", {
				className: "mb-4",
				"data-testid": "status-row",
				children: [
					/* @__PURE__ */ q(iu, {
						status: dT[e.status],
						animate: e.status === "in_progress",
						children: fT[e.status]
					}),
					e.startedAt && /* @__PURE__ */ J("p", {
						className: "text-xs text-slate-500 mt-1",
						children: ["Started: ", new Date(e.startedAt).toLocaleString()]
					}),
					e.completedAt && /* @__PURE__ */ J("p", {
						className: "text-xs text-slate-500",
						children: ["Completed: ", new Date(e.completedAt).toLocaleString()]
					})
				]
			}),
			/* @__PURE__ */ J("div", {
				className: "mb-4",
				children: [/* @__PURE__ */ q("span", {
					className: "text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider",
					children: "Phase"
				}), /* @__PURE__ */ q("div", {
					className: "mt-1",
					children: /* @__PURE__ */ J(i, {
						variant: "muted",
						size: "sm",
						children: ["Phase ", e.phase]
					})
				})]
			}),
			e.dependsOn.length > 0 && /* @__PURE__ */ J("div", {
				className: "mb-4",
				"data-testid": "dependencies-section",
				children: [/* @__PURE__ */ q("span", {
					className: "text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider",
					children: "Depends On"
				}), /* @__PURE__ */ q("div", {
					className: "flex flex-wrap gap-1.5 mt-1",
					children: e.dependsOn.map((e) => /* @__PURE__ */ q(i, {
						variant: "outline",
						size: "sm",
						className: "cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700",
						onClick: () => n?.(e),
						role: "button",
						tabIndex: 0,
						"data-testid": `dep-badge-${e}`,
						children: e
					}, e))
				})]
			}),
			e.scenarios && e.scenarios.length > 0 && /* @__PURE__ */ q("div", {
				className: "mb-4",
				"data-testid": "scenarios-section",
				children: /* @__PURE__ */ J(uo, { children: [/* @__PURE__ */ J(fo, {
					className: "text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider cursor-pointer hover:text-slate-700 dark:hover:text-slate-300",
					children: [
						"Scenarios (",
						e.scenarios.length,
						")"
					]
				}), /* @__PURE__ */ q(po, { children: /* @__PURE__ */ q(Eo, {
					variant: "compact",
					className: "mt-2",
					children: e.scenarios.map((e) => /* @__PURE__ */ q(Oo, {
						className: "text-xs",
						children: e
					}, e))
				}) })] })
			}),
			e.scope && (e.scope.read.length > 0 || e.scope.modify.length > 0) && /* @__PURE__ */ q("div", {
				className: "mb-4",
				"data-testid": "scope-section",
				children: /* @__PURE__ */ J(uo, { children: [/* @__PURE__ */ q(fo, {
					className: "text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider cursor-pointer hover:text-slate-700 dark:hover:text-slate-300",
					children: "Scope"
				}), /* @__PURE__ */ q(po, { children: /* @__PURE__ */ J("div", {
					className: "mt-2 space-y-2",
					children: [e.scope.read.length > 0 && /* @__PURE__ */ J("div", { children: [/* @__PURE__ */ q("span", {
						className: "text-xs text-slate-400",
						children: "Read:"
					}), /* @__PURE__ */ q(Eo, {
						variant: "compact",
						className: "mt-1",
						children: e.scope.read.map((e) => /* @__PURE__ */ q(Oo, {
							className: "text-xs font-mono",
							children: e
						}, e))
					})] }), e.scope.modify.length > 0 && /* @__PURE__ */ J("div", { children: [/* @__PURE__ */ q("span", {
						className: "text-xs text-slate-400",
						children: "Modify:"
					}), /* @__PURE__ */ q(Eo, {
						variant: "compact",
						className: "mt-1",
						children: e.scope.modify.map((e) => /* @__PURE__ */ q(Oo, {
							className: "text-xs font-mono",
							children: e
						}, e))
					})] })]
				}) })] })
			}),
			e.error && /* @__PURE__ */ q("div", {
				className: "p-3 rounded-md bg-rose-50 border border-rose-200 dark:bg-rose-950 dark:border-rose-800",
				role: "alert",
				"data-testid": "error-alert",
				children: /* @__PURE__ */ q("p", {
					className: "text-sm text-rose-700 dark:text-rose-300",
					children: e.error
				})
			})
		]
	}) : null;
});
pT.displayName = "NodeDetails";
//#endregion
//#region src/components/organisms/WorkflowDAG/WorkflowDAG.tsx
var mT = .1, hT = 4, gT = .2, _T = [], vT = [], yT = V(({ workPackages: e, pipelineState: t, direction: n = "TB", selectedNodeId: r, onNodeSelect: a, onNodeAction: o, layoutEngine: s = "elk", className: c }, l) => {
	let { containerRef: u, transform: d, actions: f } = jw({
		minZoom: mT,
		maxZoom: hT,
		zoomStep: gT
	}), [p, m] = G(null), [h, g] = G(""), _ = r ?? p, v = s === "elk", y = Ln(() => {
		let t = [], n = new Map(e.map((e) => [e.id, e]));
		for (let r of e) for (let e of r.dependsOn) {
			let i = n.get(e);
			if (!i) continue;
			let a = i.type === "test" && r.type === "impl" ? "test-to-impl" : "same-type";
			t.push({
				id: `${e}->${r.id}`,
				source: e,
				target: r.id,
				edgeType: a
			});
		}
		return t;
	}, [e]), b = dw(v ? e : _T, v ? y : vT, v ? { direction: n } : void 0), x = Ln(() => v ? null : zw(e, { direction: n }), [
		e,
		n,
		v
	]), S = v ? b.nodes : x?.nodes ?? [], C = b.edgeRoutes, w = Ln(() => {
		if (v) return /* @__PURE__ */ new Map();
		let e = /* @__PURE__ */ new Map(), t = new Map(S.map((e) => [e.id, e]));
		for (let r of y) {
			let i = t.get(r.source), a = t.get(r.target);
			i && a && e.set(r.id, Ww(i, a, n));
		}
		return e;
	}, [
		y,
		S,
		n,
		v
	]), T = Ln(() => {
		if (S.length === 0) return {
			minX: 0,
			minY: 0,
			maxX: 800,
			maxY: 600,
			width: 800,
			height: 600
		};
		let e = Infinity, t = Infinity, n = -Infinity, r = -Infinity;
		for (let i of S) e = Math.min(e, i.x), t = Math.min(t, i.y), n = Math.max(n, i.x + i.width), r = Math.max(r, i.y + i.height);
		return {
			minX: e - 100,
			minY: t - 100,
			maxX: n + 100,
			maxY: r + 100,
			width: n - e + 200,
			height: r - t + 200
		};
	}, [S]), E = Ln(() => {
		let e = /* @__PURE__ */ new Map();
		for (let t of S) {
			let n = e.get(t.layer) ?? [];
			n.push(t), e.set(t.layer, n);
		}
		return Array.from(e.entries()).filter(([, e]) => e.length > 1).map(([e, t]) => ({
			layer: e,
			nodes: t
		}));
	}, [S]), D = H(() => {
		S.length !== 0 && f.fitToScreen(T);
	}, [
		T,
		S.length,
		f
	]);
	In(l, () => ({
		zoomIn: f.zoomIn,
		zoomOut: f.zoomOut,
		fitToScreen: D,
		resetView: f.resetView
	}));
	let O = H((t) => {
		let n = _ === t ? null : t;
		if (a ? a(n) : m(n), n) {
			let t = e.find((e) => e.id === n);
			t && g(`Selected work package ${t.id}: ${t.title}`);
		} else g("Selection cleared");
	}, [
		_,
		a,
		e
	]);
	U(() => {
		let e = (e) => {
			e.key === "Escape" && _ && (a ? a(null) : m(null));
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [_, a]);
	let k = H(() => {
		D();
	}, [D]);
	U(() => {
		v && !b.isLayouting && b.nodes.length > 0 && g(`Layout computed for ${b.nodes.length} work packages`);
	}, [
		v,
		b.isLayouting,
		b.nodes.length
	]);
	let A = Ln(() => {
		if (!u.current) return S;
		let e = u.current.getBoundingClientRect();
		if (e.width === 0 || e.height === 0) return S;
		let t = -d.x / d.k, n = -d.y / d.k, r = (e.width - d.x) / d.k, i = (e.height - d.y) / d.k;
		return S.filter((e) => e.x + e.width >= t - 200 && e.x <= r + 200 && e.y + e.height >= n - 200 && e.y <= i + 200);
	}, [S, d]);
	if (e.length === 0) return /* @__PURE__ */ J("div", {
		className: I("flex flex-col items-center justify-center p-12 text-center", "border border-dashed border-slate-300 rounded-lg", "dark:border-slate-600", c),
		"data-testid": "workflow-dag-empty",
		children: [/* @__PURE__ */ q("p", {
			className: "text-lg font-medium text-slate-500 dark:text-slate-400",
			children: "No work packages generated"
		}), /* @__PURE__ */ q("p", {
			className: "text-sm text-slate-400 dark:text-slate-500 mt-1",
			children: "Work packages are generated during the WP phase of the pipeline."
		})]
	});
	let j = new Map(S.map((e) => [e.id, e])), M = _ ? e.find((e) => e.id === _) ?? null : null;
	return /* @__PURE__ */ J("div", {
		className: I("flex flex-col gap-3 h-full", c),
		"data-testid": "workflow-dag",
		children: [
			t && /* @__PURE__ */ q(uT, { pipelineState: t }),
			/* @__PURE__ */ J("div", {
				ref: u,
				className: I("relative flex-1 overflow-hidden rounded-lg border border-slate-200", "dark:border-slate-700", "cursor-grab active:cursor-grabbing"),
				style: {
					backgroundColor: "var(--dag-canvas-bg)",
					backgroundImage: "radial-gradient(circle, var(--dag-canvas-grid) 1px, transparent 1px)",
					backgroundSize: "20px 20px"
				},
				onDoubleClick: k,
				"data-testid": "dag-canvas",
				role: "img",
				"aria-roledescription": "directed acyclic graph",
				"aria-label": `Workflow DAG with ${e.length} work packages`,
				children: [
					/* @__PURE__ */ J("svg", {
						className: "absolute inset-0 w-full h-full pointer-events-none",
						style: {
							transform: `translate(${d.x}px, ${d.y}px) scale(${d.k})`,
							transformOrigin: "0 0"
						},
						"data-testid": "edge-layer",
						children: [E.map(({ layer: e, nodes: t }) => {
							let n = Math.min(...t.map((e) => e.x)) - 10, r = Math.min(...t.map((e) => e.y)) - 10, i = Math.max(...t.map((e) => e.x + e.width)) + 10, a = Math.max(...t.map((e) => e.y + e.height)) + 10;
							return /* @__PURE__ */ J("g", {
								role: "group",
								"aria-label": `Parallel group: ${t.length} nodes can execute simultaneously`,
								"data-testid": `parallel-group-${e}`,
								children: [/* @__PURE__ */ J("title", { children: [
									"Parallel group: ",
									t.length,
									" nodes can execute simultaneously"
								] }), /* @__PURE__ */ q("rect", {
									x: n,
									y: r,
									width: i - n,
									height: a - r,
									rx: "8",
									style: {
										fill: "var(--dag-group-fill)",
										stroke: "var(--dag-group-stroke)"
									},
									strokeWidth: "1",
									strokeDasharray: "4 4"
								})]
							}, `group-${e}`);
						}), y.map((e) => {
							let t = j.get(e.source), r = j.get(e.target);
							return !t || !r ? null : /* @__PURE__ */ q(sT, {
								edge: e,
								sourceNode: t,
								targetNode: r,
								direction: n,
								allEdgePaths: v ? void 0 : w,
								elkRoute: v ? C.get(e.id) : void 0
							}, e.id);
						})]
					}),
					/* @__PURE__ */ q("div", {
						className: "absolute inset-0",
						style: {
							transform: `translate(${d.x}px, ${d.y}px) scale(${d.k})`,
							transformOrigin: "0 0"
						},
						"data-testid": "node-layer",
						children: A.map((e) => /* @__PURE__ */ q("div", {
							className: "absolute",
							style: {
								left: e.x,
								top: e.y
							},
							children: /* @__PURE__ */ q(tT, {
								node: e,
								isSelected: _ === e.id,
								onSelect: O
							})
						}, e.id))
					}),
					/* @__PURE__ */ J("div", {
						className: "absolute bottom-3 right-3 flex items-center gap-1 bg-white/90 dark:bg-slate-800/90 rounded-md border border-slate-200 dark:border-slate-700 p-1 shadow-sm",
						"data-testid": "zoom-controls",
						children: [
							/* @__PURE__ */ q(L, {
								variant: "ghost",
								size: "icon-sm",
								onClick: f.zoomIn,
								"aria-label": "Zoom in",
								"data-testid": "zoom-in",
								children: "+"
							}),
							/* @__PURE__ */ J(i, {
								variant: "muted",
								size: "sm",
								"data-testid": "zoom-level",
								children: [Math.round(d.k * 100), "%"]
							}),
							/* @__PURE__ */ q(L, {
								variant: "ghost",
								size: "icon-sm",
								onClick: f.zoomOut,
								"aria-label": "Zoom out",
								"data-testid": "zoom-out",
								children: "-"
							}),
							/* @__PURE__ */ q(L, {
								variant: "ghost",
								size: "icon-sm",
								onClick: k,
								"aria-label": "Fit to screen",
								"data-testid": "zoom-fit",
								children: "☐"
							})
						]
					}),
					v && b.isLayouting && S.length === 0 && /* @__PURE__ */ q("div", {
						className: "absolute inset-0 flex items-center justify-center bg-white/50 dark:bg-slate-900/50",
						"data-testid": "elk-loading",
						children: /* @__PURE__ */ q("p", {
							className: "text-sm text-slate-500 dark:text-slate-400",
							children: "Computing layout…"
						})
					}),
					v && b.error && /* @__PURE__ */ q("div", {
						className: "absolute inset-0 flex items-center justify-center bg-white/80 dark:bg-slate-900/80",
						"data-testid": "elk-error",
						children: /* @__PURE__ */ J("p", {
							className: "text-sm text-red-600 dark:text-red-400",
							children: ["Layout error: ", b.error.message]
						})
					})
				]
			}),
			M && /* @__PURE__ */ q(pT, {
				node: M,
				onClose: () => O(_),
				onDependencyClick: (e) => {
					O(e);
				}
			}),
			/* @__PURE__ */ q("div", {
				"aria-live": "polite",
				"aria-atomic": "true",
				className: "sr-only",
				"data-testid": "dag-announcer",
				children: h
			})
		]
	});
});
yT.displayName = "WorkflowDAG";
//#endregion
//#region src/components/organisms/ExecutionLog/ContentBlock.tsx
var bT = {
	default: "bg-slate-50 dark:bg-slate-800",
	blue: "bg-blue-50 dark:bg-blue-500/10",
	amber: "bg-amber-50 dark:bg-amber-500/10",
	emerald: "bg-emerald-50 dark:bg-emerald-500/10",
	rose: "bg-rose-50 dark:bg-rose-500/10",
	fuchsia: "bg-fuchsia-50 dark:bg-fuchsia-500/10",
	violet: "bg-violet-50 dark:bg-violet-500/10"
}, xT = {
	default: "text-slate-700 dark:text-slate-300",
	blue: "text-slate-700 dark:text-slate-300",
	amber: "text-slate-700 dark:text-slate-300",
	emerald: "text-slate-700 dark:text-slate-300",
	rose: "text-rose-700 dark:text-rose-300",
	fuchsia: "text-slate-700 dark:text-slate-300",
	violet: "text-slate-700 dark:text-slate-300"
}, ST = {
	key: "text-purple-600 dark:text-purple-400",
	string: "text-green-600 dark:text-green-400",
	number: "text-blue-600 dark:text-blue-400",
	boolean: "text-amber-600 dark:text-amber-400",
	null: "text-amber-600 dark:text-amber-400",
	plain: ""
}, CT = /("(?:[^"\\]|\\.)*")\s*:|("(?:[^"\\]|\\.)*")|(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b|\b(true|false)\b|\b(null)\b/g;
function wT(e) {
	let t = [], n = 0;
	for (let r of e.matchAll(CT)) {
		if (r.index > n && t.push({
			text: e.slice(n, r.index),
			type: "plain"
		}), r[1] != null) {
			t.push({
				text: r[1],
				type: "key"
			});
			let e = r[0].slice(r[1].length);
			t.push({
				text: e,
				type: "plain"
			});
		} else r[2] == null ? r[3] == null ? r[4] == null ? r[5] != null && t.push({
			text: r[5],
			type: "null"
		}) : t.push({
			text: r[4],
			type: "boolean"
		}) : t.push({
			text: r[3],
			type: "number"
		}) : t.push({
			text: r[2],
			type: "string"
		});
		n = r.index + r[0].length;
	}
	return n < e.length && t.push({
		text: e.slice(n),
		type: "plain"
	}), t;
}
function TT({ content: e, isJson: t, variant: n = "default", label: r, className: i, copyLabel: a = "Copy" }) {
	let [o, s] = G(!1), [c, l] = G(!1), u = typeof e == "string" ? e : JSON.stringify(e, null, 2) ?? "", d = Ln(() => t ? wT(u) : null, [t, u]), f = H((e) => {
		e.stopPropagation(), navigator.clipboard.writeText(u), s(!0), setTimeout(() => s(!1), 2e3);
	}, [u]);
	return /* @__PURE__ */ J("div", {
		className: I("relative group/cb", i),
		children: [r && /* @__PURE__ */ J("button", {
			type: "button",
			className: "mb-1 flex max-w-full items-center gap-1 text-xs text-muted-foreground hover:text-foreground",
			onClick: (e) => {
				e.stopPropagation(), l((e) => !e);
			},
			"aria-expanded": !c,
			children: [q(c ? R : Kt, { className: "h-3 w-3 flex-shrink-0 opacity-50" }), /* @__PURE__ */ q("span", {
				className: "truncate",
				children: r
			})]
		}), /* @__PURE__ */ J("div", {
			className: I("relative rounded-md", bT[n]),
			children: [/* @__PURE__ */ J("div", {
				className: "absolute top-1 right-1 z-10 flex gap-0.5 opacity-0 transition-opacity group-hover/cb:opacity-100 focus-within:opacity-100",
				children: [/* @__PURE__ */ q(L, {
					variant: "ghost",
					size: "xs",
					onClick: (e) => {
						e.stopPropagation(), l((e) => !e);
					},
					className: "h-6 w-6 p-0",
					"aria-label": c ? "Expand" : "Collapse",
					children: q(c ? R : Kt, { className: "h-3 w-3" })
				}), /* @__PURE__ */ q(L, {
					variant: "ghost",
					size: "xs",
					onClick: f,
					className: "h-6 w-6 p-0",
					"aria-label": a,
					children: o ? /* @__PURE__ */ q(un, { className: "h-3 w-3 text-emerald-500" }) : /* @__PURE__ */ q(sn, { className: "h-3 w-3" })
				})]
			}), c ? /* @__PURE__ */ q("button", {
				type: "button",
				className: I("block w-full truncate p-2 pr-16 text-left text-xs font-mono", xT[n]),
				onClick: (e) => {
					e.stopPropagation(), l(!1);
				},
				"aria-label": "Expand",
				children: u || " "
			}) : /* @__PURE__ */ q("pre", {
				className: I("p-2 pr-16 text-xs whitespace-pre-wrap overflow-x-auto font-mono", xT[n]),
				children: d ? d.map((e, t) => e.type === "plain" ? e.text : /* @__PURE__ */ q("span", {
					className: ST[e.type],
					children: e.text
				}, t)) : u
			})]
		})]
	});
}
//#endregion
//#region src/components/organisms/ExecutionLog/RunOutput.tsx
function ET({ output: e, missionId: t, labels: n, onOpen: r }) {
	let { state: i, canOpen: a, open: o, openedRef: s } = l(e, t, r);
	return i.phase === "opened" ? /* @__PURE__ */ q("div", {
		ref: s,
		tabIndex: -1,
		role: "region",
		"aria-label": e.name,
		className: "focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 rounded-md",
		children: /* @__PURE__ */ q(TT, {
			content: i.content,
			isJson: e.isJson,
			variant: "default",
			label: e.name
		})
	}) : /* @__PURE__ */ J("div", {
		className: "rounded-md bg-slate-50 dark:bg-slate-800 px-2.5 py-2 space-y-1.5",
		"data-testid": "kept-output",
		children: [/* @__PURE__ */ q(g, {
			as: "div",
			size: "xs",
			className: "font-mono truncate",
			children: e.name
		}), /* @__PURE__ */ J("div", {
			className: "flex items-center justify-between gap-2",
			children: [/* @__PURE__ */ q(g, {
				as: "p",
				size: "xs",
				color: "muted",
				"aria-live": "polite",
				children: yn(i, n)
			}), a && /* @__PURE__ */ q(L, {
				variant: "outline",
				size: "xs",
				isLoading: i.phase === "opening",
				"aria-label": nt(n, "openKeptOutputNamed", e.name),
				onClick: (e) => {
					e.stopPropagation(), o();
				},
				children: nt(n, "openKeptOutput")
			})]
		})]
	});
}
function DT({ output: e, missionId: t, label: n, labels: r = {}, onOpen: i }) {
	let a = Ce(e), { values: o, described: s } = a;
	return /* @__PURE__ */ J(K, { children: [Cn(a) && /* @__PURE__ */ q(TT, {
		content: o,
		isJson: typeof o != "string",
		variant: "default",
		label: n
	}), s.map((e) => /* @__PURE__ */ q(ET, {
		output: e,
		missionId: t,
		labels: r,
		onOpen: i
	}, e.name))] });
}
//#endregion
//#region src/components/organisms/ExecutionLog/searchConfidence.ts
function OT(e) {
	return e === "search_knowledge";
}
var kT = "rerank degraded: ", AT = /^\s*\[(GOVERNANCE|RETRIEVED EVIDENCE)\b/, jT = /^\s*\{/, MT = /^\s*\[GOVERNANCE [^\]]*\bconfidence=([a-z]+)\]/, NT = /"confidence"\s*:\s*"([a-z]+)"/, PT = /"retrieval_diags"\s*:\s*\[[^\]]*?"(rerank degraded: [^"]*)"/;
function FT(e) {
	try {
		let t = JSON.parse(e);
		return typeof t == "object" && t ? t : null;
	} catch {
		return null;
	}
}
function IT(e) {
	return AT.test(e) || jT.test(e);
}
function LT(e) {
	if (typeof e == "object" && e) return e;
	if (typeof e != "string") return null;
	let t = FT(e);
	if (t) return t;
	if (!AT.test(e)) return null;
	let n = e.indexOf("{"), r = e.lastIndexOf("}");
	return n < 0 || r <= n ? null : FT(e.slice(n, r + 1));
}
function RT(e) {
	return e === "degraded" ? "degraded" : e === "none" ? "none" : null;
}
function zT(e, t) {
	if (t !== void 0 && !OT(t)) return null;
	let n = LT(e);
	if (n) return RT(n.confidence);
	if (typeof e != "string") return null;
	let r = MT.exec(e);
	if (r) return RT(r[1]);
	if (!IT(e)) return null;
	let i = NT.exec(e);
	return i ? RT(i[1]) : null;
}
function BT(e, t) {
	if (t !== void 0 && !OT(t)) return null;
	let n = LT(e);
	return n ? (Array.isArray(n.retrieval_diags) ? n.retrieval_diags : []).find((e) => typeof e == "string" && e.startsWith(kT)) || (typeof n.guidance == "string" && n.guidance ? n.guidance : null) : typeof e != "string" || !IT(e) ? null : PT.exec(e)?.[1] ?? null;
}
//#endregion
//#region src/components/organisms/ExecutionLog/AuditEntryItem.tsx
function VT(e) {
	if (typeof e != "object" || !e) return null;
	let t = e, n = t.error;
	if (n) return {
		summary: typeof n == "string" ? n : n.error_message ?? n.message ?? "Error",
		isError: !0
	};
	let r = t.hits ?? t.results ?? t.provider_raw_response?.results, i = t.message ?? void 0, a = t.query ?? t.provider_response?.query ?? t.provider_raw_response?.query ?? void 0, o = t.provider ?? t.provider_response?.provider ?? t.provider_raw_response?.provider ?? void 0;
	if (r !== void 0 || i || a) {
		let e = Array.isArray(r) ? r : [], t = "";
		return a && (t += `Search: "${a}"`), o && (t += t ? ` (${o})` : o), i && (t += t ? ` — ${i}` : i), !t && e.length > 0 && (t = `${e.length} result${e.length === 1 ? "" : "s"}`), t ||= "Search completed", {
			summary: t,
			hits: e.length > 0 ? e : void 0
		};
	}
	return typeof t.result == "string" ? { summary: t.result } : typeof t.content == "string" ? { summary: t.content } : typeof t.text == "string" ? { summary: t.text } : typeof t.answer == "string" ? { summary: t.answer } : null;
}
function HT({ hits: e }) {
	return /* @__PURE__ */ J("div", {
		className: "space-y-1.5 mt-1.5",
		children: [e.slice(0, 5).map((e, t) => /* @__PURE__ */ J("div", {
			className: "rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 px-2.5 py-2",
			children: [e.title && /* @__PURE__ */ J("div", {
				className: "flex items-center gap-1.5",
				children: [/* @__PURE__ */ q(g, {
					size: "xs",
					weight: "medium",
					className: "truncate",
					children: e.title
				}), e.url && /* @__PURE__ */ q("a", {
					href: e.url,
					target: "_blank",
					rel: "noopener noreferrer",
					className: "flex-shrink-0 text-blue-500 hover:text-blue-600",
					onClick: (e) => e.stopPropagation(),
					children: /* @__PURE__ */ q(ri, { className: "h-3 w-3" })
				})]
			}), e.snippet && /* @__PURE__ */ q(g, {
				size: "xs",
				color: "muted",
				className: "line-clamp-2 mt-0.5",
				children: e.snippet
			})]
		}, t)), e.length > 5 && /* @__PURE__ */ J(g, {
			size: "xs",
			color: "muted",
			children: [
				"+",
				e.length - 5,
				" more"
			]
		})]
	});
}
function UT(e) {
	return e.type === "error" && e.severity === "warning";
}
var WT = "text-amber-500/60 dark:text-amber-400/50";
function GT(e) {
	switch (e.type) {
		case "turn": return {
			icon: Ve,
			className: "text-blue-500/60 dark:text-blue-400/50"
		};
		case "tool_call": {
			let t = e;
			return t.resolved ? t.resolvedSuccess ? {
				icon: tn,
				className: "text-emerald-500/60 dark:text-emerald-400/50"
			} : {
				icon: Ur,
				className: "text-rose-500/60 dark:text-rose-400/50"
			} : {
				icon: xa,
				className: "text-purple-500/60 dark:text-purple-400/50"
			};
		}
		case "tool_result": return e.success ? {
			icon: tn,
			className: "text-emerald-500/60 dark:text-emerald-400/50"
		} : {
			icon: Ur,
			className: "text-rose-500/60 dark:text-rose-400/50"
		};
		case "hitl_request": return e.pending ? {
			icon: qe,
			className: "text-amber-500/60 dark:text-amber-400/50 animate-spin"
		} : {
			icon: pa,
			className: "text-amber-500/60 dark:text-amber-400/50"
		};
		case "hitl_response": return {
			icon: pa,
			className: "text-emerald-500/60 dark:text-emerald-400/50"
		};
		case "node_start": return {
			icon: Vi,
			className: "text-blue-500/60 dark:text-blue-400/50"
		};
		case "node_complete": {
			let t = e;
			if (It(t)) return {
				icon: Vr,
				className: "text-slate-500/60 dark:text-slate-400/50"
			};
			let n = fn(t.success, t.outcome);
			return n === "blocked" ? {
				icon: Zt,
				className: WT
			} : ot(t.success, t.forcedReason) ? {
				icon: Me,
				className: "text-amber-500/60 dark:text-amber-400/50"
			} : n === "succeeded" ? {
				icon: tn,
				className: "text-emerald-500/60 dark:text-emerald-400/50"
			} : {
				icon: Ur,
				className: "text-rose-500/60 dark:text-rose-400/50"
			};
		}
		case "error": return UT(e) ? {
			icon: Me,
			className: "text-amber-500/60 dark:text-amber-400/50"
		} : {
			icon: tt,
			className: "text-rose-500/60 dark:text-rose-400/50"
		};
		case "orchestrator_decision": return {
			icon: Nr,
			className: "text-fuchsia-500/60 dark:text-fuchsia-400/50"
		};
		case "agent_thinking": return {
			icon: T,
			className: "text-violet-500/60 dark:text-violet-400/50"
		};
		case "delegation": {
			let t = e;
			if (t.resolved) {
				let e = fn(t.resolvedSuccess, t.resolvedOutcome);
				return e === "blocked" ? {
					icon: Zt,
					className: WT
				} : e === "succeeded" ? {
					icon: tn,
					className: "text-emerald-500/60 dark:text-emerald-400/50"
				} : {
					icon: Ur,
					className: "text-rose-500/60 dark:text-rose-400/50"
				};
			}
			return {
				icon: xi,
				className: "text-violet-500/60 dark:text-violet-400/50"
			};
		}
		case "delegation_result": {
			let t = e, n = fn(t.success, t.outcome);
			return n === "blocked" ? {
				icon: Dr,
				className: WT
			} : n === "succeeded" ? {
				icon: Dr,
				className: "text-emerald-500/60 dark:text-emerald-400/50"
			} : {
				icon: Dr,
				className: "text-rose-500/60 dark:text-rose-400/50"
			};
		}
		default: return {
			icon: jr,
			className: "opacity-30"
		};
	}
}
function KT({ startTimestamp: e }) {
	let [t, n] = G(() => Date.now() - e);
	return U(() => {
		let t = setInterval(() => n(Date.now() - e), 100);
		return () => clearInterval(t);
	}, [e]), /* @__PURE__ */ q(g, {
		as: "span",
		size: "xs",
		color: "muted",
		className: "tabular-nums",
		children: Pt(t)
	});
}
function qT({ text: e }) {
	return /* @__PURE__ */ J("div", {
		className: "flex items-start gap-2 rounded-md bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-800 px-2.5 py-2",
		children: [/* @__PURE__ */ q(Zt, { className: "h-3.5 w-3.5 text-amber-500 flex-shrink-0 mt-0.5" }), /* @__PURE__ */ q(g, {
			size: "xs",
			className: "text-amber-800 dark:text-amber-300",
			children: e
		})]
	});
}
function JT({ text: e }) {
	return /* @__PURE__ */ J("div", {
		role: "note",
		className: "flex items-start gap-2 rounded-md bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-800 px-2.5 py-2",
		children: [/* @__PURE__ */ q(Me, {
			"aria-hidden": "true",
			className: "h-3.5 w-3.5 text-amber-500 flex-shrink-0 mt-0.5"
		}), /* @__PURE__ */ q(g, {
			size: "xs",
			className: "text-amber-800 dark:text-amber-300",
			children: e
		})]
	});
}
var YT = {
	succeeded: "success",
	failed: "error",
	blocked: "warning"
}, XT = {
	succeeded: "emerald",
	failed: "rose",
	blocked: "amber"
};
function ZT({ state: e, ...t }) {
	return /* @__PURE__ */ q(i, {
		variant: YT[e],
		size: "sm",
		children: t[e]
	});
}
var QT = 1e4;
function $T({ content: e, label: t, variant: n }) {
	let [r, i] = G(!1), a = e.length > QT, o = a && !r ? e.slice(0, QT) + "…" : e;
	return /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q(TT, {
		content: o,
		variant: n,
		label: t
	}), a && /* @__PURE__ */ q(L, {
		variant: "ghost",
		onClick: (e) => {
			e.stopPropagation(), i((e) => !e);
		},
		className: "text-xs text-violet-600 dark:text-violet-400 hover:underline mt-1 h-auto p-0",
		children: r ? "Show less" : `Show full (${e.length.toLocaleString()} chars)`
	})] });
}
var eE = /* @__PURE__ */ new Set([
	"turn",
	"tool_call",
	"tool_result",
	"hitl_request",
	"hitl_response",
	"node_complete",
	"error",
	"orchestrator_decision",
	"agent_thinking",
	"delegation",
	"delegation_result"
]), tE = Pn(function({ entry: e, isLast: t, isNew: n, staggerIndex: r, resolvedToolCallIds: a, labels: o = {}, onOpenOutput: s }) {
	let c = (e, t) => o[e] ?? t, l = c("blocked", $t.blocked), u = e.type === "node_complete" ? ot(e.success, e.forcedReason, o) : void 0, d = e.type === "orchestrator_decision" || e.type === "node_complete" && !e.success || u !== void 0 || e.type === "error", [f, p] = G(d), [m, h] = G(!n);
	U(() => {
		if (n && !m) {
			let e = setTimeout(() => h(!0), r * 60);
			return () => clearTimeout(e);
		}
	}, [
		n,
		m,
		r
	]);
	let { icon: _, className: v } = GT(e), y = ut(e.timestamp), b = eE.has(e.type);
	return /* @__PURE__ */ J("div", {
		id: `audit-entry-${e.id}`,
		className: I("relative group transition-all duration-300 ease-out", n && !m && "opacity-0 translate-y-2", n && m && "opacity-100 translate-y-0"),
		children: [!t && /* @__PURE__ */ q("div", { className: "absolute left-3 top-7 bottom-0 w-px bg-slate-200 dark:bg-slate-700" }), /* @__PURE__ */ J("div", {
			className: I("flex gap-3 py-1.5 rounded-md transition-colors", b && "cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/50", f && "bg-slate-50 dark:bg-slate-800/30"),
			onClick: () => b && p(!f),
			role: b ? "button" : void 0,
			tabIndex: b ? 0 : void 0,
			onKeyDown: b ? (e) => {
				(e.key === "Enter" || e.key === " ") && (e.preventDefault(), p(!f));
			} : void 0,
			children: [/* @__PURE__ */ q("div", {
				className: "flex-shrink-0 w-6 flex items-start justify-center pt-0.5",
				children: /* @__PURE__ */ q(_, { className: I("h-3.5 w-3.5 transition-transform", v, n && m && "animate-[icon-pop_0.4s_ease-out]") })
			}), /* @__PURE__ */ J("div", {
				className: "flex-1 min-w-0",
				children: [/* @__PURE__ */ J("div", {
					className: "flex items-center justify-between gap-2",
					children: [/* @__PURE__ */ J("div", {
						className: "flex items-center gap-1 min-w-0",
						children: [/* @__PURE__ */ q("div", {
							className: "truncate",
							children: (() => {
								switch (e.type) {
									case "turn": return /* @__PURE__ */ q(g, {
										as: "span",
										size: "xs",
										weight: "medium",
										className: "truncate",
										children: e.agentLabel || c("agent", "Agent")
									});
									case "tool_call": {
										let t = e, n = t.resolved || a?.has(t.toolCallId);
										return /* @__PURE__ */ J("span", {
											className: "flex items-center gap-1.5",
											children: [/* @__PURE__ */ q(g, {
												as: "span",
												size: "xs",
												className: "font-mono truncate text-purple-700 dark:text-purple-300",
												children: t.toolName
											}), n && t.resolvedDurationMs != null && t.resolvedDurationMs > 0 ? /* @__PURE__ */ q(g, {
												as: "span",
												size: "xs",
												color: "muted",
												children: Pt(t.resolvedDurationMs)
											}) : n ? null : /* @__PURE__ */ q(KT, { startTimestamp: t.timestamp })]
										});
									}
									case "tool_result": {
										let t = e, n = zT(t.output, t.toolName);
										return /* @__PURE__ */ J("span", {
											className: "flex items-center gap-1.5 min-w-0",
											children: [
												/* @__PURE__ */ q(g, {
													as: "span",
													size: "xs",
													className: "font-mono truncate",
													children: t.toolName || c("toolResult", "Tool result")
												}),
												n === "degraded" && /* @__PURE__ */ q(i, {
													variant: "warning",
													size: "sm",
													children: c("rankingDegraded", "Ranking degraded")
												}),
												n === "none" && /* @__PURE__ */ q(i, {
													variant: "muted",
													size: "sm",
													children: c("noConfidentMatch", "No confident match")
												})
											]
										});
									}
									case "hitl_request": {
										let t = e;
										return /* @__PURE__ */ J("span", {
											className: "flex items-center gap-1.5",
											children: [/* @__PURE__ */ q(g, {
												as: "span",
												size: "xs",
												weight: "medium",
												className: "truncate",
												children: e.agentLabel || c("humanInput", "Human Input")
											}), t.pending && /* @__PURE__ */ q(i, {
												variant: "warning",
												size: "sm",
												children: c("waiting", "waiting...")
											})]
										});
									}
									case "hitl_response": return /* @__PURE__ */ q(g, {
										as: "span",
										size: "xs",
										weight: "medium",
										className: "truncate",
										children: e.userName || c("humanResponse", "Human Response")
									});
									case "node_start": {
										let t = e;
										return /* @__PURE__ */ J(g, {
											as: "span",
											size: "xs",
											children: [
												/* @__PURE__ */ q(g, {
													as: "span",
													color: "muted",
													children: c("started", "Started")
												}),
												" ",
												/* @__PURE__ */ q(g, {
													as: "span",
													weight: "medium",
													children: t.nodeLabel || t.nodeId
												})
											]
										});
									}
									case "node_complete": {
										let t = e, n = fn(t.success, t.outcome);
										return /* @__PURE__ */ J(g, {
											as: "span",
											size: "xs",
											children: [
												n === "blocked" ? /* @__PURE__ */ q(g, {
													as: "span",
													className: "text-amber-600 dark:text-amber-400",
													children: l
												}) : /* @__PURE__ */ q(g, {
													as: "span",
													color: "muted",
													children: It(t) ? c("stopped", "Stopped") : n === "succeeded" ? c("completed", "Completed") : c("failed", "Failed")
												}),
												" ",
												/* @__PURE__ */ q(g, {
													as: "span",
													weight: "medium",
													children: t.nodeLabel || t.nodeId
												}),
												u && /* @__PURE__ */ J(K, { children: [" ", /* @__PURE__ */ q(i, {
													variant: "warning",
													size: "sm",
													children: u.label
												})] })
											]
										});
									}
									case "orchestrator_decision": return /* @__PURE__ */ q(g, {
										as: "span",
										size: "xs",
										weight: "medium",
										className: "truncate",
										children: e.agentLabel || c("orchestrator", "Orchestrator")
									});
									case "agent_thinking": return /* @__PURE__ */ q(g, {
										as: "span",
										size: "xs",
										weight: "medium",
										className: "truncate",
										children: e.agentLabel || c("thinking", "Thinking")
									});
									case "delegation": {
										let t = e;
										return /* @__PURE__ */ J("span", {
											className: "flex items-center gap-1.5",
											children: [
												/* @__PURE__ */ q(g, {
													as: "span",
													size: "xs",
													color: "muted",
													children: c("delegatedTo", "Delegated to")
												}),
												/* @__PURE__ */ q(g, {
													as: "span",
													size: "xs",
													weight: "medium",
													className: "truncate",
													children: t.agentLabel
												}),
												t.resolved && /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q(ZT, {
													state: fn(t.resolvedSuccess, t.resolvedOutcome),
													succeeded: c("succeeded", "succeeded"),
													failed: c("failed", "failed"),
													blocked: l
												}), t.resolvedDurationMs != null && t.resolvedDurationMs > 0 && /* @__PURE__ */ q(g, {
													as: "span",
													size: "xs",
													color: "muted",
													children: Pt(t.resolvedDurationMs)
												})] })
											]
										});
									}
									case "delegation_result": return /* @__PURE__ */ q(g, {
										as: "span",
										size: "xs",
										weight: "medium",
										className: "truncate",
										children: e.agentLabel
									});
									case "error": return UT(e) ? /* @__PURE__ */ q(g, {
										as: "span",
										size: "xs",
										className: "text-amber-600 dark:text-amber-400",
										weight: "medium",
										children: c("warning", "Warning")
									}) : /* @__PURE__ */ q(g, {
										as: "span",
										size: "xs",
										className: "text-rose-600 dark:text-rose-400",
										weight: "medium",
										children: c("error", "Error")
									});
									default: return /* @__PURE__ */ q(g, {
										as: "span",
										size: "xs",
										color: "muted",
										children: e.type
									});
								}
							})()
						}), b && (f ? /* @__PURE__ */ q(R, { className: "h-3 w-3 opacity-30 flex-shrink-0" }) : /* @__PURE__ */ q(ct, { className: "h-3 w-3 opacity-0 group-hover:opacity-30 transition-opacity flex-shrink-0" }))]
					}), /* @__PURE__ */ q(g, {
						as: "span",
						size: "xs",
						color: "subtle",
						className: "flex-shrink-0",
						children: y
					})]
				}), /* @__PURE__ */ q("div", {
					className: I("grid transition-[grid-template-rows] duration-200 ease-out", f ? "grid-rows-[1fr]" : "grid-rows-[0fr]"),
					children: /* @__PURE__ */ q("div", {
						className: "overflow-hidden",
						children: b && /* @__PURE__ */ q("div", {
							className: "mt-2 mb-1",
							children: (() => {
								switch (e.type) {
									case "turn": {
										let t = e;
										return /* @__PURE__ */ J("div", {
											className: "space-y-2 text-xs",
											children: [
												/* @__PURE__ */ J("div", {
													className: "flex justify-between",
													children: [/* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: c("turn", "Turn")
													}), /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														children: t.turnNumber + 1
													})]
												}),
												t.model && /* @__PURE__ */ J("div", {
													className: "flex justify-between",
													children: [/* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: c("model", "Model")
													}), /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														className: "font-mono",
														children: t.model
													})]
												}),
												/* @__PURE__ */ J("div", {
													className: "flex justify-between",
													children: [/* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: c("tokens", "Tokens")
													}), /* @__PURE__ */ J(g, {
														as: "span",
														size: "xs",
														children: [
															gt(t.inputTokens),
															" ",
															c("in", "in"),
															" / ",
															gt(t.outputTokens),
															" ",
															c("out", "out"),
															t.maxOutputTokens ? ` (max ${gt(t.maxOutputTokens)})` : ""
														]
													})]
												}),
												/* @__PURE__ */ J("div", {
													className: "flex justify-between",
													children: [/* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: c("duration", "Duration")
													}), /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														children: Pt(t.durationMs)
													})]
												}),
												t.userPrompt && /* @__PURE__ */ q(TT, {
													content: t.userPrompt,
													variant: "default",
													label: c("userPrompt", "User Prompt"),
													className: "mt-2"
												}),
												t.assistantResponse && /* @__PURE__ */ q(TT, {
													content: t.assistantResponse,
													variant: "blue",
													label: c("response", "Response"),
													className: "mt-2"
												})
											]
										});
									}
									case "tool_call": {
										let t = e, n = t.resolvedError || c("guardDeniedDetail", "Tool not connected to this agent — LLM answered instead.");
										return /* @__PURE__ */ J("div", {
											className: "space-y-2 text-xs",
											children: [/* @__PURE__ */ q(TT, {
												content: t.toolInput,
												isJson: !0,
												variant: "default",
												label: c("input", "Input")
											}), t.resolved && /* @__PURE__ */ J(K, { children: [t.resolvedDeniedByGuard && /* @__PURE__ */ J("div", {
												className: "flex items-start gap-2 rounded-md bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-800 px-2.5 py-2",
												children: [/* @__PURE__ */ q(tt, { className: "h-3.5 w-3.5 text-amber-500 flex-shrink-0 mt-0.5" }), /* @__PURE__ */ q(g, {
													size: "xs",
													className: "text-amber-800 dark:text-amber-300",
													children: n
												})]
											}), t.resolvedError && !t.resolvedDeniedByGuard ? /* @__PURE__ */ q(TT, {
												content: t.resolvedError,
												variant: "rose",
												label: c("error", "Error")
											}) : t.resolvedOutput == null ? null : /* @__PURE__ */ q(TT, {
												content: t.resolvedOutput,
												isJson: typeof t.resolvedOutput != "string",
												variant: "default",
												label: c("output", "Output")
											})] })]
										});
									}
									case "tool_result": {
										let t = e, n = t.output == null ? null : VT(t.output), r = t.output != null && typeof t.output != "string", i = t.error || c("guardDeniedDetail", "Tool not connected to this agent — LLM answered instead."), a = zT(t.output, t.toolName) === "degraded" ? BT(t.output, t.toolName) : null;
										return /* @__PURE__ */ J("div", {
											className: "text-xs space-y-2",
											children: [
												t.deniedByGuard && /* @__PURE__ */ J("div", {
													className: "flex items-start gap-2 rounded-md bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-800 px-2.5 py-2",
													children: [/* @__PURE__ */ q(tt, { className: "h-3.5 w-3.5 text-amber-500 flex-shrink-0 mt-0.5" }), /* @__PURE__ */ q(g, {
														size: "xs",
														className: "text-amber-800 dark:text-amber-300",
														children: i
													})]
												}),
												a && /* @__PURE__ */ J("div", {
													className: "flex items-start gap-2 rounded-md bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-800 px-2.5 py-2",
													children: [/* @__PURE__ */ q(tt, { className: "h-3.5 w-3.5 text-amber-500 flex-shrink-0 mt-0.5" }), /* @__PURE__ */ q(g, {
														size: "xs",
														className: "text-amber-800 dark:text-amber-300",
														children: a
													})]
												}),
												t.error && !t.deniedByGuard ? /* @__PURE__ */ q(TT, {
													content: t.error,
													variant: "rose"
												}) : n?.isError ? /* @__PURE__ */ q(TT, {
													content: n.summary,
													variant: "rose"
												}) : n ? /* @__PURE__ */ J("div", { children: [/* @__PURE__ */ q(g, {
													size: "xs",
													color: "muted",
													children: n.summary
												}), n.hits && /* @__PURE__ */ q(HT, { hits: n.hits })] }) : t.output ? /* @__PURE__ */ q(TT, {
													content: t.output,
													isJson: r,
													variant: "default",
													label: c("output", "Output")
												}) : null,
												t.durationMs > 0 && /* @__PURE__ */ q(g, {
													size: "xs",
													color: "muted",
													children: Pt(t.durationMs)
												})
											]
										});
									}
									case "hitl_request": {
										let t = e;
										return /* @__PURE__ */ J("div", {
											className: "text-xs",
											children: [/* @__PURE__ */ q("div", {
												className: "bg-amber-50 dark:bg-amber-500/10 p-2 rounded-md text-xs text-slate-700 dark:text-slate-300",
												children: t.prompt
											}), t.options && t.options.length > 0 && /* @__PURE__ */ q("div", {
												className: "mt-2 flex flex-wrap gap-1",
												children: t.options.map((e, t) => /* @__PURE__ */ q(i, {
													variant: "default",
													size: "sm",
													children: e
												}, t))
											})]
										});
									}
									case "hitl_response": {
										let t = e;
										return /* @__PURE__ */ J("div", {
											className: "text-xs space-y-2",
											children: [/* @__PURE__ */ q("div", {
												className: "bg-emerald-50 dark:bg-emerald-500/10 p-2 rounded-md text-xs text-slate-700 dark:text-slate-300",
												children: t.response
											}), t.responseTimeMs > 0 && /* @__PURE__ */ J("div", {
												className: "flex justify-between",
												children: [/* @__PURE__ */ q(g, {
													as: "span",
													size: "xs",
													color: "muted",
													children: c("responseTime", "Response time")
												}), /* @__PURE__ */ q(g, {
													as: "span",
													size: "xs",
													children: ln(t.responseTimeMs)
												})]
											})]
										});
									}
									case "node_complete": {
										let t = e;
										if (t.success && !u && t.output == null && t.durationMs == null) return null;
										let n = fn(t.success, t.outcome) === "blocked";
										return /* @__PURE__ */ J("div", {
											className: "space-y-2 text-xs",
											children: [
												u && /* @__PURE__ */ q(JT, { text: u.text }),
												n && /* @__PURE__ */ q(qT, { text: Wt(t.blockedReason, t.nodeLabel || t.nodeId, o) }),
												t.error && !n && /* @__PURE__ */ q(TT, {
													content: t.error,
													variant: "rose",
													label: c("errorDetails", "Error Details")
												}),
												t.output != null && /* @__PURE__ */ q(DT, {
													output: t.output,
													missionId: t.missionId,
													label: c("output", "Output"),
													labels: o,
													onOpen: s
												}),
												t.durationMs != null && /* @__PURE__ */ J("div", {
													className: "flex justify-between",
													children: [/* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: c("duration", "Duration")
													}), /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														children: Pt(t.durationMs)
													})]
												})
											]
										});
									}
									case "error": {
										let t = e;
										return /* @__PURE__ */ J("div", {
											className: "space-y-2 text-xs",
											children: [/* @__PURE__ */ q(TT, {
												content: t.message,
												variant: UT(t) ? "amber" : "rose",
												label: UT(t) ? c("details", "Details") : c("errorMessage", "Error Message")
											}), t.details == null ? null : /* @__PURE__ */ q(TT, {
												content: t.details,
												isJson: typeof t.details != "string",
												variant: "default",
												label: c("details", "Details")
											})]
										});
									}
									case "orchestrator_decision": {
										let t = e;
										return /* @__PURE__ */ J("div", {
											className: "space-y-2 text-xs",
											children: [
												/* @__PURE__ */ J("div", {
													className: "flex items-center gap-1.5",
													children: [/* @__PURE__ */ q(i, {
														variant: t.action === "delegate" ? "purple" : t.action === "complete" ? "success" : t.action === "synthesize" ? "info" : "warning",
														size: "sm",
														children: t.action
													}), t.targetAgent && /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: t.targetAgent
													})]
												}),
												/* @__PURE__ */ q(TT, {
													content: t.reasoning,
													variant: "fuchsia",
													label: c("reasoning", "Reasoning")
												}),
												t.model && /* @__PURE__ */ J("div", {
													className: "flex justify-between",
													children: [/* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: c("model", "Model")
													}), /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														className: "font-mono",
														children: t.model
													})]
												}),
												t.tokensUsed != null && t.tokensUsed > 0 && /* @__PURE__ */ J("div", {
													className: "flex justify-between",
													children: [/* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: c("tokens", "Tokens")
													}), /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														children: gt(t.tokensUsed)
													})]
												})
											]
										});
									}
									case "agent_thinking": {
										let t = e;
										return t.redacted ? /* @__PURE__ */ q("div", {
											className: "text-xs",
											children: /* @__PURE__ */ q(g, {
												as: "span",
												size: "xs",
												color: "muted",
												children: c("thinkingRedactedBody", "Thinking content redacted by model.")
											})
										}) : /* @__PURE__ */ J("div", {
											className: "space-y-2 text-xs",
											children: [/* @__PURE__ */ q($T, {
												content: t.content,
												variant: "violet",
												label: c("thinking", "Thinking")
											}), t.model && /* @__PURE__ */ J("div", {
												className: "flex justify-between",
												children: [/* @__PURE__ */ q(g, {
													as: "span",
													size: "xs",
													color: "muted",
													children: c("model", "Model")
												}), /* @__PURE__ */ q(g, {
													as: "span",
													size: "xs",
													className: "font-mono",
													children: t.model
												})]
											})]
										});
									}
									case "delegation": {
										let t = e, n = fn(t.resolvedSuccess, t.resolvedOutcome);
										return /* @__PURE__ */ J("div", {
											className: "space-y-2 text-xs",
											children: [
												/* @__PURE__ */ q(TT, {
													content: t.task,
													variant: "violet",
													label: c("task", "Task")
												}),
												t.context && /* @__PURE__ */ q(TT, {
													content: t.context,
													variant: "default",
													label: c("context", "Context"),
													className: "mt-2"
												}),
												/* @__PURE__ */ J("div", {
													className: "flex justify-between",
													children: [/* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: c("depth", "Depth")
													}), /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														children: t.depth
													})]
												}),
												t.resolved && /* @__PURE__ */ J(K, { children: [
													n === "blocked" && /* @__PURE__ */ q(qT, { text: Wt(t.resolvedBlockedReason, t.agentLabel || t.agentNodeId, o) }),
													t.resolvedSummary && /* @__PURE__ */ q(TT, {
														content: t.resolvedSummary,
														variant: XT[n],
														label: c("summary", "Summary")
													}),
													t.resolvedError && n !== "blocked" && /* @__PURE__ */ q(TT, {
														content: t.resolvedError,
														variant: "rose",
														label: c("error", "Error")
													}),
													t.resolvedTokensUsed != null && t.resolvedTokensUsed > 0 && /* @__PURE__ */ J("div", {
														className: "flex justify-between",
														children: [/* @__PURE__ */ q(g, {
															as: "span",
															size: "xs",
															color: "muted",
															children: c("tokens", "Tokens")
														}), /* @__PURE__ */ q(g, {
															as: "span",
															size: "xs",
															children: gt(t.resolvedTokensUsed)
														})]
													})
												] })
											]
										});
									}
									case "delegation_result": {
										let t = e, n = fn(t.success, t.outcome);
										return /* @__PURE__ */ J("div", {
											className: "space-y-2 text-xs",
											children: [
												/* @__PURE__ */ J("div", {
													className: "flex items-center gap-1.5",
													children: [/* @__PURE__ */ q(ZT, {
														state: n,
														succeeded: c("succeeded", "succeeded"),
														failed: c("failed", "failed"),
														blocked: l
													}), t.durationMs > 0 && /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: Pt(t.durationMs)
													})]
												}),
												n === "blocked" && /* @__PURE__ */ q(qT, { text: Wt(t.blockedReason, t.agentLabel || t.agentNodeId, o) }),
												t.summary && /* @__PURE__ */ q(TT, {
													content: t.summary,
													variant: XT[n],
													label: c("summary", "Summary")
												}),
												t.error && n !== "blocked" && /* @__PURE__ */ q(TT, {
													content: t.error,
													variant: "rose"
												}),
												t.tokensUsed != null && t.tokensUsed > 0 && /* @__PURE__ */ J("div", {
													className: "flex justify-between",
													children: [/* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														color: "muted",
														children: c("tokens", "Tokens")
													}), /* @__PURE__ */ q(g, {
														as: "span",
														size: "xs",
														children: gt(t.tokensUsed)
													})]
												})
											]
										});
									}
									default: return null;
								}
							})()
						})
					})
				})]
			})]
		})]
	});
}), nE = Pn(function({ group: e, defaultExpanded: t = !1, children: n }) {
	let [r, i] = G(t);
	return /* @__PURE__ */ J("div", {
		className: "mb-0.5",
		children: [/* @__PURE__ */ J("div", {
			className: I("flex items-center gap-1.5 py-1.5 px-1 rounded-md cursor-pointer transition-colors", "hover:bg-slate-50 dark:hover:bg-slate-800/50", r && "bg-slate-50/50 dark:bg-slate-800/20"),
			onClick: () => i(!r),
			role: "button",
			tabIndex: 0,
			onKeyDown: (e) => {
				(e.key === "Enter" || e.key === " ") && (e.preventDefault(), i(!r));
			},
			children: [
				/* @__PURE__ */ q("div", {
					className: "flex-shrink-0 w-4 flex items-center justify-center",
					children: q(r ? R : ct, { className: "h-3 w-3 opacity-40" })
				}),
				/* @__PURE__ */ q("div", {
					className: "flex-shrink-0 w-4 flex items-center justify-center",
					children: e.status === "running" ? /* @__PURE__ */ J("span", {
						className: "relative flex h-2 w-2",
						children: [/* @__PURE__ */ q("span", { className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" }), /* @__PURE__ */ q("span", { className: "relative inline-flex rounded-full h-2 w-2 bg-blue-500" })]
					}) : e.status === "failed" ? /* @__PURE__ */ q(Ur, { className: "h-3.5 w-3.5 text-rose-500/70 dark:text-rose-400/60" }) : /* @__PURE__ */ q(tn, { className: "h-3.5 w-3.5 text-emerald-500/70 dark:text-emerald-400/60" })
				}),
				/* @__PURE__ */ q(g, {
					as: "span",
					size: "xs",
					weight: "medium",
					className: "truncate flex-1 min-w-0",
					children: e.summary
				}),
				e.durationMs > 0 && /* @__PURE__ */ q(g, {
					as: "span",
					size: "xs",
					color: "muted",
					className: "flex-shrink-0 tabular-nums",
					children: Pt(e.durationMs)
				})
			]
		}), /* @__PURE__ */ q("div", {
			className: I("grid transition-[grid-template-rows] duration-200 ease-out", r ? "grid-rows-[1fr]" : "grid-rows-[0fr]"),
			children: /* @__PURE__ */ q("div", {
				className: "overflow-hidden",
				children: r && /* @__PURE__ */ q("div", {
					className: "mt-0.5",
					children: n
				})
			})
		})]
	});
});
//#endregion
//#region src/components/organisms/ExecutionLog/StatsSummary.tsx
function rE({ value: e }) {
	let [t, n] = G(!1), r = W(e);
	return U(() => {
		if (r.current !== e) {
			r.current = e, n(!0);
			let t = setTimeout(() => n(!1), 600);
			return () => clearTimeout(t);
		}
	}, [e]), /* @__PURE__ */ q(g, {
		weight: "semibold",
		className: "text-sm leading-tight",
		children: /* @__PURE__ */ q("span", {
			className: I("transition-colors duration-500", t && "text-blue-500 dark:text-blue-400"),
			children: e
		})
	});
}
function iE({ stats: e, isExecuting: t, labels: n, cardClassName: r }) {
	let i = [
		{
			icon: Ci,
			label: n?.turns ?? "Turns",
			value: e.turnCount
		},
		{
			icon: xa,
			label: n?.tools ?? "Tools",
			value: e.toolCallCount
		},
		{
			icon: Ca,
			label: n?.tokens ?? "Tokens",
			value: gt(e.tokenUsage.totalTokens)
		},
		{
			icon: Gr,
			label: n?.duration ?? "Duration",
			value: Pt(e.totalDurationMs)
		}
	];
	return /* @__PURE__ */ q("div", {
		className: "grid grid-cols-2 gap-2",
		children: i.map(({ icon: e, label: t, value: n }) => /* @__PURE__ */ J("div", {
			className: I("flex items-center gap-2.5 rounded-lg px-3 py-2.5", r ?? "bg-slate-50 dark:bg-slate-800/50"),
			children: [/* @__PURE__ */ q(e, { className: "h-4 w-4 opacity-30 flex-shrink-0" }), /* @__PURE__ */ J("div", {
				className: "min-w-0",
				children: [/* @__PURE__ */ q(g, {
					size: "xs",
					color: "muted",
					className: "leading-none",
					children: t
				}), /* @__PURE__ */ q(rE, { value: n })]
			})]
		}, t))
	});
}
//#endregion
//#region src/components/organisms/ExecutionLog/TokenBreakdown.tsx
function aE({ stats: e, labels: t }) {
	let [n, r] = G(!1), i = Object.keys(e.tokenUsage.byModel).length > 0;
	return /* @__PURE__ */ J("div", {
		className: "rounded-lg border border-slate-200 dark:border-slate-700 overflow-hidden",
		children: [/* @__PURE__ */ J(L, {
			variant: "ghost",
			onClick: () => r(!n),
			className: "w-full flex items-center justify-between px-3 py-2 h-auto bg-slate-50 dark:bg-slate-800/50 hover:bg-slate-100 dark:hover:bg-slate-800 text-left",
			children: [/* @__PURE__ */ J("div", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ q(Zr, { className: "h-4 w-4 opacity-30" }), /* @__PURE__ */ q(g, {
					as: "span",
					size: "sm",
					weight: "medium",
					children: t?.tokenUsage ?? "Token Usage"
				})]
			}), /* @__PURE__ */ J("div", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ J(g, {
					as: "span",
					size: "xs",
					color: "muted",
					children: [
						gt(e.tokenUsage.totalInputTokens),
						" ",
						t?.in ?? "in",
						" / ",
						gt(e.tokenUsage.totalOutputTokens),
						" ",
						t?.out ?? "out"
					]
				}), i && q(n ? R : ct, { className: "h-3.5 w-3.5 opacity-40" })]
			})]
		}), n && i && /* @__PURE__ */ q("div", {
			className: "px-3 py-2 space-y-1.5 border-t border-slate-200 dark:border-slate-700",
			children: Object.entries(e.tokenUsage.byModel).map(([e, t]) => /* @__PURE__ */ J("div", {
				className: "flex justify-between items-center",
				children: [/* @__PURE__ */ q(g, {
					size: "xs",
					className: "font-mono text-slate-500 dark:text-slate-400 truncate mr-2",
					children: e
				}), /* @__PURE__ */ J(g, {
					size: "xs",
					color: "muted",
					className: "flex-shrink-0",
					children: [
						gt(t.input),
						" / ",
						gt(t.output)
					]
				})]
			}, e))
		})]
	});
}
//#endregion
//#region src/components/organisms/ExecutionLog/ErrorSummary.tsx
var oE = (e) => It(e) ? "stopped" : fn(e.success, e.outcome), sE = (e) => ot(e.success, e.forcedReason) !== void 0, cE = 80;
function lE({ entries: e, onJumpToEntry: t, labels: n }) {
	let [r, i] = G(!1), a = Ln(() => e.filter((e) => e.type === "error" && e.severity !== "warning" || e.type === "node_complete" && oE(e) === "failed" || e.type === "tool_result" && !e.success), [e]), o = Ln(() => e.filter((e) => e.type === "error" && e.severity === "warning" || e.type === "node_complete" && oE(e) === "blocked" || e.type === "node_complete" && sE(e) || e.type === "tool_result" && e.success && zT(e.output, e.toolName) === "degraded"), [e]);
	if (a.length === 0 && o.length === 0) return null;
	let s = (e) => {
		switch (e.type) {
			case "error": return e.message;
			case "node_complete": return `Node failed: ${e.nodeLabel || e.nodeId}`;
			case "tool_result": {
				let t = e;
				return `${t.toolName || "Tool"}: ${t.error || (t.output && typeof t.output == "object" && "error" in t.output ? t.output.error?.error_message ?? "failed" : "failed")}`;
			}
			default: return e.type;
		}
	}, c = n?.rankingDegraded ?? "Ranking degraded", l = (e) => {
		let t = n?.andMore;
		return typeof t == "function" ? t(e) : t ?? `+${e} more`;
	}, u = (e) => {
		if (e.type === "error") return e.message;
		if (e.type === "node_complete") {
			let t = e;
			return `${sE(t) ? n?.forced ?? Et.forced : n?.blocked ?? $t.blocked}: ${t.nodeLabel || t.nodeId}`;
		}
		let t = e, r = t.toolName || "Tool", i = BT(t.output, t.toolName)?.slice(0, cE);
		return i ? `${r}: ${c} — ${i}` : `${r}: ${c}`;
	}, d = a.length, f = o.length, p = d > 0, m = f > 0, h = !p && m, _ = n?.errorCount ?? `${d} error${d === 1 ? "" : "s"}`, v = n?.warningCount ?? `${f} warning${f === 1 ? "" : "s"}`, y = p && m ? `${_}, ${v}` : p ? _ : v;
	return /* @__PURE__ */ J("div", {
		className: I("flex-shrink-0 mb-3 rounded-md border", h ? "border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/20" : "border-rose-200 dark:border-rose-800 bg-rose-50 dark:bg-rose-900/20"),
		children: [/* @__PURE__ */ J(L, {
			variant: "ghost",
			className: "w-full flex items-center justify-between px-3 py-2 text-left h-auto",
			onClick: () => i(!r),
			children: [/* @__PURE__ */ J("div", {
				className: "flex items-center gap-2",
				children: [h ? /* @__PURE__ */ q(Me, { className: "h-3.5 w-3.5 text-amber-500 flex-shrink-0" }) : /* @__PURE__ */ q(Ur, { className: "h-3.5 w-3.5 text-rose-500 flex-shrink-0" }), /* @__PURE__ */ q(g, {
					size: "xs",
					weight: "medium",
					className: h ? "text-amber-700 dark:text-amber-400" : "text-rose-700 dark:text-rose-400",
					children: y
				})]
			}), /* @__PURE__ */ q(R, { className: I("h-3.5 w-3.5 transition-transform", h ? "text-amber-400" : "text-rose-400", !r && "-rotate-90") })]
		}), r && /* @__PURE__ */ J("div", {
			className: "px-3 pb-2 space-y-1",
			children: [
				a.slice(0, 5).map((e) => /* @__PURE__ */ q(L, {
					variant: "ghost",
					className: "w-full text-left text-xs text-rose-600 dark:text-rose-400 hover:underline truncate block h-auto p-0",
					onClick: () => t(e.id),
					children: s(e)
				}, e.id)),
				d > 5 && /* @__PURE__ */ q(g, {
					size: "xs",
					color: "muted",
					children: l(d - 5)
				}),
				o.slice(0, 5).map((e) => /* @__PURE__ */ q(L, {
					variant: "ghost",
					className: "w-full text-left text-xs text-amber-600 dark:text-amber-400 hover:underline truncate block h-auto p-0",
					onClick: () => t(e.id),
					children: u(e)
				}, e.id)),
				f > 5 && /* @__PURE__ */ q(g, {
					size: "xs",
					color: "muted",
					children: l(f - 5)
				})
			]
		})]
	});
}
//#endregion
//#region src/components/organisms/PageSection/PageSection.tsx
var uE = V(({ title: e, description: t, icon: n, actions: r, divider: i = !0, className: a, children: o, ...s }, c) => /* @__PURE__ */ J("section", {
	ref: c,
	className: I("px-4", i && "border-t border-slate-200 dark:border-slate-700 pt-6 mt-6", !i && "mt-2", a),
	...s,
	children: [/* @__PURE__ */ J("div", {
		className: "flex items-start justify-between mb-4",
		children: [/* @__PURE__ */ J("div", {
			className: "min-w-0",
			children: [/* @__PURE__ */ J("div", {
				className: "flex items-center gap-2",
				children: [n && /* @__PURE__ */ q("span", {
					className: "shrink-0 text-slate-400 dark:text-slate-500",
					children: n
				}), /* @__PURE__ */ q("h2", {
					className: "text-base font-semibold text-slate-900 dark:text-slate-100",
					children: e
				})]
			}), t && /* @__PURE__ */ q("p", {
				className: "mt-1 text-xs text-slate-500 dark:text-slate-400",
				children: t
			})]
		}), r && /* @__PURE__ */ q("div", {
			className: "flex items-center gap-2 shrink-0 ml-4",
			children: r
		})]
	}), o]
}));
uE.displayName = "PageSection";
//#endregion
//#region src/components/chat/shared/AnimatedDots.tsx
var dE = {
	sm: "h-1 w-1",
	md: "h-1.5 w-1.5"
}, fE = {
	default: "bg-slate-400 dark:bg-slate-500",
	brand: "bg-purple-500 dark:bg-purple-400",
	agent: "bg-purple-500 dark:bg-purple-400",
	user: "bg-sky-500 dark:bg-sky-400"
}, pE = ({ size: e = "md", variant: t = "default", className: n }) => /* @__PURE__ */ q("span", {
	className: I("inline-flex items-center gap-1", n),
	children: [
		0,
		1,
		2
	].map((n) => /* @__PURE__ */ q("span", {
		className: I(dE[e], "rounded-full animate-fade-pulse", fE[t]),
		style: { animationDelay: `${n * 150}ms` }
	}, n))
});
pE.displayName = "AnimatedDots";
//#endregion
//#region src/components/chat/AgentActivity/AgentActivity.tsx
var mE = ({ children: e, className: t, isLast: n }) => /* @__PURE__ */ J("div", {
	className: "flex flex-col items-center",
	children: [/* @__PURE__ */ q("div", {
		className: I("flex items-center justify-center h-8 w-8 rounded-full shrink-0", t),
		children: e
	}), !n && /* @__PURE__ */ q("div", { className: "w-px flex-1 bg-slate-200 dark:bg-slate-700 min-h-[16px]" })]
}), hE = {
	started: {
		icon: Vi,
		color: "text-sky-500",
		bgColor: "bg-sky-100 dark:bg-sky-900/50"
	},
	running: {
		icon: qe,
		color: "text-amber-500",
		bgColor: "bg-amber-100 dark:bg-amber-900/50",
		spin: !0
	},
	completed: {
		icon: tn,
		color: "text-emerald-500",
		bgColor: "bg-emerald-100 dark:bg-emerald-900/50"
	},
	failed: {
		icon: Ur,
		color: "text-rose-500",
		bgColor: "bg-rose-100 dark:bg-rose-900/50"
	},
	blocked: {
		icon: Zt,
		color: "text-amber-500",
		bgColor: "bg-amber-100 dark:bg-amber-900/50"
	},
	waiting: {
		icon: Gr,
		color: "text-slate-500",
		bgColor: "bg-slate-100 dark:bg-slate-800"
	}
}, gE = {
	failed: "text-rose-600 dark:text-rose-400",
	blocked: "text-amber-700 dark:text-amber-400"
}, _E = (e) => e < 60 ? `${e.toFixed(1)}s` : `${Math.floor(e / 60)}m ${(e % 60).toFixed(0)}s`, vE = V(({ className: e, agentName: t, status: n, activity: r, icon: a, duration: o, result: s, isLast: c, approved: l, blockedLabel: u, ...d }, f) => {
	let p = hE[n], m = p.icon;
	return /* @__PURE__ */ J("div", {
		ref: f,
		className: I("flex items-start gap-3 min-w-0", e),
		...d,
		children: [/* @__PURE__ */ q(mE, {
			className: p.bgColor,
			isLast: c,
			children: a || /* @__PURE__ */ q(m, { className: I("h-4 w-4", p.color, p.spin && "animate-spin") })
		}), /* @__PURE__ */ J("div", {
			className: I("flex-1 min-w-0 min-h-8 flex flex-col justify-center px-3 -ml-1", !c && "pb-4"),
			children: [
				/* @__PURE__ */ J("div", {
					className: "flex items-center gap-2",
					children: [
						/* @__PURE__ */ q("span", {
							className: "text-sm font-medium text-slate-900 dark:text-slate-100",
							children: t
						}),
						l && /* @__PURE__ */ q(ie, { className: "h-3.5 w-3.5 text-emerald-500" }),
						n === "blocked" && /* @__PURE__ */ q(i, {
							variant: "warning",
							size: "sm",
							children: u ?? "Blocked by setup"
						}),
						o !== void 0 && /* @__PURE__ */ q("span", {
							className: "text-sm text-slate-400 dark:text-slate-500 tabular-nums",
							children: _E(o)
						})
					]
				}),
				r && /* @__PURE__ */ q("p", {
					className: "text-sm text-slate-600 dark:text-slate-400",
					children: r
				}),
				s && /* @__PURE__ */ q("p", {
					className: I("text-sm mt-1", gE[n] ?? "text-slate-500 dark:text-slate-400"),
					children: s
				})
			]
		})]
	});
});
vE.displayName = "AgentActivity";
var yE = {
	allow: {
		icon: ie,
		color: "text-emerald-500",
		label: "Allowed"
	},
	deny: {
		icon: Zt,
		color: "text-rose-500",
		label: "Denied"
	},
	obfuscate: {
		icon: Me,
		color: "text-amber-500",
		label: "Masked"
	},
	escalate: {
		icon: Yi,
		color: "text-sky-500",
		label: "Escalated"
	},
	audit: {
		icon: $i,
		color: "text-slate-500",
		label: "Logged"
	}
}, bE = V(({ className: e, agentName: t = "Assistant", children: n, isLoading: r, icon: i, isLast: a, governance: o, showFeedback: s, onFeedback: c, showCopy: l, onCopy: u, copyContent: d, showHeader: f = !0, ...p }, m) => {
	let [h, g] = G(null), [_, v] = G(!1), [y, b] = G(!1), x = (e) => {
		h === e ? g(null) : (g(e), c?.(e));
	}, S = async () => {
		if (u) u(), b(!0);
		else if (d) try {
			await navigator.clipboard.writeText(d), b(!0);
		} catch (e) {
			console.error("Failed to copy:", e);
		}
		y || setTimeout(() => b(!1), 2e3);
	}, C = o?.action === "allow", w = o && o.action !== "allow", T = w ? yE[o.action].icon : null, E = w ? yE[o.action] : null, D = o?.reason || o?.trustTier;
	return /* @__PURE__ */ J("div", {
		ref: m,
		className: I("flex items-start gap-3 min-w-0", e),
		...p,
		children: [f ? /* @__PURE__ */ q(mE, {
			className: "bg-slate-100 dark:bg-slate-800",
			isLast: a,
			children: i || /* @__PURE__ */ q(jr, { className: "h-4 w-4 text-slate-500 dark:text-slate-400" })
		}) : /* @__PURE__ */ q("div", { className: "w-8 shrink-0" }), /* @__PURE__ */ J("div", {
			className: I("flex-1 min-w-0 min-h-8 px-3 -ml-1", !a && "pb-4"),
			children: [
				f && /* @__PURE__ */ J("div", {
					className: "flex items-center gap-2 min-h-8",
					children: [
						/* @__PURE__ */ q("span", {
							className: "text-sm font-medium text-slate-900 dark:text-slate-100",
							children: t
						}),
						C && /* @__PURE__ */ q(ie, { className: "h-3.5 w-3.5 text-emerald-500" }),
						w && T && E && /* @__PURE__ */ J("button", {
							type: "button",
							onClick: D ? () => v(!_) : void 0,
							className: I("inline-flex items-center gap-1 text-sm", D && "cursor-pointer hover:opacity-80"),
							children: [
								/* @__PURE__ */ q(T, { className: I("h-3.5 w-3.5", E.color) }),
								/* @__PURE__ */ q("span", {
									className: E.color,
									children: E.label
								}),
								D && /* @__PURE__ */ q(R, { className: I("h-3 w-3 text-slate-400 transition-transform", _ && "rotate-180") })
							]
						})
					]
				}),
				_ && D && /* @__PURE__ */ J("div", {
					className: "mb-2 px-2.5 py-1.5 rounded text-sm leading-relaxed bg-slate-50 border border-slate-100 text-slate-600 dark:bg-slate-900 dark:border-slate-800 dark:text-slate-400",
					children: [o?.reason && /* @__PURE__ */ q("p", { children: o.reason }), o?.trustTier && /* @__PURE__ */ q("p", {
						className: "text-slate-400 dark:text-slate-500 mt-0.5",
						children: o.trustTier
					})]
				}),
				r ? /* @__PURE__ */ q("div", {
					className: "flex items-center gap-2 py-1",
					children: /* @__PURE__ */ q(pE, {})
				}) : /* @__PURE__ */ q("div", {
					className: "text-sm text-slate-700 dark:text-slate-300 leading-relaxed break-words [overflow-wrap:anywhere]",
					children: n
				}),
				(s || l) && !r && /* @__PURE__ */ q("div", {
					className: "mt-2",
					children: /* @__PURE__ */ J("div", {
						className: I("flex items-center gap-0.5 transition-opacity", h || y ? "opacity-100" : "opacity-40 hover:opacity-100"),
						children: [l && /* @__PURE__ */ q("button", {
							type: "button",
							onClick: S,
							className: I("p-1 rounded transition-colors", y ? "text-emerald-500" : "text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"),
							"aria-label": y ? "Copied" : "Copy message",
							children: q(y ? un : sn, { className: "h-3 w-3" })
						}), s && /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q("button", {
							type: "button",
							onClick: () => x("positive"),
							className: I("p-1 rounded transition-colors", h === "positive" ? "text-emerald-500" : "text-slate-400 hover:text-emerald-500"),
							"aria-label": "Helpful",
							"aria-pressed": h === "positive",
							children: /* @__PURE__ */ q(aa, { className: I("h-3 w-3", h === "positive" && "fill-current") })
						}), /* @__PURE__ */ q("button", {
							type: "button",
							onClick: () => x("negative"),
							className: I("p-1 rounded transition-colors", h === "negative" ? "text-rose-500" : "text-slate-400 hover:text-rose-500"),
							"aria-label": "Not helpful",
							"aria-pressed": h === "negative",
							children: /* @__PURE__ */ q(sa, { className: I("h-3 w-3", h === "negative" && "fill-current") })
						})] })]
					})
				})
			]
		})]
	});
});
bE.displayName = "AgentResponse";
var xE = V(({ className: e, userName: t = "You", children: n, avatar: r, initials: i, isLast: a, isCurrentUser: o, showHeader: s = !0, ...c }, l) => {
	let u = i || t.split(" ").map((e) => e[0]).join("").toUpperCase().slice(0, 2), d = o ?? t === "You", f = r ? /* @__PURE__ */ q("div", {
		className: "relative w-5 h-5 flex items-center justify-center",
		children: r
	}) : /* @__PURE__ */ q("span", {
		className: I("text-xs font-semibold", d ? "text-sky-700 dark:text-sky-300" : "text-indigo-700 dark:text-indigo-300"),
		children: u
	});
	return /* @__PURE__ */ J("div", {
		ref: l,
		className: I("flex items-start gap-3 min-w-0", e),
		...c,
		children: [s ? /* @__PURE__ */ q(mE, {
			className: d ? "bg-sky-200 dark:bg-sky-800" : "bg-indigo-200 dark:bg-indigo-800",
			isLast: a,
			children: f
		}) : /* @__PURE__ */ q("div", { className: "w-8 shrink-0" }), /* @__PURE__ */ q("div", {
			className: I("flex-1 min-w-0 min-h-8", !a && "pb-4"),
			children: /* @__PURE__ */ J("div", {
				className: I("rounded-lg px-3 py-2 -ml-1 border", d ? "bg-sky-50 border-sky-200 dark:bg-sky-950/60 dark:border-sky-800" : "bg-indigo-50 border-indigo-200 dark:bg-indigo-950/60 dark:border-indigo-800"),
				children: [s && /* @__PURE__ */ q("div", {
					className: "flex items-center gap-2 min-h-5",
					children: /* @__PURE__ */ q("span", {
						className: I("text-sm font-medium", d ? "text-sky-900 dark:text-sky-100" : "text-indigo-900 dark:text-indigo-100"),
						children: t
					})
				}), /* @__PURE__ */ q("div", {
					className: "text-sm text-slate-700 dark:text-slate-300 leading-relaxed break-words [overflow-wrap:anywhere]",
					children: n
				})]
			})
		})]
	});
});
xE.displayName = "UserMessage";
var SE = {
	info: {
		icon: ye,
		bgColor: "bg-slate-100 dark:bg-slate-800",
		iconColor: "text-slate-500"
	},
	warning: {
		icon: Me,
		bgColor: "bg-amber-100 dark:bg-amber-900/50",
		iconColor: "text-amber-500"
	},
	success: {
		icon: tn,
		bgColor: "bg-emerald-100 dark:bg-emerald-900/50",
		iconColor: "text-emerald-500"
	},
	error: {
		icon: Ur,
		bgColor: "bg-rose-100 dark:bg-rose-900/50",
		iconColor: "text-rose-500"
	}
}, CE = V(({ className: e, children: t, variant: n = "info", isLast: r, ...i }, a) => {
	let o = SE[n], s = o.icon;
	return /* @__PURE__ */ J("div", {
		ref: a,
		className: I("flex items-start gap-3 min-w-0", e),
		...i,
		children: [/* @__PURE__ */ q(mE, {
			className: o.bgColor,
			isLast: r,
			children: /* @__PURE__ */ q(s, { className: I("h-4 w-4", o.iconColor) })
		}), /* @__PURE__ */ q("div", {
			className: I("flex-1 min-w-0 min-h-8 flex items-center px-3 -ml-1", !r && "pb-4"),
			children: /* @__PURE__ */ q("div", {
				className: "text-sm text-slate-500 dark:text-slate-400 italic",
				children: t
			})
		})]
	});
});
CE.displayName = "SystemMessage";
var wE = V(({ className: e, agentName: t = "Agent", currentStep: n, steps: r = [], isComplete: i = !1, expandable: a = !0, startTime: o, isLast: s, ...c }, l) => {
	let [u, d] = G(!1), [f, p] = G(0);
	U(() => {
		if (!o || i) return;
		let e = setInterval(() => {
			p(Math.floor((Date.now() - o.getTime()) / 100) / 10);
		}, 100);
		return () => clearInterval(e);
	}, [o, i]);
	let m = (e) => e < 60 ? `${e.toFixed(1)}s` : `${Math.floor(e / 60)}:${(e % 60).toFixed(0).padStart(2, "0")}`, h = (e) => {
		switch (e) {
			case "complete": return /* @__PURE__ */ q(tn, { className: "h-3 w-3 text-emerald-500" });
			case "active": return /* @__PURE__ */ q(qe, { className: "h-3 w-3 text-purple-500 animate-spin" });
			case "error": return /* @__PURE__ */ q(Ur, { className: "h-3 w-3 text-rose-500" });
			default: return /* @__PURE__ */ q("div", { className: "h-3 w-3 rounded-full border border-slate-300 dark:border-slate-600" });
		}
	};
	return /* @__PURE__ */ J("div", {
		ref: l,
		className: I("flex items-start gap-3 min-w-0", e),
		...c,
		children: [/* @__PURE__ */ q(mE, {
			className: "bg-purple-100 dark:bg-purple-900/50",
			isLast: s,
			children: i ? /* @__PURE__ */ q(tn, { className: "h-4 w-4 text-emerald-500" }) : /* @__PURE__ */ q(Nr, { className: "h-4 w-4 text-purple-500 animate-pulse" })
		}), /* @__PURE__ */ J("div", {
			className: I("flex-1 min-w-0 min-h-8 px-3 -ml-1", !s && "pb-4"),
			children: [
				/* @__PURE__ */ J("div", {
					className: "flex items-center gap-2 min-h-8",
					children: [
						/* @__PURE__ */ q("span", {
							className: "text-sm font-medium text-slate-900 dark:text-slate-100",
							children: t
						}),
						o && !i && /* @__PURE__ */ q("span", {
							className: "text-sm text-slate-400 dark:text-slate-500 tabular-nums",
							children: m(f)
						}),
						a && r.length > 0 && /* @__PURE__ */ q("button", {
							type: "button",
							onClick: () => d(!u),
							className: "ml-auto p-0.5 rounded text-slate-400 hover:text-slate-600 dark:hover:text-slate-300",
							children: /* @__PURE__ */ q(R, { className: I("h-4 w-4 transition-transform", u && "rotate-180") })
						})
					]
				}),
				!i && /* @__PURE__ */ J("div", {
					className: "flex items-center gap-2 mt-1",
					children: [/* @__PURE__ */ q(pE, {
						size: "sm",
						variant: "brand"
					}), /* @__PURE__ */ q("span", {
						className: "text-sm text-slate-600 dark:text-slate-400",
						children: n || "Thinking..."
					})]
				}),
				u && r.length > 0 && /* @__PURE__ */ q("div", {
					className: "mt-2 space-y-1.5",
					children: r.map((e) => /* @__PURE__ */ J("div", {
						className: "flex items-center gap-2",
						children: [h(e.status), /* @__PURE__ */ q("span", {
							className: I("text-sm", e.status === "complete" && "text-slate-600 dark:text-slate-400", e.status === "active" && "text-purple-600 dark:text-purple-400", e.status === "error" && "text-rose-600 dark:text-rose-400", e.status === "pending" && "text-slate-400 dark:text-slate-500"),
							children: e.label
						})]
					}, e.id))
				})
			]
		})]
	});
});
wE.displayName = "ThinkingBlock";
//#endregion
//#region src/components/chat/CodeBlock/CodeBlock.tsx
var TE = V(({ className: e, code: t, language: n, filename: r, collapsible: i = !0, defaultCollapsed: a = !0, maxHeight: o = 400, showLineNumbers: s = !1, highlightLines: c = [], ...l }, u) => {
	let [d, f] = G(a), [p, m] = G(!1), h = t.split("\n"), g = h.length, _ = async () => {
		await navigator.clipboard.writeText(t), m(!0), setTimeout(() => m(!1), 2e3);
	};
	return /* @__PURE__ */ J("div", {
		ref: u,
		className: I("mt-2", e),
		...l,
		children: [
			/* @__PURE__ */ J("div", {
				className: "flex items-center gap-2 mb-1",
				children: [r ? /* @__PURE__ */ q("span", {
					className: "text-sm font-medium text-slate-600 dark:text-slate-400 font-mono",
					children: r
				}) : n ? /* @__PURE__ */ q("span", {
					className: "text-sm text-slate-500 dark:text-slate-400 uppercase",
					children: n
				}) : null, /* @__PURE__ */ J("div", {
					className: "flex items-center gap-1 ml-auto",
					children: [i && /* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => f(!d),
						className: "p-1 rounded text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors",
						"aria-label": d ? "Expand code" : "Collapse code",
						children: q(d ? R : Kt, { className: "h-3 w-3" })
					}), /* @__PURE__ */ q("button", {
						type: "button",
						onClick: _,
						className: "p-1 rounded text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors",
						"aria-label": "Copy code",
						children: p ? /* @__PURE__ */ q(un, { className: "h-3 w-3 text-emerald-500" }) : /* @__PURE__ */ q(sn, { className: "h-3 w-3" })
					})]
				})]
			}),
			!d && /* @__PURE__ */ q("div", {
				className: I("rounded-lg overflow-hidden border", "bg-slate-50 border-slate-200 dark:bg-slate-800/50 dark:border-slate-700"),
				children: /* @__PURE__ */ q("div", {
					className: "overflow-auto",
					style: { maxHeight: typeof o == "number" ? `${o}px` : o },
					children: /* @__PURE__ */ q("pre", {
						className: "p-3 leading-relaxed",
						children: /* @__PURE__ */ q("code", {
							className: "font-mono text-sm",
							children: s ? /* @__PURE__ */ q("table", {
								className: "w-full border-collapse",
								children: /* @__PURE__ */ q("tbody", { children: h.map((e, t) => /* @__PURE__ */ J("tr", {
									className: I(c.includes(t + 1) && "bg-amber-100 dark:bg-amber-500/10 border-l-2 border-amber-400"),
									children: [/* @__PURE__ */ q("td", {
										className: "pr-3 text-right text-slate-400 dark:text-slate-500 select-none w-8 align-top text-sm",
										children: t + 1
									}), /* @__PURE__ */ q("td", {
										className: "pl-3 whitespace-pre text-sm text-slate-700 dark:text-slate-300",
										children: e || " "
									})]
								}, t)) })
							}) : /* @__PURE__ */ q("span", {
								className: "whitespace-pre text-sm text-slate-700 dark:text-slate-300",
								children: t
							})
						})
					})
				})
			}),
			d && /* @__PURE__ */ J("div", {
				className: "text-sm text-slate-400 dark:text-slate-500",
				children: [
					/* @__PURE__ */ J("span", {
						className: "font-mono",
						children: [g, " lines"]
					}),
					/* @__PURE__ */ q("span", {
						className: "mx-2",
						children: "·"
					}),
					/* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => f(!1),
						className: "text-sky-500 hover:text-sky-600 dark:hover:text-sky-400",
						children: "Show code"
					})
				]
			})
		]
	});
});
TE.displayName = "CodeBlock";
//#endregion
//#region src/components/chat/ChatInput/ChatInput.tsx
var EE = V(({ className: e, onSubmit: t, isLoading: n = !1, maxLength: r, showCharacterCount: i = !1, submitButtonLabel: a = "Send", showToolbar: o = !0, toolbarActions: s, onAttachment: c, attachmentButtonLabel: l, onMention: u, onVoiceInput: d, onStop: f, disabled: p, placeholder: m = "Type a message...", value: h, onChange: g, attachmentSlot: _, sendDisabledReason: v, hasAttachments: y = !1, attachmentDisabledReason: b, ...x }, S) => {
	let [C, w] = G(""), T = Fn(), E = Fn(), [D, O] = G(1), k = W(null), A = h !== void 0, j = A ? h : C, M = A ? (e) => g?.(e) : w, ee = (e) => {
		k.current = e, typeof S == "function" ? S(e) : S && (S.current = e);
	};
	U(() => {
		if (k.current) {
			let e = k.current.rows;
			k.current.rows = 1;
			let t = Math.floor(k.current.scrollHeight / 24);
			t === e && (k.current.rows = t);
			let n = Math.min(Math.max(t, 1), 6);
			O(n), k.current.rows = n;
		}
	}, [j]);
	let te = (e) => {
		e.key === "Enter" && !e.shiftKey && (e.preventDefault(), ne());
	}, ne = () => {
		v || (j.trim() || y) && !n && t && (t(j.trim()), A || (w(""), O(1)));
	}, re = () => {
		f?.();
	}, ie = p || n, ae = j.length, oe = r ? ae > r : !1, se = (j.trim() || y) && !ie && !oe && !v, ce = [i ? "char-count" : void 0, v ? T : void 0].filter(Boolean).join(" ") || void 0;
	return /* @__PURE__ */ J("div", {
		className: I("w-full max-w-3xl mx-auto", e),
		children: [
			/* @__PURE__ */ J("div", {
				className: I("relative bg-white rounded-2xl border border-slate-200 shadow-lg shadow-slate-200/50", "dark:bg-slate-900 dark:border-slate-700 dark:shadow-slate-900/50", "transition-all duration-150", "focus-within:border-slate-300 focus-within:shadow-xl focus-within:shadow-slate-200/60", "dark:focus-within:border-slate-600 dark:focus-within:shadow-slate-900/60"),
				children: [
					_ && /* @__PURE__ */ q("div", {
						className: "px-4 pt-3",
						children: _
					}),
					/* @__PURE__ */ q("div", {
						className: "px-4 pt-4 pb-2",
						children: /* @__PURE__ */ q("textarea", {
							ref: ee,
							rows: D,
							value: j,
							onChange: (e) => M(e.target.value),
							onKeyDown: te,
							disabled: ie,
							placeholder: m,
							maxLength: r,
							className: I("w-full min-h-[24px] max-h-[200px] overflow-y-auto", "bg-transparent border-0 resize-none", "text-slate-900 text-base leading-relaxed placeholder-slate-400", "focus:outline-none focus:ring-0", "disabled:cursor-not-allowed disabled:opacity-50", "dark:text-white dark:placeholder-slate-500", oe && "text-rose-600 dark:text-rose-400"),
							"aria-label": "Chat message input",
							"aria-invalid": oe,
							"aria-describedby": ce,
							...x
						})
					}),
					/* @__PURE__ */ J("div", {
						className: "flex items-center justify-between px-3 pb-3",
						children: [/* @__PURE__ */ J("div", {
							className: "flex items-center gap-1",
							children: [s, o && !s && /* @__PURE__ */ J(K, { children: [
								(c || b) && /* @__PURE__ */ J("button", {
									type: "button",
									onClick: c,
									disabled: ie || !!b,
									title: b,
									"aria-describedby": b ? E : void 0,
									className: I("inline-flex items-center gap-2 p-2 rounded-lg text-slate-500 transition-colors", "hover:bg-slate-100 hover:text-slate-700", "dark:hover:bg-slate-800 dark:hover:text-slate-300", "disabled:opacity-50 disabled:cursor-not-allowed"),
									"aria-label": l ?? "Attach file",
									children: [/* @__PURE__ */ q(Ni, { className: "h-5 w-5 shrink-0" }), l && /* @__PURE__ */ q("span", {
										className: "text-sm",
										children: l
									})]
								}),
								u && /* @__PURE__ */ q("button", {
									type: "button",
									onClick: u,
									disabled: ie,
									className: I("p-2 rounded-lg text-slate-500 transition-colors", "hover:bg-slate-100 hover:text-slate-700", "dark:hover:bg-slate-800 dark:hover:text-slate-300", "disabled:opacity-50 disabled:cursor-not-allowed"),
									"aria-label": "Mention",
									children: /* @__PURE__ */ q(kr, { className: "h-5 w-5" })
								}),
								d && /* @__PURE__ */ q("button", {
									type: "button",
									onClick: d,
									disabled: ie,
									className: I("p-2 rounded-lg text-slate-500 transition-colors", "hover:bg-slate-100 hover:text-slate-700", "dark:hover:bg-slate-800 dark:hover:text-slate-300", "disabled:opacity-50 disabled:cursor-not-allowed"),
									"aria-label": "Voice input",
									children: /* @__PURE__ */ q(ki, { className: "h-5 w-5" })
								})
							] })]
						}), /* @__PURE__ */ J("div", {
							className: "flex items-center gap-3",
							children: [i && r && /* @__PURE__ */ J("span", {
								id: "char-count",
								className: I("text-xs", oe ? "text-rose-600 dark:text-rose-400" : "text-slate-400 dark:text-slate-500"),
								"aria-live": "polite",
								children: [
									ae,
									"/",
									r
								]
							}), n && f ? /* @__PURE__ */ q("button", {
								type: "button",
								onClick: re,
								className: I("flex items-center justify-center h-9 w-9 rounded-lg", "bg-slate-900 text-white", "hover:bg-slate-800 transition-colors", "dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100"),
								"aria-label": "Stop generation",
								children: /* @__PURE__ */ q(ta, {
									className: "h-4 w-4",
									fill: "currentColor"
								})
							}) : /* @__PURE__ */ q("button", {
								type: "button",
								onClick: ne,
								disabled: !se,
								title: v,
								"aria-describedby": v ? T : void 0,
								className: I("flex items-center justify-center h-9 w-9 rounded-lg transition-colors", se ? "bg-slate-900 text-white hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100" : "bg-slate-100 text-slate-400 cursor-not-allowed dark:bg-slate-800 dark:text-slate-600"),
								"aria-label": a,
								children: n ? /* @__PURE__ */ q(nu, {
									size: "sm",
									className: "border-current border-t-transparent"
								}) : /* @__PURE__ */ q(_t, { className: "h-5 w-5" })
							})]
						})]
					})
				]
			}),
			v ? /* @__PURE__ */ q("p", {
				id: T,
				role: "status",
				className: "mt-2 text-center text-xs text-amber-700 dark:text-amber-300",
				children: v
			}) : /* @__PURE__ */ J("p", {
				className: "mt-2 text-center text-xs text-slate-400 dark:text-slate-500",
				children: [
					/* @__PURE__ */ q("kbd", {
						className: "px-1.5 py-0.5 bg-slate-100 dark:bg-slate-800 rounded text-[10px] font-mono",
						children: "Enter"
					}),
					" ",
					"to send · ",
					" ",
					/* @__PURE__ */ q("kbd", {
						className: "px-1.5 py-0.5 bg-slate-100 dark:bg-slate-800 rounded text-[10px] font-mono",
						children: "Shift+Enter"
					}),
					" ",
					"for new line"
				]
			}),
			b && /* @__PURE__ */ q("p", {
				id: E,
				className: "mt-1 text-center text-xs text-slate-500 dark:text-slate-400",
				children: b
			})
		]
	});
});
EE.displayName = "ChatInput";
//#endregion
//#region src/components/chat/ConversationList/ConversationList.tsx
function DE(e) {
	let t = new Date(e), n = /* @__PURE__ */ new Date(), r = n.getTime() - t.getTime(), i = Math.floor(r / 1e3), a = Math.floor(i / 60), o = Math.floor(a / 60), s = Math.floor(o / 24);
	return a < 1 ? "now" : a < 60 ? `${a}m` : o < 24 ? `${o}h` : s < 7 ? `${s}d` : t.getFullYear() === n.getFullYear() ? t.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric"
	}) : t.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric"
	});
}
var OE = V(({ className: e, conversations: t, activeId: n, onSelect: r, onDelete: i, emptyMessage: a = "No conversations yet", ...o }, s) => t.length ? /* @__PURE__ */ q("div", {
	ref: s,
	className: I("flex flex-col gap-1", e),
	role: "list",
	"aria-label": "Conversations",
	...o,
	children: t.map((e) => {
		let t = e.id === n, a = DE(e.timestamp);
		return /* @__PURE__ */ J("div", {
			role: "listitem",
			className: I("group relative flex items-start gap-3 p-3 rounded-lg cursor-pointer transition-colors", "hover:bg-slate-100 dark:hover:bg-slate-800", t && "bg-slate-100 dark:bg-slate-800", "focus-within:ring-1 focus-within:ring-slate-300 dark:focus-within:ring-slate-600"),
			children: [/* @__PURE__ */ J("div", {
				className: "flex-1 min-w-0",
				children: [/* @__PURE__ */ J("div", {
					className: "flex items-center justify-between gap-2",
					children: [/* @__PURE__ */ q("h3", {
						className: I("font-medium text-sm truncate leading-5", t ? "text-slate-900 dark:text-white" : "text-slate-700 dark:text-slate-300"),
						children: /* @__PURE__ */ q("button", {
							type: "button",
							className: "block w-full truncate text-left outline-none after:absolute after:inset-0 after:content-['']",
							"aria-current": t ? "true" : void 0,
							onClick: () => r?.(e.id),
							children: e.title
						})
					}), /* @__PURE__ */ q("time", {
						className: "relative text-[10px] text-slate-400 dark:text-slate-500 shrink-0 tabular-nums",
						dateTime: new Date(e.timestamp).toISOString(),
						title: new Date(e.timestamp).toLocaleString(),
						children: a
					})]
				}), e.preview && /* @__PURE__ */ q("p", {
					className: "text-xs text-slate-500 dark:text-slate-400 truncate mt-0.5",
					children: e.preview
				})]
			}), i && /* @__PURE__ */ q(L, {
				variant: "ghost",
				size: "icon-sm",
				onClick: (t) => {
					t.stopPropagation(), i(e.id);
				},
				className: I("relative z-10 shrink-0 opacity-0 group-hover:opacity-100 focus-visible:opacity-100 transition-opacity", "text-slate-400 hover:text-rose-600 dark:hover:text-rose-400"),
				"aria-label": `Delete conversation: ${e.title}`,
				children: /* @__PURE__ */ J("svg", {
					xmlns: "http://www.w3.org/2000/svg",
					viewBox: "0 0 24 24",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "2",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					className: "h-4 w-4",
					"aria-hidden": "true",
					children: [
						/* @__PURE__ */ q("polyline", { points: "3 6 5 6 21 6" }),
						/* @__PURE__ */ q("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }),
						/* @__PURE__ */ q("line", {
							x1: "10",
							y1: "11",
							x2: "10",
							y2: "17"
						}),
						/* @__PURE__ */ q("line", {
							x1: "14",
							y1: "11",
							x2: "14",
							y2: "17"
						})
					]
				})
			})]
		}, e.id);
	})
}) : /* @__PURE__ */ q("div", {
	ref: s,
	className: I("flex items-center justify-center p-8 text-slate-500 dark:text-slate-400 text-sm", e),
	...o,
	children: a
}));
OE.displayName = "ConversationList";
//#endregion
//#region src/components/chat/ActivityIndicator/ActivityIndicator.tsx
var kE = V(({ className: e, actor: t, name: n, activity: r, icon: i, isLast: a, initials: o, isCurrentUser: s, ...c }, l) => {
	let u = t === "agent", d = n || (u ? "Assistant" : "You"), f = o || d.split(" ").map((e) => e[0]).join("").toUpperCase().slice(0, 2), p = s ?? d === "You", m = u ? "bg-purple-100 dark:bg-purple-900/50" : p ? "bg-sky-100 dark:bg-sky-900/50" : "bg-violet-100 dark:bg-violet-900/50", h = u ? /* @__PURE__ */ q(Nr, { className: "h-4 w-4 text-purple-500 dark:text-purple-400 animate-pulse" }) : /* @__PURE__ */ q("span", {
		className: I("text-xs font-medium", p ? "text-sky-600 dark:text-sky-400" : "text-violet-600 dark:text-violet-400"),
		children: f
	}), g = u ? "Thinking" : "typing";
	return /* @__PURE__ */ J("div", {
		ref: l,
		className: I("flex items-start gap-3", e),
		...c,
		children: [/* @__PURE__ */ J("div", {
			className: "flex flex-col items-center",
			children: [/* @__PURE__ */ q("div", {
				className: I("flex items-center justify-center h-8 w-8 rounded-full shrink-0", m),
				children: i || h
			}), !a && /* @__PURE__ */ q("div", { className: "w-px flex-1 bg-slate-200 dark:bg-slate-700 min-h-[16px]" })]
		}), /* @__PURE__ */ q("div", {
			className: I("flex-1 min-h-8 flex items-center px-3 -ml-1", !a && "pb-4"),
			children: /* @__PURE__ */ J("div", {
				className: "flex flex-col",
				children: [/* @__PURE__ */ J("div", {
					className: "flex items-center",
					children: [/* @__PURE__ */ q("span", {
						className: "text-sm font-medium text-slate-900 dark:text-slate-100",
						children: d
					}), /* @__PURE__ */ q(pE, {
						variant: t,
						className: "ml-1.5"
					})]
				}), /* @__PURE__ */ q("span", {
					className: "text-sm text-slate-500 dark:text-slate-400",
					children: r || g
				})]
			})
		})]
	});
});
kE.displayName = "ActivityIndicator";
//#endregion
//#region src/components/chat/FileAttachment/FileAttachment.tsx
var AE = (e) => {
	let t = e.split(".").pop()?.toLowerCase() || "";
	return [
		"xlsx",
		"xls",
		"csv",
		"parquet"
	].includes(t) ? "spreadsheet" : [
		"json",
		"js",
		"ts",
		"tsx",
		"jsx",
		"py",
		"go",
		"html",
		"css",
		"xml",
		"yaml",
		"yml"
	].includes(t) ? "code" : [
		"png",
		"jpg",
		"jpeg",
		"gif",
		"svg",
		"webp",
		"ico"
	].includes(t) ? "image" : [
		"pdf",
		"doc",
		"docx",
		"txt",
		"md",
		"rtf"
	].includes(t) ? "document" : "other";
}, jE = ({ filename: e, className: t }) => {
	let n = AE(e), r = I("h-4 w-4", t);
	switch (n) {
		case "spreadsheet": return /* @__PURE__ */ q(pi, { className: I(r, "text-emerald-500") });
		case "code": return /* @__PURE__ */ q(si, { className: I(r, "text-purple-500") });
		case "image": return /* @__PURE__ */ q(li, { className: I(r, "text-sky-500") });
		case "document": return /* @__PURE__ */ q(hi, { className: I(r, "text-amber-500") });
		default: return /* @__PURE__ */ q(_i, { className: I(r, "text-slate-400") });
	}
}, ME = (e) => e < 1024 ? `${e} B` : e < 1048576 ? `${(e / 1024).toFixed(1)} KB` : e < 1073741824 ? `${(e / 1048576).toFixed(1)} MB` : `${(e / 1073741824).toFixed(1)} GB`, NE = ({ status: e, progress: t }) => {
	switch (e) {
		case "uploading": return /* @__PURE__ */ J("div", {
			className: "flex items-center gap-1.5",
			children: [/* @__PURE__ */ q(qe, { className: "h-3 w-3 text-sky-500 animate-spin" }), t !== void 0 && /* @__PURE__ */ J("span", {
				className: "text-xs text-slate-500 tabular-nums",
				children: [t, "%"]
			})]
		});
		case "processing": return /* @__PURE__ */ q(qe, { className: "h-3 w-3 text-amber-500 animate-spin" });
		case "complete": return /* @__PURE__ */ q(tn, { className: "h-3 w-3 text-emerald-500" });
		case "error": return /* @__PURE__ */ q(tt, { className: "h-3 w-3 text-rose-500" });
		default: return null;
	}
}, PE = ({ file: e, compact: t, onRemove: n, onDownload: r, onRetry: i }) => {
	let a = e.status || "complete", o = a === "complete", s = a === "error", c = a === "uploading";
	return /* @__PURE__ */ J("div", {
		className: I("group flex items-center gap-2 rounded-lg border transition-colors", t ? "px-2 py-1" : "px-3 py-2", s ? "border-rose-200 bg-rose-50 dark:border-rose-800 dark:bg-rose-950/30" : "border-slate-200 bg-slate-50 dark:border-slate-700 dark:bg-slate-800/50", o && "hover:border-slate-300 dark:hover:border-slate-600"),
		children: [
			/* @__PURE__ */ q(jE, { filename: e.name }),
			/* @__PURE__ */ J("div", {
				className: "flex-1 min-w-0",
				children: [
					/* @__PURE__ */ J("div", {
						className: "flex items-center gap-2",
						children: [/* @__PURE__ */ q("span", {
							className: I("text-sm truncate", s ? "text-rose-700 dark:text-rose-300" : "text-slate-700 dark:text-slate-300"),
							title: e.name,
							children: e.name
						}), !t && /* @__PURE__ */ q(NE, {
							status: a,
							progress: e.progress
						})]
					}),
					!t && /* @__PURE__ */ J("div", {
						className: "flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400",
						children: [/* @__PURE__ */ q("span", { children: ME(e.size) }), s && e.error && /* @__PURE__ */ q("span", {
							className: "text-rose-600 dark:text-rose-400",
							children: e.error
						})]
					}),
					c && e.progress !== void 0 && !t && /* @__PURE__ */ q("div", {
						className: "mt-1.5 h-1 w-full rounded-full bg-slate-200 dark:bg-slate-700 overflow-hidden",
						children: /* @__PURE__ */ q("div", {
							className: "h-full bg-sky-500 transition-all duration-300",
							style: { width: `${e.progress}%` }
						})
					})
				]
			}),
			/* @__PURE__ */ J("div", {
				className: "flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity",
				children: [
					s && i && /* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => i(e.id),
						className: "p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-700 text-sky-500 hover:text-sky-600 dark:text-sky-400 dark:hover:text-sky-300",
						title: "Retry",
						children: /* @__PURE__ */ q(qi, { className: "h-3.5 w-3.5" })
					}),
					o && r && /* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => r(e.id),
						className: "p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200",
						title: "Download",
						children: /* @__PURE__ */ q(ti, { className: "h-3.5 w-3.5" })
					}),
					n && /* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => n(e.id),
						className: "p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-500 hover:text-rose-500 dark:text-slate-400 dark:hover:text-rose-400",
						title: "Remove",
						children: /* @__PURE__ */ q(O, { className: "h-3.5 w-3.5" })
					})
				]
			})
		]
	});
}, FE = V(({ className: e, files: t, onRemove: n, onDownload: r, onRetry: i, compact: a = !1, maxVisible: o = 5, ...s }, c) => {
	let [l, u] = G(!1), d = Array.isArray(t) ? t : [t], f = o && !l ? d.slice(0, o) : d, p = l ? 0 : d.length - f.length;
	return d.length === 0 ? null : /* @__PURE__ */ J("div", {
		ref: c,
		className: I("flex flex-wrap gap-2", a && "gap-1", e),
		...s,
		children: [f.map((e) => /* @__PURE__ */ q(PE, {
			file: e,
			compact: a,
			onRemove: n,
			onDownload: r,
			onRetry: i
		}, e.id)), p > 0 && /* @__PURE__ */ J("button", {
			type: "button",
			onClick: () => u(!0),
			className: I("flex items-center justify-center rounded-lg border border-slate-200 bg-slate-50", "dark:border-slate-700 dark:bg-slate-800/50", "hover:border-slate-300 hover:bg-slate-100 dark:hover:border-slate-600 dark:hover:bg-slate-800", "transition-colors cursor-pointer", a ? "px-2 py-1 text-xs" : "px-3 py-2 text-sm", "text-slate-500 dark:text-slate-400"),
			children: [
				"+",
				p,
				" more"
			]
		})]
	});
});
FE.displayName = "FileAttachment";
var IE = V(({ className: e, files: t, onRemove: n, onDownload: r, onRetry: i, title: a, showCard: o = !1, ...s }, c) => {
	if (t.length === 0) return null;
	let l = /* @__PURE__ */ J(K, { children: [a && /* @__PURE__ */ q("div", {
		className: "text-xs font-medium text-slate-500 dark:text-slate-400 mb-2",
		children: a
	}), /* @__PURE__ */ q("div", {
		className: "space-y-1.5",
		children: t.map((e) => /* @__PURE__ */ q(PE, {
			file: e,
			onRemove: n,
			onDownload: r,
			onRetry: i
		}, e.id))
	})] });
	return o ? /* @__PURE__ */ q("div", {
		ref: c,
		className: I("rounded-lg border border-slate-200 bg-white p-3", "dark:border-slate-700 dark:bg-slate-900", e),
		...s,
		children: l
	}) : /* @__PURE__ */ q("div", {
		ref: c,
		className: e,
		...s,
		children: l
	});
});
IE.displayName = "FileAttachmentList";
//#endregion
//#region src/components/chat/EscalationCard/EscalationCard.tsx
var LE = {
	pending: {
		color: "text-amber-600 dark:text-amber-400",
		label: "Pending",
		icon: Gr
	},
	approved: {
		color: "text-emerald-600 dark:text-emerald-400",
		label: "Approved",
		icon: tn
	},
	denied: {
		color: "text-rose-600 dark:text-rose-400",
		label: "Denied",
		icon: Ur
	},
	modified: {
		color: "text-sky-600 dark:text-sky-400",
		label: "Modified",
		icon: di
	},
	expired: {
		color: "text-slate-500 dark:text-slate-400",
		label: "Expired",
		icon: Gr
	}
}, RE = {
	action_approval: {
		icon: Zt,
		label: "Approval Required",
		color: "text-amber-500"
	},
	content_review: {
		icon: di,
		label: "Content Review",
		color: "text-sky-500"
	},
	guidance: {
		icon: Ve,
		label: "Guidance Needed",
		color: "text-purple-500"
	},
	compliance_review: {
		icon: ie,
		label: "Compliance Review",
		color: "text-violet-500"
	}
}, zE = {
	critical: {
		border: "border-l-4 border-l-red-500",
		bg: "bg-red-50 dark:bg-red-500/10",
		badge: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300"
	},
	high: {
		border: "border-l-4 border-l-amber-500",
		bg: "bg-amber-50 dark:bg-amber-500/10",
		badge: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300"
	},
	medium: {
		border: "border-l-4 border-l-yellow-400",
		bg: "bg-yellow-50 dark:bg-yellow-400/10",
		badge: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300"
	},
	low: {
		border: "border-l-4 border-l-slate-300",
		bg: "bg-slate-50 dark:bg-slate-700/30",
		badge: "bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-300"
	}
}, BE = (e) => {
	let t = /* @__PURE__ */ new Date(), n = e.getTime() - t.getTime();
	if (n <= 0) return "Expired";
	let r = Math.floor(n / 6e4), i = Math.floor(n % 6e4 / 1e3);
	return r > 0 ? `${r}m ${i}s` : `${i}s`;
}, VE = V(({ className: e, type: t, status: n, agentName: r, action: i, reason: a, content: o, expiresAt: s, resolvedBy: c, resolutionReason: l, onApprove: u, onDeny: d, onGuidance: f, onModify: p, isReadOnly: m = !1, isSubmitting: h = !1, severity: g, ruleName: _, ...v }, y) => {
	let [b, x] = G(!1), [S, C] = G(""), [w, T] = G(o || ""), [E, D] = G(!1), O = n === "pending", k = O && !m && !h, A = RE[t], j = LE[n], M = g ? zE[g] : null, ee = A.icon, te = j.icon, ne = () => {
		S.trim() && (f?.(S.trim()), C(""));
	}, re = () => {
		p?.(w), D(!1);
	};
	return /* @__PURE__ */ J("div", {
		ref: y,
		className: I("rounded-lg border max-w-sm", M ? I(M.border, M.bg) : O ? "border-amber-200 dark:border-yellow-600/50 bg-amber-50/50 dark:bg-yellow-950/20" : "border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-900/50", e),
		...v,
		children: [
			/* @__PURE__ */ J("div", {
				className: "flex items-center gap-2 px-3 py-2 border-b border-slate-200/50 dark:border-slate-700/50",
				children: [
					/* @__PURE__ */ q(ee, { className: I("h-4 w-4", A.color) }),
					/* @__PURE__ */ q("span", {
						className: "text-sm font-medium text-slate-900 dark:text-slate-100",
						children: A.label
					}),
					g && M && /* @__PURE__ */ q("span", {
						className: I("text-xs px-2 py-0.5 rounded-full font-medium", M.badge),
						children: g
					}),
					/* @__PURE__ */ q("div", { className: "flex-1" }),
					s && O && /* @__PURE__ */ J("div", {
						className: "flex items-center gap-1 text-xs text-slate-500 dark:text-slate-400",
						children: [/* @__PURE__ */ q(Gr, { className: "h-3 w-3" }), /* @__PURE__ */ q("span", {
							className: "tabular-nums",
							children: BE(s)
						})]
					}),
					!O && /* @__PURE__ */ J("div", {
						className: I("flex items-center gap-1 text-xs", j.color),
						children: [/* @__PURE__ */ q(te, { className: "h-3 w-3" }), /* @__PURE__ */ q("span", { children: j.label })]
					})
				]
			}),
			/* @__PURE__ */ J("div", {
				className: "px-3 py-2.5 space-y-2",
				children: [
					_ && /* @__PURE__ */ J("div", {
						className: "text-xs text-slate-500 dark:text-slate-400",
						children: ["Rule: ", /* @__PURE__ */ q("span", {
							className: "font-mono",
							children: _
						})]
					}),
					/* @__PURE__ */ J("div", {
						className: "text-sm",
						children: [
							/* @__PURE__ */ q("span", {
								className: "font-medium text-slate-900 dark:text-slate-100",
								children: r
							}),
							/* @__PURE__ */ q("span", {
								className: "text-slate-500 dark:text-slate-400",
								children: " wants to "
							}),
							/* @__PURE__ */ q("span", {
								className: "text-slate-700 dark:text-slate-300",
								children: i
							})
						]
					}),
					a && /* @__PURE__ */ q(K, { children: t === "guidance" ? /* @__PURE__ */ q("div", {
						className: "text-sm text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-800 rounded px-2.5 py-1.5 border border-slate-200 dark:border-slate-700",
						children: a
					}) : /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ J("button", {
						type: "button",
						onClick: () => x(!b),
						className: "flex items-center gap-1 text-xs text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300",
						children: [/* @__PURE__ */ q("span", { children: "Details" }), /* @__PURE__ */ q(R, { className: I("h-3 w-3 transition-transform", b && "rotate-180") })]
					}), b && /* @__PURE__ */ q("div", {
						className: "text-xs text-slate-600 dark:text-slate-400",
						children: a
					})] }) }),
					t === "content_review" && o && !E && /* @__PURE__ */ q("div", {
						className: "text-sm text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-800 rounded px-2.5 py-1.5 border border-slate-200 dark:border-slate-700 max-h-24 overflow-y-auto whitespace-pre-wrap",
						children: o
					}),
					t === "content_review" && E && /* @__PURE__ */ q("textarea", {
						value: w,
						onChange: (e) => T(e.target.value),
						className: "w-full text-sm text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-800 rounded px-2.5 py-1.5 border border-sky-300 dark:border-sky-700 min-h-[80px] focus:outline-none focus:ring-2 focus:ring-sky-500 resize-none"
					}),
					!O && (c || l) && /* @__PURE__ */ J("div", {
						className: "text-xs text-slate-500 dark:text-slate-400 border-t border-slate-200 dark:border-slate-700 pt-2 mt-2",
						children: [c && /* @__PURE__ */ J("span", { children: ["Resolved by ", c] }), l && /* @__PURE__ */ q("p", {
							className: "mt-0.5",
							children: l
						})]
					}),
					k && t === "guidance" && /* @__PURE__ */ J("div", {
						className: "flex items-end gap-2",
						children: [/* @__PURE__ */ q("textarea", {
							value: S,
							onChange: (e) => C(e.target.value),
							placeholder: "Provide guidance...",
							className: "flex-1 text-sm text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 rounded px-2.5 py-1.5 border border-slate-200 dark:border-slate-700 min-h-[48px] focus:outline-none focus:ring-2 focus:ring-purple-500 resize-none",
							onKeyDown: (e) => {
								e.key === "Enter" && e.ctrlKey && (e.preventDefault(), ne());
							}
						}), /* @__PURE__ */ q("button", {
							type: "button",
							onClick: ne,
							disabled: !S.trim() || h,
							className: "flex items-center gap-1 px-2.5 py-1.5 rounded text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
							children: /* @__PURE__ */ q(Zi, { className: "h-3.5 w-3.5" })
						})]
					})
				]
			}),
			k && t !== "guidance" && /* @__PURE__ */ q("div", {
				className: "flex items-center gap-2 px-3 py-2 border-t border-slate-200/50 dark:border-slate-700/50",
				children: t === "content_review" && E ? /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q("button", {
					type: "button",
					onClick: re,
					disabled: h,
					className: "px-3 py-1.5 rounded text-sm font-medium text-white bg-sky-600 hover:bg-sky-700 disabled:opacity-50 transition-colors max-w-[120px]",
					children: "Save"
				}), /* @__PURE__ */ q("button", {
					type: "button",
					onClick: () => {
						D(!1), T(o || "");
					},
					className: "px-3 py-1.5 rounded text-sm font-medium text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800 transition-colors",
					children: "Cancel"
				})] }) : /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ J("div", {
					className: "flex items-center gap-2",
					children: [/* @__PURE__ */ q("button", {
						type: "button",
						onClick: u,
						disabled: h,
						className: "px-3 py-1.5 rounded text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 transition-colors max-w-[120px]",
						children: "Approve"
					}), /* @__PURE__ */ q("button", {
						type: "button",
						onClick: d,
						disabled: h,
						className: "px-3 py-1.5 rounded text-sm font-medium text-rose-600 hover:bg-rose-50 dark:text-rose-400 dark:hover:bg-rose-950 transition-colors",
						children: "Deny"
					})]
				}), t === "content_review" && /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q("div", { className: "flex-1" }), /* @__PURE__ */ q("button", {
					type: "button",
					onClick: () => D(!0),
					disabled: h,
					className: "px-3 py-1.5 rounded text-sm font-medium text-sky-600 hover:bg-sky-50 dark:text-sky-400 dark:hover:bg-sky-950 transition-colors",
					children: "Edit"
				})] })] })
			})
		]
	});
});
VE.displayName = "EscalationCard";
//#endregion
//#region src/components/chat/FeedbackButtons/FeedbackButtons.tsx
var HE = V(({ className: e, onFeedback: t, submitted: n = !1, submittedType: r, disabled: i = !1, ...a }, o) => {
	let [s, c] = G(r || null), [l, u] = G(n), d = (e) => {
		i || l || (e === s ? c(null) : (c(e), t?.({ type: e }), u(!0)));
	};
	return /* @__PURE__ */ J("div", {
		ref: o,
		className: I("flex items-center gap-0.5 transition-opacity", s ? "opacity-100" : "opacity-40 hover:opacity-100", i && "opacity-30 cursor-not-allowed", e),
		...a,
		children: [/* @__PURE__ */ q("button", {
			type: "button",
			onClick: () => d("positive"),
			disabled: i || l,
			className: I("p-1 rounded transition-colors", s === "positive" ? "text-emerald-500" : "text-slate-400 hover:text-emerald-500", (i || l) && "cursor-not-allowed"),
			"aria-label": "Helpful",
			"aria-pressed": s === "positive",
			children: /* @__PURE__ */ q(aa, { className: I("h-3 w-3", s === "positive" && "fill-current") })
		}), /* @__PURE__ */ q("button", {
			type: "button",
			onClick: () => d("negative"),
			disabled: i || l,
			className: I("p-1 rounded transition-colors", s === "negative" ? "text-rose-500" : "text-slate-400 hover:text-rose-500", (i || l) && "cursor-not-allowed"),
			"aria-label": "Not helpful",
			"aria-pressed": s === "negative",
			children: /* @__PURE__ */ q(sa, { className: I("h-3 w-3", s === "negative" && "fill-current") })
		})]
	});
});
HE.displayName = "FeedbackButtons";
//#endregion
//#region src/components/chat/VoiceRecordingOverlay/VoiceRecordingOverlay.tsx
var UE = (e) => `${Math.floor(e / 60)}:${(e % 60).toString().padStart(2, "0")}`, WE = V(({ className: e, duration: t, onStop: n, isOverlay: r = !0, audioLevel: i = 0, ...a }, o) => {
	let [s, c] = G(1), [l, u] = G(0);
	U(() => {
		let e = 1 + i * .3;
		c(e);
	}, [i]), U(() => {
		let e, t = 0, n = (r) => {
			r - t >= 33.333333333333336 && (u(r), t = r), e = requestAnimationFrame(n);
		};
		return e = requestAnimationFrame(n), () => cancelAnimationFrame(e);
	}, []);
	let d = (e) => {
		let t = l / 150, n = e * .8;
		return i > 0 ? 6 + i * 16 * (Math.sin(t + n) * .5 + .5) : 8 + 4 * (Math.sin(t * .5 + n) * .5 + .5);
	};
	return /* @__PURE__ */ q("div", {
		ref: o,
		className: I("flex items-center justify-center", r && "absolute bottom-full mb-2 left-0 right-0", e),
		...a,
		children: /* @__PURE__ */ J("div", {
			className: I("flex items-center gap-4 px-4 py-2.5 rounded-full", "bg-white dark:bg-slate-800", "border border-slate-200 dark:border-slate-700", "shadow-lg dark:shadow-slate-900/50"),
			children: [
				/* @__PURE__ */ J("div", {
					className: "relative flex items-center justify-center",
					children: [
						/* @__PURE__ */ q("div", {
							className: "absolute inset-0 bg-red-400 rounded-full opacity-30",
							style: {
								transform: `scale(${s})`,
								transition: "transform 150ms ease-out"
							}
						}),
						/* @__PURE__ */ q("div", {
							className: "absolute inset-0 bg-red-400 rounded-full opacity-20 animate-ping",
							style: { animationDuration: "1.5s" }
						}),
						/* @__PURE__ */ q("div", {
							className: "relative z-10 flex items-center justify-center h-8 w-8 bg-red-500 rounded-full",
							children: /* @__PURE__ */ q(ki, { className: "h-4 w-4 text-white" })
						})
					]
				}),
				/* @__PURE__ */ J("div", {
					className: "flex flex-col",
					children: [/* @__PURE__ */ q("span", {
						className: "text-sm font-medium text-slate-700 dark:text-slate-200",
						children: "Recording"
					}), /* @__PURE__ */ q("span", {
						className: "text-xs text-slate-500 dark:text-slate-400 font-mono tabular-nums",
						children: UE(t)
					})]
				}),
				/* @__PURE__ */ q("div", {
					className: "flex items-center gap-0.5 h-6",
					children: [...[
						,
						,
						,
						,
						,
					]].map((e, t) => /* @__PURE__ */ q("div", {
						className: "w-1 rounded-full bg-red-400",
						style: {
							height: `${d(t)}px`,
							transition: "height 50ms ease-out"
						}
					}, t))
				}),
				/* @__PURE__ */ q("button", {
					type: "button",
					onClick: n,
					className: I("flex items-center justify-center h-8 w-8 rounded-full", "bg-red-500 hover:bg-red-600", "text-white transition-colors", "focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 dark:focus:ring-offset-slate-800"),
					"aria-label": "Stop and save recording",
					children: /* @__PURE__ */ q(ta, { className: "h-3.5 w-3.5 fill-current" })
				})
			]
		})
	});
});
WE.displayName = "VoiceRecordingOverlay";
var GE = V(({ className: e, isRecording: t = !1, onToggle: n, size: r = "md", disabled: i = !1, ...a }, o) => {
	let s = {
		sm: "h-8 w-8",
		md: "h-10 w-10",
		lg: "h-12 w-12"
	}, c = {
		sm: "h-4 w-4",
		md: "h-5 w-5",
		lg: "h-6 w-6"
	};
	return /* @__PURE__ */ q("button", {
		ref: o,
		type: "button",
		onClick: n,
		disabled: i,
		className: I("flex items-center justify-center rounded-full transition-all", s[r], t ? "bg-red-500 hover:bg-red-600 text-white animate-pulse" : "bg-slate-100 hover:bg-slate-200 text-slate-600 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-400", i && "opacity-50 cursor-not-allowed", "focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-slate-900", t ? "focus:ring-red-500" : "focus:ring-slate-500", e),
		"aria-label": t ? "Stop recording" : "Start voice recording",
		"aria-pressed": t,
		...a,
		children: /* @__PURE__ */ q(ki, { className: I(c[r], t && "animate-none") })
	});
});
GE.displayName = "VoiceRecordingButton";
var KE = (e, t) => {
	let n = e * 1e3;
	return Array.from({ length: t }, (e, t) => {
		let r = (n + t * 137) % 100, i = .3 + Math.sin(t * .5) * .2, a = (Math.sin(r) * .5 + .5) * .5;
		return Math.min(1, Math.max(.15, i + a));
	});
}, qE = V(({ className: e, src: t, duration: n, waveform: r, onPlay: i, onPause: a, onEnded: o, isCurrentUser: s, userName: c, initials: l, avatar: u, playbackRates: d = [
	1,
	1.5,
	2
], isLast: f, ...p }, m) => {
	let h = W(null), [g, _] = G(!1), [v, y] = G(0), [b, x] = G(1), S = c || (s ? "You" : "Assistant"), C = s ?? S === "You", w = l || S.split(" ").map((e) => e[0]).join("").toUpperCase().slice(0, 2), T = r || KE(n, 24);
	U(() => {
		if (t) {
			let e = new Audio(t);
			e.playbackRate = b, h.current = e;
			let n = () => {
				y(e.currentTime);
			}, r = () => {
				_(!1), y(0), o?.();
			};
			return e.addEventListener("timeupdate", n), e.addEventListener("ended", r), () => {
				e.removeEventListener("timeupdate", n), e.removeEventListener("ended", r), e.pause();
			};
		}
	}, [t, o]), U(() => {
		h.current && (h.current.playbackRate = b);
	}, [b]);
	let E = H(() => {
		!h.current && !t ? g ? (_(!1), a?.()) : (_(!0), i?.()) : h.current && (g ? (h.current.pause(), _(!1), a?.()) : (h.current.play(), _(!0), i?.()));
	}, [
		g,
		t,
		i,
		a
	]);
	U(() => {
		if (!t && g) {
			let e = setInterval(() => {
				y((e) => {
					let t = e + .1 * b;
					return t >= n ? (_(!1), o?.(), 0) : t;
				});
			}, 100);
			return () => clearInterval(e);
		}
	}, [
		t,
		g,
		n,
		b,
		o
	]);
	let D = (e) => {
		let t = Math.min(n, Math.max(0, e));
		y(t), h.current && (h.current.currentTime = t);
	}, O = (e) => {
		let t = e.currentTarget.getBoundingClientRect(), r = (e.clientX - t.left) / t.width;
		D(r * n);
	}, k = (e) => {
		let t = {
			ArrowRight: 5,
			ArrowUp: 5,
			ArrowLeft: -5,
			ArrowDown: -5,
			PageUp: 10,
			PageDown: -10
		};
		e.key in t ? (e.preventDefault(), D(v + t[e.key])) : e.key === "Home" ? (e.preventDefault(), D(0)) : e.key === "End" && (e.preventDefault(), D(n));
	}, A = () => {
		let e = (d.indexOf(b) + 1) % d.length;
		x(d[e] ?? b);
	}, j = n > 0 ? v / n : 0, M = Math.floor(j * 24), ee = C ? "bg-sky-100 dark:bg-sky-900/50" : "bg-slate-100 dark:bg-slate-800";
	return /* @__PURE__ */ J("div", {
		ref: m,
		className: I("flex items-start gap-3", e),
		...p,
		children: [/* @__PURE__ */ J("div", {
			className: "flex flex-col items-center",
			children: [/* @__PURE__ */ q("div", {
				className: I("flex items-center justify-center h-8 w-8 rounded-full shrink-0", ee),
				children: u || /* @__PURE__ */ q("span", {
					className: I("text-xs font-medium", C ? "text-sky-600 dark:text-sky-400" : "text-slate-600 dark:text-slate-400"),
					children: w
				})
			}), !f && /* @__PURE__ */ q("div", { className: "w-px flex-1 bg-slate-200 dark:bg-slate-700 min-h-[16px]" })]
		}), /* @__PURE__ */ q("div", {
			className: I("flex-1 min-h-8", !f && "pb-4"),
			children: /* @__PURE__ */ J("div", {
				className: I("rounded-lg px-3 py-2 -ml-1 max-w-[240px]", C ? "bg-sky-50 dark:bg-sky-950/30 border border-sky-100 dark:border-sky-900/50" : "bg-slate-50 dark:bg-slate-900/30 border border-slate-100 dark:border-slate-800"),
				children: [/* @__PURE__ */ J("div", {
					className: "flex items-center gap-2 mb-2",
					children: [/* @__PURE__ */ q("span", {
						className: "text-sm font-medium text-slate-900 dark:text-slate-100",
						children: S
					}), /* @__PURE__ */ q(ki, { className: "h-3 w-3 text-slate-400" })]
				}), /* @__PURE__ */ J("div", {
					className: "flex items-center gap-2",
					children: [
						/* @__PURE__ */ q("button", {
							type: "button",
							onClick: E,
							className: I("flex items-center justify-center p-2 rounded-lg shrink-0 transition-colors", C ? "bg-sky-100 hover:bg-sky-200 dark:bg-sky-900/50 dark:hover:bg-sky-800/50 text-sky-600 dark:text-sky-400" : "bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-400"),
							"aria-label": g ? "Pause" : "Play",
							children: q(g ? Fi : Vi, {
								className: "h-4 w-4",
								fill: "currentColor"
							})
						}),
						/* @__PURE__ */ J("div", {
							className: "flex-1 min-w-0",
							children: [/* @__PURE__ */ q("div", {
								className: "flex items-center gap-[2px] h-6 cursor-pointer rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400",
								onClick: O,
								onKeyDown: k,
								role: "slider",
								tabIndex: 0,
								"aria-label": "Audio progress",
								"aria-valuemin": 0,
								"aria-valuemax": n,
								"aria-valuenow": v,
								"aria-valuetext": `${UE(Math.floor(v))} of ${UE(Math.floor(n))}`,
								children: T.slice(0, 24).map((e, t) => {
									let n = t < M, r = Math.max(3, e * 20);
									return /* @__PURE__ */ q("div", {
										className: I("w-[2px] rounded-full transition-colors", C ? n ? "bg-sky-500 dark:bg-sky-400" : "bg-sky-200 dark:bg-sky-800" : n ? "bg-slate-500 dark:bg-slate-400" : "bg-slate-200 dark:bg-slate-700"),
										style: { height: `${r}px` }
									}, t);
								})
							}), /* @__PURE__ */ J("div", {
								className: "flex items-center justify-between mt-0.5",
								children: [/* @__PURE__ */ q("span", {
									className: "text-[10px] font-mono tabular-nums text-slate-400 dark:text-slate-500",
									children: UE(Math.floor(v))
								}), /* @__PURE__ */ q("span", {
									className: "text-[10px] font-mono tabular-nums text-slate-400 dark:text-slate-500",
									children: UE(Math.floor(n))
								})]
							})]
						}),
						d.length > 1 && /* @__PURE__ */ J("button", {
							type: "button",
							onClick: A,
							className: I("flex items-center justify-center p-2 rounded-lg shrink-0 transition-colors", "text-xs font-medium tabular-nums min-w-[32px]", "bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700", "text-slate-500 dark:text-slate-400"),
							"aria-label": `Playback speed: ${b}x`,
							children: [b, "x"]
						})
					]
				})]
			})
		})]
	});
});
qE.displayName = "VoiceMessage";
//#endregion
//#region src/components/chat/VoiceCallControls/VoiceCallControls.tsx
var JE = {
	sm: {
		button: "w-10 h-10",
		hangup: "w-12 h-12",
		icon: "h-4 w-4",
		hangupIcon: "h-5 w-5"
	},
	md: {
		button: "w-12 h-12",
		hangup: "w-14 h-14",
		icon: "h-5 w-5",
		hangupIcon: "h-6 w-6"
	},
	lg: {
		button: "w-14 h-14",
		hangup: "w-16 h-16",
		icon: "h-6 w-6",
		hangupIcon: "h-7 w-7"
	}
}, YE = V(({ className: e, isMuted: t = !1, onMuteToggle: n, onHangup: r, showCaptions: i, onCaptionsToggle: a, direction: o = "horizontal", size: s = "md", disabled: c = !1, ...l }, u) => {
	let d = JE[s], f = I("flex items-center justify-center rounded-full transition-all", "focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-slate-900", c && "opacity-50 cursor-not-allowed", !c && "hover:scale-105 active:scale-95");
	return /* @__PURE__ */ J("div", {
		ref: u,
		className: I("flex items-center", o === "horizontal" ? "flex-row gap-4" : "flex-col gap-3", e),
		...l,
		children: [
			/* @__PURE__ */ q("button", {
				type: "button",
				onClick: n,
				disabled: c,
				className: I(f, d.button, t ? "bg-rose-500 hover:bg-rose-600 text-white focus:ring-rose-500" : "bg-slate-700 hover:bg-slate-600 text-white dark:bg-slate-600 dark:hover:bg-slate-500 focus:ring-slate-500"),
				"aria-label": t ? "Unmute microphone" : "Mute microphone",
				"aria-pressed": t,
				children: q(t ? Di : ki, { className: d.icon })
			}),
			/* @__PURE__ */ q("button", {
				type: "button",
				onClick: r,
				disabled: c,
				className: I(f, d.hangup, "bg-rose-500 hover:bg-rose-600 text-white focus:ring-rose-500"),
				"aria-label": "End call",
				children: /* @__PURE__ */ q(Li, { className: d.hangupIcon })
			}),
			a !== void 0 && /* @__PURE__ */ q("button", {
				type: "button",
				onClick: a,
				disabled: c,
				className: I(f, d.button, i ? "bg-violet-500 hover:bg-violet-600 text-white focus:ring-violet-500" : "bg-slate-600 hover:bg-slate-500 text-white dark:bg-slate-700 dark:hover:bg-slate-600 focus:ring-slate-500"),
				"aria-label": i ? "Hide captions" : "Show captions",
				"aria-pressed": i,
				children: /* @__PURE__ */ q(Lr, { className: d.icon })
			})
		]
	});
});
YE.displayName = "VoiceCallControls";
//#endregion
//#region src/components/chat/SpeakingIndicator/SpeakingIndicator.tsx
var XE = {
	sm: {
		ringExpand: 2,
		dotSize: "w-2 h-2",
		dotOffset: "-bottom-0.5 -right-0.5"
	},
	md: {
		ringExpand: 4,
		dotSize: "w-2.5 h-2.5",
		dotOffset: "-bottom-0.5 -right-0.5"
	},
	lg: {
		ringExpand: 6,
		dotSize: "w-3 h-3",
		dotOffset: "-bottom-1 -right-1"
	}
}, ZE = V(({ className: e, state: t, children: n, speakingColor: r = "violet", listeningColor: i = "emerald", size: a = "md", showDot: o = !1, ...s }, c) => {
	let l = XE[a], u = t !== "idle", d = t === "speaking" ? r : i, f = {
		violet: {
			ring: "bg-violet-500",
			dot: "bg-violet-500"
		},
		emerald: {
			ring: "bg-emerald-500",
			dot: "bg-emerald-500"
		},
		purple: {
			ring: "bg-purple-500",
			dot: "bg-purple-500"
		},
		green: {
			ring: "bg-green-500",
			dot: "bg-green-500"
		},
		sky: {
			ring: "bg-sky-500",
			dot: "bg-sky-500"
		},
		blue: {
			ring: "bg-blue-500",
			dot: "bg-blue-500"
		}
	}, p = f[d] || f.violet;
	return /* @__PURE__ */ J("div", {
		ref: c,
		className: I("relative inline-flex", e),
		...s,
		children: [
			u && /* @__PURE__ */ J(K, { children: [/* @__PURE__ */ q("div", {
				className: I("absolute inset-0 rounded-full opacity-50", p.ring, "animate-speaking-ring-1"),
				style: { "--ring-expand": `${l.ringExpand}px` }
			}), /* @__PURE__ */ q("div", {
				className: I("absolute inset-0 rounded-full opacity-30", p.ring, "animate-speaking-ring-2"),
				style: { "--ring-expand": `${l.ringExpand * 1.5}px` }
			})] }),
			/* @__PURE__ */ q("div", {
				className: "relative z-10",
				children: n
			}),
			o && u && /* @__PURE__ */ q("div", { className: I("absolute z-20 rounded-full border-2 border-white dark:border-slate-900", l.dotSize, l.dotOffset, p.dot, "animate-pulse") })
		]
	});
});
ZE.displayName = "SpeakingIndicator";
//#endregion
//#region src/components/chat/VoiceCallPanel/VoiceCallPanel.tsx
var QE = (e) => {
	let t = Math.floor(e / 60), n = e % 60;
	return `${t.toString().padStart(2, "0")}:${n.toString().padStart(2, "0")}`;
}, $E = (e, t, n) => {
	switch (e) {
		case "idle": return "Ready";
		case "dialing": return "Dialing...";
		case "connecting": return "Connecting...";
		case "connected": return t ? "Speaking..." : n ? "On call" : "Listening...";
		case "reconnecting": return "Reconnecting...";
		case "ended": return "Call ended";
		case "error": return "Connection failed";
		default: return "";
	}
}, eD = (e, t, n) => e === "connected" ? t ? "speaking" : n ? "idle" : "listening" : "idle", tD = V(({ className: e, state: t, participantName: n, avatar: r, duration: i = 0, isMuted: a = !1, isRemoteSpeaking: o = !1, error: s, transcript: c, showCaptions: l = !1, onMuteToggle: u, onHangup: d, onCaptionsToggle: f, onRetry: p, variant: m = "fullscreen", ...h }, g) => {
	let _ = eD(t, o, a), v = $E(t, o, a), y = t === "dialing" || t === "connecting" || t === "reconnecting", b = t === "connected";
	return m === "fullscreen" ? /* @__PURE__ */ q("div", {
		ref: g,
		className: I("flex items-center justify-center bg-black/60 backdrop-blur-sm", e),
		...h,
		children: /* @__PURE__ */ q("div", {
			className: "bg-gradient-to-b from-slate-900 to-slate-800 rounded-3xl overflow-hidden shadow-2xl max-w-sm w-full mx-4",
			children: /* @__PURE__ */ J("div", {
				className: "flex flex-col items-center justify-center p-8 min-h-[350px]",
				children: [t === "error" && /* @__PURE__ */ J(K, { children: [
					/* @__PURE__ */ q("div", {
						className: "w-20 h-20 rounded-full bg-rose-500/20 flex items-center justify-center mb-4",
						children: /* @__PURE__ */ q(tt, { className: "w-10 h-10 text-rose-500" })
					}),
					/* @__PURE__ */ q("h3", {
						className: "text-xl font-semibold text-white mb-2",
						children: "Connection Failed"
					}),
					/* @__PURE__ */ q("p", {
						className: "text-sm text-slate-400 text-center mb-6 px-4",
						children: s || "Unable to connect"
					}),
					/* @__PURE__ */ J("div", {
						className: "flex items-center gap-3",
						children: [p && /* @__PURE__ */ J("button", {
							type: "button",
							onClick: p,
							className: "px-6 py-3 bg-violet-600 text-white rounded-xl hover:bg-violet-700 transition-colors flex items-center gap-2",
							children: [/* @__PURE__ */ q(qi, { className: "w-4 h-4" }), "Try Again"]
						}), d && /* @__PURE__ */ q("button", {
							type: "button",
							onClick: d,
							className: "px-6 py-3 bg-slate-700 text-white rounded-xl hover:bg-slate-600 transition-colors",
							children: "Cancel"
						})]
					})
				] }), t !== "error" && /* @__PURE__ */ J(K, { children: [
					/* @__PURE__ */ q(ZE, {
						state: _,
						size: "lg",
						showDot: !0,
						children: /* @__PURE__ */ q("div", {
							className: I("w-28 h-28 rounded-full flex items-center justify-center", _ === "speaking" && "bg-violet-500", _ === "listening" && "bg-emerald-500", _ === "idle" && "bg-slate-700"),
							children: r || /* @__PURE__ */ q(zi, { className: "w-14 h-14 text-white" })
						})
					}),
					/* @__PURE__ */ q("h3", {
						className: "text-2xl font-semibold text-white mt-6 mb-1",
						children: n
					}),
					/* @__PURE__ */ q("p", {
						className: "text-sm text-slate-400 mb-2",
						children: v
					}),
					b && /* @__PURE__ */ q("p", {
						className: "text-lg font-mono text-emerald-400 mb-6 tabular-nums",
						children: QE(i)
					}),
					y && /* @__PURE__ */ q("div", {
						className: "mb-6",
						children: /* @__PURE__ */ q(qe, { className: "w-8 h-8 text-violet-500 animate-spin" })
					}),
					t === "ended" && i > 0 && /* @__PURE__ */ J("p", {
						className: "text-sm text-slate-500 mb-4 tabular-nums",
						children: ["Duration: ", QE(i)]
					}),
					b && /* @__PURE__ */ q(YE, {
						isMuted: a,
						onMuteToggle: u,
						onHangup: d,
						showCaptions: l,
						onCaptionsToggle: f,
						size: "lg"
					}),
					y && d && /* @__PURE__ */ q("button", {
						type: "button",
						onClick: d,
						className: "mt-4 px-6 py-2 text-slate-400 hover:text-white transition-colors",
						children: "Cancel"
					}),
					l && c && b && /* @__PURE__ */ q("div", {
						className: "absolute bottom-20 left-4 right-4",
						children: /* @__PURE__ */ q("div", {
							className: "bg-black/70 rounded-lg px-4 py-2 text-white text-sm text-center",
							children: c
						})
					})
				] })]
			})
		})
	}) : m === "inline" ? /* @__PURE__ */ q("div", {
		ref: g,
		className: I("rounded-2xl bg-slate-800 text-white shadow-lg max-w-sm overflow-hidden", "border-t-2", t === "connected" ? "border-t-emerald-500" : t === "error" ? "border-t-rose-500" : "border-t-amber-500", e),
		...h,
		children: /* @__PURE__ */ J("div", {
			className: "p-4",
			children: [
				/* @__PURE__ */ J("div", {
					className: "flex items-center justify-between mb-3",
					children: [/* @__PURE__ */ J("div", {
						className: "flex items-center gap-3",
						children: [/* @__PURE__ */ q(ZE, {
							state: _,
							size: "sm",
							showDot: !0,
							children: /* @__PURE__ */ q("div", {
								className: I("w-10 h-10 rounded-full flex items-center justify-center", t === "connected" ? "bg-emerald-500" : "bg-slate-700"),
								children: r || /* @__PURE__ */ q(zi, { className: "w-5 h-5 text-white" })
							})
						}), /* @__PURE__ */ J("div", { children: [/* @__PURE__ */ q("div", {
							className: "font-medium text-sm",
							children: n
						}), /* @__PURE__ */ q("div", {
							className: I("text-xs", t === "connected" ? "text-emerald-400" : "text-slate-400"),
							children: b ? QE(i) : v
						})] })]
					}), y && /* @__PURE__ */ q(qe, { className: "w-5 h-5 text-amber-500 animate-spin" })]
				}),
				l && c && b && /* @__PURE__ */ q("div", {
					className: "bg-slate-700/50 rounded-lg p-3 mb-3 text-sm text-slate-300 min-h-[48px]",
					children: c
				}),
				t === "error" && s && /* @__PURE__ */ J("div", {
					className: "bg-rose-500/20 rounded-lg p-3 mb-3 text-sm text-rose-300 flex items-center gap-2",
					children: [/* @__PURE__ */ q(tt, { className: "w-4 h-4 shrink-0" }), s]
				}),
				b && /* @__PURE__ */ q(YE, {
					isMuted: a,
					onMuteToggle: u,
					onHangup: d,
					showCaptions: l,
					onCaptionsToggle: f,
					size: "md",
					className: "justify-center"
				}),
				t === "error" && p && /* @__PURE__ */ J("div", {
					className: "flex justify-center gap-3",
					children: [/* @__PURE__ */ J("button", {
						type: "button",
						onClick: p,
						className: "px-4 py-2 bg-violet-600 text-white text-sm rounded-lg hover:bg-violet-700 transition-colors flex items-center gap-2",
						children: [/* @__PURE__ */ q(qi, { className: "w-3 h-3" }), "Retry"]
					}), d && /* @__PURE__ */ q("button", {
						type: "button",
						onClick: d,
						className: "px-4 py-2 bg-slate-700 text-white text-sm rounded-lg hover:bg-slate-600 transition-colors",
						children: "Cancel"
					})]
				})
			]
		})
	}) : /* @__PURE__ */ J("div", {
		ref: g,
		className: I("flex items-center gap-3 px-3 py-2 rounded-lg", "bg-slate-800 text-white", e),
		...h,
		children: [
			/* @__PURE__ */ q("div", { className: I("w-2 h-2 rounded-full shrink-0", t === "connected" && !a && "bg-emerald-500 animate-pulse", t === "connected" && a && "bg-slate-500", y && "bg-amber-500 animate-pulse", t === "error" && "bg-rose-500", t === "ended" && "bg-slate-500") }),
			/* @__PURE__ */ q("div", {
				className: "flex-1 min-w-0",
				children: /* @__PURE__ */ J("div", {
					className: "flex items-center gap-2",
					children: [
						/* @__PURE__ */ q("span", {
							className: "text-sm font-medium truncate",
							children: n
						}),
						b && /* @__PURE__ */ q("span", {
							className: "text-xs text-emerald-400 font-mono tabular-nums",
							children: QE(i)
						}),
						y && /* @__PURE__ */ q("span", {
							className: "text-xs text-amber-400",
							children: v
						})
					]
				})
			}),
			b && /* @__PURE__ */ J("div", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ q("button", {
					type: "button",
					onClick: u,
					className: I("p-1.5 rounded-full transition-colors", a ? "bg-rose-500/20 text-rose-400 hover:bg-rose-500/30" : "bg-slate-700 text-slate-300 hover:bg-slate-600"),
					"aria-label": a ? "Unmute" : "Mute",
					children: a ? /* @__PURE__ */ q("svg", {
						className: "w-4 h-4",
						fill: "currentColor",
						viewBox: "0 0 24 24",
						children: /* @__PURE__ */ q("path", { d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" })
					}) : /* @__PURE__ */ q("svg", {
						className: "w-4 h-4",
						fill: "currentColor",
						viewBox: "0 0 24 24",
						children: /* @__PURE__ */ q("path", { d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" })
					})
				}), /* @__PURE__ */ q("button", {
					type: "button",
					onClick: d,
					className: "p-1.5 rounded-full bg-rose-500/20 text-rose-400 hover:bg-rose-500/30 transition-colors",
					"aria-label": "End call",
					children: /* @__PURE__ */ q("svg", {
						className: "w-4 h-4",
						fill: "currentColor",
						viewBox: "0 0 24 24",
						children: /* @__PURE__ */ q("path", { d: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z" })
					})
				})]
			}),
			y && /* @__PURE__ */ q(qe, { className: "w-4 h-4 text-amber-500 animate-spin shrink-0" })
		]
	});
});
tD.displayName = "VoiceCallPanel";
//#endregion
//#region src/components/chat/AudioPlayer/AudioPlayer.tsx
var nD = (e) => `${Math.floor(e / 60)}:${Math.floor(e % 60).toString().padStart(2, "0")}`, rD = (e, t) => {
	let n = Math.floor(e * 1e3);
	return Array.from({ length: t }, (e, t) => {
		let r = (n + t * 137) % 100, i = .3 + Math.sin(t * .5) * .2, a = (Math.sin(r) * .5 + .5) * .5;
		return Math.min(1, Math.max(.15, i + a));
	});
}, iD = V(({ className: e, src: t, blob: n, duration: r, text: i, voice: a, language: o, autoPlay: s = !1, playbackRates: c = [
	1,
	1.5,
	2
], variant: l = "default", waveform: u, onPlay: d, onPause: f, onEnded: p, onTimeUpdate: m, ...h }, g) => {
	let _ = W(null), [v, y] = G(), [b, x] = G(!1), [S, C] = G(!0), [w, T] = G(!1), [E, D] = G(0), [O, k] = G(r || 0), [A, j] = G(1), M = l === "compact" ? 16 : 32, ee = u || rD(O || 10, M);
	U(() => {
		if (n) {
			let e = URL.createObjectURL(n);
			return y(e), () => URL.revokeObjectURL(e);
		}
	}, [n]);
	let te = t || v;
	U(() => {
		if (!te) {
			C(!1);
			return;
		}
		let e = new Audio(te);
		_.current = e;
		let t = () => {
			k(e.duration), C(!1), T(!1);
		}, n = () => {
			D(e.currentTime), m?.(e.currentTime);
		}, r = () => {
			x(!1), D(0), p?.();
		}, i = () => {
			x(!0), d?.();
		}, a = () => {
			x(!1), f?.();
		}, o = () => {
			T(!0), C(!1);
		}, c = () => {
			C(!1), s && e.play().catch(() => {});
		};
		return e.addEventListener("loadedmetadata", t), e.addEventListener("timeupdate", n), e.addEventListener("ended", r), e.addEventListener("play", i), e.addEventListener("pause", a), e.addEventListener("error", o), e.addEventListener("canplay", c), e.load(), () => {
			e.removeEventListener("loadedmetadata", t), e.removeEventListener("timeupdate", n), e.removeEventListener("ended", r), e.removeEventListener("play", i), e.removeEventListener("pause", a), e.removeEventListener("error", o), e.removeEventListener("canplay", c), e.pause(), _.current = null;
		};
	}, [
		te,
		s,
		d,
		f,
		p,
		m
	]), U(() => {
		_.current && (_.current.playbackRate = A);
	}, [A]);
	let ne = H(() => {
		_.current && (b ? _.current.pause() : _.current.play().catch(() => {}));
	}, [b]), re = H((e) => {
		let t = parseFloat(e.target.value);
		D(t), _.current && (_.current.currentTime = t);
	}, []), ie = H((e) => {
		if (!_.current || !O) return;
		let t = e.currentTarget.getBoundingClientRect(), n = (e.clientX - t.left) / t.width * O;
		D(n), _.current.currentTime = n;
	}, [O]), ae = H(() => {
		let e = (c.indexOf(A) + 1) % c.length;
		j(c[e] ?? 1);
	}, [A, c]), oe = O > 0 ? E / O : 0, se = Math.floor(oe * M);
	return w ? /* @__PURE__ */ q("div", {
		ref: g,
		className: I("rounded-lg border border-rose-200 bg-rose-50 dark:bg-rose-900/20 dark:border-rose-800 p-3", e),
		...h,
		children: /* @__PURE__ */ J("div", {
			className: "flex items-center gap-2 text-rose-600 dark:text-rose-400",
			children: [/* @__PURE__ */ q(tt, { className: "w-4 h-4" }), /* @__PURE__ */ q("span", {
				className: "text-sm",
				children: "Failed to load audio"
			})]
		})
	}) : l === "compact" ? /* @__PURE__ */ J("div", {
		ref: g,
		className: I("flex items-center gap-2 rounded-lg px-2 py-1.5", "bg-slate-100 dark:bg-slate-800", e),
		...h,
		children: [
			/* @__PURE__ */ q("button", {
				type: "button",
				onClick: ne,
				disabled: S,
				className: I("w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-colors", "bg-emerald-500 hover:bg-emerald-600 text-white", "focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 dark:focus:ring-offset-slate-800"),
				"aria-label": b ? "Pause" : "Play",
				children: S ? /* @__PURE__ */ q(qe, { className: "w-3.5 h-3.5 animate-spin" }) : b ? /* @__PURE__ */ q(Fi, {
					className: "w-3.5 h-3.5",
					fill: "currentColor"
				}) : /* @__PURE__ */ q(Vi, {
					className: "w-3.5 h-3.5 ml-0.5",
					fill: "currentColor"
				})
			}),
			/* @__PURE__ */ q("div", {
				className: "flex-1 h-1 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden",
				children: /* @__PURE__ */ q("div", {
					className: "h-full bg-emerald-500 transition-all duration-100",
					style: { width: `${oe * 100}%` }
				})
			}),
			/* @__PURE__ */ q("span", {
				className: "text-xs text-slate-500 dark:text-slate-400 font-mono tabular-nums min-w-[36px]",
				children: nD(E)
			})
		]
	}) : l === "waveform" ? /* @__PURE__ */ q("div", {
		ref: g,
		className: I("rounded-lg border border-slate-200 bg-white dark:bg-slate-900 dark:border-slate-800 p-3", e),
		...h,
		children: /* @__PURE__ */ J("div", {
			className: "flex items-center gap-3",
			children: [
				/* @__PURE__ */ q("button", {
					type: "button",
					onClick: ne,
					disabled: S,
					className: I("w-10 h-10 rounded-full flex items-center justify-center shrink-0 transition-colors", "bg-emerald-500 hover:bg-emerald-600 text-white", "focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 dark:focus:ring-offset-slate-900"),
					"aria-label": b ? "Pause" : "Play",
					children: S ? /* @__PURE__ */ q(qe, { className: "w-4 h-4 animate-spin" }) : b ? /* @__PURE__ */ q(Fi, {
						className: "w-4 h-4",
						fill: "currentColor"
					}) : /* @__PURE__ */ q(Vi, {
						className: "w-4 h-4 ml-0.5",
						fill: "currentColor"
					})
				}),
				/* @__PURE__ */ q("div", {
					className: "flex-1 flex items-center gap-[2px] h-8 cursor-pointer",
					onClick: ie,
					role: "slider",
					"aria-label": "Audio progress",
					"aria-valuemin": 0,
					"aria-valuemax": O,
					"aria-valuenow": E,
					tabIndex: 0,
					children: ee.slice(0, M).map((e, t) => {
						let n = t < se, r = Math.max(4, e * 28);
						return /* @__PURE__ */ q("div", {
							className: I("flex-1 max-w-[3px] rounded-full transition-colors", n ? "bg-emerald-500 dark:bg-emerald-400" : "bg-slate-200 dark:bg-slate-700"),
							style: { height: `${r}px` }
						}, t);
					})
				}),
				/* @__PURE__ */ J("span", {
					className: "text-xs text-slate-500 dark:text-slate-400 font-mono tabular-nums min-w-[64px] text-right",
					children: [
						nD(E),
						" / ",
						nD(O)
					]
				})
			]
		})
	}) : /* @__PURE__ */ J("div", {
		ref: g,
		className: I("rounded-lg border border-emerald-200 bg-emerald-50 dark:bg-emerald-900/20 dark:border-emerald-800 p-3", e),
		...h,
		children: [
			i && /* @__PURE__ */ J("div", {
				className: "flex items-start gap-3 mb-3",
				children: [/* @__PURE__ */ q(ha, { className: "w-5 h-5 text-emerald-600 dark:text-emerald-400 shrink-0 mt-0.5" }), /* @__PURE__ */ J("p", {
					className: "text-sm text-slate-800 dark:text-slate-200 flex-1",
					children: [
						"\"",
						i,
						"\""
					]
				})]
			}),
			/* @__PURE__ */ J("div", {
				className: "flex items-center gap-3",
				children: [
					/* @__PURE__ */ q("button", {
						type: "button",
						onClick: ne,
						disabled: S,
						className: I("w-10 h-10 rounded-full flex items-center justify-center shrink-0 transition-colors", "bg-emerald-600 hover:bg-emerald-700 text-white", "focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 dark:focus:ring-offset-emerald-900"),
						"aria-label": b ? "Pause" : "Play",
						children: S ? /* @__PURE__ */ q(qe, { className: "w-4 h-4 animate-spin" }) : b ? /* @__PURE__ */ q(Fi, {
							className: "w-4 h-4",
							fill: "currentColor"
						}) : /* @__PURE__ */ q(Vi, {
							className: "w-4 h-4 ml-0.5",
							fill: "currentColor"
						})
					}),
					/* @__PURE__ */ q("div", {
						className: "flex-1",
						children: /* @__PURE__ */ q("input", {
							type: "range",
							min: 0,
							max: O || 100,
							step: .1,
							value: E,
							onChange: re,
							className: I("w-full h-2 rounded-lg appearance-none cursor-pointer", "bg-emerald-200 dark:bg-emerald-800", "accent-emerald-600"),
							"aria-label": "Seek"
						})
					}),
					/* @__PURE__ */ J("span", {
						className: "text-xs text-slate-600 dark:text-slate-400 font-mono tabular-nums min-w-[64px] text-right",
						children: [
							nD(E),
							" / ",
							nD(O)
						]
					}),
					c.length > 1 && /* @__PURE__ */ J("button", {
						type: "button",
						onClick: ae,
						className: I("px-2 py-1 rounded text-xs font-medium tabular-nums transition-colors", "bg-emerald-200 hover:bg-emerald-300 text-emerald-700", "dark:bg-emerald-800 dark:hover:bg-emerald-700 dark:text-emerald-300"),
						"aria-label": `Playback speed: ${A}x`,
						children: [A, "x"]
					})
				]
			}),
			(a || o) && /* @__PURE__ */ J("div", {
				className: "mt-2 flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400",
				children: [
					a && /* @__PURE__ */ J("span", { children: ["Voice: ", a] }),
					a && o && /* @__PURE__ */ q("span", { children: "-" }),
					o && /* @__PURE__ */ q("span", { children: o })
				]
			})
		]
	});
});
iD.displayName = "AudioPlayer";
//#endregion
//#region src/components/chat/LiveTranscript/LiveTranscript.tsx
var aD = {
	user: {
		text: "text-emerald-600 dark:text-emerald-400",
		bg: "bg-emerald-500"
	},
	agent: {
		text: "text-violet-600 dark:text-violet-400",
		bg: "bg-violet-500"
	},
	system: {
		text: "text-slate-500 dark:text-slate-400",
		bg: "bg-slate-400"
	}
}, oD = (e) => e.toLocaleTimeString([], {
	hour: "2-digit",
	minute: "2-digit"
}), sD = V(({ className: e, entries: t = [], text: n, isListening: r = !1, maxHeight: i = 200, variant: a = "inline", ...o }, s) => {
	let c = W(null);
	U(() => {
		c.current && a === "inline" && (c.current.scrollTop = c.current.scrollHeight);
	}, [
		t,
		n,
		a
	]);
	let l = n || t[t.length - 1]?.text;
	return a === "overlay" ? /* @__PURE__ */ q("div", {
		ref: s,
		className: I("px-4 py-2", e),
		...o,
		children: /* @__PURE__ */ q("div", {
			className: I("bg-black/70 backdrop-blur-sm rounded-lg px-4 py-2", "text-white text-sm text-center", "animate-fade-in"),
			children: l || r && /* @__PURE__ */ J("span", {
				className: "flex items-center justify-center gap-2 text-slate-300",
				children: [/* @__PURE__ */ q(pE, {
					size: "sm",
					variant: "default"
				}), /* @__PURE__ */ q("span", { children: "Listening..." })]
			})
		})
	}) : a === "subtitle" ? /* @__PURE__ */ q("div", {
		ref: s,
		className: I("text-center px-4 py-2", e),
		...o,
		children: l ? /* @__PURE__ */ q("span", {
			className: I("text-sm text-slate-700 dark:text-slate-300", t[t.length - 1]?.isFinal === !1 && "italic text-slate-500 dark:text-slate-400"),
			children: l
		}) : r && /* @__PURE__ */ q("span", {
			className: "flex items-center justify-center gap-2 text-sm text-slate-400",
			children: /* @__PURE__ */ q(pE, {
				size: "sm",
				variant: "default"
			})
		})
	}) : /* @__PURE__ */ q("div", {
		ref: s,
		className: I("rounded-lg border border-slate-200 bg-white dark:bg-slate-900 dark:border-slate-800", e),
		...o,
		children: /* @__PURE__ */ J("div", {
			ref: c,
			className: "overflow-y-auto px-3 py-2 space-y-2",
			style: { maxHeight: `${i}px` },
			children: [
				t.length === 0 && !r && /* @__PURE__ */ q("p", {
					className: "text-sm text-slate-400 dark:text-slate-500 text-center py-4 italic",
					children: "No transcript yet"
				}),
				t.map((e) => {
					let t = aD[e.speaker] || aD.system, n = e.speaker === "user" ? "You" : e.speaker === "agent" ? "Agent" : "System";
					return /* @__PURE__ */ J("div", {
						className: "flex items-start gap-2",
						children: [/* @__PURE__ */ q("div", { className: I("w-2 h-2 rounded-full mt-1.5 shrink-0", t.bg) }), /* @__PURE__ */ J("div", {
							className: "flex-1 min-w-0",
							children: [/* @__PURE__ */ J("div", {
								className: "flex items-center gap-2",
								children: [/* @__PURE__ */ q("span", {
									className: I("text-xs font-medium", t.text),
									children: n
								}), e.timestamp && /* @__PURE__ */ q("span", {
									className: "text-xs text-slate-400 dark:text-slate-500",
									children: oD(e.timestamp)
								})]
							}), /* @__PURE__ */ q("p", {
								className: I("text-sm text-slate-700 dark:text-slate-300 leading-relaxed", e.isFinal === !1 && "italic text-slate-500 dark:text-slate-400"),
								children: e.text
							})]
						})]
					}, e.id);
				}),
				r && /* @__PURE__ */ J("div", {
					className: "flex items-center gap-2 py-1",
					children: [/* @__PURE__ */ q("div", { className: "w-2 h-2 rounded-full bg-emerald-500 animate-pulse" }), /* @__PURE__ */ q(pE, {
						size: "sm",
						variant: "user"
					})]
				})
			]
		})
	});
});
sD.displayName = "LiveTranscript";
//#endregion
//#region src/components/chat/MentionMenu/MentionMenu.tsx
var cD = (e) => e < 1024 ? `${e} B` : e < 1048576 ? `${(e / 1024).toFixed(1)} KB` : `${(e / 1048576).toFixed(1)} MB`, lD = (e, t) => {
	if (e.icon) return e.icon;
	let n = I("w-4 h-4", e.type === "file" ? t ? "text-amber-600 dark:text-amber-400" : "text-slate-500 dark:text-slate-400" : t ? "text-violet-600 dark:text-violet-400" : "text-slate-500 dark:text-slate-400");
	return e.type === "file" ? /* @__PURE__ */ q(hi, { className: n }) : /* @__PURE__ */ q(jr, { className: n });
}, uD = V(({ className: e, items: t, filterType: n = "all", onFilterChange: r, query: i = "", onQueryChange: a, selectedIndex: o = 0, onSelectedIndexChange: s, onSelect: c, onClose: l, isOpen: u = !0, showSearch: d = !1, searchPlaceholder: f = "Search...", emptyMessage: p = "No results found", labels: m = {}, ...h }, g) => {
	let [_, v] = G(o), [y, b] = G(n), [x, S] = G(i), C = s ? o : _, w = r ? n : y, T = a ? i : x, E = t.filter((e) => {
		let t = w === "all" || w === "files" && e.type === "file" || w === "agents" && (e.type === "agent" || e.type === "user"), n = !T || e.name.toLowerCase().includes(T.toLowerCase()) || e.description?.toLowerCase().includes(T.toLowerCase());
		return t && n;
	}), D = t.filter((e) => e.type === "file").length, O = t.filter((e) => e.type === "agent" || e.type === "user").length;
	U(() => {
		if (C >= E.length) {
			let e = Math.max(0, E.length - 1);
			s ? s(e) : v(e);
		}
	}, [
		E.length,
		C,
		s
	]);
	let k = H((e) => {
		if (u) switch (e.key) {
			case "ArrowDown": {
				e.preventDefault();
				let t = Math.min(C + 1, E.length - 1);
				s ? s(t) : v(t);
				break;
			}
			case "ArrowUp": {
				e.preventDefault();
				let t = Math.max(C - 1, 0);
				s ? s(t) : v(t);
				break;
			}
			case "Enter":
			case "Tab":
				E.length > 0 && (e.preventDefault(), c(E[C]));
				break;
			case "Escape": e.preventDefault(), l?.();
		}
	}, [
		u,
		C,
		E,
		c,
		l,
		s
	]);
	U(() => (document.addEventListener("keydown", k), () => document.removeEventListener("keydown", k)), [k]);
	let A = (e) => {
		r ? r(e) : b(e), s ? s(0) : v(0);
	}, j = (e) => {
		a ? a(e) : S(e), s ? s(0) : v(0);
	};
	return u ? /* @__PURE__ */ J("div", {
		ref: g,
		className: I("bg-white rounded-xl shadow-xl border border-slate-200 max-h-80 overflow-hidden", "dark:bg-slate-900 dark:border-slate-700", e),
		role: "listbox",
		"aria-label": "Mention suggestions",
		...h,
		children: [
			d && /* @__PURE__ */ q("div", {
				className: "p-2 border-b border-slate-100 dark:border-slate-800",
				children: /* @__PURE__ */ J("div", {
					className: "relative",
					children: [/* @__PURE__ */ q(te, { className: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" }), /* @__PURE__ */ q("input", {
						type: "text",
						value: T,
						onChange: (e) => j(e.target.value),
						placeholder: f,
						className: I("w-full pl-9 pr-3 py-2 text-sm rounded-lg", "bg-slate-50 border border-slate-200", "focus:outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100", "dark:bg-slate-800 dark:border-slate-700", "dark:focus:border-sky-500 dark:focus:ring-sky-900/50", "placeholder-slate-400 dark:placeholder-slate-500"),
						autoFocus: !0
					})]
				})
			}),
			/* @__PURE__ */ J("div", {
				className: "flex border-b border-slate-100 bg-slate-50/50 dark:border-slate-800 dark:bg-slate-800/50",
				children: [
					/* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => A("all"),
						className: I("flex-1 px-3 py-2 text-xs font-medium transition-colors", w === "all" ? "text-amber-600 border-b-2 border-amber-500 bg-white dark:bg-slate-900 dark:text-amber-400" : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"),
						children: m.all || "All"
					}),
					/* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => A("files"),
						className: I("flex-1 px-3 py-2 text-xs font-medium transition-colors", w === "files" ? "text-amber-600 border-b-2 border-amber-500 bg-white dark:bg-slate-900 dark:text-amber-400" : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"),
						children: m.files || `Files (${D})`
					}),
					/* @__PURE__ */ q("button", {
						type: "button",
						onClick: () => A("agents"),
						className: I("flex-1 px-3 py-2 text-xs font-medium transition-colors", w === "agents" ? "text-amber-600 border-b-2 border-amber-500 bg-white dark:bg-slate-900 dark:text-amber-400" : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"),
						children: m.agents || `Agents (${O})`
					})
				]
			}),
			/* @__PURE__ */ J("div", {
				className: "overflow-y-auto max-h-56 py-1",
				children: [E.map((e, t) => {
					let n = t === C, r = e.type === "file";
					return /* @__PURE__ */ J("button", {
						type: "button",
						role: "option",
						"aria-selected": n,
						onClick: () => c(e),
						onMouseEnter: () => {
							s ? s(t) : v(t);
						},
						className: I("w-full text-left px-4 py-2.5 transition-colors flex items-center gap-3", n ? r ? "bg-amber-50 text-slate-900 dark:bg-amber-950/50 dark:text-white" : "bg-violet-50 text-slate-900 dark:bg-violet-950/50 dark:text-white" : "hover:bg-slate-50 text-slate-700 dark:hover:bg-slate-800 dark:text-slate-300"),
						children: [/* @__PURE__ */ q("div", {
							className: I("flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center", n ? r ? "bg-amber-100 dark:bg-amber-900/40" : "bg-violet-100 dark:bg-violet-900/40" : "bg-slate-100 dark:bg-slate-800"),
							children: lD(e, n)
						}), /* @__PURE__ */ J("div", {
							className: "flex-1 min-w-0",
							children: [/* @__PURE__ */ q("div", {
								className: "font-medium truncate text-sm",
								children: e.name
							}), (e.description || e.size !== void 0) && /* @__PURE__ */ q("div", {
								className: "text-xs text-slate-400 dark:text-slate-500 mt-0.5 truncate",
								children: e.size === void 0 ? e.description : cD(e.size)
							})]
						})]
					}, e.id);
				}), E.length === 0 && /* @__PURE__ */ q("div", {
					className: "px-4 py-6 text-center text-sm text-slate-400 dark:text-slate-500",
					children: p
				})]
			})
		]
	}) : null;
});
uD.displayName = "MentionMenu";
var dD = V(({ className: e, item: t, onRemove: n, removable: r = !0, ...i }, a) => {
	let o = t.type === "file";
	return /* @__PURE__ */ J("span", {
		ref: a,
		className: I("inline-flex items-center gap-1 px-2 py-0.5 mx-0.5 text-sm font-medium rounded-md border align-middle", o ? "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/40 dark:text-amber-300 dark:border-amber-700" : "bg-violet-100 text-violet-700 border-violet-200 dark:bg-violet-900/40 dark:text-violet-300 dark:border-violet-700", e),
		...i,
		children: [
			q(o ? hi : jr, { className: "w-3 h-3" }),
			/* @__PURE__ */ q("span", { children: t.name }),
			r && n && /* @__PURE__ */ q("button", {
				type: "button",
				onClick: (e) => {
					e.stopPropagation(), n();
				},
				className: I("ml-1 hover:text-red-500 dark:hover:text-red-400", "focus:outline-none focus:ring-1 focus:ring-red-300 rounded-sm"),
				"aria-label": `Remove ${t.name}`,
				children: "×"
			})
		]
	});
});
dD.displayName = "MentionBadge";
//#endregion
//#region src/components/chat/EmptyChatState/EmptyChatState.tsx
var fD = {
	welcome: {
		icon: Ti,
		title: "How can I help?",
		subtitle: "Start a conversation by typing a message below.",
		iconBgClass: "bg-sky-100 dark:bg-sky-900/30",
		iconColorClass: "text-sky-600 dark:text-sky-400"
	},
	mission: {
		icon: ra,
		title: "Mission Ready",
		subtitle: "Send a message to begin working on this mission.",
		iconBgClass: "bg-amber-100 dark:bg-amber-900/30",
		iconColorClass: "text-amber-600 dark:text-amber-400"
	},
	agent: {
		icon: jr,
		title: "Talk to Agent",
		subtitle: "Ask anything and the agent will help you.",
		iconBgClass: "bg-violet-100 dark:bg-violet-900/30",
		iconColorClass: "text-violet-600 dark:text-violet-400"
	},
	noAccess: {
		icon: Zt,
		title: "No Agent Access",
		subtitle: "Contact your administrator to request access to this agent.",
		iconBgClass: "bg-rose-100 dark:bg-rose-900/30",
		iconColorClass: "text-rose-600 dark:text-rose-400"
	},
	error: {
		icon: tt,
		title: "Something went wrong",
		subtitle: "Please try again or contact support if the issue persists.",
		iconBgClass: "bg-rose-100 dark:bg-rose-900/30",
		iconColorClass: "text-rose-600 dark:text-rose-400"
	}
}, pD = V(({ className: e, context: t = "welcome", title: n, subtitle: r, icon: i, actions: a, suggestions: o, onSuggestionClick: s, ...c }, l) => {
	let u = fD[t], d = u.icon, f = n ?? u.title, p = r ?? u.subtitle;
	return /* @__PURE__ */ J("div", {
		ref: l,
		className: I("flex flex-col items-center justify-center text-center", "min-h-[300px] py-12 px-6", "animate-fade-in", e),
		role: "status",
		"aria-live": "polite",
		...c,
		children: [
			/* @__PURE__ */ q("div", {
				className: I("flex items-center justify-center", "h-16 w-16 rounded-full mb-5", u.iconBgClass),
				children: i ?? /* @__PURE__ */ q(d, {
					className: I("h-8 w-8", u.iconColorClass),
					"aria-hidden": "true"
				})
			}),
			/* @__PURE__ */ q("h3", {
				className: "text-lg font-semibold text-slate-900 dark:text-slate-100 mb-2",
				children: f
			}),
			p && /* @__PURE__ */ q("p", {
				className: "text-sm text-slate-500 dark:text-slate-400 max-w-md mb-6",
				children: p
			}),
			o && o.length > 0 && /* @__PURE__ */ q("div", {
				className: "flex flex-wrap justify-center gap-2 mb-6 max-w-lg",
				children: o.map((e, t) => /* @__PURE__ */ q("button", {
					type: "button",
					onClick: () => s?.(e),
					className: I("px-3 py-1.5 rounded-full text-sm", "bg-slate-100 text-slate-700 border border-slate-200", "hover:bg-slate-200 hover:border-slate-300", "dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700", "dark:hover:bg-slate-700 dark:hover:border-slate-600", "transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500"),
					children: e
				}, t))
			}),
			a && /* @__PURE__ */ q("div", {
				className: "flex items-center gap-3",
				children: a
			})
		]
	});
});
pD.displayName = "EmptyChatState";
//#endregion
//#region src/components/chat/ConnectionStatus/ConnectionStatus.tsx
var mD = {
	connected: {
		icon: ya,
		message: "Connected",
		bannerBgClass: "bg-emerald-50 border-emerald-200 dark:bg-emerald-950/50 dark:border-emerald-800",
		pillBgClass: "bg-emerald-100 dark:bg-emerald-900/50",
		textClass: "text-emerald-700 dark:text-emerald-300",
		dotClass: "bg-emerald-500"
	},
	connecting: {
		icon: qe,
		message: "Connecting...",
		bannerBgClass: "bg-amber-50 border-amber-200 dark:bg-amber-950/50 dark:border-amber-800",
		pillBgClass: "bg-amber-100 dark:bg-amber-900/50",
		textClass: "text-amber-700 dark:text-amber-300",
		dotClass: "bg-amber-500",
		spin: !0
	},
	reconnecting: {
		icon: qe,
		message: "Reconnecting",
		bannerBgClass: "bg-amber-50 border-amber-200 dark:bg-amber-950/50 dark:border-amber-800",
		pillBgClass: "bg-amber-100 dark:bg-amber-900/50",
		textClass: "text-amber-700 dark:text-amber-300",
		dotClass: "bg-amber-500",
		spin: !0
	},
	disconnected: {
		icon: _a,
		message: "Disconnected",
		bannerBgClass: "bg-amber-50 border-amber-200 dark:bg-amber-950/50 dark:border-amber-800",
		pillBgClass: "bg-amber-100 dark:bg-amber-900/50",
		textClass: "text-amber-700 dark:text-amber-300",
		dotClass: "bg-amber-500"
	},
	error: {
		icon: tt,
		message: "Connection error",
		bannerBgClass: "bg-rose-50 border-rose-200 dark:bg-rose-950/50 dark:border-rose-800",
		pillBgClass: "bg-rose-100 dark:bg-rose-900/50",
		textClass: "text-rose-700 dark:text-rose-300",
		dotClass: "bg-rose-500"
	}
}, hD = V(({ className: e, state: t, reconnectAttempt: n, message: r, variant: i = "banner", autoHide: a = !0, autoHideDelay: o = 2e3, ...s }, c) => {
	let [l, u] = G(!0), [d, f] = G(!1), p = mD[t], m = p.icon, h = r ?? p.message;
	return t === "reconnecting" && n !== void 0 && (h = r ?? `Reconnecting (attempt ${n})...`), U(() => {
		if (t === "connected" && a) {
			let e = setTimeout(() => {
				f(!0), setTimeout(() => u(!1), 200);
			}, o);
			return () => clearTimeout(e);
		}
		u(!0), f(!1);
	}, [
		t,
		a,
		o
	]), l ? i === "banner" ? /* @__PURE__ */ J("div", {
		ref: c,
		role: "status",
		"aria-live": "polite",
		className: I("flex items-center justify-center gap-2 px-4 py-2 border-b", "transition-opacity duration-200", p.bannerBgClass, d && "opacity-0", e),
		...s,
		children: [
			/* @__PURE__ */ q(m, {
				className: I("h-4 w-4", p.textClass, p.spin && "animate-spin"),
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ q("span", {
				className: I("text-sm font-medium", p.textClass),
				children: h
			}),
			/* @__PURE__ */ q("span", {
				className: "sr-only",
				children: t === "connected" ? "You are now connected" : `Connection status: ${t}`
			})
		]
	}) : i === "pill" ? /* @__PURE__ */ J("div", {
		ref: c,
		role: "status",
		"aria-live": "polite",
		className: I("inline-flex items-center gap-1.5 px-3 py-1 rounded-full", "transition-opacity duration-200", p.pillBgClass, d && "opacity-0", e),
		...s,
		children: [
			/* @__PURE__ */ q("span", {
				className: I("h-2 w-2 rounded-full", p.dotClass, (t === "connecting" || t === "reconnecting") && "animate-pulse"),
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ q("span", {
				className: I("text-xs font-medium", p.textClass),
				children: h
			}),
			/* @__PURE__ */ q("span", {
				className: "sr-only",
				children: t === "connected" ? "You are now connected" : `Connection status: ${t}`
			})
		]
	}) : /* @__PURE__ */ J("div", {
		ref: c,
		role: "status",
		"aria-live": "polite",
		className: I("inline-flex items-center gap-1.5", "transition-opacity duration-200", d && "opacity-0", e),
		...s,
		children: [
			/* @__PURE__ */ q(m, {
				className: I("h-3.5 w-3.5", p.textClass, p.spin && "animate-spin"),
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ q("span", {
				className: I("text-xs", p.textClass),
				children: h
			}),
			/* @__PURE__ */ q("span", {
				className: "sr-only",
				children: t === "connected" ? "You are now connected" : `Connection status: ${t}`
			})
		]
	}) : null;
});
hD.displayName = "ConnectionStatus";
//#endregion
//#region src/components/chat/MessageGroup/MessageGroup.tsx
var gD = (e) => e.toLocaleTimeString(void 0, {
	hour: "numeric",
	minute: "2-digit",
	hour12: !0
}), _D = V(({ className: e, avatar: t, senderName: n, isOwn: r = !1, timestamp: i, children: a, ...o }, s) => {
	let c = jn.toArray(a), l = c.length;
	return /* @__PURE__ */ J("div", {
		ref: s,
		className: I("flex gap-3 py-2", r && "flex-row-reverse", e),
		...o,
		children: [
			!r && /* @__PURE__ */ q("div", {
				className: "flex flex-col items-center",
				children: /* @__PURE__ */ q("div", {
					className: "h-8 w-8 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center shrink-0 overflow-hidden",
					children: t ?? /* @__PURE__ */ q("span", {
						className: "text-xs font-medium text-slate-600 dark:text-slate-400",
						children: n?.split(" ").map((e) => e[0]).join("").toUpperCase().slice(0, 2) ?? "?"
					})
				})
			}),
			/* @__PURE__ */ J("div", {
				className: I("flex flex-col min-w-0 max-w-[80%]", r ? "items-end" : "items-start"),
				children: [(n || i) && /* @__PURE__ */ J("div", {
					className: I("flex items-center gap-2 mb-1 px-1", r && "flex-row-reverse"),
					children: [n && /* @__PURE__ */ q("span", {
						className: "text-xs font-medium text-slate-700 dark:text-slate-300",
						children: n
					}), i && /* @__PURE__ */ q("span", {
						className: "text-xs text-slate-400 dark:text-slate-500",
						children: gD(i)
					})]
				}), /* @__PURE__ */ q("div", {
					className: "flex flex-col gap-1",
					children: c.map((e, t) => {
						let n = t === 0, r = t === l - 1;
						return Nn(e) ? Mn(e, {
							key: t,
							"data-group-position": n ? "first" : r ? "last" : "middle"
						}) : /* @__PURE__ */ q("div", { children: e }, t);
					})
				})]
			}),
			r && /* @__PURE__ */ q("div", { className: "w-8 shrink-0" })
		]
	});
});
_D.displayName = "MessageGroup";
var vD = V(({ className: e, isOwn: t = !1, children: n, ...r }, i) => /* @__PURE__ */ q("div", {
	ref: i,
	className: I("px-3 py-2 rounded-2xl text-sm leading-relaxed", t ? "bg-sky-600 text-white dark:bg-sky-500" : "bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-slate-100", "[&[data-group-position=\"first\"]]:rounded-bl-md", "[&[data-group-position=\"middle\"]]:rounded-l-md", "[&[data-group-position=\"last\"]]:rounded-tl-md", t && "[&[data-group-position=\"first\"]]:rounded-br-md", t && "[&[data-group-position=\"middle\"]]:rounded-r-md", t && "[&[data-group-position=\"last\"]]:rounded-tr-md", e),
	...r,
	children: n
}));
vD.displayName = "MessageBubble";
//#endregion
//#region src/components/chat/MarkdownRenderer/MarkdownRenderer.tsx
var yD = V(({ className: e, content: t, keywords: n = [], compact: r = !1, onLinkClick: i, renderCodeBlock: a, ReactMarkdown: o, remarkGfm: s, ...c }, l) => {
	let u = H((e) => {
		if (n.length === 0 || !e) return e;
		let t = RegExp(`(${n.map((e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})`, "gi"), r = e.split(t);
		return r.length === 1 ? e : r.map((e, t) => n.some((t) => t.toLowerCase() === e.toLowerCase()) ? /* @__PURE__ */ q("mark", {
			className: "bg-amber-100 text-amber-900 px-0.5 rounded dark:bg-amber-500/20 dark:text-amber-200",
			children: e
		}, t) : e);
	}, [n]), d = H((e, t) => {
		i && (e.preventDefault(), i(t));
	}, [i]), f = H((e, t) => /* @__PURE__ */ q(TE, {
		code: e,
		language: t,
		collapsible: !1,
		defaultCollapsed: !1,
		showLineNumbers: !1
	}), []), p = a || f, m = {
		paragraph: r ? "mb-2 last:mb-0" : "mb-4 last:mb-0",
		list: r ? "mb-2 pl-5 space-y-1" : "mb-4 pl-6 space-y-2",
		heading: r ? "mb-2" : "mb-3",
		blockquote: r ? "my-2" : "my-4",
		pre: r ? "mb-2" : "mb-4",
		image: r ? "my-2" : "my-4"
	}, h = {
		p: ({ children: e }) => /* @__PURE__ */ q("p", {
			className: m.paragraph,
			children: typeof e == "string" ? u(e) : e
		}),
		ul: ({ children: e }) => /* @__PURE__ */ q("ul", {
			className: I(m.list, "list-disc"),
			children: e
		}),
		ol: ({ children: e }) => /* @__PURE__ */ q("ol", {
			className: I(m.list, "list-decimal"),
			children: e
		}),
		li: ({ children: e }) => /* @__PURE__ */ q("li", {
			className: "text-slate-800 dark:text-slate-200",
			children: typeof e == "string" ? u(e) : e
		}),
		code: ({ children: e, className: t }) => {
			let n = t?.startsWith("language-"), r = n ? t?.replace("language-", "") : void 0;
			return n && typeof e == "string" ? p(e.trim(), r) : /* @__PURE__ */ q("code", {
				className: "bg-slate-100 dark:bg-slate-800 px-1.5 py-0.5 rounded text-sm font-mono text-slate-800 dark:text-slate-200",
				children: e
			});
		},
		pre: ({ children: e }) => /* @__PURE__ */ q("div", {
			className: m.pre,
			children: e
		}),
		img: ({ src: e, alt: t }) => /* @__PURE__ */ q("img", {
			src: e || "",
			alt: t || "Image",
			className: I("max-w-full h-auto rounded-xl shadow-lg block", m.image),
			style: { maxHeight: "600px" },
			crossOrigin: "anonymous"
		}),
		a: ({ href: e, children: t }) => /* @__PURE__ */ q("a", {
			href: e,
			target: "_blank",
			rel: "noopener noreferrer",
			onClick: (t) => e && d(t, e),
			className: "text-amber-600 hover:text-amber-700 underline dark:text-amber-400 dark:hover:text-amber-300",
			children: t
		}),
		blockquote: ({ children: e }) => /* @__PURE__ */ q("blockquote", {
			className: I("border-l-4 border-slate-300 pl-4 text-slate-600 italic", "dark:border-slate-600 dark:text-slate-400", m.blockquote),
			children: e
		}),
		h1: ({ children: e }) => /* @__PURE__ */ q("h1", {
			className: I("text-2xl font-bold text-slate-900 dark:text-slate-100", m.heading),
			children: e
		}),
		h2: ({ children: e }) => /* @__PURE__ */ q("h2", {
			className: I("text-xl font-bold text-slate-900 dark:text-slate-100", m.heading),
			children: e
		}),
		h3: ({ children: e }) => /* @__PURE__ */ q("h3", {
			className: I("text-lg font-semibold text-slate-900 dark:text-slate-100", m.heading),
			children: e
		}),
		h4: ({ children: e }) => /* @__PURE__ */ q("h4", {
			className: I("text-base font-semibold text-slate-900 dark:text-slate-100", m.heading),
			children: e
		}),
		h5: ({ children: e }) => /* @__PURE__ */ q("h5", {
			className: I("text-sm font-semibold text-slate-900 dark:text-slate-100", m.heading),
			children: e
		}),
		h6: ({ children: e }) => /* @__PURE__ */ q("h6", {
			className: I("text-sm font-medium text-slate-900 dark:text-slate-100", m.heading),
			children: e
		}),
		table: ({ children: e }) => /* @__PURE__ */ q("div", {
			className: "overflow-x-auto mb-4",
			children: /* @__PURE__ */ q("table", {
				className: "min-w-full divide-y divide-slate-200 dark:divide-slate-700",
				children: e
			})
		}),
		thead: ({ children: e }) => /* @__PURE__ */ q("thead", {
			className: "bg-slate-50 dark:bg-slate-800",
			children: e
		}),
		tbody: ({ children: e }) => /* @__PURE__ */ q("tbody", {
			className: "divide-y divide-slate-200 dark:divide-slate-700",
			children: e
		}),
		tr: ({ children: e }) => /* @__PURE__ */ q("tr", { children: e }),
		th: ({ children: e }) => /* @__PURE__ */ q("th", {
			className: "px-4 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider dark:text-slate-300",
			children: e
		}),
		td: ({ children: e }) => /* @__PURE__ */ q("td", {
			className: "px-4 py-2 text-sm text-slate-700 dark:text-slate-300",
			children: e
		}),
		hr: () => /* @__PURE__ */ q("hr", { className: "my-4 border-slate-200 dark:border-slate-700" }),
		strong: ({ children: e }) => /* @__PURE__ */ q("strong", {
			className: "font-semibold",
			children: e
		}),
		em: ({ children: e }) => /* @__PURE__ */ q("em", { children: e }),
		del: ({ children: e }) => /* @__PURE__ */ q("del", {
			className: "line-through text-slate-500 dark:text-slate-400",
			children: e
		})
	}, g = s ? [s] : [];
	return /* @__PURE__ */ q("div", {
		ref: l,
		className: I("text-slate-800 leading-relaxed dark:text-slate-200", e),
		...c,
		children: /* @__PURE__ */ q(o, {
			remarkPlugins: g,
			components: h,
			children: t
		})
	});
});
yD.displayName = "MarkdownRenderer";
//#endregion
//#region src/components/chat/SuggestionChips/SuggestionChips.tsx
var bD = a([
	"inline-flex items-center justify-center font-medium",
	"border rounded-md cursor-pointer",
	"transition-all duration-150",
	"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900",
	"disabled:pointer-events-none disabled:opacity-50",
	"hover:scale-[1.02] hover:shadow-sm",
	"active:scale-[0.98]"
], {
	variants: { size: {
		sm: "h-7 px-2.5 text-xs",
		md: "h-8 px-3 text-sm"
	} },
	defaultVariants: { size: "sm" }
}), xD = V(({ className: e, suggestion: t, onChipSelect: n, disabled: r = !1, size: i, maxLength: a = 60, animationDelay: o = 0, ...s }, c) => {
	let l = t.length > a ? `${t.slice(0, a)}...` : t;
	return /* @__PURE__ */ q("button", {
		ref: c,
		type: "button",
		disabled: r,
		onClick: () => n(t),
		className: I(bD({ size: i }), "bg-white text-slate-700 border-slate-300", "hover:bg-slate-50 hover:border-slate-400", "focus-visible:ring-slate-500", "dark:bg-slate-800 dark:text-slate-200 dark:border-slate-600", "dark:hover:bg-slate-700 dark:hover:border-slate-500", "animate-fade-in opacity-0", e),
		style: {
			animationDelay: `${o}ms`,
			animationFillMode: "forwards"
		},
		title: t.length > a ? t : void 0,
		"aria-label": `Select suggestion: ${t}`,
		...s,
		children: l
	});
});
xD.displayName = "SuggestionChip";
var SD = V(({ className: e, suggestions: t, maxVisible: n = 3, onSelect: r, disabled: i = !1, size: a = "sm", maxChipLength: o = 60, staggerDelay: s = 50, ...c }, l) => {
	if (!t || t.length === 0) return null;
	let u = t.slice(0, n);
	return /* @__PURE__ */ q("div", {
		ref: l,
		className: I("flex flex-wrap gap-2", e),
		role: "group",
		"aria-label": "Suggested responses",
		...c,
		children: u.map((e, t) => /* @__PURE__ */ q(xD, {
			suggestion: e,
			onChipSelect: r,
			disabled: i,
			size: a,
			maxLength: o,
			animationDelay: t * s
		}, `${e}-${t}`))
	});
});
SD.displayName = "SuggestionChips";
//#endregion
//#region src/components/chat/GovernanceIndicator/GovernanceIndicator.tsx
var CD = a(["inline-flex items-center rounded-lg transition-colors"], {
	variants: {
		size: {
			sm: "p-1.5",
			md: "p-2 gap-1.5"
		},
		action: {
			allow: "text-slate-500 dark:text-slate-400",
			deny: "text-rose-500 dark:text-rose-400",
			obfuscate: "text-amber-500 dark:text-amber-400",
			escalate: "text-sky-500 dark:text-sky-400",
			audit: "text-slate-500 dark:text-slate-400"
		}
	},
	defaultVariants: {
		size: "sm",
		action: "audit"
	}
}), wD = {
	allow: {
		icon: ie,
		label: "Allowed",
		description: "Request was allowed by governance rules"
	},
	deny: {
		icon: Zt,
		label: "Denied",
		description: "Request was denied by governance rules"
	},
	obfuscate: {
		icon: Me,
		label: "Obfuscated",
		description: "Response was partially obfuscated for privacy"
	},
	escalate: {
		icon: Gi,
		label: "Escalated",
		description: "Request was escalated for human review"
	},
	audit: {
		icon: $i,
		label: "Audited",
		description: "Request was logged for audit purposes"
	}
}, TD = V(({ className: e, action: t, showLabel: n = !1, label: r, size: i = "sm", ...a }, o) => {
	let s = wD[t], c = s.icon, l = r || s.label, u = !n, d = /* @__PURE__ */ J("div", {
		ref: o,
		className: I(CD({
			size: i,
			action: t
		}), e),
		...a,
		children: [
			/* @__PURE__ */ q(c, {
				className: "h-4 w-4",
				"aria-hidden": "true"
			}),
			n && /* @__PURE__ */ q("span", {
				className: "text-xs font-medium",
				children: l
			}),
			!n && /* @__PURE__ */ q("span", {
				className: "sr-only",
				children: l
			})
		]
	});
	return u ? /* @__PURE__ */ q(E, {
		delayDuration: 200,
		children: /* @__PURE__ */ J(k, { children: [/* @__PURE__ */ q(ae, {
			asChild: !0,
			children: d
		}), /* @__PURE__ */ q(ze, {
			side: "top",
			children: /* @__PURE__ */ J("div", {
				className: "text-center",
				children: [/* @__PURE__ */ q("div", {
					className: "font-medium",
					children: l
				}), /* @__PURE__ */ q("div", {
					className: "text-xs text-slate-400 dark:text-slate-500 mt-0.5",
					children: s.description
				})]
			})
		})] })
	}) : d;
});
TD.displayName = "GovernanceIndicator";
//#endregion
//#region src/components/chat/ToolCallCard/ToolCallCard.tsx
var ED = {
	pending: {
		borderColor: "border-l-slate-300 dark:border-l-slate-600",
		bgColor: "bg-slate-50 dark:bg-slate-800/50",
		icon: Gr,
		iconColor: "text-slate-400 dark:text-slate-500",
		label: "Pending"
	},
	running: {
		borderColor: "border-l-amber-400 dark:border-l-amber-500",
		bgColor: "bg-amber-50/50 dark:bg-amber-500/5",
		icon: qe,
		iconColor: "text-amber-500 dark:text-amber-400",
		label: "Running",
		animate: !0
	},
	success: {
		borderColor: "border-l-emerald-400 dark:border-l-emerald-500",
		bgColor: "bg-emerald-50/50 dark:bg-emerald-500/5",
		icon: tn,
		iconColor: "text-emerald-500 dark:text-emerald-400",
		label: "Success"
	},
	error: {
		borderColor: "border-l-rose-400 dark:border-l-rose-500",
		bgColor: "bg-rose-50/50 dark:bg-rose-500/5",
		icon: Ur,
		iconColor: "text-rose-500 dark:text-rose-400",
		label: "Error"
	}
}, DD = (e) => e < 1e3 ? `${e}ms` : `${(e / 1e3).toFixed(1)}s`, OD = ({ data: e }) => {
	let t = (e, n = 0) => {
		let r = "  ".repeat(n);
		if (e === null) return /* @__PURE__ */ q("span", {
			className: "text-slate-400 dark:text-slate-500",
			children: "null"
		});
		if (typeof e == "string") {
			let t = e.length > 100 ? `${e.slice(0, 100)}...` : e;
			return /* @__PURE__ */ J("span", {
				className: "text-emerald-600 dark:text-emerald-400",
				children: [
					"\"",
					t,
					"\""
				]
			});
		}
		if (typeof e == "number") return /* @__PURE__ */ q("span", {
			className: "text-amber-600 dark:text-amber-400",
			children: e
		});
		if (typeof e == "boolean") return /* @__PURE__ */ q("span", {
			className: "text-violet-600 dark:text-violet-400",
			children: e ? "true" : "false"
		});
		if (Array.isArray(e)) return e.length === 0 ? /* @__PURE__ */ q("span", { children: "[]" }) : /* @__PURE__ */ J("span", { children: [
			"[\n",
			e.map((i, a) => /* @__PURE__ */ J("span", { children: [
				r,
				"  ",
				t(i, n + 1),
				a < e.length - 1 ? "," : "",
				"\n"
			] }, a)),
			r,
			"]"
		] });
		if (typeof e == "object") {
			let i = Object.entries(e);
			return i.length === 0 ? /* @__PURE__ */ q("span", { children: "{}" }) : /* @__PURE__ */ J("span", { children: [
				"{\n",
				i.map(([e, a], o) => /* @__PURE__ */ J("span", { children: [
					r,
					"  ",
					/* @__PURE__ */ J("span", {
						className: "text-sky-600 dark:text-sky-400",
						children: [
							"\"",
							e,
							"\""
						]
					}),
					":",
					" ",
					t(a, n + 1),
					o < i.length - 1 ? "," : "",
					"\n"
				] }, e)),
				r,
				"}"
			] });
		}
		return /* @__PURE__ */ q("span", { children: String(e) });
	};
	return /* @__PURE__ */ q("pre", {
		className: "text-xs font-mono text-slate-700 dark:text-slate-300 whitespace-pre-wrap break-all",
		children: t(e)
	});
}, kD = V(({ className: e, name: t, arguments: n, result: r, status: i = "pending", duration: a, collapsible: o = !0, defaultCollapsed: s, error: c, ...l }, u) => {
	let [d, f] = G(s ?? i === "success"), p = ED[i], m = p.icon, h = () => {
		o && f(!d);
	}, g = n || r || c;
	return /* @__PURE__ */ J("div", {
		ref: u,
		className: I("rounded-lg border border-l-4 overflow-hidden", "border-slate-200 dark:border-slate-700", p.borderColor, p.bgColor, e),
		...l,
		children: [/* @__PURE__ */ J("button", {
			type: "button",
			onClick: h,
			disabled: !o || !g,
			className: I("w-full flex items-center gap-2 px-3 py-2", "text-left transition-colors", o && g && "hover:bg-slate-100/50 dark:hover:bg-slate-700/30", !o || !g ? "cursor-default" : "cursor-pointer"),
			"aria-expanded": !d,
			"aria-controls": `tool-call-content-${t}`,
			children: [
				/* @__PURE__ */ q(xa, { className: "h-4 w-4 text-slate-400 dark:text-slate-500 shrink-0" }),
				/* @__PURE__ */ q("span", {
					className: "font-mono text-sm font-medium text-slate-900 dark:text-slate-100 truncate",
					children: t
				}),
				/* @__PURE__ */ J("span", {
					className: I("inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium", i === "pending" && "bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-400", i === "running" && "bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300", i === "success" && "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300", i === "error" && "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-300"),
					children: [/* @__PURE__ */ q(m, { className: I("h-3 w-3", p.iconColor, p.animate && "animate-spin") }), /* @__PURE__ */ q("span", { children: p.label })]
				}),
				a !== void 0 && /* @__PURE__ */ q("span", {
					className: "text-xs text-slate-400 dark:text-slate-500 tabular-nums",
					children: DD(a)
				}),
				o && g && /* @__PURE__ */ q(R, { className: I("h-4 w-4 text-slate-400 dark:text-slate-500 ml-auto shrink-0 transition-transform", !d && "rotate-180") })
			]
		}), !d && g && /* @__PURE__ */ J("div", {
			id: `tool-call-content-${t}`,
			className: "px-3 pb-3 space-y-3 border-t border-slate-200/50 dark:border-slate-700/50",
			children: [
				n && Object.keys(n).length > 0 && /* @__PURE__ */ J("div", {
					className: "pt-3",
					children: [/* @__PURE__ */ q("span", {
						className: "text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wide",
						children: "Arguments"
					}), /* @__PURE__ */ q("div", {
						className: "mt-1.5 p-2 rounded bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 max-h-48 overflow-y-auto",
						children: /* @__PURE__ */ q(OD, { data: n })
					})]
				}),
				r && /* @__PURE__ */ J("div", { children: [/* @__PURE__ */ q("span", {
					className: "text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wide",
					children: "Result"
				}), /* @__PURE__ */ q("div", {
					className: "mt-1.5 p-2 rounded bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 max-h-48 overflow-y-auto",
					children: /* @__PURE__ */ q("pre", {
						className: "text-xs font-mono text-slate-700 dark:text-slate-300 whitespace-pre-wrap break-all",
						children: r
					})
				})] }),
				c && /* @__PURE__ */ J("div", { children: [/* @__PURE__ */ q("span", {
					className: "text-xs font-medium text-rose-500 dark:text-rose-400 uppercase tracking-wide",
					children: "Error"
				}), /* @__PURE__ */ q("div", {
					className: "mt-1.5 p-2 rounded bg-rose-50 dark:bg-rose-500/10 border border-rose-200 dark:border-rose-500/20",
					children: /* @__PURE__ */ q("pre", {
						className: "text-xs font-mono text-rose-600 dark:text-rose-400 whitespace-pre-wrap break-all",
						children: c
					})
				})] })
			]
		})]
	});
});
kD.displayName = "ToolCallCard";
//#endregion
//#region src/components/chat/HITLPrompt/HITLPrompt.tsx
var AD = {
	low: {
		borderColor: "border-l-sky-400 dark:border-l-sky-500",
		bgColor: "bg-sky-50/50 dark:bg-sky-500/5",
		headerBg: "bg-sky-50 dark:bg-sky-500/10",
		badgeClass: "bg-sky-100 text-sky-700 dark:bg-sky-500/20 dark:text-sky-300",
		label: "Low"
	},
	medium: {
		borderColor: "border-l-amber-400 dark:border-l-amber-500",
		bgColor: "bg-amber-50/50 dark:bg-amber-500/5",
		headerBg: "bg-amber-50 dark:bg-amber-500/10",
		badgeClass: "bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300",
		label: "Medium"
	},
	high: {
		borderColor: "border-l-orange-400 dark:border-l-orange-500",
		bgColor: "bg-orange-50/50 dark:bg-orange-500/5",
		headerBg: "bg-orange-50 dark:bg-orange-500/10",
		badgeClass: "bg-orange-100 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300",
		label: "High"
	},
	critical: {
		borderColor: "border-l-rose-400 dark:border-l-rose-500",
		bgColor: "bg-rose-50/50 dark:bg-rose-500/5",
		headerBg: "bg-rose-50 dark:bg-rose-500/10",
		badgeClass: "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-300",
		label: "Critical",
		pulse: !0
	}
}, jD = (e, t) => {
	let n = e / t * 100;
	return n > 50 ? "text-emerald-500 dark:text-emerald-400" : n > 25 ? "text-amber-500 dark:text-amber-400" : "text-rose-500 dark:text-rose-400";
}, MD = (e, t) => {
	let n = e / t * 100;
	return n > 50 ? "bg-emerald-500" : n > 25 ? "bg-amber-500" : "bg-rose-500";
}, ND = V(({ className: e, requestId: t, action: n, agentName: r = "Agent", missionName: i, urgency: a = "medium", timeoutSeconds: o, timeoutAction: s = "deny", onApprove: c, onDeny: l, onModify: u, isResolved: d = !1, resolution: f, showCommentInput: p = !1, showModify: m = !1, ...h }, g) => {
	let [_, v] = G(o ?? 0), [y, b] = G(""), [x, S] = G(!1), [C, w] = G(!1), T = AD[a], E = o ?? 0;
	U(() => {
		if (!o || d || _ <= 0) return;
		let e = setInterval(() => {
			v((t) => t <= 1 ? (clearInterval(e), 0) : t - 1);
		}, 1e3);
		return () => clearInterval(e);
	}, [
		o,
		d,
		_
	]), U(() => {
		_ === 0 && !d && o && (s === "approve" ? c?.(t, "Auto-approved (timeout)") : l?.(t, "Auto-denied (timeout)"));
	}, [
		_,
		d,
		o,
		s,
		t,
		c,
		l
	]);
	let D = H(() => {
		C || d || (w(!0), c?.(t, y || void 0));
	}, [
		C,
		d,
		c,
		t,
		y
	]), O = H(() => {
		p && !x ? S(!0) : C || d || (w(!0), l?.(t, y || void 0));
	}, [
		C,
		d,
		p,
		x,
		l,
		t,
		y
	]), k = H(() => {
		C || d || u?.(t);
	}, [
		C,
		d,
		u,
		t
	]);
	if (d) {
		let t = f === "approved", r = f === "denied" || f === "expired", i = f === "modified";
		return /* @__PURE__ */ q("div", {
			ref: g,
			className: I("rounded-lg border border-l-4 overflow-hidden", "border-slate-200 dark:border-slate-700", t && "border-l-emerald-400 dark:border-l-emerald-500 bg-emerald-50/30 dark:bg-emerald-500/5", r && "border-l-rose-400 dark:border-l-rose-500 bg-rose-50/30 dark:bg-rose-500/5", i && "border-l-amber-400 dark:border-l-amber-500 bg-amber-50/30 dark:bg-amber-500/5", "opacity-75", e),
			...h,
			children: /* @__PURE__ */ J("div", {
				className: "flex items-center gap-2 px-3 py-2",
				children: [
					t && /* @__PURE__ */ q(tn, { className: "h-4 w-4 text-emerald-500" }),
					r && /* @__PURE__ */ q(Ur, { className: "h-4 w-4 text-rose-500" }),
					i && /* @__PURE__ */ q(We, { className: "h-4 w-4 text-amber-500" }),
					/* @__PURE__ */ J("span", {
						className: "text-sm font-medium text-slate-700 dark:text-slate-300",
						children: [
							t && "Approved",
							r && (f === "expired" ? "Expired" : "Denied"),
							i && "Modified"
						]
					}),
					/* @__PURE__ */ q("span", {
						className: "text-sm text-slate-500 dark:text-slate-400",
						children: n.description
					})
				]
			})
		});
	}
	return /* @__PURE__ */ J("div", {
		ref: g,
		className: I("rounded-lg border border-l-4 overflow-hidden animate-scale-in", "border-slate-200 dark:border-slate-700", T.borderColor, T.bgColor, T.pulse && "animate-pulse", e),
		role: "alertdialog",
		"aria-labelledby": `hitl-title-${t}`,
		"aria-describedby": `hitl-desc-${t}`,
		...h,
		children: [
			/* @__PURE__ */ J("div", {
				className: I("flex items-center gap-2 px-3 py-2", T.headerBg),
				children: [
					/* @__PURE__ */ q(Zt, { className: "h-4 w-4 text-amber-500 dark:text-amber-400 shrink-0" }),
					/* @__PURE__ */ q("span", {
						id: `hitl-title-${t}`,
						className: "text-sm font-medium text-slate-900 dark:text-slate-100",
						children: "Approval Required"
					}),
					/* @__PURE__ */ q("span", {
						className: I("inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium", T.badgeClass),
						children: T.label
					}),
					r && /* @__PURE__ */ J("span", {
						className: "text-sm text-slate-500 dark:text-slate-400",
						children: ["from ", r]
					}),
					o && _ > 0 && /* @__PURE__ */ J("div", {
						className: "ml-auto flex items-center gap-1.5",
						children: [/* @__PURE__ */ q(Gr, { className: I("h-3.5 w-3.5", jD(_, E)) }), /* @__PURE__ */ J("span", {
							className: I("text-xs font-medium tabular-nums", jD(_, E)),
							children: [_, "s"]
						})]
					})
				]
			}),
			o && _ > 0 && /* @__PURE__ */ q("div", {
				className: "h-1 bg-slate-200 dark:bg-slate-700",
				children: /* @__PURE__ */ q("div", {
					className: I("h-full transition-all duration-1000 ease-linear", MD(_, E)),
					style: { width: `${_ / E * 100}%` }
				})
			}),
			/* @__PURE__ */ J("div", {
				className: "px-3 py-3 space-y-3",
				children: [
					/* @__PURE__ */ q("p", {
						id: `hitl-desc-${t}`,
						className: "text-sm text-slate-700 dark:text-slate-300",
						children: n.description
					}),
					i && /* @__PURE__ */ J("p", {
						className: "text-xs text-slate-500 dark:text-slate-400",
						children: ["Mission: ", i]
					}),
					n.toolName && /* @__PURE__ */ J("div", {
						className: "p-2 rounded bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700",
						children: [/* @__PURE__ */ J("div", {
							className: "flex items-center gap-2 mb-1",
							children: [/* @__PURE__ */ q("span", {
								className: "text-xs font-medium text-slate-500 dark:text-slate-400",
								children: "Tool:"
							}), /* @__PURE__ */ q("span", {
								className: "text-xs font-mono text-slate-700 dark:text-slate-300",
								children: n.toolName
							})]
						}), n.arguments && Object.keys(n.arguments).length > 0 && /* @__PURE__ */ q("pre", {
							className: "text-xs font-mono text-slate-600 dark:text-slate-400 whitespace-pre-wrap break-all",
							children: JSON.stringify(n.arguments, null, 2)
						})]
					}),
					n.risk && /* @__PURE__ */ J("div", {
						className: "flex items-start gap-2 p-2 rounded bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-500/20",
						children: [/* @__PURE__ */ q(Me, { className: "h-4 w-4 text-amber-500 dark:text-amber-400 shrink-0 mt-0.5" }), /* @__PURE__ */ q("span", {
							className: "text-xs text-amber-700 dark:text-amber-300",
							children: n.risk
						})]
					}),
					o && _ > 0 && /* @__PURE__ */ J("p", {
						className: "text-xs text-slate-500 dark:text-slate-400",
						children: [
							"Auto-",
							s,
							" in ",
							_,
							"s"
						]
					}),
					(p || x) && /* @__PURE__ */ q("textarea", {
						value: y,
						onChange: (e) => b(e.target.value),
						placeholder: x ? "Reason for denial..." : "Add a comment (optional)...",
						className: I("w-full px-2.5 py-1.5 text-sm rounded border", "bg-white dark:bg-slate-800", "border-slate-200 dark:border-slate-700", "text-slate-700 dark:text-slate-300", "placeholder-slate-400 dark:placeholder-slate-500", "focus:outline-none focus:ring-2 focus:ring-slate-300 dark:focus:ring-slate-600", "resize-none min-h-[60px]"),
						"aria-label": x ? "Denial reason" : "Comment"
					})
				]
			}),
			/* @__PURE__ */ J("div", {
				className: "flex items-center gap-2 px-3 py-2 border-t border-slate-200/50 dark:border-slate-700/50",
				children: [
					/* @__PURE__ */ J("button", {
						type: "button",
						onClick: D,
						disabled: C,
						className: I("inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-sm font-medium", "bg-emerald-600 text-white", "hover:bg-emerald-700", "focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2", "disabled:opacity-50 disabled:cursor-not-allowed", "transition-colors"),
						"aria-label": "Approve action",
						children: [/* @__PURE__ */ q(tn, { className: "h-4 w-4" }), /* @__PURE__ */ q("span", { children: "Approve" })]
					}),
					/* @__PURE__ */ J("button", {
						type: "button",
						onClick: O,
						disabled: C,
						className: I("inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-sm font-medium", "border border-rose-300 dark:border-rose-700", "text-rose-600 dark:text-rose-400", "hover:bg-rose-50 dark:hover:bg-rose-500/10", "focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-2", "disabled:opacity-50 disabled:cursor-not-allowed", "transition-colors"),
						"aria-label": "Deny action",
						children: [/* @__PURE__ */ q(Ur, { className: "h-4 w-4" }), /* @__PURE__ */ q("span", { children: "Deny" })]
					}),
					m && u && /* @__PURE__ */ J("button", {
						type: "button",
						onClick: k,
						disabled: C,
						className: I("inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-sm font-medium", "border border-amber-300 dark:border-amber-700", "text-amber-600 dark:text-amber-400", "hover:bg-amber-50 dark:hover:bg-amber-500/10", "focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2", "disabled:opacity-50 disabled:cursor-not-allowed", "transition-colors"),
						"aria-label": "Modify action",
						children: [/* @__PURE__ */ q(We, { className: "h-4 w-4" }), /* @__PURE__ */ q("span", { children: "Modify" })]
					})
				]
			})
		]
	});
});
ND.displayName = "HITLPrompt";
//#endregion
//#region src/components/chat/ChatHeader/ChatHeader.tsx
var PD = {
	connected: {
		color: "text-emerald-500",
		bgColor: "bg-emerald-500",
		icon: ya,
		label: "Connected"
	},
	connecting: {
		color: "text-amber-500",
		bgColor: "bg-amber-500",
		icon: qe,
		animate: !0,
		label: "Connecting"
	},
	reconnecting: {
		color: "text-amber-500",
		bgColor: "bg-amber-500",
		icon: qe,
		animate: !0,
		label: "Reconnecting"
	},
	disconnected: {
		color: "text-slate-400",
		bgColor: "bg-slate-400",
		icon: _a,
		label: "Disconnected"
	},
	error: {
		color: "text-rose-500",
		bgColor: "bg-rose-500",
		icon: _a,
		label: "Connection Error"
	}
}, FD = (e) => e.split(" ").map((e) => e[0]).join("").toUpperCase().slice(0, 2), ID = {
	online: "bg-emerald-500",
	busy: "bg-amber-500",
	offline: "bg-slate-400"
}, LD = V(({ className: e, title: t, subtitle: n, status: r, participants: i, maxParticipants: a = 3, actions: o, icon: s, showBack: c, onBack: l, connectionState: u, ...d }, f) => {
	let p = i?.slice(0, a) ?? [], m = (i?.length ?? 0) - a, h = u ? PD[u] : null, g = h?.icon;
	return /* @__PURE__ */ J("header", {
		ref: f,
		className: I("sticky top-0 z-10 h-14 flex items-center gap-3 px-4", "bg-white dark:bg-slate-900", "border-b border-slate-200 dark:border-slate-700", e),
		...d,
		children: [
			c && /* @__PURE__ */ q("button", {
				type: "button",
				onClick: l,
				className: I("shrink-0 p-1.5 -ml-1.5 rounded", "text-slate-500 dark:text-slate-400", "hover:bg-slate-100 dark:hover:bg-slate-800", "focus:outline-none focus:ring-2 focus:ring-slate-300 dark:focus:ring-slate-600", "transition-colors"),
				"aria-label": "Go back",
				children: /* @__PURE__ */ q(wt, { className: "h-5 w-5" })
			}),
			s && /* @__PURE__ */ q("div", {
				className: "shrink-0 h-8 w-8 flex items-center justify-center rounded-full bg-slate-100 dark:bg-slate-800",
				children: s
			}),
			/* @__PURE__ */ J("div", {
				className: "flex-1 min-w-0",
				children: [/* @__PURE__ */ J("div", {
					className: "flex items-center gap-2",
					children: [
						/* @__PURE__ */ q("h1", {
							className: "text-sm font-semibold text-slate-900 dark:text-slate-100 truncate",
							children: t
						}),
						u && /* @__PURE__ */ J("div", {
							className: "flex items-center gap-1",
							title: h?.label,
							children: [g && /* @__PURE__ */ q(g, { className: I("h-3.5 w-3.5", h?.color, h?.animate && "animate-spin") }), !g && /* @__PURE__ */ q("span", { className: I("h-2 w-2 rounded-full", h?.bgColor, u === "connecting" || u === "reconnecting" ? "animate-pulse" : "") })]
						}),
						r
					]
				}), n && /* @__PURE__ */ q("p", {
					className: "text-xs text-slate-500 dark:text-slate-400 truncate max-sm:hidden",
					children: n
				})]
			}),
			i && i.length > 0 && /* @__PURE__ */ q("div", {
				className: "flex items-center shrink-0",
				children: /* @__PURE__ */ J("div", {
					className: "flex -space-x-2",
					children: [p.map((e, t) => /* @__PURE__ */ J("div", {
						className: "relative",
						style: { zIndex: p.length - t },
						title: e.name,
						children: [e.avatar ? /* @__PURE__ */ q("img", {
							src: e.avatar,
							alt: e.name,
							className: I("h-7 w-7 rounded-full", "border-2 border-white dark:border-slate-900", "object-cover")
						}) : /* @__PURE__ */ q("div", {
							className: I("h-7 w-7 rounded-full", "border-2 border-white dark:border-slate-900", "bg-slate-200 dark:bg-slate-700", "flex items-center justify-center", "text-xs font-medium text-slate-600 dark:text-slate-300"),
							children: FD(e.name)
						}), e.status && /* @__PURE__ */ q("span", { className: I("absolute -bottom-0.5 -right-0.5", "h-2.5 w-2.5 rounded-full", "border-2 border-white dark:border-slate-900", ID[e.status]) })]
					}, e.id)), m > 0 && /* @__PURE__ */ J("div", {
						className: I("h-7 w-7 rounded-full", "border-2 border-white dark:border-slate-900", "bg-slate-300 dark:bg-slate-600", "flex items-center justify-center", "text-xs font-medium text-slate-700 dark:text-slate-200"),
						style: { zIndex: 0 },
						children: ["+", m]
					})]
				})
			}),
			o && /* @__PURE__ */ q("div", {
				className: "flex items-center gap-1 shrink-0",
				children: o
			})
		]
	});
});
LD.displayName = "ChatHeader";
//#endregion
export { Se as ActionBadge, kE as ActivityIndicator, vE as AgentActivity, bE as AgentResponse, Ou as Alert, Au as AlertDescription, ku as AlertTitle, iw as AppMain, qC as AppShell, JC as AppSidebar, $C as AppSidebarFooter, YC as AppSidebarHeader, nw as AppSidebarLanguageMenu, tw as AppSidebarLanguageSwitch, XC as AppSidebarNav, ZC as AppSidebarNavItem, QC as AppSidebarSection, rw as AppSidebarUserMenu, ew as AppSidebarUserProfile, Iv as AppSwitcher, hC as AreaChart, $v as ArtifactPanel, iD as AudioPlayer, nE as AuditEntryCycleGroup, tE as AuditEntryItem, Ua as Avatar, $t as BLOCKED_LABEL_DEFAULTS, i as Badge, gC as BarChart, L as Button, cC as CHART_COLORS, xt as Caption, xu as Card, Tu as CardContent, wu as CardDescription, Eu as CardFooter, Su as CardHeader, Cu as CardTitle, fC as ChartLegend, dC as ChartTooltip, LD as ChatHeader, EE as ChatInput, Vt as Checkbox, Qe as Code, TE as CodeBlock, uo as Collapsible, po as CollapsibleContent, fo as CollapsibleTrigger, Mu as ColoredSection, qa as Combobox, Ja as ComboboxMulti, xC as CommandPalette, EC as CommandPaletteEmpty, wC as CommandPaletteGroup, SC as CommandPaletteInput, TC as CommandPaletteItem, CC as CommandPaletteList, DC as CommandPaletteSeparator, id as ConfirmDialog, hD as ConnectionStatus, TT as ContentBlock, OE as ConversationList, sC as DEFAULT_MARGIN, hn as DataTable, De as DataTableAction, _ as DataTableActions, p as DataTableBody, me as DataTableCell, jt as DataTableEmpty, r as DataTableFooter, kt as DataTableHead, ce as DataTableHeader, de as DataTablePagination, _e as DataTableRow, x as DataTableSectionHeader, A as DataTableTable, Lu as Dialog, Yu as DialogBody, Bu as DialogClose, Uu as DialogContent, $u as DialogDescription, Ku as DialogEyebrow, Zu as DialogFooter, qu as DialogHeader, Gu as DialogIcon, Vu as DialogOverlay, zu as DialogPortal, Qu as DialogTitle, Ru as DialogTrigger, _C as DonutChart, go as DropZone, D as DropdownMenu, je as DropdownMenuCheckboxItem, Le as DropdownMenuContent, w as DropdownMenuGroup, re as DropdownMenuItem, Xt as DropdownMenuLabel, ee as DropdownMenuPortal, Ue as DropdownMenuRadioGroup, Be as DropdownMenuRadioItem, Ke as DropdownMenuSeparator, ve as DropdownMenuShortcut, e as DropdownMenuSub, ht as DropdownMenuSubContent, cn as DropdownMenuSubTrigger, Ut as DropdownMenuTrigger, Ya as EditableCombobox, _o as EditableText, pD as EmptyChatState, oe as EmptyState, lE as ErrorSummary, mn as ErrorText, VE as EscalationCard, Et as FORCED_LABEL_DEFAULTS, HE as FeedbackButtons, FE as FileAttachment, IE as FileAttachmentList, yv as FilterChipBar, kC as Form, MC as FormActions, PC as FormDivider, Nu as FormField, jC as FormGroup, NC as FormMessage, AC as FormSection, yC as Gauge, TD as GovernanceIndicator, ND as HITLPrompt, FC as Header, BC as HeaderActions, IC as HeaderContainer, LC as HeaderLogo, RC as HeaderNav, zC as HeaderNavItem, VC as HeaderUserMenu, En as Heading, vC as HeatMap, at as HelperText, Iu as IconButton, bo as IdChip, on as Input, Wv as JsonViewer, wo as Label, mC as LineChart, Xv as LineageCard, Eo as List, ko as ListDivider, Oo as ListItem, sD as LiveTranscript, yD as MarkdownRenderer, dD as MentionBadge, uD as MentionMenu, vD as MessageBubble, _D as MessageGroup, sw as MissionCard, pT as NodeDetails, xv as OrgSwitcher, Sn as PageDescription, HC as PageHeader, KC as PageHeaderActions, WC as PageHeaderBreadcrumbs, UC as PageHeaderRow, GC as PageHeaderTitle, uE as PageSection, Ee as PageTitle, Ao as PasswordInput, uT as PipelineProgress, en as Popover, Dt as PopoverAnchor, et as PopoverArrow, Gt as PopoverClose, rn as PopoverContent, st as PopoverTrigger, Rv as ProcessStatusStrip, Xo as Progress, an as RUN_CHAT_TOOL_WINDOW, $e as RUN_END_STOPPED_DECISION, ks as RadioGroup, As as RadioGroupItem, js as ReadOnlyField, Ms as RoleBadge, DT as RunOutput, ad as SearchDropdown, od as SearchInput, Lv as SectionCard, f as SectionDescription, vn as SectionTitle, Zc as Select, rl as SelectContent, Qc as SelectGroup, al as SelectItem, il as SelectLabel, nl as SelectScrollDownButton, tl as SelectScrollUpButton, ol as SelectSeparator, el as SelectTrigger, $c as SelectValue, Ie as SimpleTooltip, sd as Skeleton, ld as SkeletonAvatar, ud as SkeletonCard, cd as SkeletonText, eu as Slider, i_ as Sparkline, ZE as SpeakingIndicator, nu as Spinner, uw as SplitView, m_ as StatCard, iE as StatsSummary, iu as Status, xD as SuggestionChip, SD as SuggestionChips, Qt as Switch, CE as SystemMessage, au as Table, su as TableBody, fu as TableCaption, du as TableCell, Ae as TableCellPrimary, b as TableCellSecondary, cu as TableFooter, uu as TableHead, ou as TableHeader, lu as TableRow, h_ as Tabs, v_ as TabsContent, g_ as TabsList, __ as TabsTrigger, g as Text, ge as TextLink, pu as Textarea, wE as ThinkingBlock, bC as TimeSeriesChart, dv as Toast, fv as ToastAction, pv as ToastClose, hv as ToastDescription, cv as ToastProvider, mv as ToastTitle, lv as ToastViewport, aE as TokenBreakdown, kD as ToolCallCard, k as Tooltip, Ne as TooltipArrow, ze as TooltipContent, E as TooltipProvider, ae as TooltipTrigger, C as TrustBadge, bu as UserChip, xE as UserMessage, YE as VoiceCallControls, tD as VoiceCallPanel, qE as VoiceMessage, GE as VoiceRecordingButton, WE as VoiceRecordingOverlay, sT as WPEdge, tT as WPNode, yT as WorkflowDAG, On as actionBadgeVariants, Tn as alertVariants, Vn as announceToScreenReader, it as badgeVariants, Wt as blockedReasonText, kv as buildAgionAppUrl, xn as buttonVariants, Nt as captionVariants, Te as cardVariants, d as chatMessageVariants, I as cn, o as codeVariants, zw as computeDAGLayout, br as computeDAGMetadata, Ww as computeEdgePath, Av as createAgionAppSwitcherApps, Bt as deriveRunChatSteps, Yw as detectIntersections, gv as filterChipBarVariants, _v as filterChipVariants, ir as filterComboboxOptions, nn as filterNoise, rr as filterRowsBySearchBody, ot as forcedEndingNote, Pt as formatDuration, ln as formatHITLDuration, ut as formatTime, gt as formatTokens, Xw as generateHopBridge, c as getActionBadgeVariant, Fe as getActionLabel, Ga as getAvatarColor, Ov as getCurrentAgionAppId, Zw as getEdgeColor, Hn as getFocusableElements, Ka as getInitials, mu as getTrustBadgeVariant, M as getTrustTierLabel, Bn as globalsPath, qt as groupByCycle, At as headingVariants, vo as idChipVariants, _n as inputVariants, OT as isKnowledgeSearchTool, It as isStoppedNode, St as isStoppedRunEnd, Gv as lineageCardVariants, Do as listItemVariants, To as listVariants, yt as mergeDelegationResults, vr as mergeExecutionState, Ye as mergeToolResults, gr as parsePlanToDAG, Sr as planToWorkflowProps, ke as progressIndicatorVariants, y as progressVariants, uC as resolveColor, fn as resolveDelegationState, h as roleBadgeVariants, nr as scoreRows, zT as searchConfidenceState, BT as searchDegradedReason, Ce as splitRunOutput, Un as srOnlyStyles, a_ as statCardVariants, he as statusVariants, ue as textLinkVariants, pe as textVariants, Mt as trustBadgeVariants, lC as useChartColors, oC as useChartDimensions, OC as useCommandPalette, ed as useDialogScrolled, dr as useFocusTrap, Tr as useGACPipelineState, hr as useGACRelay, lr as useIsDesktop, sr as useIsMobile, cr as useIsTablet, ur as useIsTouchDevice, or as useMediaQuery, fr as useReducedMotion, ar as useTheme, hu as userChipVariants };

//# sourceMappingURL=index.mjs.map